{
  "queryBar": {
    "placeholder": "Type to filter...",
    "clearFilters": "Clear filters",
    "back": "Back",
    "apply": "Apply",
    "filterBy": "Filter by {{category}}",
    "filterByHeading": "Filter by",
    "editCategory": "Edit {{category}}",
    "searchOptions": "Search options...",
    "removeFilter": "Remove filter",
    "removeCategory": "Remove {{category}}",
    "clearAll": "Clear all ({{count}})",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "requiresParent": "Select {{category}} first",
    "requiresRequired": "Select the required filters first",
    "noValues": "No matching values",
    "noCategories": "No matching filters",
    "clearFiltersLocked": "Default filters can't be cleared",
    "lockedCategory": "{{category}} is applied by default — you can change it, but not remove it"
  },
  "unifiedLakehouse": {
    "eyebrow": "Lakehouse Governance",
    "pageTitle": "Unified Lakehouse",
    "title": "Unified lakehouse policy management",
    "subtitle": "Map canonical objects across platforms, review attached policies, detect coverage drift, resolve role mapping, preview native policies, and deploy everywhere.",
    "previewBadge": "Preview",
    "unknownDataSource": "Unknown data source",
    "moreDataSources_one": "Show {{count}} more data source",
    "moreDataSources_other": "Show {{count}} more data sources",
    "notApplicable": "Not applicable",
    "notAvailable": "Not available",
    "separatorDot": "·",
    "missing": "Missing",
    "noPolicyApplied": "No policy applied",
    "owner": "Owner: {{owner}}",
    "allCovered": "All policies fully covered",
    "driftCount_one": "{{count}} drift item needs attention",
    "driftCount_other": "{{count}} drift items need attention",
    "policyCount_one": "{{count}} policy",
    "policyCount_other": "{{count}} policies",
    "tabs": {
      "catalog": "Unified Catalog",
      "policies": "Unified Policies",
      "userAttributes": "User Attributes",
      "deployment": "Deployment Activity",
      "audit": "Audit Trail"
    },
    "filters": {
      "dataSource": "Data source",
      "policyType": "Policy type",
      "coverageStatus": "Coverage status"
    },
    "columns": {
      "policyName": "Policy Name",
      "policyType": "Policy Type",
      "canonicalObject": "Canonical Object",
      "dataSourceCoverage": "Data Source Coverage",
      "coverageStatus": "Coverage Status",
      "lastUpdated": "Last Updated",
      "objectName": "Object Name",
      "objectType": "Object Type",
      "catalogSchema": "Catalog / Schema",
      "attachedPolicies": "Attached Policies",
      "dataSource": "Data Source",
      "platform": "Platform",
      "objectExists": "Object Exists",
      "policyStatus": "Policy Status",
      "roleMappingStatus": "Role Mapping Status",
      "action": "Action",
      "nativeRole": "Native Role",
      "plannedAction": "Planned Action",
      "result": "Result",
      "nativeObjectName": "Native Object Name",
      "databaseCatalog": "Database / Catalog",
      "schema": "Schema",
      "table": "Table",
      "columns": "Columns",
      "mappingState": "Mapping State",
      "columnName": "Column Name",
      "dataType": "Data Type",
      "classification": "Classification",
      "policyApplied": "Policy Applied",
      "target": "Target",
      "actor": "Actor",
      "policy": "Policy",
      "dataSources": "Data Sources",
      "timestamp": "Timestamp",
      "verification": "Verification",
      "evidence": "Evidence"
    },
    "actions": {
      "createPolicy": "Create Policy",
      "details": "Details",
      "viewDetails": "View Details",
      "resolveDrift": "Resolve Drift",
      "mapRole": "Map Role",
      "view": "View",
      "viewPolicy": "View Policy",
      "openPolicy": "Open Policy",
      "deploy": "Deploy Policy"
    },
    "catalog": {
      "title": "Unified Catalog",
      "subtitle": "Discover canonical lakehouse objects and their native mappings across mapped data sources.",
      "searchPlaceholder": "Search canonical object, catalog, schema, or native object",
      "empty": "No catalog objects found"
    },
    "userAttributes": {
      "title": "User Attributes",
      "subtitle": "Discover canonical user attributes and their native mappings across mapped accounts.",
      "panel": {
        "subtitle": "Canonical user attribute and its mappings across platforms."
      },
      "tabs": {
        "overview": "Overview",
        "mappings": "Mappings"
      },
      "overview": {
        "title": "Attribute Overview"
      },
      "mappedAccounts": {
        "title": "Mapped Accounts"
      },
      "columns": {
        "canonicalName": "Canonical Name",
        "code": "Code",
        "type": "Type",
        "status": "Status",
        "account": "Account",
        "platform": "Platform",
        "nativeAttributeName": "Native Attribute Name",
        "nativeType": "Native Type",
        "mappingStatus": "Mapping Status"
      }
    },
    "policies": {
      "title": "Unified Policies",
      "subtitle": "Review unified policy intent, platform coverage, role mapping readiness, and remediation actions across mapped data sources.",
      "searchPlaceholder": "Search by policy name or canonical object",
      "empty": "No policies found",
      "draftTooltip": "Draft: Changes saved but not deployed",
      "create": {
        "title": "Create Unified Catalog Policy",
        "subtitle": "Define policy intent once, preview canonical impact, and deploy platform-specific policy mappings across connected engines.",
        "actions": {
          "create": "Create",
          "update": "Update",
          "publish": "Publish"
        },
        "updateDeployedConfirmation": {
          "title": "Warning",
          "message": "Clicking Continue will change the policy state to Saved. This will not impact enforcement of the currently deployed policy. The new policy won't take effect until it's Deployed.",
          "continue": "Continue",
          "cancel": "Cancel"
        },
        "steps": {
          "details": {
            "label": "Policy Details",
            "description": "Name, type, enforcement",
            "subtitle": "Set the policy identity and enforcement model before defining scope."
          },
          "policyScope": {
            "label": "Policy Scope",
            "description": "Define canonical intent",
            "heading": "Define Scope",
            "subtitle": "Define what canonical resources this policy should apply to. TrustLogix will find matching objects and map them across connected platforms.",
            "browseSelectTitle": "Browse & Select",
            "browseSelectSubtitle": "Select hierarchy scope and add specific canonical resources in one place.",
            "searchResources": "Search Resources",
            "searchPlaceholder": "Search resources",
            "catalogTree": "Catalog Tree",
            "noCatalogDataFound": "No catalog data found.",
            "noTargetSelected": "No target selected",
            "selectedScopeSummary": "Selected Scope Summary",
            "target": "Target",
            "additionalResources": "Additional Resources",
            "explicitlySelected": "{{count}} explicitly selected",
            "selectionBehavior": "Selection behavior",
            "selectionBehaviorDescription": "Choosing a hierarchy node applies the policy to matching resources in that branch.",
            "viewDetails": "View Details",
            "viewNSelected": "View {{count}} selected",
            "privilegeSelection": "Privilege Selection",
            "selected": "selected",
            "objectPrivilegesPlaceholder": "Select object privileges",
            "matchedResources": "Matched Resources",
            "scopeDetails": "SCOPE DETAILS",
            "canonicalObjectType": "CANONICAL OBJECT TYPE",
            "targetPlatform": "TARGET PLATFORM",
            "targetAccount": "TARGET ACCOUNT",
            "nativeDatabaseCatalogSchemaTable": "NATIVE DATABASE / CATALOG / SCHEMA / TABLE",
            "physicalSourceLocation": "PHYSICAL / SOURCE LOCATION",
            "noDetailsRows": "No details found"
          },
          "roleAssignment": {
            "label": "Role Assignment",
            "description": "Assign canonical roles",
            "canonicalRoles": "Canonical Roles",
            "subtitle": "Select canonical roles that should receive access to the selected scope.",
            "selectedScope": "SELECTED SCOPE",
            "selectedScopeSummary": "All tables and views in Finance whose name contains \"customer\"",
            "matchingCanonicalResources_one": "{{count}} matching canonical resource",
            "matchingCanonicalResources_other": "{{count}} matching canonical resources",
            "assignedPrincipals": "Assigned Principals",
            "emptyAssigned": "No canonical roles selected.",
            "emptyAssignedDescription": "Select canonical roles from the left panel to assign them.",
            "infoMessage": "Note: Canonical role names are just text labels. Sometimes, roles with very similar names (like \"Financial\" and \"financial\") are exactly the same behind the scenes. To be safe, always click Details to confirm before selecting.",
            "targetPlatform": "TARGET PLATFORM",
            "targetAccount": "TARGET ACCOUNT",
            "canonicalRole": "CANONICAL ROLE",
            "explicitlySelected": "{{value}} plus {{count}} explicitly selected",
            "nativeRoleMapping": "NATIVE ROLE MAPPING",
            "mappingStatus": "MAPPING STATUS",
            "noMappingRows": "No mapping details found",
            "accountMappingDetails": "Account Mapping Details",
            "roleDetails": "ROLE MAPPING",
            "mappedSummary": "{{mapped}} mapped · {{unmapped}} needing mapping"
          },
          "conditions": {
            "label": "Access Conditions",
            "description": "Define access rules",
            "subtitle": "Control who can access this policy using user and group conditions.",
            "attributeLabel": "Attribute",
            "operatorLabel": "Operator",
            "matchWithLabel": "Match With",
            "matchWithCustomValue": "Custom value",
            "conditionsTitle": "APPLIED ACCESS CONDITIONS"
          },
          "review": {
            "label": "Review",
            "description": "Recap your selections",
            "subtitle": "Review the policy details, scope, roles, and privileges you selected before deploying.",
            "loading": "Generating review details...",
            "error": "Failed to load review details.",
            "ready": "Review details are ready.",
            "noPolicyId": "Policy id was not found. Please go back and create policy again.",
            "summary": {
              "title": "Policy Summary",
              "labels": {
                "policy": "POLICY",
                "type": "TYPE",
                "scope": "SCOPE",
                "roles": "ROLES",
                "privileges": "PRIVILEGES",
                "targets": "TARGETS"
              }
            },
            "coverage": {
              "title": "DEPLOYMENT COVERAGE",
              "subtitle": "Target readiness is based on generated grants for each account.",
              "chip": "{{ready}} / {{total}} accounts receiving grants",
              "counts": {
                "targetAccounts": "Target Accounts",
                "ready": "Accounts Ready",
                "partial": "Partial",
                "noGrants": "Accounts With No Grants",
                "totalGrants": "Total Grants Generated"
              },
              "details": {
                "accountStatus": "Account Status",
                "generatedGrants": "Generated Grants",
                "roleCoverage": "Role Coverage",
                "scopeCoverage": "Scope Coverage",
                "nativeGrants": "Native Grants",
                "mapped": "Mapped",
                "noMapped": "No Mapped"
              },
              "meta": "{{grants}} grants · {{roles}} · {{scope}}",
              "summaryLabels": {
                "grant_one": "grant",
                "grant_other": "grants",
                "roles": "Roles",
                "scope": "Scope"
              },
              "viewGrants": "View grants",
              "viewDetails": "View details",
              "noGrantsWarning": "No grants generated because this target has no mapped scope resources.",
              "partialDeploymentTitle": "Partial deployment expected",
              "partialDeploymentSummary": "{{totalGrants}} native grants generated across {{coveredAccounts}} of {{totalAccounts}} target accounts.",
              "partialDeploymentMessage": "**Partial deployment expected**\n\n{{totalGrants}} native grants generated across {{coveredAccounts}} of {{totalAccounts}} target accounts.",
              "reviewRequiredTitle": "Review required",
              "reviewRequiredSummary_one": "{{count}} target account is partial or missing grants. Publishing may result in a partially deployed policy.",
              "reviewRequiredSummary_other": "{{count}} target accounts are partial or missing grants. Publishing may result in a partially deployed policy.",
              "reviewRequiredListItem": "- <strong> {{accountName}} · </strong> {{message}}",
              "reviewRequiredAcknowledge": "I understand this policy may be partially deployed.",
              "status": {
                "ready": "Ready",
                "partial": "Partial",
                "noGrants": "No grants"
              }
            },
            "fields": {
              "id": "Policy ID",
              "name": "Policy Name",
              "description": "Description",
              "status": "Status",
              "policyType": "Policy Type",
              "canonicalName": "Canonical Name",
              "privileges": "Privileges",
              "objects": "Objects",
              "roles": "Roles"
            }
          },
          "deploy": {
            "label": "Publish",
            "description": "Publish policy to data sources",
            "subtitle": "Review deployment coverage and generated native grants before publishing."
          }
        },
        "fields": {
          "name": "Policy Name",
          "namePlaceholder": "Enter policy name",
          "policyType": "Policy Type",
          "policyTypeHint": "Policy type determines which resource levels are eligible for selection.",
          "selectPolicyTypeFirst": "Please select policy type",
          "allowedTargetLevel": "Allowed target level",
          "description": "Description",
          "descriptionPlaceholder": "Enter description"
        },
        "policyTypes": {
          "2": "Object Access",
          "10": "Row Access",
          "12": "Column Masking"
        },
        "validation": {
          "scopeRequired": "Select at least one resource from the catalog.",
          "privilegeRequired": "Select at least one object privilege.",
          "roleRequired": "Assign at least one canonical role."
        }
      },
      "delete": {
        "title": "Delete Policy",
        "description": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone."
      },
      "deploy": {
        "title": "Deploy Policy",
        "description": "Are you sure you want to deploy policy \"{{name}}\"?"
      },
      "redeploy": {
        "title": "Redeploy Policy",
        "description": "Are you sure you want to redeploy policy \"{{name}}\"?"
      },
      "disable": {
        "title": "Disable Policy",
        "description": "Are you sure you want to disable this policy?"
      },
      "enable": {
        "title": "Enable Policy",
        "description": "Are you sure you want to enable this policy?"
      },
      "edit": {
        "title": "Edit Policy",
        "subtitle": "Update the scope and roles for this policy."
      },
      "discardDraft": {
        "confirmationTitle": "Discard Draft",
        "confirmationMessage": "Discarding the draft will revert the policy changes. Do you want to proceed?"
      }
    },
    "deployment": {
      "title": "Deployment Activity"
    },
    "audit": {
      "title": "Audit Trail",
      "subtitle": "Immutable record of policy deployments and verifications across mapped data sources.",
      "empty": "No audit events found"
    },
    "object": {
      "title": "Object Details",
      "subtitle": "Canonical object with platform mappings and attached unified policies.",
      "overview": "Object Overview",
      "name": "Canonical Object Name",
      "type": "Object Type",
      "catalog": "Catalog",
      "schema": "Schema",
      "table": "Table",
      "externalLocation": "External Location",
      "noColumns": "No column metadata available for this object.",
      "tabs": {
        "overview": "Overview",
        "mappings": "Mappings",
        "columns": "Columns",
        "policies": "Policies"
      }
    },
    "policy": {
      "overview": "Policy Overview",
      "title": "Policy Details",
      "driftSubtitle": "Resolve missing policies and role mappings before deployment.",
      "name": "Policy Name",
      "type": "Policy Type",
      "description": "Description",
      "target": "Policy Target",
      "roleMapping": "Role Mapping",
      "noRoleMapping": "This policy does not require role mapping before deployment.",
      "autoCreateRoles": "Auto Create Missing Roles",
      "autoCreateConfirm": "Create FINANCE_ANALYST in all unmapped platforms?",
      "createRoles": "Create Roles",
      "businessRole": "Business Role",
      "roleCoverage": "Role Mapping Coverage",
      "coverage": "Coverage",
      "mappedOf": "{{mapped}} of {{total}} data sources mapped",
      "nativePreview": "Native Policy Preview",
      "noNativePreview": "No data available",
      "viewErrorDetails": "View Error Details",
      "errorDialogTitle": "Error Details",
      "deploymentPlan": "Deployment Plan",
      "resolveBeforeDeploy": "Resolve role mapping before deployment.",
      "deployResult": "Deploy Result",
      "deployedMessage": "{{name}} is now deployed across every data source where {{object}} exists.",
      "reviewDeployment": "Review Deployment Plan",
      "tabs": {
        "overview": "Overview",
        "target": "Target & Scope",
        "roleMapping": "Role Mapping",
        "preview": "Native Policy Preview",
        "deployment": "Deployment Review"
      }
    },
    "drift": {
      "title": "Drift Detected: {{name}}",
      "subtitle": "Resolve missing policies and role mappings before deployment.",
      "currentCoverage": "Current Coverage",
      "expectedCoverage": "Expected Coverage After Fix",
      "roleMapping": "Role Mapping",
      "roleMappingRequired": "Role mapping required",
      "roleMappingMapped": "Fully Mapped",
      "pendingDeployments": "Policy Deployments",
      "pendingValue_one": "{{count}} pending",
      "pendingValue_other": "{{count}} pending",
      "readiness": "Missing Policies & Role Readiness",
      "reviewPlan": "Review Deployment Plan",
      "mapBeforeReview": "Map or create the role before reviewing the deployment plan."
    },
    "mapRole": {
      "title": "Map Native Role",
      "subtitle": "Select an existing role or create a new role for this data source.",
      "save": "Save Mapping",
      "existingRole": "Select Existing Role",
      "newRole": "Create New Role",
      "useSameName": "Use same role name across all unmapped data sources"
    },
    "preview": {
      "hint": "Review what will be created or updated when drift is resolved.",
      "createRole": "Create or map native role",
      "roleCompleted": "Role mapping completed",
      "deployPolicy": "Deploy missing policy",
      "coverageRestored": "Policy coverage restored",
      "noChanges": "No pending changes — coverage is already complete.",
      "afterRemediation": "After remediation",
      "coverageChange": "Coverage: {{from}}% → 100%"
    },
    "toast": {
      "policyCreated": "Policy created successfully.",
      "roleMapped": "Role mapping saved.",
      "roleMapFailed": "Failed to save role mapping.",
      "deployed": "Policy deployed successfully.",
      "published": "Policy published successfully.",
      "publishFailed": "Failed to publish policy.",
      "deployFailed": "Failed to deploy policy.",
      "policyDeleted": "Policy deleted successfully.",
      "policyDisabled": "Policy disabled successfully.",
      "policyEnabled": "Policy enabled successfully.",
      "policyUpdated": "Policy updated successfully."
    }
  },
  "statusBadge": {
    "reviewed": "Reviewed",
    "partiallyReviewed": "Partially Reviewed",
    "reviewFailed": "Review Failed",
    "reviewing": "Reviewing",
    "disabled": "Disabled",
    "disabling": "Disabling",
    "deploying": "Deploying",
    "published": "Published",
    "deployed": "Deployed",
    "partiallyDeployed": "Partially Deployed",
    "failed": "Failed",
    "skipped": "Skipped",
    "deleting": "Deleting",
    "saved": "Saved",
    "eligible": "Eligible",
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "locked": "Locked",
    "failedLogin": "Failed Login",
    "missingInfo": "Missing Info",
    "draft": "Draft",
    "archived": "Archived",
    "deleted": "Deleted",
    "synced": "Synced",
    "provisioned": "Provisioned",
    "failedToProvision": "Failed to Provision",
    "success": "Success",
    "completed": "Completed",
    "scheduled": "Scheduled",
    "inProgress": "In Progress",
    "unknown": "Unknown",
    "allow": "Allow",
    "deny": "Deny",
    "allowWithOverride": "Allow with Override",
    "needsReview": "Needs Review",
    "healthy": "Healthy",
    "allowed": "Allowed",
    "denied": "Denied"
  },
  "policyDrawer": {
    "title": "Policy Details",
    "previousPolicy": "Previous policy",
    "nextPolicy": "Next policy",
    "resizeDrawer": "Resize drawer",
    "actionsMenu": "Policy actions",
    "position": "{{position}} of {{total}}",
    "version": "Version {{version}}",
    "tabs": {
      "overview": "Overview",
      "securedObjects": "Secured Objects",
      "grants": "Access Controls & Grants",
      "audit": "Audit History"
    }
  },
  "slidePanel": {
    "closePanel": "Close panel",
    "resizePanel": "Drag to resize panel",
    "previous": "Previous",
    "continue": "Continue",
    "finish": "Finish",
    "saveAsDraft": "Save as Draft",
    "save": "Save",
    "cancel": "Cancel",
    "optional": "Optional",
    "stepLabel": "Step {{current}} of {{total}}",
    "stepNav": {
      "blocked": {
        "backNavigationLocked": "Navigation is locked while this step completes.",
        "footerOnlyEntry": "Continue from the previous step to reach this one.",
        "notAvailableYet": "Finish the earlier steps to unlock this step."
      }
    },
    "errorFallback": "An error occurred. Please try again.",
    "validation": {
      "requiredField": "This field is required.",
      "requiredSummary_one": "{{count}} required field needs your attention",
      "requiredSummary_other": "{{count}} required fields need your attention",
      "requiredDescription": "Please review and provide values for the missing fields below.",
      "goToFirstError": "Go to first error",
      "errorsRemaining_one": "{{count}} error remaining",
      "errorsRemaining_other": "{{count}} errors remaining",
      "previousError": "Previous error",
      "nextError": "Next error"
    },
    "preview": {
      "expand": "Expand preview",
      "collapse": "Collapse preview"
    }
  },
  "notification": {
    "defaultTitle": {
      "success": "Success",
      "error": "Error",
      "warning": "Warning",
      "info": "Info"
    }
  },
  "workspaceSelector": {
    "description": "All analytics, risks, policies, tags, and reports are scoped to this workspace.",
    "switching": "Switching workspace...",
    "expand": "Expand workspace selector",
    "minimize": "Minimize workspace selector",
    "selectedWorkspace": {
      "label": "Selected Workspace",
      "info": "Actions performed here will be scoped to this workspace."
    }
  },
  "accessAnalyzer": {
    "attributes": {
      "auth_type": "Authentication Type",
      "granted_role_count": "Inherits From",
      "granted_roles_to_user": "Roles Assigned",
      "granted_groups_to_user": "Groups Assigned",
      "granted_to_role_count": "Inherited By",
      "indirect_role_count": "Roles Inherited",
      "last_login": "Last Login",
      "mfa_enabled": "MFA Enabled",
      "password_enabled": "Password Enabled",
      "role_count": "Roles Assigned",
      "rsa_enabled": "RSA Key Enabled",
      "schema_count": "Schemas Granted",
      "table_count": "Tables Count",
      "user_count": "Users Assigned",
      "user_type": "User Provisioning",
      "database_grants": "Database Grants",
      "type": "User Type"
    },
    "attributesTitle": {
      "auth_type": "User Authentication Type",
      "granted_role_count": "Number of roles  this role Inherits from (Granted Roles)",
      "granted_roles_to_user": "Number of roles assigned to this user",
      "granted_groups_to_user": "Number of groups assigned to this user",
      "granted_to_role_count": "Number of roles  Inheriting this role  (Granted to Roles)",
      "indirect_role_count": "Number of roles that can access this database because of inherited roles",
      "indirect_role_count_for_schema": "Number of roles that can access this schema because of inherited roles",
      "last_login": "Last login date by this user",
      "mfa_enabled": "Specifies whether Duo Security is enabled for the user, which requires the user to use MFA (multi-factor authorization) for login.",
      "password_enabled": "Specifies whether a password was created for the user.",
      "role_count": "Number of roles that are granted privileges on this database directly",
      "role_count_for_schema": "Number of roles that are granted privileges on this schema directly",
      "rsa_enabled": "Specifies whether RSA public key used for key pair authentication has been set up for the user.",
      "schema_count": "Number of schemas in this database",
      "table_count": "Number of tables in this schema",
      "user_count": "Number of users granted this role",
      "database_grants": "Number of databases granted to this group",
      "user_type": "SCIM provisioning: is an automated method of provisioning users and groups to a cloud application using the SCIM protocol.<br /><br />Local provisioning: is a manual method of provisioning users and groups to a cloud application by creating and updating users and groups in the application's user interface.",
      "type": "Types of Users",
      "databricks_group_membership_info": "Group memberships require Workspace Admin or Account Admin access."
    },
    "emptyState": {
      "noData": "No Data Found",
      "noDatabaseAccess": "No access on any database for selected user",
      "noSchemaAccess": "No access on any schema for selected user"
    },
    "manage": {
      "ALERT": {
        "title": "Risk Alerts"
      },
      "ALL_GRANTED_ROLE": {
        "add": "Assign Role",
        "add_item_to": "Assign role(s) to {{name}}",
        "empty_list_sub_text": "To grant this role a user, click \"Grant\n  Role\".",
        "empty_list_text": "No roles inherits from",
        "empty_search_sub_text": "Try adjusting your search query to find what you're looking for. ",
        "empty_search_text": "No roles found",
        "empty_value": "Please choose a value.",
        "revoke_title": "Are you sure you want to revoke this role?",
        "search": "Search assigned roles",
        "search_item": "Select roles",
        "search_item_not_found": "No Role Found"
      },
      "ALL_GRANTED_TO_ROLE": {
        "add": "Assign Role",
        "add_item_to": "Add role(s) to {{name}}",
        "empty_list_sub_text": "To grant this role a role, click \"Grant\n  Role\".",
        "empty_list_text": "No roles inherited",
        "empty_search_sub_text": "Try adjusting your search query to find what you're looking for. ",
        "empty_search_text": "No roles found",
        "empty_value": "Please choose a value.",
        "revoke_title": "Are you sure you want to revoke this role?",
        "search": "Search Inherited by roles",
        "search_item": "Select roles",
        "search_item_not_found": "No Role Found"
      },
      "ROLE": {
        "add": "Assign Role",
        "add_item_to": "Assign Role(s) to {{name}}",
        "empty_list_sub_text": "To grant this role a user, click \"Grant\n  Role\".",
        "empty_list_text": "No roles assigned",
        "empty_search_sub_text": "Try adjusting your search query to find what you're looking for. ",
        "empty_search_text": "No roles found",
        "empty_value": "Please choose a value.",
        "revoke_title": "Are you sure you want to revoke this role?",
        "search": "Search assigned roles",
        "searchForSqlServer": "Search users",
        "search_item": "Search or select roles",
        "search_item_not_found": "No Role Found",
        "title": "Manage Role Membership"
      },
      "USER": {
        "add": "Add Membership",
        "add_item_to": "Add Membership(s) to {{name}}",
        "empty_list_sub_text": "To grant this role a user, click \"Add\n  Membership\".",
        "empty_list_text": "No users assigned",
        "empty_search_sub_text": "Try adjusting your search query to find what you're looking for. ",
        "empty_search_text": "No users found",
        "empty_value": "Please choose a value.",
        "revoke_title": "Are you sure you want to remove this user from this role?",
        "search": "Search assigned members",
        "search_item": "Search or select users",
        "search_item_not_found": "No User Found",
        "title": "Manage Membership",
        "titleForSqlServer": "Users Mapped to this Login"
      },
      "GROUP": {
        "add": "Assign Group",
        "add_item_to": "Assign Group(s) to {{name}}",
        "empty_list_sub_text": "To grant this group a user, click \"Assign Group\".",
        "empty_list_text": "No groups assigned",
        "empty_search_sub_text": "Try adjusting your search query to find what you're looking for. ",
        "empty_search_text": "No groups found",
        "empty_value": "Please choose a value.",
        "revoke_title": "Are you sure you want to remove this group from this user?",
        "search": "Search assigned groups",
        "search_item": "Search or select groups",
        "search_item_not_found": "No Group Found",
        "title": "Group Membership Details"
      }
    },
    "status": {
      "GRANTED": "Assigned",
      "GRANT_FAILED": "Assignment Failed",
      "GRANT_IN_PROGRESS": "Role Assignment in progress",
      "REVOKE_FAILED": "Revocation Failed",
      "REVOKE_IN_PROGRESS": "Revoking in progress"
    },
    "titles": {
      "granted_role_count": "Assigned Roles to role {{rolename}}",
      "granted_to_role_count": "Roles  Inheriting this role{{rolename}}",
      "user_count": "Assigned Users to role {{rolename}}"
    }
  },
  "accessPolicy": {
    "bulkImport": {
      "button": "Import policies",
      "title": "Import policies from CSV",
      "subtitle": "Create multiple row access and masking policies by uploading a CSV file.",
      "uploadTitle": "Upload CSV",
      "uploadHint": "Drag and drop your CSV file here",
      "browseFiles": "Browse files",
      "uploadConstraints": "CSV only · Maximum {{max}} rows",
      "downloadTemplate": "Download CSV template",
      "viewRequirements": "View CSV field requirements",
      "hideRequirements": "Hide CSV field requirements",
      "replaceFile": "Replace file",
      "checkingFile": "Checking file…",
      "readyToImport": "{{size}} · Ready to import",
      "submit_one": "Import {{count}} policy",
      "submit_other": "Import {{count}} policies",
      "startSuccess": "Policy import started.",
      "startError": "Could not start the policy import. Please try again.",
      "errors": {
        "unsupportedFileType": "Unsupported file. Upload a .csv file.",
        "fileTooLarge": "File is larger than {{max}}. Upload a smaller file.",
        "emptyFile": "This file is empty.",
        "headerOnly": "This file has no policy rows — only the header row was found.",
        "missingColumns": "Missing required columns: {{columns}}.",
        "tooManyRows": "This file has {{rows}} rows. Upload a maximum of {{max}} rows.",
        "unreadable": "This file could not be read. Upload a valid CSV file."
      },
      "summary": {
        "title": "Import summary",
        "policies": "Policies",
        "rowAccess": "Row access",
        "masking": "Masking",
        "unknownKind": "Unrecognised type",
        "targetDatabases": "Target databases",
        "moreDatabases": "+{{count}} more",
        "checksPassedTitle": "File structure checks passed",
        "checksPassedText": "Policy conflicts and target metadata are checked while the import runs."
      },
      "requirements": {
        "title": "CSV field requirements",
        "subtitle": "Friendly labels are shown first. CSV column names appear underneath.",
        "hide": "Hide CSV field requirements",
        "columnField": "Field",
        "columnRequired": "Required",
        "columnDescription": "Description"
      },
      "fields": {
        "policyKind": {
          "label": "Policy type",
          "required": "Yes",
          "description": "Row Access or Masking"
        },
        "database": {
          "label": "Source database",
          "required": "Yes",
          "description": "Database referenced by the policy"
        },
        "schema": {
          "label": "Schema",
          "required": "Yes",
          "description": "Target schema"
        },
        "entity": {
          "label": "Object",
          "required": "Yes",
          "description": "Table or View"
        },
        "column": {
          "label": "Column",
          "required": "Conditional",
          "description": "Required for masking policies"
        },
        "entityDomain": {
          "label": "Object type",
          "required": "Yes",
          "description": "TABLE, VIEW, or COLUMN"
        },
        "argColumns": {
          "label": "Argument columns",
          "required": "Depends",
          "description": "Columns used by the predicate"
        },
        "signature": {
          "label": "Policy signature",
          "required": "Depends",
          "description": "Function signature metadata"
        },
        "body": {
          "label": "Policy condition",
          "required": "Yes",
          "description": "SQL condition or predicate"
        },
        "returnType": {
          "label": "Return type",
          "required": "Depends",
          "description": "Function return type metadata"
        }
      },
      "guidelines": {
        "title": "Before you upload",
        "maxRows": "Maximum {{max}} policy rows per file",
        "supportedTypes": "Supports Row Access and Masking policies",
        "supportedObjects": "Supported objects: Tables, Views, and Columns",
        "noTagPolicies": "Tag-based policies are not currently supported",
        "existingPolicies": "Existing policies on the same target may cause individual rows to fail"
      },
      "results": {
        "title": "Import results",
        "completedAt": "Completed {{date}}",
        "processed": "Processed",
        "successful": "Successful",
        "failed": "Failed",
        "filterLabel": "Filter results by status",
        "filters": {
          "all": "All",
          "successful": "Successful",
          "failed": "Failed"
        },
        "rowStatus": {
          "queued": "Queued",
          "processing": "Processing"
        },
        "searchHint": "Search target, type, or error",
        "viewFailure": "View failure",
        "empty": "No policies match the current filter.",
        "loadError": "Could not load the import results. Please try again.",
        "columns": {
          "row": "Row",
          "policyKind": "Policy type",
          "target": "Target",
          "objectType": "Object type",
          "column": "Column",
          "status": "Status",
          "details": "Details"
        },
        "policyKind": {
          "rowAccess": "Row Access",
          "masking": "Masking"
        }
      },
      "failure": {
        "title": "Import row {{row}}",
        "subtitle": "Import result",
        "submittedValues": "Submitted values",
        "resolveHint": "Fix the source CSV, then start a new import. Successful rows do not need to be included again."
      },
      "banner": {
        "inProgressTitle": "Bulk policy import in progress",
        "completedTitle": "Bulk policy import completed",
        "viewResults": "View results",
        "partialTitle": "Bulk policy import completed with errors",
        "failedTitle": "Bulk policy import failed",
        "processed": "{{processed}} of {{total}} policies processed",
        "successful": "{{count}} successful",
        "failed": "{{count}} failed",
        "dismiss": "Dismiss import status"
      }
    },
    "3w": "Make sure the Schema Name value matches the schema name created in Redshift.",
    "syncMetadata": {
      "button": "Sync Metadata",
      "title": "Sync Project Metadata",
      "infoAlert": "Metadata synchronization updates catalogs, schemas, tables, and principals used for policy creation. This allows secure resource picking when building your access rules.",
      "projectLabel": "Project",
      "projectPlaceholder": "Select a project",
      "warnAlert": "Synchronizing high-volume catalogs may take up to a minute. You can safely close the dialog after starting; synchronization will continue in the background.",
      "cancel": "Cancel",
      "startSync": "Start Sync",
      "successMessage": "Metadata synchronization started. It will continue in the background.",
      "errorMessage": "Failed to start metadata synchronization. Please try again."
    },
    "accessControlsGrants": "Access Controls and Grants",
    "accountWithPoliciesError": "Remove all the underlying access policies to delete \"{{name}}\"",
    "choosePolicy": {
      "dataObject": {
        "description": "Provision access of  data objects like Database, Schema, Warehouse, Stream, Data Share, & Tags to Access Roles.",
        "title": "Role Based Access Control"
      },
      "dataView": {
        "description": "Enforce fine grained access controls on the data by filtering or masking the data by using User attributes and data attributes.",
        "title": "Attribute Based Access Control"
      },
      "title": "What type of policy would you like to create?"
    },
    "confirmationText": "Are you sure you want to cancel your changes?",
    "deployedPolicy": "Deployed Policy",
    "entitlements": {
      "joinPredicateHelpTextLine1": "Please ensure the database object names are fully qualified names, e.g.: <database name>.<schema_name>.<table_name>",
      "joinPredicateHelpTextLine2": "Grant select permissions to trustlogix roles and principal role on the mapping tables used in predicate."
    },
    "existingPolicyBody": "A policy named <strong> {{name}} </strong> with the same conditions already exists. <br /> You may cancel and choose different properties for a new policy, or click \"Edit Existing Policy\" to <br /> review or modify its conditions.",
    "existingPolicyLoaded": "The policy {{name}} has been loaded",
    "existingPolicyTitle": "Existing Policy Options",
    "externalDataTypeInfo": "Pre-configure External Schema and ensure the Trustlet user is granted usage on this schema.",
    "hintForDatabase": "Glue Catalog is the source of this metadata",
    "joinPredicateHelpText": "{{name}}",
    "noTableFound": "No tables/views found in glue for selected schema.",
    "placeholderForColumnPredicate": "Please choose columns to be used in predicate",
    "placeholderForColumnTitle": "Please choose column title",
    "placeholderForCondition": "Please choose condition",
    "placeholderForDatabase": "Please choose {{database}}",
    "placeholderForElementName": "Please choose element name",
    "placeholderForObjectPrivilege": "Please choose object privileges",
    "placeholderForObjectType": "Please choose object type",
    "placeholderForPolicyType": "Please choose policy type",
    "placeholderForRoleTemplate": "Please choose privilege template",
    "placeholderForSchema": "Please choose {{schema}}",
    "placeholderForSubRoleTemplate": "Please choose privilege sub template",
    "placeholderForTableName": "Please choose table name",
    "placeholderForTags": "Please choose tags",
    "predicateError": "Special characters ;: are not allowed in predicate query",
    "resources": "Secured Resources",
    "rowAccessPolicy": "Row Access Policy",
    "stepTwoInfo": "2. Choose condition(s):",
    "stepTwoInfoForShareGrant": "2. Choose share(s):",
    "stepTwoInfoForSingleTable": "2. Specify row and/or column level condition(s):",
    "partialDeployment": {
      "button": "View Failure Details",
      "deployButton": "Deploy Failed Grants",
      "bannerTitle": "Deployed with warnings",
      "bannerMessage": "This policy was deployed but encountered failures — some rules may not be enforced.",
      "dialogTitle_zero": "Failed Grant Statements",
      "dialogTitle_one": "{{count}} Failed Grant Statement",
      "dialogTitle_other": "{{count}} Failed Grant Statements",
      "link": "Click here to see failure details.",
      "tooltip": "The policy was deployed, but some grants failed."
    },
    "useDefineFunction": "Use Define Function (UDF) for Column Level Conditions: ",
    "autoDeployPolicyLabel": "Auto assign privileges to modified objects",
    "enableGrantsLabel": "Enable Grants on Future Objects",
    "tier": {
      "choosePolicyType": "Choose Policy Type",
      "chooseObjects": "Choose Objects",
      "choosePrivilege": "Choose Privilege"
    },
    "apps": "Apps",
    "selectApps": "Select apps",
    "autoDeployPolicyTitle": "All updated objects that are part of the classification will automatically be assigned privileges.",
    "noUdfAvailable": "No UDF available.",
    "discardDraft": {
      "confirmationTitle": "Discard Draft",
      "confirmationMessage": "Discarding the draft will revert the policy changes. Do you want to proceed?"
    }
  },
  "applications": {
    "AI_AGENT": {
      "pageTitle": "AI Agents",
      "createLabel": "Create AI Agent",
      "create": {
        "title": "Create New AI Agent",
        "successMessage": "AI Agent created successfully."
      },
      "edit": {
        "title": "Edit AI Agent",
        "successMessage": "AI Agent updated successfully."
      },
      "delete": {
        "confirmTitle": "Delete AI Agent",
        "successMessage": "AI Agent deleted successfully."
      },
      "form_labels": {
        "name": "Agent Name",
        "description": "Description",
        "status": "Agent Status",
        "statusInfo": "Only active agents can be targeted by new Access Policies."
      }
    },
    "APPLICATION": {
      "pageTitle": "Applications",
      "createLabel": "Create Application",
      "create": {
        "title": "Create New Application",
        "successMessage": "Application created successfully."
      },
      "edit": {
        "title": "Edit Application",
        "successMessage": "Application updated successfully."
      },
      "delete": {
        "confirmTitle": "Delete Application",
        "successMessage": "Application deleted successfully."
      },
      "form_labels": {
        "name": "Application Name",
        "description": "Description",
        "status": "Application Status",
        "statusInfo": "Only active applications can be targeted by new Access Policies."
      }
    }
  },
  "latestReleases": {
    "title": "What’s New in TrustLogix",
    "newBadge": "NEW",
    "majorReleaseBadge": "MAJOR RELEASE",
    "viewDetails": "View Details",
    "readMore": "Read More",
    "viewFullReleaseNotes": "View Full Release Notes",
    "ariaCollapseBanner": "Collapse banner",
    "ariaExpandBanner": "Expand banner",
    "ariaDismissNotification": "Dismiss notification"
  },
  "accessPolicyWizard": {
    "steps": {
      "basics": {
        "description": "Policy name and description",
        "sectionDescription": "This policy governs data and resource access when requested through the Application, {{applicationName}}.",
        "sectionDescriptionAiAgent": "This policy governs data and resource access when requested through the AI Agent, {{applicationName}}."
      },
      "resources": {
        "label": "Resource Selection",
        "description": "What this policy protects",
        "sectionDescription": "Choose the resources this policy will protect from unauthorized access."
      },
      "accessRules": {
        "label": "Policy Condition",
        "description": "Conditions for granting access",
        "sectionDescription": "Conditions and action to apply access control on resources.",
        "sectionDescriptionAiAgent": "Conditions ensuring the AI Agent validates all rules before granting access."
      },
      "responseContext": {
        "label": "Response Context",
        "description": "Extra context in the response",
        "sectionDescription": "Additional context information that will be added in policy response."
      },
      "review": {
        "sectionDescription": "Review the policy before saving it."
      }
    },
    "fields": {
      "description": "Description",
      "resourceSource": "Resource Source",
      "resources": "Resources",
      "value": "Value",
      "objectType": "Object Type",
      "actions": "Actions",
      "userAttributes": "Attributes (optional)",
      "resourceAttributes": "Attributes (optional)",
      "variable": "Variable",
      "attributeValue": "Value"
    },
    "resources": {
      "actionsTitle": "Actions allowed",
      "actionsDescription": "Specify the operations allowed (e.g., READ, WRITE) on the protected resource.",
      "objectTypeValueLabel": "{{objectType}} Value"
    },
    "accessRules": {
      "withFollowingConditions": "With the following conditions"
    },
    "responseContext": {
      "userAttributesTitle": "User Attributes",
      "resourceAttributesTitle": "Resource Attributes",
      "customAttributesTitle": "Custom Attributes",
      "addCustomAttributes": "Add Custom Attributes",
      "addAttribute": "Add Attribute"
    },
    "review": {
      "resources": "Resource Selection",
      "responseContext": "Response Context",
      "resourceSource": "Resource Source",
      "dataSource": "Data Source",
      "actionsAllowed": "Actions Allowed",
      "userAttributes": "User Attributes",
      "resourceAttributes": "Resource Attributes"
    },
    "preview": {
      "noResources": "No resources selected yet.",
      "noResponseContext": "No response context added yet."
    },
    "validation": {
      "invalidPolicyName": "Invalid Policy Name"
    },
    "deployMissingPolicy": "This policy could not be prepared for deployment because it was not saved. Go back and save it again.",
    "deployingMessage": "The access policy {{name}} is being deployed.",
    "freemiumTooltip": "Unlock Unlimited Access and Exclusive Features"
  },
  "resourceAccessPolicy": {
    "title": "Access Policies",
    "appliesTo": "Applies To",
    "policyNameHint": "Policy name can only use letters, numbers, underscore and no space. e.g.: “policy_name”"
  },
  "policyStatusMessages": {
    "POLICY_SAVED": "Policy is saved.",
    "POLICY_REVIEW_COMPLETED": "Policy is saved.",
    "POLICY_DEPLOYMENT_FAILED": "Policy is failed please check the detail under Status ellipsis.",
    "POLICY_FAILED": "Policy is failed please check the detail under Status ellipsis.",
    "POLICY_DEPLOYED": "Policy has been successfully deployed.",
    "POLICY_PARTIAL_DEPLOYED": "The policy was deployed, but some grants failed.",
    "POLICY_PUBLISHED": "Policy is in the process of being deployed.",
    "POLICY_DELETED": "Policy is in the process of being deleted."
  },
  "account": {
    "columns": {
      "name": "Data Source Name",
      "accessPolicy": "Access Policy",
      "monitoringPolicy": "Monitoring Policy",
      "dataRisk": "Data Risk"
    },
    "actions": {
      "configure": "Configure",
      "fixNow": "Fix now",
      "viewStatusDetails": "View status details for {{name}}"
    },
    "searchPlaceholder": "Search data sources by name",
    "deleteError": "Data Source Delete Error",
    "errorUpdateTitle": "Data Source Update Error",
    "updateTitle": "Data Source Update",
    "kpi": {
      "filteredBy": "Filtered by",
      "clearFilter": "Clear filter",
      "viewAll": "View All Data Sources",
      "label": {
        "favorites": "Favorites",
        "active": "Active",
        "missing": "Incomplete",
        "failed": "Failed"
      },
      "caption": {
        "favorites": "Your starred data sources"
      },
      "empty": {
        "favoritesTitle": "No favorites yet",
        "favoritesDescription": "Star a data source using the ★ in the first column to pin it here. Clear the filter to see all data sources.",
        "activeTitle": "No active data sources",
        "activeDescription": "No data sources are currently active. Clear the filter to see all data sources.",
        "missingTitle": "No incomplete data sources",
        "missingDescription": "Every data source has complete connection details. Clear the filter to see all data sources.",
        "failedTitle": "No failed data sources",
        "failedDescription": "No data sources have failed to connect. Clear the filter to see all data sources."
      }
    }
  },
  "favorites": {
    "columnHeader": "Favorite",
    "add": "Add {{name}} to favorites",
    "remove": "Remove {{name}} from favorites",
    "saveError": "Couldn't save your favorite. Please try again.",
    "unavailable": "Favorites are currently unavailable"
  },
  "adminSensitiveData": {
    "actionFail": "Fail",
    "actionStatus": "Action Status",
    "actionSuccess": "Success"
  },
  "alertFrequency": {
    "Each violation": "For Every Occurrence",
    "First violation": "Only First Occurrence",
    "after": "After",
    "occurrences": "Occurrences"
  },
  "alerts": {
    "descriptions": {
      "accountName": "account name ",
      "actionname": "the query action performed by the user",
      "application": "the application name being used to perform the action.",
      "classification": "the classification(PII,PHI, PCI etc) of the selected resource (table, schema, db etc)",
      "dataSourceName": "data source name",
      "detectedon": "the date on which this alert was triggered",
      "ipAddress": "the Ip address used by the user/client app.",
      "objectName": "the name of resource under observation.",
      "occurredOn": "date on which the activity/action was performed.",
      "username": "user who performed the activity/action.",
      "createMaskingPolicyDescription": "The alert will be dismissed once the policy has been deployed."
    },
    "severity": {
      "0": "Critical",
      "1": "High",
      "2": "Medium",
      "3": "Low",
      "4": "Informational"
    },
    "snowflake": {
      "targetname": "the name of the target resource"
    },
    "title": "Alerts may use variables by substituting tokens from the list provided below:",
    "dismissReasonLabel": "Enter your reason (optional)",
    "suppressAlert": {
      "title": "Suppress Alert",
      "description": "Are you sure you want to suppress this alert for the <strong>{{policyName}}</strong> for the next <strong>{{duration}}</strong>?",
      "durationLabel": "Duration",
      "suppressAlertSuccess": "Alert suppression rule applied successfully.",
      "warning": "This action will also dismiss this alert."
    },
    "modals": {
      "viewPolicyTitle": "View Policy",
      "rawAuditRecordTitle": "Raw Audit Record",
      "noDataAvailable": "No Data Available"
    }
  },
  "dataRisks": {
    "noRisksFound": "No data risks found.",
    "categories": {
      "shadow_it": "Shadow IT",
      "overly_granted_access": "Overly Granted Access",
      "dark_data": "Dark Data",
      "regulatory_compliance": "Regulatory Compliance",
      "security_misconfigurations": "Misconfigurations",
      "data_exfiltration": "Data Exfiltration",
      "privacy_compliance": "Privacy Compliance"
    },
    "dismissAll": "Dismiss All",
    "columns": {
      "risk": "Risk",
      "severity": "Severity",
      "riskCategory": "Risk Category",
      "dataSource": "Data Source",
      "triggeredBy": "Triggered By",
      "triggeredOn": "Triggered On",
      "riskControl": "Risk Control",
      "remediation": "Remediation",
      "riskDetails": "Risk Details"
    },
    "drawer": {
      "title": "Risk Details",
      "actionsMenu": "Risk actions",
      "previous": "Previous risk",
      "next": "Next risk",
      "dismissed": "Dismissed",
      "errorRemediationDetails": "Error & Remediation Details",
      "tabs": {
        "overview": "Overview",
        "policy": "Triggering Policy",
        "evidence": "Raw Audit Record"
      },
      "sections": {
        "details": "Risk Details",
        "recommendation": "Recommendation",
        "context": "Context",
        "dismissal": "Dismissal",
        "ticket": "Ticket"
      },
      "fields": {
        "dataSource": "Data Source",
        "riskControl": "Risk Control",
        "occurredOn": "Occurred On",
        "detectedOn": "Detected On",
        "policyDescription": "Policy Description",
        "object": "Object",
        "target": "Target",
        "user": "User",
        "role": "Role",
        "resource": "Resource",
        "ipAddress": "IP Address",
        "eventName": "Event",
        "workspace": "Workspace"
      }
    }
  },
  "applicationDetails": {
    "accessAnalyzer": "Access Analyzer",
    "accessPolicyMenu": "Access Policies",
    "dataRisks": "Data Risks",
    "dataSprawl": "Data Sprawl",
    "domainPolicy": "Domain Policies",
    "health": "Health",
    "kriMenu": "Activity Reports",
    "monitoringMenu": "Monitoring Policies",
    "overview": "Overview",
    "privacyPolicyMenu": "Privacy Policies",
    "recommendationMenu": "Recommendations",
    "info": {
      "overview": "The data and metrics shown on the Overview page are applicable across all workspaces within this data source."
    }
  },
  "auditHistory": {
    "CREATE_DATA_ACCESS_POLICY": "Create",
    "DELETE_DATA_ACCESS_POLICY": "Delete",
    "DEPLOY_DATA_ACCESS_POLICY": "Deploy",
    "DISABLING_DATA_ACCESS_POLICY": "Disable",
    "PUBLISH_DATA_ACCESS_POLICY": "Publish",
    "UPDATE_DATA_ACCESS_POLICY": "Update",
    "REVIEW_DELTA_DATA_ACCESS_POLICY": "Delta Deploy",
    "UPDATE_USER_ATTRIBUTE_VALUE": "Update",
    "UPDATE_USER_ATTRIBUTE_VALUE_BY_PARENT": "Update",
    "CREATE_USER_ATTRIBUTE_VALUE": "Create",
    "CREATE_USER_ATTRIBUTE_VALUE_BY_PARENT": "Create",
    "DELETE_USER_ATTRIBUTE_VALUE": "Delete",
    "DELETE_USER_ATTRIBUTE_VALUE_BY_PARENT": "Delete",
    "REVIEW_DATA_ACCESS_POLICY": "Review",
    "SYNC_DATA_ACCESS_POLICY": "Sync",
    "USER_ATTRIBUTE_VALUE_COPY_SOURCE": "Copy from existing",
    "CREATE_USER_ATTRIBUTE_VALUE_BY_COPY": "Create from existing",
    "UPDATE_USER_ATTRIBUTE_VALUE_BY_COPY": "Update from existing"
  },
  "aurora": {
    "RLS Policy": "Row Filter",
    "Schema (All-Tables)": "Schema (All-Tables)",
    "Schema (Multi-Table)": "Schema (Multi-Table)",
    "Single-Table": "Row Access and Column Grants"
  },
  "authenticationSecurity": {
    "attempts": "Authentication attempts",
    "attemptsInfo": "Specify number of authentication attempts allowed before user is locked out.",
    "error": "$t(authenticationSecurity.title)  Error",
    "lockoutTime": "Lockout time",
    "lockoutTimeInfo": "Specify duration user will be locked out after unsuccessful attempts.",
    "loginId": "Login ID:",
    "password": "Password:",
    "success": "$t(authenticationSecurity.title)  Success",
    "title": "Session Details",
    "trustletCredentials": "Trustlet Credentials",
    "syncUserCredentials": "Sync User Credentials"
  },
  "administration": {
    "title": "Settings",
    "description": "Manage tenant configuration, integrations, attributes, users, and security settings.",
    "searchPlaceholder": "Search settings",
    "noResultsTitle": "No settings found",
    "noResultsDescription": "Try a different search term.",
    "noCapabilitiesTitle": "No settings available",
    "noCapabilitiesDescription": "You don't have access to any settings.",
    "sections": {
      "configuration": "Configuration",
      "aiPolicyEnforcement": "AI Policy Enforcement",
      "integrationsAttributes": "Integrations & Attributes",
      "usersSecurity": "Users & Security",
      "internalOperations": "Internal Operations"
    },
    "capabilities": {
      "tenantSettings": {
        "title": "Tenant Settings",
        "description": "Manage tenant-level preferences and feature settings."
      },
      "dataSourceSettings": {
        "title": "Data Source Settings",
        "description": "Manage privilege templates and user defined functions for data sources."
      },
      "privilegeTemplateManagement": {
        "title": "Privilege Template Management",
        "description": "Manage privilege template mappings used for access policies."
      },
      "userDefinedFunctions": {
        "title": "User Defined Functions",
        "description": "Manage system and custom user defined functions."
      },
      "utilityScripts": {
        "title": "Utility Scripts",
        "description": "Manage scripts used in CI/CD policy-governance pipelines."
      },
      "onPremMetadata": {
        "title": "OnPrem Metadata",
        "description": "Review authorized service users and host information for database access."
      },
      "integrations": {
        "title": "Integrations",
        "description": "Configure and manage external integrations."
      },
      "attributeManagement": {
        "title": "Attribute Management",
        "description": "Manage attributes, attribute values, and source configurations."
      },
      "userManagement": {
        "title": "User Management",
        "description": "Manage users, roles, and administrative access."
      },
      "authenticationSecurity": {
        "title": "Authentication Security",
        "description": "Manage session lockout rules and service-user credentials."
      },
      "tenantActivation": {
        "title": "Tenant Activation",
        "description": "Manage tenant activation and feature availability."
      },
      "riskThreshold": {
        "title": "Risk Configuration",
        "description": "Manage Risk Threshold",
        "pageSubtitle": "Define risk score thresholds to monitor, control, and trigger governance actions.",
        "riskLevelsTitle": "Risk Levels",
        "riskLevelsSubtitle": "Define the score ranges for each risk level zone.",
        "thresholdAriaLabel": "Blocked risk threshold",
        "thresholdInfo": "Only values below <strong>{{threshold}}</strong> are allowed — anything above will be automatically blocked.",
        "saveSuccess": "Risk threshold configuration saved successfully.",
        "saveError": "Unable to save risk threshold configuration."
      },
      "aiPolicyEnforcement": {
        "title": "MCP Access Gateway",
        "description": "Configure the gateway used to route and enforce access policies for MCP traffic."
      },
      "oauthClientProfiles": {
        "title": "OAuth Client Profiles",
        "description": "Manage the OAuth client identities TrustLogix uses when connecting to MCP services."
      }
    }
  },
  "integrationsPage": {
    "searchPlaceholder": "Search integrations",
    "emptyTitle": "No integrations found",
    "emptyDescription": "Try a different search term.",
    "editIntegration": "Edit {{name}}",
    "addIntegration": "Integrate {{name}}"
  },
  "changePassword": {
    "confirmNewPassword": "Confirm New Password",
    "currentPassword": "Current Password",
    "error": "$t(changePassword.title) Error",
    "newPassword": "New Password",
    "success": "Password Changed Successfully",
    "title": "Change Password"
  },
  "principalView": {
    "noPrincipals": "No principals assigned.",
    "type": {
      "servicePrincipal": "Service Principals",
      "user": "Users",
      "group": "Group Names",
      "role": "Roles",
      "databaseRoles": "Database Roles",
      "accountRoles": "Account Roles",
      "shares": "Shares"
    }
  },
  "multiSelectTabs": {
    "rightPanelTitle": "Assigned items",
    "assignedShares": "Assigned Shares",
    "assignedPrincipals": "Assigned Principals",
    "search": "Search",
    "selectAll": "Select All",
    "emptySearchMessage": "No search results found",
    "emptySearchDescription": "Try adjusting your search or choose from the list above.",
    "emptyAssignedMessage": "No items added yet.",
    "emptyAssignedDescription": "Choose from {{tabTitles}} on the left to define who should receive access.",
    "addCustom": "Add custom",
    "customItemInvalidFormat": "Only letters, numbers, underscore, hyphen and dot are allowed.",
    "loading": "Loading…",
    "remove": "Remove"
  },
  "common": {
    "trustlogix": "TrustLogix",
    "removeItemAriaLabel": "Remove {{name}}",
    "removeRowAriaLabel": "Remove row",
    "moreActions": "More actions",
    "All-Table": "All-Table",
    "Classified-Data": "Classified-Data",
    "Column Masking Policy": "Mask Column",
    "Data Product Access": "Data Product Access",
    "External Schema (All-Tables)": "External Schema (All-Tables)",
    "Multi-Table": "Multi-Table",
    "RLS Policy": "Row Filter",
    "Resource Policy": "Resource Access",
    "Role Template": "Privilege Template",
    "Row Filter": "Row Access",
    "Schema (All-Tables)": "Schema (All-Tables)",
    "Schema (Multi-Table)": "Schema (Multi-Table)",
    "Single-Table": "Single-Table",
    "Tag": "Tag",
    "ViewRemediation&Error": "View Remediation & Error",
    "alert": "Alert",
    "alert_plural": "Alerts",
    "auroraColumns": "COLUMN(S)",
    "blockPublicAccess": "Block Public Access",
    "businessEmail": "Business Email Address",
    "cancel": "Cancel",
    "classificationType": "Classification Type",
    "close": "Close",
    "cloudAccountName": "Data Source Name",
    "columnName": "Column Name",
    "configurations": "Configurations",
    "copiedToClipboard": "Copied to clipboard",
    "copyFailed": "Could not copy to clipboard",
    "count": "Count",
    "createMaskingPolicy": "Create Masking Policy",
    "createPolicy": "Create policy",
    "createRoleAnddatabaseAndSchemaGrants": "Create role, $t(common.databaseAndSchemaGrants)",
    "dataNofFound": "Data not found",
    "dataPlatform": "Data Platform",
    "dataProduct": "Data Product",
    "databaseAndSchemaGrants": "Database and $t(common.schemaGrants)",
    "databaseGrants": "Database Grants",
    "databaseName": "Database Name",
    "databaseNames": "Database Names",
    "datasourceName": "DataSource Name",
    "datasourceNames": "Data Source Names",
    "delete": "Delete",
    "deletePolicy": "$t(common.delete) Policy",
    "description": "Description",
    "discardChanges": {
      "title": "Discard unsaved changes?",
      "message": "You have unsaved changes. If you leave now, your changes will be lost.",
      "keepEditing": "Keep editing",
      "discard": "Discard changes"
    },
    "disableUser": "Disable User",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "refresh": "Refresh",
    "edit": "Edit",
    "editExistingPolicy": "Edit Existing Policy",
    "email": "Email Address",
    "errorCaptcha": "Invalid Verification Token, Please make sure that your have access to https://www.google.com and try again",
    "enforcementType": "Enforcement Type",
    "exceptColumns": "EXCEPT COLUMN(S)",
    "failedLoginAttempts": "Failed login attempts",
    "filteredBy": "Filter By",
    "formRequired": "(All fields are required unless specified optional)",
    "formWorkspacePrivilegeTemplateInfo": "To manage the workspace, please ensure that the service principal is assigned the Account Admin role.",
    "fullName": "Full Name",
    "glueDatasourceName": "Glue Database Name",
    "groupUserTableSchemaGrants": "Group User Table Schema Grants",
    "lastUpdatedBy": "Last Updated By",
    "lastUpdatedOn": "Last Updated On",
    "loginId": "LoginID",
    "maskColumns": "MASK COLUMN(S)",
    "maskingPattern": "Masking Pattern",
    "mismatchErrorForAssumeRole": "Not recognized due to incorrect format. Use path elements in the example provided below.",
    "name": "Name",
    "value": "Value",
    "name_value": "Name/Value",
    "new": "New",
    "next": "Next",
    "no": "No",
    "notAvailable": "Not Available",
    "objectGrants": "Object Grants",
    "modelName": "Model Name",
    "objectName": "Object Name",
    "objectNameLowercase": "object name",
    "objectNames": "Object Names",
    "objectNamesLowercase": "object names",
    "objectPrivileges": "object Privileges",
    "objectType": "Object Type",
    "optional": "(optional)",
    "orgName": "Organization Name",
    "percentage": "Percentage",
    "phone": "Phone Number",
    "policyDescription": "Policy $t(common.description)",
    "policyInfo": "Policy Info",
    "policyName": "Policy Name",
    "policyType": "Policy Type",
    "policyView": "Policy View",
    "premiumFeatureTitle": "This is premium feature. Please contact TrustLogix at sales@trustlogix.io.",
    "principalTypeAndConditions": "Principal Type and Conditions",
    "revokeRole": "Revoke Role",
    "project": "Project",
    "roleName": "Role Name",
    "roleTemplate": "Privilege Template",
    "roleTemplateHelpText": "Choose a <0> Template </0> to grant predefined privileges on resources contained in below selected schema.",
    "roleTemplateWithIcon": "Privilege Template <icon>",
    "search": "Search",
    "searchPlaceholder": "Search by keywords on the current page...",
    "save": "Save",
    "saveChanges": "Save Changes",
    "schemaGrants": "Schema Grants",
    "schemaName": "Schema Name",
    "severity": "Severity",
    "signUp": "SIGN UP",
    "startMonitoring": "Start monitoring data",
    "status": "Status",
    "subRoleTemplate": "Privilege Sub Template",
    "subRoleTemplateHelpText": "Choose a <0> Sub Template </0> to grant predefined privileges on resources.",
    "successfulLoginAttempts": "Successful login attempts",
    "tableGrants": "Table Grants",
    "tableName": "Table Name",
    "tableNames": "Table Names",
    "tag": "Tag",
    "tagKey": "Tag Key",
    "tagName": "Tag Name",
    "tagValue": "Tag Value",
    "tags": "Tags",
    "targetOutputPath": "Target Output Path",
    "tenant_root_user": "TENANT_ROOT_USER",
    "textCopied": "{{text}} copied",
    "togglePasswordVisibility": "toggle password visibility",
    "update": "Update",
    "updatePolicy": "Edit policy",
    "viewBucketPolicies": "View Bucket Settings",
    "viewDescription": "View Description",
    "viewDetails": {
      "DATABASE": "View Database Access",
      "ROLE": "View Role Access",
      "USER": "View User Access"
    },
    "viewName": "View Name",
    "viewUserDetails": "View User details",
    "database": "Database",
    "schema": "Schema",
    "column": "Column",
    "semanticModels": "Semantic Models",
    "workspaceName": "Workspace Name",
    "workspace": "Workspace",
    "yes": "Yes",
    "noTagsFoundErrorMessage": "No tags found. Please visit the Tag Management page to add or associate tags.",
    "allowlistGroups": "Groups",
    "databricksWorkspaceAttributesInfoWithoutAccountId": "Databricks workspace users, groups and service principals are displayed here from the configured workspaces as the account information is missing in the data source configuration.",
    "databricksWorkspaceAttributesInfo": "Databricks account users, groups and service principals across the configured workspaces are displayed here.",
    "databricksWorkspaceAttributesInfoWithoutAccountIdMonitoring": "Databricks workspace users and service principals are displayed here from the configured workspaces as the account information is missing in the data source configuration.",
    "databricksWorkspaceAttributesInfoMonitoring": "Databricks account users and service principals across the configured workspaces are displayed here.",
    "operators": {
      "contains": "Contains",
      "equals": "Equals",
      "greaterThan": "Greater Than",
      "lessThan": "Less Than",
      "startsWith": "Starts With",
      "endsWith": "Ends With",
      "notEquals": "Not Equals",
      "notContains": "Not Contains",
      "in": "In",
      "isInSession": "Is in session",
      "notIn": "Not In"
    },
    "back": "Back",
    "done": "Done",
    "continue": "Continue"
  },
  "configureAssumeRole": {
    "connectionTitle": "Connection Details : ",
    "glueTitle": "Glue Catalog Assume Role :",
    "prerequisite": "Prerequisite: "
  },
  "configureMySql": {
    "MemberAwsAccountId": "Member AWS Account ID",
    "auditLogLocation": "Audit Log Location",
    "cloudTrailAccountId": "CloudTrail Account ID",
    "cloudTrailLocation": "CloudTrail Location",
    "cloudTrailRegion": "CloudTrail Region",
    "informationTextForRegion": "Provide AWS region you want to monitor",
    "toolTipExForAssumeRole": "e.g.: arn:aws:iam::<accountid>:role/<role-name>",
    "toolTipTextForAssumeRole": "Create an IAM assume role in the member AWS account",
    "toolTipTextForAwsAcctIdForS3": "Provide an Account ID of the member account in your Organization. TrustLogix will monitor activity on the buckets in this account",
    "toolTipTextForExternalId": "Attach External Id to Trust relationships of the IAM assume role"
  },
  "configureAmazonS3": {
    "MemberAwsAccountId": "Member AWS Account ID",
    "auditLogLocation": "Audit Log Location",
    "cloudTrailAccountId": "CloudTrail Account ID",
    "cloudTrailLocation": "CloudTrail Location",
    "cloudTrailRegion": "CloudTrail Region",
    "informationTextForRegion": "Provide AWS region you want to monitor",
    "toolTipExForAssumeRole": "e.g.: arn:aws:iam::<accountid>:role/<role-name>",
    "toolTipTextForAssumeRole": "Create an IAM assume role in the member AWS account",
    "toolTipTextForAwsAcctIdForS3": "Provide an Account ID of the member account in your Organization. TrustLogix will monitor activity on the buckets in this account",
    "toolTipTextForExternalId": "Attach External Id to Trust relationships of the IAM assume role"
  },
  "copyToClipboard": {
    "title": "Copy to Clipboard"
  },
  "dashboard": {
    "access_control_polices": "Access Control Policies",
    "access_data": "Specify requirements to control who accesses your data.  ",
    "allSensitiveObjectsProtected": " Great job! All sensitive objects are protected with policies.",
    "monitor_policies": "Monitoring Policies",
    "monitor_sensitive": "Start monitoring your data and create alerts to protect sensitive objects.",
    "noAccessPolicyFound": "No access policies found",
    "noAlerts": "No current alerts",
    "noOverlyGrandPolicyFound": "No overly granted policies",
    "noPrivilegedFound": "No privileged role assignments found",
    "noRoleFound": "No role assignments found",
    "noSensitiveObjectFound": "No sensitive objects found",
    "objectsWithPolices": "Objects without policies",
    "review_role": "Review role assignments and identify overly granted roles.",
    "sensitiveObjects": "Sensitive Objects",
    "userWithOverlyGrantedRole": " Users with overly granted roles",
    "user_and_role": "Users and Roles"
  },
  "dataAccess": {
    "datasourcePolicyName": "Data Source Policy Name",
    "redeployRequired": "You need to re-deploy this policy, changes were made in Privilege Template",
    "placeholders": {
      "policyType": "Please choose policy type",
      "roleName": "Please choose role name",
      "shareName": "Please choose share name"
    }
  },
  "dataClassification": {
    "s3Tagging": "Classification is defined using S3 <0>Tags</0>",
    "snowflakeTagging": " Classification is defined using Snowflake Object <0>Tagging</0>"
  },
  "dataMovement": {
    "showingDate_one": "Showing last {{count}} day",
    "showingDate_other": "Showing last {{count}} days"
  },
  "dateTime": {
    "min": "min"
  },
  "policyWizard": {
    "validationWarning": {
      "title": "Validation Warning",
      "confirmPrompt": "Do you want to continue?",
      "blockedTooltip": "Resolve the validation warnings, or go back to a previous step and make changes, before continuing."
    },
    "createTitle": "Create Policy",
    "editTitle": "Edit Policy",
    "save": "Save",
    "deploy": "Deploy",
    "deployLater": "Deploy Later",
    "draftLoadError": "Could not load the saved draft. Showing the deployed policy instead — saving now will overwrite the draft.",
    "close": "Close",
    "switchToClassic": "Switch to classic form",
    "switchToWizard": "Try the new wizard",
    "banner": {
      "promoBadge": "NEW UI V2",
      "promoTitle": "Welcome to the New Policy Wizard",
      "promoDescription": "We've streamlined the creation layout into steps. You can temporarily fall back to the old layout at any time if needed.",
      "legacyBadge": "Legacy Layout",
      "legacyTitle": "Viewing Classic Single-Page Form",
      "legacyDescription": "This classic view is being retired. Going forward, new access policies will be created using the new wizard experience.",
      "minimize": "Minimize",
      "expand": "Show details"
    },
    "savedReadyToDeploy": "Your policy has been saved and is ready to be deployed.",
    "deployedPolicyWarning": {
      "title": "Warning",
      "continue": "Continue",
      "cancel": "Cancel",
      "saved": "Saved",
      "statePrefix": "Clicking",
      "stateMiddle": "will change the policy state to",
      "stateSuffix": ", this will not impact the enforcement of the currently deployed policy.",
      "deployLater": "The new policy won't take effect until it's Deployed."
    },
    "steps": {
      "basics": {
        "label": "Basics",
        "description": "Policy name and type",
        "sectionDescription": "Define the policy name, type, and basic settings."
      },
      "dataRules": {
        "label": "Data Rules",
        "description": "Define masking and column rules",
        "sectionDescription": "Configure the data conditions this policy applies to.",
        "infoMessage": {
          "10": "Access to the data will be restricted to the users who fulfill the conditions outlined in **Policy Builder Step**",
          "12": "The data will be masked for everyone except for the users who meet the conditions in **Policy Builder Step**"
        },
        "resourceScope": {
          "label": "Policy Scope",
          "description": "What this policy applies to",
          "sectionDescription": "Define what this policy applies to."
        }
      },
      "policyBuilder": {
        "label": "Policy Builder",
        "description": "Conditions and principals",
        "sectionDescription": "Build the conditions and define who this policy applies to.",
        "roleAssignment": {
          "label": "Role Assignment",
          "description": "Assign roles to grant access",
          "sectionDescription": "Assign the roles that should be granted access to the selected objects."
        },
        "accessRules": {
          "label": "Access Rules",
          "description": "Who can access the content",
          "sectionDescription": "Define who can access the content in scope, and under what conditions."
        }
      },
      "review": {
        "label": "Review",
        "description": "Confirm all settings",
        "sectionDescription": "Review all settings before saving."
      },
      "deploying": {
        "label": "Deploy",
        "description": "Validate and publish policy",
        "sectionDescription": "Validating and preparing the policy for deployment."
      }
    },
    "fields": {
      "name": "Name",
      "description": "Short Description",
      "policyType": "Policy Type",
      "policySubtype": "Condition",
      "maskingType": "Masking Type",
      "tables": "Tables",
      "columns": "Columns",
      "tags": "Tags",
      "workspace": "Workspace",
      "dataSource": "Data Source",
      "schemas": "Schemas",
      "views": "Views",
      "functions": "Functions",
      "apps": "Apps"
    },
    "resourceScope": {
      "scopeTypeLabel": "Scope Type",
      "tagsErrorTitle": "Sensitivity Labels Error",
      "scopeType": {
        "groupLabel": "Scope Type",
        "available": "Available",
        "comingSoon": "Coming soon",
        "sensitivityLabels": {
          "title": "Sensitivity Labels",
          "description": "Include content dynamically based on its Microsoft Purview sensitivity labels."
        },
        "sharePointResources": {
          "title": "Specific SharePoint Resources",
          "description": "Choose specific SharePoint sites, document libraries, folders, or files."
        }
      },
      "sensitivityLabels": {
        "title": "Sensitivity Labels",
        "label": "Choose sensitivity labels",
        "hint": "Content carrying any of the selected labels is governed by this policy."
      }
    },
    "review": {
      "policyDetails": "Policy Details",
      "dataRules": "Data Rules",
      "targets": "Targets",
      "masking": "Masking",
      "conditions": "Conditions",
      "principals": "Principals",
      "conditionsPrefix": "Access is granted if",
      "principalsPrefix": "Grant access to",
      "principalsPrefixRole": "Grant access to ",
      "referencedColumns": "Referenced Columns",
      "noConditions": "No conditions defined.",
      "matchWith": {
        "CONSTANT": "Constant Value",
        "VALUE": "Value",
        "USER_ATTRIBUTE": "User Attribute",
        "AGENT_ATTRIBUTE": "Agent Attribute",
        "RESOURCE_ATTRIBUTE": "Resource Attribute",
        "FUNCTION": "System or Custom Function",
        "CUSTOM_EXPRESSION": "Custom Expression",
        "COLUMN_TAGGED_AS": "Column Tagged As",
        "SESSION_ATTRIBUTE": "Session Attribute",
        "DATA_ATTRIBUTE": "Column Name",
        "REQUEST_ATTRIBUTE": "Request Attribute"
      },
      "attributeCategory": {
        "USER": "User Attribute",
        "AGENT": "Agent Attribute",
        "RESOURCE": "Resource Attribute",
        "FUNCTION": "Function",
        "CUSTOM_EXPRESSION": "Custom Expression",
        "COLUMN_TAGGED_AS": "Column Tagged As"
      },
      "operatorLabel": {
        "equals": "is equal to",
        "not_equals": "is not equal to",
        "in": "is in",
        "not_in": "is not in",
        "contains": "contains",
        "unknown": "—"
      },
      "policyDataType": "Data Type",
      "objectType": "Object Type",
      "roleTemplate": "Privilege Template",
      "privileges": "Privileges",
      "objects": "Objects"
    },
    "preview": {
      "title": "Live Preview",
      "noDataRules": "No data rules defined yet.",
      "noTargets": "No targets selected yet.",
      "reviewNote": "Review everything above before saving."
    },
    "deploying": {
      "includeViewAccessGrants": "Deploy view grants for the principals defined within the conditions",
      "stages": {
        "validating": "Validating policy conditions",
        "generatingGrants": "Generating grants",
        "impactedPolicies": "Checking for impacted policies"
      }
    },
    "visualizer": {
      "title": "Policy Impact Visualizer",
      "subtitle": "How data transforms for a targeted user role",
      "appliedRuleLogic": "Applied Rule Logic",
      "tableTitle": "Dataset Preview (Analytics_Table)",
      "tableRole": "Role: Finance Analyst",
      "columns": {
        "userId": "User ID",
        "region": "Region",
        "salary": "Salary ($)",
        "email": "Email Account"
      },
      "masking": {
        "headline": "Simulated Data Masking Active",
        "description": "Sensitive data columns are automatically intercepted at query-time. Columns containing Credit Card or SSNs are masked into anonymized formats, while harmless data remains visible."
      },
      "row": {
        "headline": "Simulated Row Access Control Active",
        "description": "Filters rows dynamically based on identity attributes. Non-matching rows are completely omitted from query results."
      },
      "object": {
        "headline": "Simulated Object Access Block Active",
        "description": "Entire warehouse tables or cloud buckets are blocked. Any unauthorized access attempt triggers an access-denied state."
      },
      "resource": {
        "headline": "Simulated Sensitivity-Based Access Active",
        "description": "Content is included by its Microsoft Purview sensitivity label, not by its location. Documents carrying a governed label are blocked for users who do not meet the conditions, while everything else stays untouched — including content labelled after the policy is deployed.",
        "labels": {
          "highlyConfidential": "Highly Confidential",
          "confidential": "Confidential",
          "internal": "Internal"
        }
      },
      "contentTitle": "Content Preview (Finance SharePoint Site)",
      "contentRole": "Role: External Contractor",
      "states": {
        "blocked": "Blocked",
        "visible": "Visible"
      }
    },
    "helpMeChoose": {
      "title": "What are you looking to protect?",
      "subtitle": "We'll recommend the right policy type.",
      "selected": "{{type}} selected",
      "options": {
        "masking": {
          "title": "Specific sensitive columns",
          "subtitle": "Hide SSNs, passwords, credit card numbers"
        },
        "row": {
          "title": "Entire records or rows",
          "subtitle": "Limit data by region, tenant, or manager"
        },
        "object": {
          "title": "Entire tables, views, or buckets",
          "subtitle": "Baseline database or file permissions"
        },
        "dataProduct": {
          "title": "Published data products",
          "subtitle": "Governed tables and views shared across a data domain"
        },
        "resource": {
          "title": "Documents and files by sensitivity",
          "subtitle": "SharePoint content labelled Confidential, Internal, and similar"
        }
      }
    }
  },
  "domainPolicy": {
    "table": {
      "title": "Domain Policies",
      "policyName": "Policy Name",
      "dataDomain": "Data Domain",
      "dataProducts": "Data Products",
      "policyType": "Policy Type"
    },
    "removeRuleAriaLabel": "Remove rule",
    "deleteConditionAriaLabel": "Delete condition",
    "enableRiskBasedAccess": {
      "title": "Enable Risk based access",
      "description": "Inject adaptive guardrails into this specific row access policy"
    },
    "policyPreview": {
      "10": {
        "columns": "Filter rows from object names <0></0>",
        "columnsDefault": "Filter rows from object names ...",
        "tags": "Filter rows from object tagged as <0></0>"
      },
      "12": {
        "columns": "Mask columns <0></0> with masking pattern {{maskingType}}",
        "columnsDefault": "Mask columns tagged as...",
        "tags": "Mask columns tagged as <0></0> with masking pattern {{maskingType}}"
      },
      "columns": "Mask columns <0></0> with masking pattern {{maskingType}}",
      "columnsDefault": "Mask columns tagged as...",
      "conditions": "For <strong>{{users}}</strong> <br/>",
      "customSqlRules": "with custom SQL provided",
      "rules": "{holder} {attribute} {operation} {value_holder} {value}",
      "tags": "Mask columns tagged as <0></0> with masking pattern {{maskingType}}"
    },
    "reviewPolicy": {
      "columns": "Columns Names <0></0> with masking pattern {{maskingType}}",
      "conditions": "For <strong>{{users}}</strong> where ",
      "rules": "<strong>{attribute}</strong> {operation} <strong>{value}</strong>",
      "tags": "Mask columns tagged as <0></0> with masking pattern {{maskingType}}"
    },
    "rowAccessPolicyPreview": {
      "columns": "Allow Rows from objects classified as <strong>{{tag}}</strong> in <strong>{{datasource}}</strong> to users with following conditions"
    }
  },
  "error404": {
    "401": {
      "401": {
        "heading": "Unauthorized Access",
        "subHeading": "You do not have permission to view this page. Please contact your administrator if you believe this is an error."
      }
    },
    "404": {
      "404": {
        "heading": "Oops.. Something went wrong.",
        "subHeading": "The requested page could not be found. Please check the URL."
      }
    },
    "AccessAnalyzer": {
      "PROCESSING_COMPLETED": {
        "heading": "Processing Completed, No Data",
        "subHeading": "Nothing to see here! We could not find database objects to analyze the access. Please contact your data source administrator. If you need further assistance please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a>."
      },
      "PROCESSING_FAILED": {
        "heading": "Processing Failed",
        "subHeading": "Oops.. Something went terribly wrong. TrustLogix support team has been notified of the problem. If there is no update in 24 hrs, please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a> and mention that access analyzer is not showing. Please provide your Organization name and Data Source Name in the email."
      },
      "PROCESSING_IN_PROGRESS": {
        "heading": "Processing in Progress",
        "subHeading": "TData entitlement reports are being generated. The process typically takes between 1-2 hours after data source registration, but it may take longer in certain situations. Please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a> if it has been more than 4hrs."
      },
      "PROCESSING_NOT_STARTED": {
        "heading": "Gathering activity reports is not started",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      }
    },
    "DataRisk": {
      "PROCESSING_COMPLETED": {
        "heading": "No data risks to display.",
        "subHeading": "At the moment, there are no risks to be addressed."
      },
      "PROCESSING_FAILED": {
        "heading": "Data source risks assessment is currently underway",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      },
      "PROCESSING_IN_PROGRESS": {
        "heading": "Data source risks assessment is currently underway",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      },
      "PROCESSING_NOT_STARTED": {
        "heading": "Gathering information, no risks identified yet",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      }
    },
    "DataSprawl": {
      "PROCESSING_COMPLETED": {
        "heading": "Processing Completed, No Data",
        "subHeading": "Nothing to see here! We could not find any data movement in or out of this data source.If you think there is a mistake please review the data source registration and ensure the TrustLogix was granted permissions to monitor. If you need further assistance please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a>."
      },
      "PROCESSING_FAILED": {
        "heading": "Processing Failed",
        "subHeading": "Oops.. Something went terribly wrong. TrustLogix support team has been notified of the problem. If there is no update in 24 hrs, please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a> and mention that Data Sprawl report is not showing any data. Please provide your Organization name and Data Source Name in the email."
      },
      "PROCESSING_IN_PROGRESS": {
        "heading": "Data source risks assessment is currently underway",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      },
      "PROCESSING_NOT_STARTED": {
        "heading": "Data source risks assessment is currently underway",
        "subHeading": "The process typically takes between 1-2 hours, but it may take longer in certain situations."
      }
    },
    "Report": {
      "PROCESSING_COMPLETED": {
        "heading": "",
        "subHeading": "No data found in this time range"
      },
      "PROCESSING_FAILED": {
        "heading": "",
        "subHeading": "Apologies for the problem. TrustLogix support has been notified. If no update in 24 hrs, please contact <a href='mailto:support@trustlogix.io'> TrustLogix Support </a>, mentioning missing data in Shadow IT tools report. Provide Organization name and Data Source Name in the email."
      },
      "PROCESSING_IN_PROGRESS": {
        "heading": "",
        "subHeading": "We are currently analyzing the tools connected to this data source. Normally, this process takes around 1-2 hours after registering the data source, but it might take longer in certain cases. If it has been more than 4 hours, kindly reach out to <a href='mailto:support@trustlogix.io'> TrustLogix Support </a> for further assistance."
      },
      "PROCESSING_NOT_STARTED": {
        "heading": "",
        "subHeading": "We are currently analyzing the tools connected to this data source. Normally, this process takes around 1-2 hours after registering the data source, but it might take longer in certain cases. If it has been more than 4 hours, kindly reach out to <a href='mailto:support@trustlogix.io'> TrustLogix Support </a> for further assistance."
      }
    }
  },
  "maskingPattern": {
    "placeholder": {
      "CREDIT_CARD": "For Unauthorized users the column will be maksed 3400-****-****-1234",
      "CUSTOM_PATTERN": "Please provide a custom pattern like (\"*****\") that will be applied on this column for all Unauthorized users",
      "EMAIL": "For Unauthorized users the column will be masked as x*****@domain.com",
      "REGULAR_EXPRESSION": "Please provide a regular expression that will be applied on this column for all Unauthorized users",
      "SSN": "For Unauthorized users the column will be masked as ***-**-1234"
    }
  },
  "aiLanding": {
    "selectDataSource": "Select data source",
    "complianceNote": {
      "message": "<label>NOTE:</label> This is a short summary by our Guardian Agent. If you decide to have an in-depth analysis of <frameworks>{{frameworks}}</frameworks> violations, please schedule a compliance report.",
      "frameworkList": "{{leading}} and {{last}}",
      "defaultFrameworks": "these security frameworks",
      "scheduleReport": "Schedule Compliance Report →"
    },
    "sideBar": {
      "newChat": "New Chat",
      "searchHistoryPlaceholder": "Search history...",
      "recentActivity": "Recent Activity",
      "home": "Home",
      "refreshRecentActivity": "Refresh",
      "processing": "Processing",
      "loadingMoreText": "Loading..."
    },
    "riskCards": {
      "backToAssistant": "Back to Assistant",
      "back": "Back",
      "dismissAlert": "Dismiss alert",
      "dismissAlertDescription": "Are you sure you want to dismiss the following alert?",
      "dismissAlertTitle": "Dismiss Alert",
      "headerTitle": "Recent Security Risk Findings",
      "investigate": "Investigate",
      "next": "Next alerts",
      "previous": "Previous alerts",
      "searchByPolicyRefId": "Search by keyword on the current page",
      "subtitle": "List of risky activities occurring in your environment.",
      "title": "Active Findings",
      "viewAlert": "View alert",
      "viewAlertLabel": "View details for {{title}}",
      "viewFullFindings": "View All Findings",
      "moreTags": "+{{count}} more",
      "metadataFieldsWithCount": "Risk Metadata ({{count}})",
      "severity": {
        "0": "Critical",
        "1": "High",
        "2": "Medium",
        "3": "Low",
        "4": "Informational"
      },
      "metadata": "Risk Metadata"
    },
    "riskDetails": {
      "executiveSummaryTitle": "Executive Summary",
      "evidenceTimelineTitle": "Evidence And Timeline",
      "rootCauseTitle": "Root cause",
      "recommendationTitle": "Recommendation",
      "suggestionsTitle": "Suggestions",
      "categoryLabel": "Category",
      "confidenceLabel": "Confidence",
      "confidenceAriaLabel": "Confidence score: {{value}} percent",
      "timeDetectedLabel": "Time Detected",
      "frameworksLabel": "Frameworks",
      "complianceTagsLabel": "Compliance Tags",
      "metadataTitleWithCount": "Risk Metadata ({{count}})",
      "metadataFields": {
        "ruleName": "Rule Name",
        "ruleDescription": "Rule Description",
        "accountName": "Account Name",
        "accountType": "Account Type",
        "category": "Category",
        "framework": "Framework",
        "version": "Version",
        "section": "Section",
        "complianceTags": "Compliance Tags",
        "sourceType": "Source Type",
        "sourcePath": "Source Path"
      }
    },
    "AiRisk": {
      "NoRisksWithSearch": {
        "title": "No risks found for this search \"{{search}}\"",
        "message": "Try adjusting your search to find the risk you're looking for."
      },
      "NoRisksWithFilters": {
        "title": "No risks found for selected filters"
      },
      "NoRisks": {
        "title": "No risks detected",
        "message": "TrustAI continuously monitors your environment for unusual access patterns and sensitive data exposure."
      },
      "NoCriticalRisks": {
        "title": "No critical risks detected"
      }
    },
    "streamingMessage": {
      "previousStepsCompleted_one": "{{count}} previous step completed",
      "previousStepsCompleted_other": "{{count}} previous steps completed",
      "hiddenArchiveItems": "...and {{count}} more"
    }
  },
  "monitoringPolicy": {
    "name": "Name",
    "preview": {
      "title": "Live Preview",
      "queryLabel": "Query",
      "noTargetDetails": "Nothing targeted yet.",
      "noQuery": "No query entered yet.",
      "reviewNote": "Review everything above before saving."
    },
    "nameEdit": "Edit the policy name and description",
    "alertText": "Principal {{name}} performed action on resource <objectName> at <occurredOn>",
    "monitoringPolicyStatusError": "Allowlist and classification data is required to enable the policy.",
    "subTitle": "Enter the policy name and description. Select a risk category and optional risk controls to get started.",
    "subTitleEdit": "Edit the policy name and description",
    "resourceTypeWarning": "This policy will only take effect if there are matching objects with above classification",
    "selectConditionInfo": "Principals are associated with user names or user applications or user IP addresses or user roles. The value All can mean any of the above entities",
    "submitDisabledTitle": "Please fill the required information before saving the policy.",
    "userAgent": "User Agent",
    "userApplication": "User Application",
    "userIP": "User IP",
    "userRole": "User Role",
    "whitelistDataClassificationError": "Allowlist and classification data is required to enable the policy. Policy can be saved with disabled state.",
    "objectTypeInfo": "The object type can be <b>Listing</b>, <b>Share</b>, <b>Managed Account</b>, or <b>Custom Type</b>.",
    "cancelText": "Cancel",
    "alertSuppressionRuleApplied": "Alert suppression rule(s) applied to this policy.",
    "mute": {
      "title": "Mute Policy Alerts",
      "description": "Are you sure you want to mute the alerts for the <strong>{{policyName}}</strong>{{durationText}} <strong>{{duration}}</strong>?",
      "durationText": " for the next",
      "confirmationText": "Mute Alerts",
      "warningMessage": "This action will also dismiss the active alerts for the policy.",
      "durationLabel": "Duration",
      "tooltip": "Alerts are muted on {{date}} {{duration}}",
      "tooltipPermanently": "permanently",
      "tooltipForDuration": "for {{duration}}"
    },
    "unmute": {
      "title": "Unmute Policy Alerts",
      "description": "Are you sure you want to unmute the alerts for the <strong>{{policyName}}</strong>?",
      "confirmationText": "Unmute Alerts",
      "warningMessage": "This action will display all the active alerts for the policy."
    },
    "delete": {
      "title": "Delete Policy",
      "description": "Are you sure you want to delete <strong>\"{{policyName}}\"</strong> ?"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "muted": "Muted"
    },
    "wizard": {
      "basicsLabel": "Policy Details",
      "basicsDescription": "Policy identity details",
      "targetLabel": "Scope & Triggers",
      "targetDescription": "Configure targets, resources & actions",
      "triggerLabel": "Alert Management",
      "triggerDescription": "Configure alerts & risk severity",
      "reviewLabel": "Review",
      "reviewDescription": "Confirm details and activate"
    },
    "wizardIntro": "General Policy Identity",
    "description": "Description",
    "createTitle": "Create policy",
    "editTitle": "Edit policy",
    "save": "Save",
    "triggerSectionTitle": "Configure Frequency, Severity & Mitigation Recommendations",
    "alertFrequencyLabel": "Alert Frequency",
    "severityLabel": "Rule Risk Severity",
    "triggerAlertAfter": "Trigger Alert After",
    "violatingOccurrences": "Violating Occurrences",
    "remediationAction": "Recommended Remediation Action",
    "riskCategoryLabel": "Risk category",
    "riskControlsLabel": "Risk Controls (optional)",
    "invalidPolicyName": "Invalid Policy Name",
    "invalidObjectType": "Invalid object type, only letters and white spaces are allowed",
    "dataSizeMinError": "DataSize should be greater than 0",
    "timeThresholdMinError": "TimeThreshold should be greater than 0",
    "alertTextLabel": "Alert Text (optional)",
    "thresholdLabel": "Threshold (>=)",
    "hoursUnit": "hours",
    "daysUnit": "days",
    "excludedUsersLabel": "Excluded Users (optional)",
    "enterNamesPlaceholder": "Enter names",
    "typeAndPressEnterHint": "Type and press enter to add value",
    "alertPlaceholderAdvanced": "Please view details for all records that matched the query conditions",
    "alertPlaceholderStandard": "Insert alert recommendation here",
    "advancedQueryConditionPlaceholder": "Query results matched the condition in the custom query",
    "principalConditionsTitle": "Principal and conditions",
    "principalConditionsDescription": "Select a principal type and relevant conditions.",
    "addPrincipal": "+ Add principal",
    "addRule": "Add Rule",
    "remove": "Remove",
    "choosePrincipalLabel": "Choose a principal",
    "principalFloatLabel": "Principal",
    "chooseConditionLabel": "Choose a condition",
    "conditionFloatLabel": "Condition",
    "chooseListTypeLabel": "Choose a list type",
    "listTypeFloatLabel": "List type",
    "enterValuesLabel": "Enter values",
    "valuesFloatLabel": "Values",
    "chooseValuesLabel": "Choose values",
    "chooseGroupsLabel": "Choose groups",
    "monitoringResourceTitle": "Monitoring resource",
    "selectPrincipalFirst": "Select a principal first.",
    "monitoringResourceDescription": "Select a monitoring resource and classification tags (if applicable).",
    "chooseObjectLabel": "Choose an object",
    "objectFloatLabel": "Object",
    "chooseClassificationLabel": "Choose one or more classification",
    "classificationFloatLabel": "Classification",
    "chooseDatabaseLabel": "Choose a database",
    "databaseFloatLabel": "Database",
    "chooseSchemaLabel": "Choose a schema",
    "schemaFloatLabel": "Schema",
    "chooseTablesViewsLabel": "Please choose Tables/Views",
    "tablesViewsFloatLabel": "Tables/Views",
    "chooseColumnLabel": "Choose a column",
    "columnFloatLabel": "Column",
    "addObjectType": "Add an object type",
    "objectTypeLabel": "Object type",
    "enterObjectTypePlaceholder": "Enter object type",
    "removeObjectTypeAriaLabel": "Remove object type",
    "actionsTitle": "Actions",
    "actionsDisabledDescription": "Specify classification tag(s) before choosing actions.",
    "actionsDescription": "Select one or more actions.",
    "chooseActionsLabel": "Choose actions",
    "actionsFloatLabel": "Actions",
    "actionsLinkedMessage": "Actions that are linked to each other are displayed in the list",
    "dataSizeLabel": "Data size (>=)",
    "chooseTypeDefaultItem": "Choose type",
    "rolesLabel": "Roles",
    "chooseWorkspaceLabel": "Choose workspace",
    "queryTitle": "Query",
    "queryDescription": "Define the target by writing a SELECT query. The wizard derives matched rows from your query result.",
    "queryValidationsTitle": "The following validations are applied on this policy query:",
    "queryValidationSelectOnly": "Only SELECT DML operation is allowed.",
    "queryValidationOneColumn": "At least one column must be specified in the SELECT clause.",
    "queryValidationFilterCondition": "At least one FILTER condition must be specified.",
    "queryValidationTopLimit": "TOP or LIMIT or FETCH FIRST clause with a lower limit of 1 or a higher limit of 1000 must be specified.",
    "useQueryEditor": "Use query editor",
    "useConditionBuilder": "Use Condition Builder",
    "review": {
      "title": "Review the policy details before saving.",
      "policyDetails": "Policy Details",
      "type": "Type",
      "target": "Target",
      "principals": "Principals",
      "resourceType": "Resource type",
      "dataClassification": "Data classification",
      "actions": "Actions",
      "trigger": "Trigger",
      "alertFrequency": "Alert frequency",
      "severity": "Severity",
      "riskCategory": "Risk category",
      "riskControl": "Risk control",
      "status": "Status",
      "active": "Active",
      "activeHelpText": "When active, the policy will start generating alerts immediately after saving."
    }
  },
  "monitoringType": {
    "Custom Query": "advanced_monitoring",
    "Standard": "monitoring",
    "advanced_monitoring": "Custom Query",
    "monitoring": "Standard",
    "recommendation": "recommendation"
  },
  "oauth": {
    "errors": {
      "accountNotFound": "Invalid account id please contact your administrator",
      "oAuthCodeMissing": "Invalid or Missing oAuth Code"
    }
  },
  "registrations": {
    "chooseDataSource": "Select a Data Source",
    "jdbcConnectionUrlLabels": {
      "databricks": "Workspace Deployment Name(s)",
      "snowflake": "Account Identifier",
      "oracle": "ServerName and Port",
      "sqlserver": "ServerName and Port",
      "mysql": "ServerName and Port"
    },
    "jdbcConnectionUrlPlaceHolders": {
      "databricks": "<workspace>.cloud.databricks.com or <workspace>.azuredatabricks.net",
      "snowflake": "Enter account identifier",
      "oracle": "jdbc:oracle:thin:@//xxxxxxx:1521",
      "sqlserver": "ServerName,1433",
      "mysql": "jdbc:mysql://ServerName:3306"
    },
    "labels": {
      "cloudAccountID": "Data Source ID :",
      "dataSourceName": "Data Source Name",
      "oauthTenantId": "Tenant ID",
      "oauthClientId": "Client ID",
      "workspace": "Workspaces",
      "subtype": "Data Source Engine"
    },
    "placeHolders": {
      "oauthTenantId": "Enter Tenant Id",
      "oauthClientId": "Enter Client Id"
    },
    "passwordLabels": {
      "databricks": "Client Secret",
      "snowflake": "Password",
      "oracle": "Password",
      "sqlserver": "Password",
      "mysql": "Password",
      "powerbi": "Client Secret"
    },
    "passwordPlaceHolders": {
      "databricks": "Enter Client Secret",
      "snowflake": "Enter Password",
      "oracle": "<TrustLogix_password>",
      "sqlserver": "Enter Password",
      "mysql": "Enter Password",
      "powerbi": "Enter Client Secret"
    },
    "reviewDetails": "DATA SOURCE DETAILS :",
    "title": "Data Source Registration",
    "updateTitle": "Data Source Configuration",
    "usernameLabels": {
      "databricks": "Service Principal Name",
      "snowflake": "Username",
      "oracle": "Username",
      "sqlserver": "Username",
      "mysql": "Username",
      "powerbi": "Service Account Name"
    },
    "usernamePlaceHolders": {
      "databricks": "Enter Service Principal Name",
      "snowflake": "Enter Username",
      "oracle": "<TrustLogix_user>",
      "sqlserver": "Enter Username",
      "mysql": "Enter Username",
      "powerbi": "Enter Service Account Name"
    },
    "template": {
      "createTitle": "Register Data Source",
      "editTitle": "Edit Data Source",
      "selectDatasourceTitle": "Select Data Source",
      "datasourceLabel": "Data Source Type",
      "accountNameLabel": "Account Name",
      "accountNamePlaceholder": "e.g. production-snowflake",
      "stepSelectLabel": "Select Data Source",
      "stepSelectDesc": "Choose a data source and name this account",
      "stepPrereqLabel": "Prerequisites",
      "stepPrereqDesc": "Run the setup script in your data source",
      "stepConnectionLabel": "Connection & Authentication",
      "stepConnectionDesc": "Provide the connection details",
      "stepProjectLabel": "Project Selection",
      "stepProjectDesc": "Select Dremio Cloud projects to connect",
      "closeLabel": "Close",
      "saveLabel": "Save",
      "reApplyLabel": "Re-Apply Configuration",
      "registerAndConfigureLabel": "Register and configure",
      "selectDatasourceError": "Please select a data source",
      "prerequisiteValidationError": "You must acknowledge the prerequisites.",
      "singleAccountPerTypeTooltip": "An account of this type is already registered."
    },
    "preview": {
      "title": "Live Preview",
      "dataSourceTitle": "Data Source",
      "connectionTitle": "Connection & Authentication",
      "projectTitle": "Project Selection",
      "fieldName": "Name",
      "fieldType": "Type",
      "noConnectionDetails": "No connection details entered yet.",
      "noProjectsSelected": "No projects selected yet.",
      "reviewNote": "Review everything above before saving."
    },
    "errors": {
      "failedToRegisterAccount": "Failed to register account",
      "failedToUpdateAccountName": "Failed to update account name",
      "failedToSaveAccountDetails": "Failed to save account details",
      "missingAccountId": "Cannot save: account id is missing. Please re-open the wizard."
    },
    "messages": {
      "accountConfiguredSuccessfully": "Account configured successfully."
    },
    "prerequisites": {
      "stepLabel": "Step {{number}} -",
      "downloadButton": "Download",
      "extractZip": "and extract the zip file.",
      "downloadError": "Download Error"
    },
    "fieldGroups": {
      "connectionConfiguration": "Connection Configuration",
      "iamRole": "IAM Role",
      "attributeSourceConfiguration": "Attribute Source Configuration",
      "auditLogConfiguration": "Audit Log Configuration",
      "dynamodbConfiguration": "DynamoDB Configuration",
      "amazonS3Configuration": "Amazon S3 Configuration"
    },
    "fields": {
      "selectAll": {
        "title": "All Services",
        "description": "Select every available service. Adding or removing a single service clears this."
      },
      "optionsLoadError": "Could not load the available options. Retry once the connection is restored.",
      "noOptions": "No options are available for this data source."
    },
    "snowflake": {
      "label": "Snowflake",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the Snowflake setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite script in my Snowflake account.",
        "steps": {
          "runSql": "<b>Using Snowsight or Classic Console :</b> Please upload the .ipynb notebook OR copy the content from the downloaded zip folder file <b>tlx_snowflake_pre_requisite_sql_setup.sql</b> onto the UI. Replace the <ph>password</ph>/<ph>RSA_PUBLIC_KEY</ph> value with actual password/public key for the TrustLogix Snowflake user and execute all the SQL statements using the <b>ACCOUNTADMIN</b> role."
        }
      },
      "fields": {
        "jdbcConnectionUrl": {
          "label": "Account Identifier",
          "hint": "How to obtain the Snowflake <a href=\"https://docs.trustlogix.io/data-sources/snowflake/how-to-locate-snowflake-account-identifier\" target=\"_blank\" rel=\"noopener noreferrer\">account identifier</a>?"
        },
        "authType": {
          "label": "Authentication Type",
          "options": {
            "rsa": "Key Pair Authentication",
            "oauth": "OAuth Authentication"
          }
        },
        "username": {
          "label": "User Name"
        },
        "privateKey": {
          "label": "Private Key",
          "hint": "Learn how to generate your Private and Public Key — see the <a href=\"https://docs.snowflake.com/en/user-guide/key-pair-auth\" target=\"_blank\" rel=\"noopener noreferrer\">Snowflake key-pair authentication docs</a>."
        },
        "passphrase": {
          "label": "Passphrase",
          "hint": "Passphrase used to encrypt the RSA private key."
        },
        "userId": {
          "label": "User Mapping Attribute"
        },
        "oauthTokenEndpoint": {
          "label": "OAuth Token Endpoint",
          "hint": "External OAuth token endpoint URL."
        },
        "scope": {
          "label": "Scope"
        },
        "oauthClientId": {
          "label": "Client ID",
          "hint": "Learn how to generate your Client ID, Secret, Scope, and User Mapping Attribute — <a href=\"https://community.snowflake.com/s/article/Create-External-OAuth-Token-Using-Azure-AD-For-The-OAuth-Client-Itself\" target=\"_blank\" rel=\"noopener noreferrer\">Snowflake KB</a> | <a href=\"https://docs.snowflake.com/en/user-guide/oauth-ext-overview\" target=\"_blank\" rel=\"noopener noreferrer\">Snowflake doc</a>."
        },
        "oauthClientSecret": {
          "label": "Client Secret"
        }
      }
    },
    "postgresql": {
      "label": "PostgreSQL",
      "fields": {
        "jdbcConnectionUrl": {
          "label": "Database Server"
        },
        "dbName": {
          "label": "Database Name"
        },
        "username": {
          "label": "User Name"
        },
        "password": {
          "label": "Password"
        }
      }
    },
    "mysql": {
      "label": "MySQL",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the MySQL setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite script in my MySQL account.",
        "steps": {
          "runSql": "<b>Using MySQL Workbench or UI tool:</b> Copy the content from the downloaded zip file <b>tlx_mysql_ui_setup.sql</b> onto the UI. Replace the <ph>TrustLogix_user</ph> and <ph>TrustLogix_password</ph> values with the actual username and password and execute all the SQL statements using the <b>root</b> user."
        }
      },
      "fields": {
        "subtype": {
          "label": "Data Source Engine"
        },
        "jdbcConnectionUrl": {
          "label": "JDBC Connection URL",
          "placeholder": "jdbc:mysql://host:3306"
        },
        "username": {
          "label": "User Name"
        },
        "password": {
          "label": "Password"
        },
        "databaseIdentifier": {
          "label": "Database Identifier",
          "placeholder": "mysql-db"
        },
        "roleName": {
          "label": "Database Assume Role",
          "hint": "Create an IAM assume role in the member AWS account<br />e.g.: arn:aws:iam::&lt;accountid&gt;:role/&lt;role-name&gt;"
        },
        "region": {
          "label": "Database Region",
          "placeholder": "us-east-1"
        }
      }
    },
    "sqlserver": {
      "label": "SQL Server",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the SQL Server setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite script in my SQL Server account.",
        "steps": {
          "execute": "<b>Connect to SQLServer using SSMS :</b> Execute the SQL scripts <b>tlx_sqlserver_grants.sql</b> and <b>tlx_sqlserver_grants_for_aws_rds.sql</b> from the downloaded zip file within SQLServer Management Studio UI.",
          "capture": "Capture the username and password that are used in the grants SQL script along with the hostname and populate the below section.",
          "grantsLabel": "TrustLogix User Grants:",
          "grantsExternal": "TrustLogix control plane user will be granted <b>CONNECT</b> permissions on all existing databases for viewing catalog information.<br/>TrustLogix control plane user will be granted <b>SELECT, ALTER, EXECUTE, CREATE FUNCTION, CREATE TABLE</b> permissions on <b>TLX_POLICY_DB</b> for User Attribute management from the TrustLogix Console.<br/><br/>TrustLogix data plane user will be granted <b>CONNECT, ALTER, ALTER ANY MASK, ALTER ANY SECURITY POLICY</b> permissions on all existing databases for Masking and Row Access Policies.<br/>TrustLogix data plane user will be granted <b>SELECT, ALTER, EXECUTE, CREATE FUNCTION, CREATE TABLE</b> permissions on <b>TLX_POLICY_DB</b> for Masking and Row Access Policies.<br/>Additionally TrustLogix data plane user will be added as a member of <b>db_securityadmin</b> role of each database.",
          "grantsSaas": "TrustLogix user will be granted <b>CONNECT, ALTER, ALTER ANY MASK, ALTER ANY SECURITY POLICY</b> permissions on all existing databases for Masking and Row Access Policies.<br/>TrustLogix user will be granted <b>SELECT, ALTER, EXECUTE, CREATE FUNCTION, CREATE TABLE</b> permissions on <b>TLX_POLICY_DB</b> for Masking and Row Access Policies.<br/>Additionally TrustLogix user will be added as a member of <b>db_securityadmin</b> role of each database."
        }
      },
      "fields": {
        "jdbcConnectionUrl": {
          "label": "Server Name",
          "placeholder": "host.example.com,1433",
          "hint": "How to obtain the <a href=\"https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_ConnectToMicrosoftSQLServerInstance.html\" target=\"_blank\" rel=\"noopener noreferrer\">servername</a>?"
        },
        "dbName": {
          "label": "Database Name"
        },
        "username": {
          "label": "User Name"
        },
        "password": {
          "label": "Password"
        }
      }
    },
    "oracle": {
      "label": "Oracle",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the Oracle setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite script in my Oracle account.",
        "steps": {
          "runSql": "<b>Using Oracle SQL Developer or UI tool:</b> Copy the content from the downloaded zip file <b>tlx_oracle_ui_setup.sql</b> onto the UI. Replace the <ph>TrustLogix_user</ph> and <ph>TrustLogix_password</ph> values with the actual username and password and execute all the SQL statements using the <b>SYS</b> user."
        }
      },
      "fields": {
        "jdbcConnectionUrl": {
          "label": "JDBC Connection URL",
          "placeholder": "jdbc:oracle:thin:@host:1521"
        },
        "dbName": {
          "label": "SID",
          "placeholder": "ORCL"
        },
        "username": {
          "label": "User Name"
        },
        "password": {
          "label": "Password"
        }
      }
    },
    "aws": {
      "label": "AWS",
      "fields": {
        "externalId": {
          "label": "External ID",
          "hint": "AWS External ID used when assuming the TrustLogix IAM role. Generated by TrustLogix."
        },
        "roleArn": {
          "label": "IAM Role ARN",
          "placeholder": "arn:aws:iam::123456789012:role/TrustLogixRole",
          "hint": "The ARN of the IAM role TrustLogix assumes with the External ID above.",
          "patternMessage": "Must be a valid IAM role ARN: arn:aws:iam::<12-digit-account>:role/<role-name>"
        },
        "jdbcConnectionUrl": {
          "label": "Redshift JDBC URL",
          "placeholder": "jdbc:redshift://cluster.region.redshift.amazonaws.com:5439/dev"
        },
        "username": {
          "label": "User Name"
        },
        "clusterName": {
          "label": "Cluster Name"
        }
      }
    },
    "aurora": {
      "label": "Aurora",
      "fields": {
        "externalId": {
          "label": "External ID",
          "hint": "AWS External ID used when assuming the TrustLogix IAM role. Generated by TrustLogix."
        },
        "roleArn": {
          "label": "IAM Role ARN",
          "placeholder": "arn:aws:iam::123456789012:role/TrustLogixRole",
          "hint": "The ARN of the IAM role TrustLogix assumes with the External ID above.",
          "patternMessage": "Must be a valid IAM role ARN: arn:aws:iam::<12-digit-account>:role/<role-name>"
        },
        "jdbcConnectionUrl": {
          "label": "Aurora JDBC URL",
          "placeholder": "jdbc:mysql://cluster.region.rds.amazonaws.com:3306/db"
        },
        "username": {
          "label": "User Name"
        },
        "password": {
          "label": "Password"
        }
      }
    },
    "dynamodb": {
      "label": "DynamoDB",
      "fields": {
        "s3RawDataBucketName": {
          "label": "CloudTrail Log Location",
          "placeholder": "aws-cloudtrail-logs-bucket/prefix/AWSLogs/o-orgId",
          "hint": "S3 path to the CloudTrail logs for this DynamoDB table.",
          "patternMessage": "Must be in the form <bucket>/<prefix>/AWSLogs or <bucket>/<prefix>/AWSLogs/o-<orgId>"
        },
        "awsAccountId": {
          "label": "AWS Account ID"
        },
        "region": {
          "label": "AWS Region",
          "placeholder": "us-east-1"
        }
      }
    },
    "amazons3": {
      "label": "Amazon S3",
      "fields": {
        "s3RawDataBucketName": {
          "label": "CloudTrail Log Location",
          "placeholder": "aws-cloudtrail-logs-bucket/prefix/AWSLogs/o-orgId",
          "hint": "S3 path to the CloudTrail logs for this S3 bucket.",
          "patternMessage": "Must be in the form <bucket>/<prefix>/AWSLogs or <bucket>/<prefix>/AWSLogs/o-<orgId>"
        }
      }
    },
    "dremio": {
      "label": "Dremio",
      "authType": {
        "label": "Authentication Type",
        "options": {
          "oauth": "OAuth Authentication",
          "pat": "Personal Access Token"
        }
      },
      "fields": {
        "jdbcConnectionUrl": {
          "label": "JDBC Connection URL",
          "placeholder": "jdbc:arrow-flight-sql://host"
        },
        "oauthClientId": {
          "label": "OAuth Client ID"
        },
        "oauthClientSecret": {
          "label": "OAuth Client Secret"
        },
        "scope": {
          "label": "Scope"
        },
        "oauthTokenEndpoint": {
          "label": "OAuth Token Endpoint"
        },
        "exchangeAudience": {
          "label": "Exchange Audience"
        },
        "patToken": {
          "label": "Personal Access Token"
        }
      },
      "projectSelection": {
        "label": "Project",
        "description": "Dremio Cloud organizes data into projects — isolated workspaces that contain catalogs, spaces, and data sources. Access controls and governance policies are applied at the project level. Select the Dremio Cloud project you want TrustLogix to monitor and enforce data access policies within.",
        "required": "A project must be selected",
        "loadingError": "Failed to load projects. Check your connection settings and try again."
      },
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the Dremio setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite SQL setup in my Dremio account.",
        "steps": {
          "runSql": "<b>Using Dremio Sql Runner tab :</b> Please copy the content from the downloaded zip folder file <b>tlx_dremio_pre_requisite_sql_setup.sql</b> onto the UI. Replace the <ph>service_user_email</ph> value with actual emailid for the TrustLogix Dremio user and execute all the SQL statements using the ORG owner principal, user with the ownership privilege."
        }
      }
    },
    "powerbi": {
      "label": "Power BI",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the Power BI setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite steps for my Power BI account.",
        "steps": {
          "register": "Register a data source in TrustLogix which will be used as the source of user attributes for data access controls.",
          "followDocs": "Follow the steps in <a>https://docs.trustlogix.io/data-sources/power-bi/pre-requisites-for-power-bi-registration</a> to create the TrustLogix Power BI Azure application"
        }
      },
      "fields": {
        "username": {
          "label": "User Name"
        },
        "oauthTenantId": {
          "label": "OAuth Tenant ID"
        },
        "oauthClientId": {
          "label": "OAuth Client ID"
        },
        "oauthClientSecret": {
          "label": "Client Secret"
        },
        "datasource": {
          "label": "Data Source",
          "hint": "Data source of the user attributes used for access controls."
        }
      }
    },
    "microsoft365": {
      "label": "Microsoft 365",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Create a Microsoft Entra ID application for TrustLogix before completing the connection step.",
        "acknowledgeLabel": "I have completed the prerequisite steps for my Microsoft 365 tenant.",
        "steps": {
          "registerApp": "In the <b>Microsoft Entra admin center</b>, register a new application for TrustLogix. Note its <b>Directory (tenant) ID</b> and <b>Application (client) ID</b> — you will enter both on the next step.",
          "grantPermissions": "Grant the application read access to the Microsoft Graph and Microsoft Purview APIs it needs to read SharePoint sites and sensitivity labels, then have a tenant administrator grant admin consent.",
          "createSecret": "Under <b>Certificates and secrets</b>, create a new client secret and copy its value immediately — Entra ID only displays it once."
        }
      },
      "fields": {
        "subtype": {
          "label": "Services",
          "hint": "Select one or more Microsoft 365 services to bring under governance."
        },
        "oauthTenantId": {
          "label": "OAuth Tenant ID",
          "hint": "The Directory (tenant) ID of your Microsoft Entra ID tenant."
        },
        "oauthClientId": {
          "label": "OAuth Client ID",
          "hint": "The Application (client) ID of the registered TrustLogix application."
        },
        "oauthClientSecret": {
          "label": "Client Secret"
        }
      }
    },
    "databricks": {
      "label": "Databricks",
      "prerequisites": {
        "title": "Prerequisite Steps",
        "description": "Download and run the Databricks setup script before completing the connection step.",
        "acknowledgeLabel": "I have run the prerequisite script in my Databricks account.",
        "steps": {
          "runNotebookForTrustletUser": "<b>Using Databricks UI :</b> Execute the notebook scripts from the downloaded zip file onto the UI in the following order:<br> <ul> <li><b>1. tlx_databricks_grants.ipynb</b></li> <li><b>2. tlx_databricks_grants_to_cp_service_principal_scheduler.ipynb</b></li> </ul>",
          "runNotebook": "<b>Using Databricks UI :</b> Execute the notebook script <b>tlx_databricks_grants.ipynb</b> from the downloaded zip file onto the UI.",
          "capture": "Capture the output of notebook script from Step 2 in order to populate the workspace deployment name(s), SQL warehouse ID, client ID and client secret. Also retrieve the TrustLogix Service Principal Name created in Step 2 to complete the registration."
        }
      },
      "fields": {
        "serviceAccountId": {
          "label": "Account ID",
          "hint": "The account id is used for workspace-level access controls. How to obtain the Databricks <a href=\"https://docs.databricks.com/en/admin/account-settings/index.html#account-id\" target=\"_blank\" rel=\"noopener noreferrer\">Account ID</a>?"
        },
        "jdbcConnectionUrl": {
          "label": "Workspace Hostname(s)",
          "placeholder": "adb-xxxx.xx.azuredatabricks.net",
          "hint": "How to obtain the Databricks <a href=\"https://docs.databricks.com/api/account/workspaces/create\" target=\"_blank\" rel=\"noopener noreferrer\">workspace deployment name</a>?"
        },
        "warehouse": {
          "label": "SQL Warehouse Identifier(s)",
          "hint": "How to obtain the Databricks <a href=\"https://docs.databricks.com/en/integrations/compute-details.html\" target=\"_blank\" rel=\"noopener noreferrer\">SQL warehouse identifier</a>?"
        },
        "username": {
          "label": "User Name"
        },
        "oauthClientId": {
          "label": "Client ID",
          "hint": "To administer Databricks workspaces with TrustLogix, <a href=\"https://docs.databricks.com/en/admin/users-groups/service-principals.html#assign-account-admin-roles-to-a-service-principal\" target=\"_blank\" rel=\"noopener noreferrer\">assign</a> the Account Admin role to the service principal (clientId)."
        },
        "oauthClientSecret": {
          "label": "Client Secret"
        }
      }
    }
  },
  "reportList": {
    "PrivilegedOperationsNotDetected": " Privileged operations listed below were not detected",
    "clientConnectivityReportDesc": "Summary report of  login activity",
    "clientConnectivityReportDescForSqlServer": "Users login attempt report",
    "clientConnectivityReportName": "Client Connectivity Report",
    "clientConnectivityReportNameForS3": "Client Tools Connectivity",
    "clientConnectivityReportNameForSnowflake": "Client Tools Connectivity Report",
    "dataDataReportNote": "The report details are limited to 1000 records. Click on Download Report button to get the complete list of records.",
    "dataReadWriteActivityReportDescriptionForDynamoDB": "DynamoDB data plane activity report",
    "dataReadWriteActivityReportDescriptionForS3": "Report of object-level activity in classified S3 buckets",
    "dataReadWriteActivityReportNameForDynamoDB": "DynamoDB Data Activity Report",
    "dataReadWriteActivityReportNameForS3": "Object Access Operations",
    "dataShareActivityTimelineReport": "Users with Data Sharing and export privileges",
    "dataShareActivityTimelineReportDesc": "Summary of Users and Roles who have data sharing, exchange and unload privileges",
    "databricksManagementActivityReport": "Databricks Management Operations Activity Report",
    "dynamoDBManagementActivityReport": "DynamoDB Management Activity Report",
    "empty": "Report will be shown once data processing is completed",
    "emptySnowflakepQueryTypeCount": "Data Management Operations listed below were not detected in last 30 days:",
    "emptySnowflakesQueryTypeCount": "Data Operations listed below were not detected on Classified Data in last 30 days:",
    "eventsActivityReportDescForS3": "Report of Number of S3 API requests vs failed requests",
    "eventsActivityReportName": "Failed vs Successful API calls",
    "eventsActivityReportNameForS3": "API Success and Failure Report",
    "integrateIngestedVsProcessedData": "Integrate Ingested vs Processed Data Report",
    "labels": {
      "DynamoDBManagementOperations": "DynamoDB Management Operations",
      "S3ManagementOperations": "S3 Management Operations",
      "classifyData": "Add classification data to generate this report",
      "classifyDataForSnowflake": "Add tag data to snowflake to view this report",
      "clientToolsUsedToConnect": "Least used client tools",
      "clientToolsUsedToConnectForAurora": "Details of all the Client tools used to connect to Aurora",
      "clientToolsUsedToConnectForDatabricks": "Details of client tools used to connect to Databricks",
      "clientToolsUsedToConnectForMySql": "Details of all the Client tools used to connect to MySQL",
      "clientToolsUsedToConnectForRedshift": "Details of all the Client tools used to connect to Redshift",
      "clientToolsUsedToConnectForS3": "Details of all the Client tools used to access data in the S3 buckets",
      "clientToolsUsedToConnectForSnowflake": "Details of all the Client tools used to connect to Snowflake",
      "clientToolsUsedToConnectForSqlServer": "Details of all the Client tools used to connect to SQL Server",
      "dataReadOrWriteOperations": "Data Read/Write Operations",
      "dataReadOrWriteOperationsClassification": "Data Read/Write Operations on Classified Objects",
      "databaseManagementOperations": "Database Management Operations",
      "eventsActivityReportName": "Failed vs Successful API calls",
      "integrateIngestedVsProcessedData": "Integrate Ingested vs Processed Data Report",
      "snowflake": "snowflake",
      "trustlogix": "trustlogix"
    },
    "loginActivityReportName": "User Login Activity Report",
    "piiDataShareActivityTimelineReport": "Data Sharing activity Report",
    "piiDataShareActivityTimelineReportDesc": "Details of all Data Sharing  activities as a data provider account",
    "postgreSQLCISReportDescription": "PostgreSQL CIS Benchmark Data",
    "postgreSQLCISReportName": "PostgreSQL CIS Report",
    "reportNote": "The report details are limited to 1000 records. Please contact <strong> {{email}} </strong> to download the complete details.",
    "s3ManagementActivityReport": "Bucket Management Operations",
    "senstiveDataActivityReportDescription": "Summary report of  Data access activities on Classified Objects",
    "senstiveDataActivityReportName": "Data Access Report",
    "snowflakeManagementActivityReport": "Data Management Activity Report",
    "sqlServerCISReport": "SQL Server CIS Report",
    "unusedTables": "Dark Data Report",
    "unusedTablesDescription": "Details of objects that have not been accessed for last 30 days",
    "userActivityReportDescription": "Database Management and Read-Write activity report",
    "userActivityReportDescriptionForDatabricks": "Summary report of Data & Cluster Management operations like Mount UnMount, Group assignments",
    "userActivityReportDescriptionForDynamoDB": "DynamoDB control plane activity report",
    "userActivityReportDescriptionForMySql": "Summary report of Copy-Clone activities",
    "userActivityReportDescriptionForS3": "Report of Security sensitive management operations on all S3 buckets",
    "userActivityReportDescriptionForSnowflake": "Summary report of Load-Unload, Copy-Clone activities",
    "userActivityReportName": "User Activity Report",
    "userBehaviorAnalyticsDescription": "Risk Score Based On User Activity On Classified Data",
    "userBehaviorAnalyticsName": "User Behavior Analytics",
    "userConnectivityReportDescription": "User login attempts report",
    "userConnectivityReportName": "User Connectivity Report",
    "userPolicy": "User Data Entitlements Report",
    "userPolicyDescription": "Details of Permissions and access on various data sets for all the users  using the Data platform",
    "userPolicyDescriptionForSnowflake": "Detail of types of access that users have to Snowflake database. It provides information about the user, role, and privileges of all roles except ACCOUNTADMIN, SECURITYADMIN, SYSADMIN."
  },
  "reportsConfiguration": {
    "errorTitle": "S3 Bucket Error",
    "saveMessage": "Changes has been saved",
    "successTitle": "Reports Configuration Success"
  },
  "roleTemplates": {
    "ACCOUNT": "Account",
    "DATABASE": "Database",
    "INTEGRATION": "Integration",
    "RESOURCE MONITOR": "Resource Monitor",
    "SCHEMA": "Schema",
    "SHARED_DATABASE": "Shared Database",
    "WAREHOUSE": "Warehouse",
    "APPLICATION": "Application",
    "APPLICATION ROLE": "Application Role",
    "DATA_EXCHANGE_LISTING": "Organization Listing",
    "SNOWFLAKE_INTELLIGENCE": "Snowflake Intelligence",
    "DBT_PROJECT": "Dbt Project"
  },
  "s3DataLakeAccessPolicy": {
    "configureAwsDataLakeAdministrator": "Configure AWS Data Lake Administrator",
    "configureSnowflakeS3IntegrationDetails": "Configure Snowflake S3 Integration Details",
    "createPolicyTitle": "Create a new policy by entering details below.",
    "dataLakeAdministratorUsername": "Data Lake Administrator User Name",
    "enterIntegrationDetails": "Enter integration details"
  },
  "services": {
    "all": "All",
    "aurora": "Amazon Aurora",
    "aws": "Amazon Redshift",
    "bigquery": "BigQuery",
    "databricks": "Databricks",
    "dynamodb": "Amazon DynamoDB",
    "emr": "Amazon EMR",
    "glue_data_pipeline": "Amazon Glue",
    "kafka": "Kafka",
    "mysql": "MySQL",
    "postgresql": "PostgreSQL",
    "s3": "Amazon S3",
    "snowflake": "Snowflake",
    "sqlserver": "SQL Server",
    "tableau": "Tableau",
    "oracle": "Oracle",
    "powerbi": "Power BI",
    "dremio": "Dremio",
    "microsoft365": "Microsoft 365"
  },
  "settings": {
    "dataClassification": "Data Classification",
    "tagManagement": "Tag Management",
    "title": "Configurations",
    "whitelist": "Allowlist",
    "settings": "Settings"
  },
  "userMenu": {
    "helpMenuList": {
      "releaseNotes": "Release Notes",
      "documentation": "Documentation"
    },
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  },
  "severity": {
    "critical": "Critical",
    "high": "High",
    "low": "Low",
    "medium": "Medium",
    "informational": "Informational"
  },
  "trustAiBoard": {
    "pageTitle": "Security Overview",
    "pageSubtitle": "AI & Data Governance Posture",
    "outcomeDelta": {
      "to": "to"
    },
    "inventory": {
      "environment": "Environment",
      "businessUnit": "Business Unit",
      "owner": "Owner",
      "status": "Policy Status"
    },
    "relationships": {
      "title": "Relationship Explorer",
      "subtitle": "Explore Identity → Agent → Gateway → Tool → Data paths across the complete discovered estate.",
      "back": "Back to Executive Overview",
      "nodes_one": "{{count}} node",
      "nodes_other": "{{count}} nodes",
      "edges_one": "{{count}} relationship",
      "edges_other": "{{count}} relationships",
      "search": "Search nodes, owners, business units, or environments",
      "searchResults": "Matching relationship nodes",
      "clusterLabel": "Cluster by",
      "cluster": {
        "businessUnit": "Business unit",
        "owner": "Owner",
        "environment": "Environment",
        "none": "No clustering"
      },
      "runtimePaths": "Runtime paths",
      "policyCoverage": "Policy coverage",
      "violations": "Violations",
      "legend": "Relationship legend",
      "protected": "Protected",
      "needsAttention": "Needs attention or has violations",
      "estateTotals": "Generated estate totals",
      "assets": "assets",
      "attention": "attention",
      "aggregateAccessibleName": "{{cluster}}, {{layer}}, {{total}} assets, {{attention}} need attention, {{violations}} violations",
      "assetAccessibleName": "{{name}}. {{type}}. {{status}}. {{violations}} violations.",
      "violationCountValue_one": "{{count}} violation",
      "violationCountValue_other": "{{count}} violations",
      "overviewTitle": "{{cluster}} relationship overview",
      "overviewHint": "Each row summarizes one governed path. Search for an asset to inspect its live lineage.",
      "focusedTitle": "Lineage for {{name}}",
      "focusedHint": "Showing {{count}} directly related assets across the identity-to-data path.",
      "backToOverview": "Back to overview",
      "allRelationships": "All relationships",
      "layers": {
        "identity": "Identity",
        "agent": "Agent",
        "gateway": "Gateway",
        "tool": "MCP or registry",
        "data": "Platform, catalog, or sensitive asset"
      },
      "assetTypes": {
        "ai-agents": "AI agents",
        "mcp-servers": "MCP servers",
        "tools": "agent tools",
        "data-sources": "data sources",
        "tool-registries": "tool registries",
        "data-platforms": "data platforms",
        "enterprise-datasets": "mapped catalogs",
        "sensitive-datasets": "sensitive assets",
        "identity-sources": "identity sources",
        "gateways": "gateways"
      },
      "policyStatuses": {
        "protected": "Protected",
        "needsAttention": "Needs attention",
        "notEvaluated": "Not Yet Evaluated"
      },
      "loadError": "The relationship map could not be loaded. Refresh the page to try again.",
      "violationCount": "Violation Count",
      "runtimeStatus": "Runtime Status",
      "active": "Active",
      "inactive": "Inactive"
    },
    "incident": {
      "readSource": "Read the source",
      "sourceNoteTitle": "Source and scope",
      "sourceNoteBody": "Based on the {{version}} published by {{sourceLabel}}. The external account may evolve as the investigation continues.",
      "whatHappenedEyebrow": "What happened",
      "signalsEyebrow": "Detection signals",
      "exposureEyebrow": "Exposure mapping",
      "recommendationsEyebrow": "External recommendations",
      "reviewAgents": "Review affected agents",
      "reviewFindings": "Review related findings",
      "startRemediation": "Start readiness remediation",
      "panelDisclaimer": " This exposure review maps analogous control gaps; it is not evidence of compromise.",
      "statuses": {
        "gap": "Gap",
        "partial": "Partial",
        "ready": "Ready",
        "verified": "Verified"
      }
    },
    "guardian": {
      "railLabel": "Guardian",
      "ask": "Ask Guardian",
      "askAbout": "Ask Guardian about {{name}}",
      "askAgent": "Ask Guardian about this agent",
      "contextLabel": "Context",
      "contextChanged": "Context changed: {{from}} → {{to}}",
      "open": "Open Guardian",
      "dock": "Dock Guardian",
      "expand": "Expand Guardian to half the screen",
      "restoreWidth": "Restore Guardian width",
      "resize": "Resize Guardian",
      "widthPercent": "{{percent}}% of screen width",
      "undock": "Undock Guardian",
      "switchContext": "Switch Guardian context",
      "starters": "Suggested questions",
      "followUps": "Suggested next steps",
      "retry": "Retry response",
      "messageContext": "Context: {{name}}",
      "loading": "Guardian is loading…",
      "kind": {
        "estate": "AI Estate"
      },
      "inputPlaceholder": "Ask Guardian...",
      "send": "Send message to Guardian",
      "close": "Close Guardian",
      "disclaimer": "Guardian explains and recommends. It never applies a policy on your behalf.",
      "error": "I could not answer that just now. Retry this response or ask another question.",
      "askDataPlatform": "Ask Guardian about {{name}} governance",
      "viewAccessFlow": "View Access Path",
      "currentPage": "Current page"
    },
    "impact": {
      "before": "Before",
      "after": "After",
      "approveEnforce_one": "Approve & Enforce for {{count}} Agent",
      "approveEnforce_other": "Approve & Enforce for {{count}} Agents"
    },
    "confirm": {
      "title_one": "Enforce {{policy}} for {{count}} agent?",
      "title_other": "Enforce {{policy}} for {{count}} agents?",
      "summaryIntro": "TrustAI will:",
      "preserveWorkflows": "Preserve allowed business workflows",
      "confirm": "Enforce Policy",
      "enforceSuccess": "Mock decision recorded. Runtime enforcement is not verified.",
      "enforceError": "Something went wrong enforcing this policy. Please try again."
    },
    "ibac": {
      "title": "TrustAI IBAC Enforcement",
      "expansion": "IBAC — Identity & Business Intent Authorization Control",
      "supportingStatement": "TrustAI IBAC is the central decision point that evaluates identity, intent, data, region, purpose, and policy before allowing or denying governed access.",
      "evaluationDimensionsTitle": "TrustAI IBAC evaluates",
      "currentDecision": "Current decision",
      "ongoingEnforcement": "Ongoing enforcement",
      "evidenceOutcome": "Evidence outcome",
      "steps": {
        "policyValidated": "Policy validated",
        "scopeResolved": "Scope resolved",
        "agentsRouted_one": "{{count}} agent routed through IBAC",
        "agentsRouted_other": "{{count}} agents routed through IBAC",
        "evidenceGenerated": "Audit evidence generated",
        "enforcementVerified": "Enforcement verified"
      }
    },
    "outcomes": {
      "title": "Verified Outcomes",
      "subtitle": "Runtime evidence requires backend verification. Mock policy assignments are recorded in each agent’s activity.",
      "verified": "Verified",
      "pending": "Pending",
      "metrics": {
        "issuesRemediated": "Issues remediated",
        "agentsRoutedThroughIbac": "Agents routed through TrustAI IBAC",
        "agentsBlockedCrossRegionCopy": "Agents blocked from invalid cross-region copy",
        "agentsRestrictedEmbargoed": "Agents restricted from embargoed access",
        "agentsProtectedByIntentAuth": "Agents protected by intent-based authorization",
        "percentEuActionsLogged": "EU employee-data actions logged"
      },
      "proof": {
        "scope": "Scope",
        "enforcement": "Enforcement",
        "outcome": "Outcome",
        "evidence": "Evidence"
      },
      "viewAuditEvidence": "View Audit Evidence",
      "exportSummary": "Export Executive Summary",
      "exportToast": "Executive summary export started.",
      "audit": {
        "decisionId": "Decision ID",
        "timestamp": "Timestamp",
        "agent": "Agent",
        "userIdentity": "User identity",
        "dataClass": "Data class",
        "sourceRegion": "Source region",
        "destinationRegion": "Destination region",
        "declaredPurpose": "Declared purpose",
        "matchedPolicy": "Matched policy",
        "decision": "Decision",
        "decisions": {
          "allow": "Allow",
          "deny": "Deny"
        },
        "enforcementPoint": "Enforcement point",
        "evidenceStatus": "Evidence status",
        "evidenceStatuses": {
          "generated": "Generated",
          "pending": "Pending"
        },
        "empty": "No audit evidence yet — approve and enforce a policy to generate it."
      }
    },
    "decisionPanel": {
      "enforcing": "Enforcing…",
      "subtitle": "Executive decision workflow — {{controlName}}"
    },
    "workflow": {
      "ariaLabel": "Executive decision workflow progress",
      "runningNote": "Keep this panel open while TrustAI verifies enforcement.",
      "stages": {
        "situation": "Situation",
        "recommendation": "Recommendation",
        "scope": "Scope",
        "outcome": "Outcome",
        "strategy": "Strategy",
        "decision": "Decision",
        "enforcement": "Enforcement"
      },
      "next": {
        "recommendation": "See what we recommend",
        "scope": "Review affected scope",
        "outcome": "See what changes",
        "strategy": "Choose a policy",
        "decision": "Review & Approve",
        "enforcement": "Enforcement"
      }
    },
    "strategy": {
      "complianceFallback": "Compliance",
      "recommendedBadge": "Guardian Recommended",
      "selected": "Selected",
      "select": "Select",
      "selectStrategy": "Select This Policy",
      "openPolicyBuilder": "Open Policy Builder",
      "emergencyAction": "Emergency action",
      "alternativesTitle": "Compare Other Policies",
      "alternativesSubtitle": "Expand an alternative to review its trade-offs before changing the recommendation.",
      "moreOptions": "More containment options",
      "alternativeMeta": "{{coverage}} coverage · {{disruption}} disruption · {{confidence}}% confidence",
      "selectionAnnouncement": "Selected strategy: {{strategy}}",
      "optionsLabel": "Applies to",
      "disruptionValue": "{{level}} disruption",
      "coverageValue": "{{level}} compliance coverage",
      "disruption": {
        "low": "Low",
        "lowMedium": "Low–Medium",
        "medium": "Medium",
        "high": "High",
        "critical": "Critical"
      },
      "coverage": {
        "full": "Full",
        "partial": "Partial",
        "none": "None"
      },
      "metrics": {
        "activitiesPrevented": "risky activities prevented",
        "confidence": "confidence"
      },
      "summary": {
        "guardianLabel": "Guardian Recommendation",
        "selectedLabel": "Selected Strategy",
        "guardianConfidence": "Guardian confidence",
        "strategyConfidence": "Strategy confidence",
        "guardianRecommends": "Guardian recommends:",
        "restoreGuardian": "Restore Guardian Recommendation",
        "businessDisruption": "Business disruption",
        "complianceCoverage": "Compliance coverage",
        "affectedAgents": "Affected agents",
        "activitiesStopped": "Risky activities stopped",
        "whyGuardian": "Why Guardian recommends this",
        "selectionConsiderations": "Selection considerations",
        "expectedOutcome": "Expected outcome"
      },
      "outcomes": {
        "agents_one": "{{count}} agent protected",
        "agents_other": "{{count}} agents protected",
        "activities_one": "{{count}} risky activity prevented",
        "activities_other": "{{count}} risky activities prevented",
        "controls": "{{complianceLabel}} controls enforced",
        "audit": "Audit evidence generated"
      },
      "postApproval": {
        "title": "What happens after approval?",
        "policy": "The selected policy is created or attached.",
        "agents": "Affected agents receive updated protection.",
        "confirmation": "Enforcement starts only after final confirmation.",
        "audit": "Audit evidence is recorded.",
        "progress": "Progress appears in the Enforcement step."
      },
      "comparison": {
        "show": "Compare strategies",
        "hide": "Hide comparison",
        "recommendedYes": "Recommended",
        "riskReductionValue": "{{percent}}% risk reduction",
        "columns": {
          "strategy": "Strategy",
          "disruption": "Business Disruption",
          "coverage": "Compliance Coverage",
          "confidence": "Confidence",
          "agents": "Agents",
          "action": "Action"
        }
      }
    },
    "executive": {
      "futureProtectionTitle": "Protection scope",
      "futureProtectionDescription": "Guardian selected the 23 highest-risk uncovered agents. You can expand the reviewed scope to all 92, narrow it further, or roll back the policy from protected inventory.",
      "futureProtectionToggle": "Automatically apply this policy to newly discovered agents",
      "businessOwner": "Business owner: ",
      "impactDimensions": {
        "business": "Business impact",
        "compliance": "Compliance impact",
        "operational": "Operational impact"
      },
      "technicalDetails": "Technical details",
      "recommendedAction": "Recommended action",
      "why": "Why",
      "confidence": "Confidence",
      "confidencePercent": "{{percent}}%",
      "evidenceTitle": "Evidence & Confidence",
      "evidenceSubtitle": "What this recommendation is based on.",
      "askGuardian": "Ask Guardian",
      "askGuardianSubtitle": "Guardian explains this recommendation. It does not change policy.",
      "scopeTitle": "Affected scope",
      "scopePresetLabel": "Protection scope presets",
      "scopePresetMeta": "{{agents}} agents · {{applications}} data platforms",
      "scopeSubtitle_one": "{{count}} agent is affected by this recommendation.",
      "scopeSubtitle_other": "{{count}} agents are affected by this recommendation.",
      "scopeGroups": {
        "agents": "Agents",
        "dataSources": "Data sources",
        "businessUnits": "Business units",
        "classifications": "Data classifications"
      },
      "moreScopeItems": "+{{count}} more",
      "filtersTitle": "Narrow the scope",
      "filterAnyPlaceholder": "Any",
      "filterResultCount_one": "Showing {{count}} of {{total}} agent",
      "filterResultCount_other": "Showing {{count}} of {{total}} agents",
      "removeFilter": "Remove {{value}} filter",
      "clearFilters_one": "Clear {{count}} filter",
      "clearFilters_other": "Clear {{count}} filters",
      "filterGroups": {
        "dataSource": "Data source",
        "businessUnit": "Business unit",
        "classification": "Classification",
        "application": "Application",
        "agent": "Agent",
        "complianceFramework": "Compliance framework"
      },
      "outcomeTitle": "Current state vs expected state",
      "outcomeSubtitle": "What changes the moment this policy is approved.",
      "currentState": "Current",
      "expectedState": "After policy",
      "current": {
        "affectedAgents_one": "{{count}} affected agent",
        "affectedAgents_other": "{{count}} affected agents",
        "riskyActivities_one": "{{count}} risky activity in the last 30 days",
        "riskyActivities_other": "{{count}} risky activities in the last 30 days",
        "noApproval": "No approval workflow",
        "noAuditTrail": "No audit trail"
      },
      "expected": {
        "noUnauthorized": "0 unauthorized transfers",
        "approvalEnabled": "Approval workflow enabled",
        "auditEnabled": "Audit trail enabled",
        "workflowsContinue": "Business workflows continue"
      },
      "behaviorTitle": "What stops and what keeps working",
      "behaviorSubtitle": "Outcomes, not rules — nothing here changes how work gets done.",
      "blocked": "Blocked",
      "allowed": "Allowed",
      "decisionTitle": "Approve this decision",
      "decisionSubtitle": "Review what you are approving, then enforce it. To change how the violation is contained, go back to the strategies.",
      "approval": {
        "selectedStrategyLabel": "Selected strategy",
        "outcomeTitle": "Expected outcome",
        "outcomeSubtitle": "What changes the moment this is enforced.",
        "dimensions": {
          "business": "Business impact",
          "compliance": "Compliance benefits"
        },
        "evidenceTitle": "Evidence summary",
        "agentsTitle": "Affected agents",
        "agentsSubtitle_one": "{{count}} agent will be brought under this policy.",
        "agentsSubtitle_other": "{{count}} agents will be brought under this policy."
      },
      "actions": {
        "approveTitle": "Approve & enforce",
        "approveDescription_one": "Apply {{strategy}} to {{count}} agent, with approval and audit trail enabled.",
        "approveDescription_other": "Apply {{strategy}} to {{count}} agents, with approval and audit trail enabled.",
        "backToStrategiesTitle": "Back to strategies",
        "backToStrategiesDescription": "Choose a different way to contain this violation.",
        "backToStrategiesCta": "Change strategy",
        "compareTitle": "Compare strategies",
        "compareDescription": "See risk reduction, business disruption, and compliance coverage side by side.",
        "compareCta": "Compare",
        "customTitle": "Create custom policy",
        "customDescription": "Advanced — author a bespoke policy in the policy builder instead. Estimated setup: 20–30 minutes.",
        "customCta": "Open policy builder",
        "customToast": "Opening the policy builder. Estimated setup for a custom policy is 20–30 minutes.",
        "dismissTitle": "Dismiss recommendation",
        "dismissDescription": "Requires a written justification, recorded against this issue.",
        "dismissCta": "Dismiss"
      },
      "dismissDialog": {
        "title": "Dismiss “{{issue}}”?",
        "intro": "Dismissing a recommendation is an auditable decision. Your justification is recorded against this issue and visible to compliance reviewers.",
        "justificationLabel": "Justification",
        "justificationPlaceholder": "Why is no action needed on this issue?",
        "confirm": "Dismiss recommendation",
        "recorded": "Recommendation dismissed. Justification recorded: “{{justification}}”"
      }
    },
    "pageSupportingCopy": "Understand your AI estate, policy coverage, access risks, and highest-priority governance actions.",
    "lastEvaluated": "Last evaluated {{value}}",
    "estate": {
      "title": "Your AI + Data Estate",
      "subtitle": "What TrustLogix can see across your AI agents, MCP services, and data sources.",
      "metric": {
        "ai-agents": "AI Agents",
        "mcp-servers": "MCP Services",
        "data-sources": "Data Sources"
      },
      "hint": {
        "mcp-servers": "Model Context Protocol (MCP) services that expose tools, resources, or capabilities to AI agents. Their tools are listed in each service's details."
      },
      "hintLabel": {
        "mcp-servers": "About MCP services"
      },
      "welcomeSubtitle": "Bring in AI agents or data sources to start building your estate.",
      "card": {
        "count": {
          "ai-agents_one": "{{value}} onboarded",
          "ai-agents_other": "{{value}} onboarded",
          "mcp-servers_one": "{{value}} service",
          "mcp-servers_other": "{{value}} services",
          "data-sources_one": "{{value}} connected",
          "data-sources_other": "{{value}} connected"
        },
        "tools_one": "{{value}} tool",
        "tools_other": "{{value}} tools",
        "status": {
          "notOnboarded": "Not onboarded",
          "notDiscovered": "Not discovered yet",
          "notConnected": "Not connected",
          "importing": "Importing…",
          "discovering": "Discovering…",
          "discoveryComplete": "Discovery complete",
          "disabled": "Not enabled",
          "loading": "Loading…",
          "unavailable": "Unable to load",
          "restricted": "Access restricted"
        },
        "description": {
          "notOnboarded": {
            "ai-agents": "Import agents to understand their access and protection."
          },
          "notDiscovered": {
            "mcp-servers": "MCP services will appear as your AI environment is onboarded."
          },
          "notConnected": {
            "data-sources": "Connect enterprise data sources to evaluate access and protection."
          },
          "importing": {
            "ai-agents": "Agents appear here as the import completes."
          },
          "discovering": {
            "mcp-servers": "MCP services appear as your agents are discovered."
          },
          "discoveryComplete": {
            "ai-agents": "No agents discovered.",
            "mcp-servers": "No MCP services discovered.",
            "data-sources": "No data sources discovered."
          },
          "disabled": {
            "default": "{{label}} is not enabled for your organization."
          },
          "unavailable": {
            "default": "We couldn't load your {{label}} inventory. Other areas are unaffected."
          },
          "restricted": {
            "default": "You don't have permission to view {{label}}."
          }
        },
        "qualifier": {
          "notEvaluated": "Not evaluated",
          "evaluating": "Evaluation in progress",
          "partiallyEvaluated_one": "{{count}} not evaluated yet",
          "partiallyEvaluated_other": "{{count}} not evaluated yet",
          "inProgress": "Import in progress",
          "stale": "Showing the last known count"
        },
        "action": {
          "importAgents": "Import Agents",
          "connectData": "Connect Data Sources",
          "viewAgents": "View agents",
          "viewServices": "View services",
          "viewSources": "View sources",
          "viewProgress": "View progress",
          "retry": "Try again"
        },
        "actionLabel": "{{action}}: {{label}}"
      }
    },
    "hero": {
      "action": {
        "importAgents": "Import Agents",
        "connectData": "Connect Data Sources"
      },
      "newTenant": {
        "eyebrow": "Get started with TrustLogix",
        "title": "Bring your AI and data estate into TrustLogix",
        "description": "Import AI agents or connect enterprise data sources to understand access, evaluate policy coverage, and apply protection."
      },
      "importAi": {
        "eyebrow": "Expand to AI governance",
        "title": "Bring your AI agents into TrustLogix",
        "description": "Import agents to understand their access, policy coverage, and enforcement status."
      },
      "connectData": {
        "eyebrow": "Unlock the full value of AI governance",
        "title": "Connect your enterprise data",
        "description": "Connect data sources to understand enterprise data access and apply data-layer protection."
      }
    },
    "search": {
      "placeholder": "Search agents, services, and data sources",
      "resultsLabel": "Estate search results",
      "searching": "Searching your estate...",
      "noResults": "Nothing in your estate matches “{{query}}”.",
      "disabledHint": "Import agents to search your estate.",
      "moreInGroup_one": "{{count}} more match",
      "moreInGroup_other": "{{count}} more matches",
      "groups": {
        "agents": "Agents",
        "aiPlatforms": "Agent Registries",
        "dataPlatforms": "Data Platforms",
        "businessFunctions": "Business Functions",
        "mcpServers": "MCP Servers"
      },
      "type": {
        "agent": "Agent",
        "aiPlatform": "Agent Registry",
        "dataPlatform": "Data Platform",
        "businessFunction": "Business Function",
        "mcpServer": "MCP Server"
      },
      "typeWithProvider": "{{type}}: {{provider}}",
      "unavailable": "Search is unavailable right now. Try again in a moment."
    },
    "explore": {
      "noEnvironment": {
        "title": "Secure your AI estate",
        "description": "Import agents to understand their access, policy coverage, and enforcement status. They appear here once the import completes.",
        "cta": "Import Agents"
      },
      "discovering": {
        "title": "Discovery is still running",
        "description": "Agents appear here as TrustLogix finishes analyzing them."
      },
      "error": {
        "title": "Could not load your estate categories",
        "description": "The rest of the board is unaffected. Retry to load the categories again.",
        "retry": "Retry"
      }
    },
    "requiresAttention": {
      "title": "Priority Risks & Policy Gaps",
      "subtitle": "Highest-priority governance issues based on policy exposure, affected agents, sensitive data, and business impact.",
      "affectedAgents_one": "{{count}} affected agent",
      "affectedAgents_other": "{{count}} affected agents",
      "distinctAgents_other": "{{agents}} distinct agents are affected across {{count}} issues. An agent can appear under more than one issue, so the counts on the cards do not add up.",
      "affectedPlatforms_one": "{{count}} data platform",
      "affectedPlatforms_other": "{{count}} data platforms",
      "policyContext": "Policy context: {{value}}",
      "viewDetails": "View Details",
      "viewDetailsAria": "View details for {{name}}",
      "reviewRecommendation": "Review Recommendation",
      "reviewRecommendationAria": "Review the recommended policy for {{name}}",
      "recommendedPolicy": "Recommended policy",
      "reviewEnforcedIssue": "Review recorded decision",
      "enforced": "Mock decision recorded",
      "viewAll_one": "View the {{count}} governance issue",
      "viewAll_other": "View all {{count}} governance issues",
      "empty": "No governance issues currently require attention.",
      "severityHint": "Severity represents the potential impact and urgency assigned to this governance finding.",
      "severityHintLabel": "About severity",
      "categoryHint": {
        "default": "The governance or policy domain associated with this finding.",
        "dataSovereignty": "Risks involving geographic, jurisdictional, residency, or organizational boundaries for data access.",
        "leastPrivilege": "Risks where an agent has broader data access than required for its intended tasks.",
        "agentIntent": "Risks where observed access behavior differs from the agent's approved purpose or access boundaries."
      },
      "categoryHintLabel": "About the {{category}} category",
      "details": {
        "severity": "Severity",
        "category": "Governance category",
        "impact": "Impact",
        "description": "Description",
        "recommendedPolicy": "Recommended policy",
        "accessPath": "Access path",
        "viewAccessPath": "View Access Path",
        "viewAccessPathAria": "View the access path for {{name}}",
        "noAccessPath": "No access-path evidence is available for this finding yet.",
        "businessUnits": "Business units"
      }
    },
    "whatsChanged": {
      "title": "What's Changed",
      "subtitle": "Movement since the previous evaluation.",
      "noHistory": "No measured history is available for comparison. Runtime evaluation pending.",
      "items": {
        "newPolicyGaps_one": "New policy gap",
        "newPolicyGaps_other": "New policy gaps",
        "newlyDiscoveredAgents_one": "Newly discovered agent",
        "newlyDiscoveredAgents_other": "Newly discovered agents",
        "identityIssues_one": "Identity issue requiring review",
        "identityIssues_other": "Identity issues requiring review",
        "issuesResolved_one": "Governance issue resolved",
        "issuesResolved_other": "Governance issues resolved"
      }
    },
    "externalIntelligence": {
      "title": "External Intelligence",
      "summary_one": "{{count}} relevant advisory",
      "summary_other": "{{count}} relevant advisories",
      "viewAdvisory": "View advisory"
    },
    "governanceLandscape": {
      "title": "AI & Data Posture",
      "subtitle": "See where policy coverage and access risks need attention.",
      "tabsAria": "Governance landscape estates",
      "tab": {
        "ai": "AI Agents",
        "data": "Data Sources",
        "attention_one": "{{count}} needs attention",
        "attention_other": "{{count}} need attention",
        "attentionAtLeast_one": "At least {{count}} needs attention",
        "attentionAtLeast_other": "At least {{count}} need attention",
        "attentionRule": {
          "ai": "Agents with a policy gap, a setup gap, or not yet evaluated - each agent counted once. Agents whose enforcement readiness is unknown are not counted.",
          "data": "Data sources that are not active - missing connection, inactive, or failed login."
        },
        "noAttention": "Nothing needs attention",
        "attentionSources_one": "{{count}} source needs attention",
        "attentionSources_other": "{{count}} sources need attention",
        "getStarted": "Get started",
        "onboarding": "Onboarding in progress",
        "unavailable": "Not available",
        "unavailableTotal": "—",
        "notOnboarded": "Not onboarded",
        "notConnected": "Not connected",
        "comingSoon": "Coming soon"
      },
      "legend": {
        "aria": "Policy coverage legend",
        "title": "Policy coverage",
        "titleHint": "Policy coverage reflects TrustAI access-control evaluation. It does not represent the complete security or compliance posture of the agent.",
        "titleHintLabel": "About policy coverage",
        "secureHint": "Required access policies are currently applied based on TrustAI's evaluated policy coverage.",
        "secureHintLabel": "About policy covered",
        "notSecureHint": "One or more recommended access controls are missing, incomplete, or require review.",
        "notSecureHintLabel": "About policy gaps",
        "notEvaluatedHint": "TrustAI has discovered these agents, but has not yet evaluated their policy coverage.",
        "notEvaluatedHintLabel": "About not yet evaluated"
      },
      "metricsInfo": {
        "label": "How to read these cards",
        "policyTitle": "Policy coverage",
        "policyText": "Policy-covered agents out of every agent in the category. Unprotected agents have a known policy gap, or access TrustAI has not evaluated yet.",
        "recommendationTitle": "Recommended policy",
        "recommendationText": "TrustLogix may identify a policy that can address some or all of a protection gap. A recommendation is not itself a gap and does not guarantee full remediation.",
        "enforcementTitle": "Enforcement path",
        "enforcementText": "Agents routed through the TrustLogix proxy. Agents bypassing it are not enforced - an agent can have a policy and still lack enforcement.",
        "overlapTitle": "Counts may overlap",
        "overlapText": "Policy protection and enforcement issues can overlap. An agent may need additional policy protection and also require TrustLogix enforcement setup."
      },
      "estateSummary": "{{estate}} · {{summary}}",
      "shownCategories_one": "{{count}} category shown",
      "shownCategories_other": "{{count}} categories shown",
      "shownPlatforms_one": "{{count}} platform shown",
      "shownPlatforms_other": "{{count}} platforms shown",
      "empty": {
        "title": "Nothing needs attention here",
        "description": "Every item in this estate already satisfies its required governance policies."
      },
      "dataEmpty": {
        "title": "Connect your enterprise data",
        "description": "Connect data sources to understand enterprise data access and apply data-layer protection."
      },
      "environmentScope_one": "{{count}} agent discovered in {{environment}}",
      "environmentScope_other": "{{count}} agents discovered in {{environment}}"
    },
    "dataGovernance": {
      "platform": {
        "dataSources_one": "{{count}} data source",
        "dataSources_other": "{{count}} data sources",
        "openPlatformAria": "View {{name}} data sources",
        "viewDataSources": "View Data Sources"
      },
      "alerts": {
        "sectionSubtitle": "Data sources across your environment and detected risks",
        "sectionInfo": "Alerts represent findings detected during the latest available data source assessment. Policy coverage is shown separately.",
        "aboutSection": "About data source alerts",
        "viewAll": "View all data source alerts",
        "loading": "Loading data source alerts",
        "topCategoriesTooltip": "Alert categories with the most findings in the latest assessment. Select one to review those alerts.",
        "aboutTopCategories": "About alert categories",
        "moreCategories_one": "+ {{count}} more category",
        "moreCategories_other": "+ {{count}} more categories",
        "reviewCategoryAria_one": "Review {{count}} {{category}} alert on {{name}}",
        "reviewCategoryAria_other": "Review {{count}} {{category}} alerts on {{name}}",
        "noAlerts": "No alerts detected",
        "view": "View:",
        "viewLabel": "Data sources view",
        "viewSources": "Sources",
        "viewPlatforms": "Platforms",
        "viewAllSources": "View all data sources",
        "searchSources": "Search data sources...",
        "searchPlatforms": "Search platforms...",
        "sortLabel": "Sort:",
        "sort": {
          "attention": "Attention first",
          "alerts": "Most alerts",
          "name": "Name",
          "platform": "Platform"
        },
        "viewDataSource": "View data source",
        "openSourceAria": "Open {{name}}",
        "noMatches": "No matches",
        "noMatchesHint": "Try a different name or platform.",
        "unavailable": "Alert information unavailable",
        "retry": "Retry",
        "categoriesTitle": "Alert categories",
        "openAlerts_one": "Open alert",
        "openAlerts_other": "Open alerts",
        "sourcesWithAlerts_one": "Source with alerts",
        "sourcesWithAlerts_other": "Sources with alerts",
        "sourcesClear_one": "Source clear",
        "sourcesClear_other": "Sources clear",
        "sourceClearDetail": "Nothing on this data source needs review",
        "platformClearDetail_one": "{{count}} data source has no open alerts",
        "platformClearDetail_other": "{{count}} data sources have no open alerts"
      },
      "status": {
        "INCOMPLETE": "Incomplete",
        "NOT_EVALUATED": "Not Yet Evaluated"
      }
    },
    "accessFlows": {
      "preview": {
        "title": "Agent Access Paths",
        "subtitle": "Understand how AI agents reach enterprise data and where policy controls are missing.",
        "layer": {
          "identity": "Identity",
          "agent": "Agent",
          "enforcement": "Enforcement",
          "access": "Access Layer",
          "data": "Data"
        },
        "node": {
          "identity": "Non-human Identity",
          "agent": "AI Agent",
          "enforcement": "TrustLogix Enforcement",
          "access": "MCP / Gateway",
          "data": "Data Source"
        },
        "metric": {
          "agentsNeedingAttention_one": "Agent Requiring Review",
          "agentsNeedingAttention_other": "Agents Requiring Review",
          "serviceAccountsToReview_one": "Service Account Requiring Review",
          "serviceAccountsToReview_other": "Service Accounts Requiring Review",
          "pathsWithPolicyGaps_one": "Access Path with Policy Gaps",
          "pathsWithPolicyGaps_other": "Access Paths with Policy Gaps"
        },
        "hint": {
          "pathsWithPolicyGaps": "Agent-to-data access paths where one or more expected policy controls are missing or incomplete.",
          "pathsWithPolicyGapsLabel": "About access paths with policy gaps",
          "notEvaluated": "TrustAI has discovered this component, but runtime activity has not yet been evaluated for this access path.",
          "notEvaluatedLabel": "About runtime evaluation"
        },
        "cta": "View Access Paths"
      },
      "pageTitle": "Agent Access Flows",
      "pageSubtitle": "Trace agent access from identity to enterprise data and identify governance gaps.",
      "eyebrow": "Detailed investigation",
      "backToFinding": "Back to Finding",
      "filtersAria": "Agent access flow filters",
      "search": "Search agents...",
      "searchLabel": "Search agents",
      "businessUnit": "Business Unit",
      "dataPlatform": "Data Platform",
      "status": "Status",
      "all": "All",
      "statusOption": {
        "attention": "Needs Attention",
        "all": "All",
        "secure": "Policy Covered",
        "not-evaluated": "Not Yet Evaluated"
      },
      "position": {
        "needAttention": "Agent {{index}} of {{count}} needing attention",
        "matching": "Agent {{index}} of {{count}} matching your filters",
        "affected": "Agent {{index}} of {{count}} affected by {{finding}}"
      },
      "switcher": {
        "label": "Change the selected agent",
        "change": "Change agent",
        "previous": "Previous agent",
        "next": "Next agent",
        "previousNamed": "Previous agent: {{name}}",
        "nextNamed": "Next agent: {{name}}"
      },
      "counts": {
        "gaps_one": "{{count}} policy gap",
        "gaps_other": "{{count}} policy gaps",
        "violations_one": "{{count}} violation",
        "violations_other": "{{count}} violations",
        "notEvaluated": "Not yet evaluated",
        "clear": "No policy gaps or violations"
      },
      "browse": {
        "title": "Agents",
        "titleAttention": "Agents needing attention",
        "count_one": "{{count}} agent",
        "count_other": "{{count}} agents",
        "searchLabel": "Filter agents in this list",
        "filterLabel": "Filter agents by status",
        "selected": "Selected",
        "empty": "No agents in this list match your search.",
        "needsAttention": "Needs attention",
        "enforcement": "TrustLogix enforcement: {{status}}"
      },
      "context": {
        "eyebrow": "Selected agent",
        "metaLabel": "Agent summary",
        "mcps_one": "{{count}} MCP",
        "mcps_other": "{{count}} MCPs",
        "tools_one": "{{count}} tool",
        "tools_other": "{{count}} tools",
        "viewDetails": "View agent details"
      },
      "empty": {
        "title": "No agents match these filters.",
        "description": "Try changing Business Unit, Data Platform, Status, or search criteria.",
        "clearFilters": "Clear filters"
      },
      "flowStatus": {
        "NEEDS_ATTENTION": "Needs Attention",
        "SECURE": "Policy Covered",
        "NOT_EVALUATED": "Not Yet Evaluated"
      },
      "state": {
        "POLICY_ENFORCED": "Policy enforced",
        "POLICY_GAP": "Policy gap",
        "VIOLATION": "Violation",
        "NOT_EVALUATED": "Not yet evaluated",
        "POLICY_ASSIGNED": "Policy assigned"
      },
      "loadError": "Agent access flows could not be loaded. Refresh the page to try again."
    },
    "lifecycle": {
      "setupCards": {
        "title": "AI + Data Estate",
        "subtitle": "Build visibility across the systems your agents use.",
        "aiPlatforms": {
          "title": "AI Agents",
          "description": "Import agents from a supported platform, or register them manually."
        },
        "dataPlatforms": {
          "title": "Data Platforms",
          "description": "Connect enterprise data that agents may access.",
          "supported": "Supported data platforms",
          "cta": "Connect a data platform"
        }
      },
      "agentPrep": {
        "extend": {
          "checking": "Checking whether AI agents have been onboarded…",
          "unavailable": "We couldn't check whether AI agents have been onboarded. Your data platform content is unaffected."
        },
        "helper": {
          "default": "Your agents' MCP connection settings must point to the TrustLogix MCP Gateway rather than directly to downstream MCP services. Starting the import does not make this change.",
          "configured": "Update agents' MCP connections to use the gateway. You will confirm these requirements in the import wizard."
        },
        "actions": {
          "import": "Import Agents",
          "setUp": "Set up MCP Gateway",
          "instructions": "View setup instructions",
          "retry": "Retry",
          "retryLabel": "Retry gateway configuration check"
        }
      },
      "job": {
        "viewDetails": "View onboarding activity",
        "refresh": "Refresh status",
        "dismiss": "Dismiss",
        "refreshing": {
          "title": "Refreshing inventory…",
          "description": "The import finished. Your agent inventory is updating, and nothing needs to be started again."
        },
        "unavailable": {
          "title": "Job status unavailable",
          "description": "TrustLogix could not read this job's status. The job itself may still be running, and nothing needs to be started again."
        },
        "zeroResult": {
          "title": "{{name}} finished without importing any agents",
          "description": "No agents were found in the selected projects. Review the selected projects or the agent registry."
        }
      },
      "agentPosture": {
        "kicker": "Agent posture",
        "title": "Agent posture details aren’t available yet",
        "body_one": "{{value}} agent is already onboarded. Detailed policy coverage and protection status for your agents isn’t available in this view yet.",
        "body_other": "{{value}} agents are already onboarded. Detailed policy coverage and protection status for your agents isn’t available in this view yet.",
        "noteProgress": "We’re working on bringing agent posture data to this view.",
        "noteMeanwhile": "In the meantime, you can view your onboarded agents.",
        "cta": "View onboarded agents"
      },
      "aiOnboarding": {
        "kicker": "Extend governance to your AI agents",
        "title": "Secure your AI estate",
        "body": "Your data sources are already connected. Import agents to understand their access, policy coverage, and enforcement status."
      },
      "inventory": {
        "pending": {
          "title": "Loading your AI and data estate"
        },
        "unavailable": {
          "title": "Your AI and data estate could not be loaded",
          "description": "TrustLogix could not read your inventory, so it cannot say what has been connected. This does not mean nothing has been.",
          "retry": "Retry"
        }
      },
      "inventorySource": {
        "manual": {
          "title": "Keep your agent inventory up to date",
          "description": "Your agents were imported manually. Connect a supported agent registry to discover agents from their source.",
          "cta": "Import Agents",
          "dismiss": "Dismiss"
        },
        "lastImported": "Last imported: {{value}}",
        "lastSynced": "Last synced: {{value}}",
        "registryUnhealthy": {
          "title": "{{name}} is not connected",
          "description": "Agents already imported from this registry remain in your inventory. Their details and evaluations are unchanged.",
          "cta": "View registry details"
        }
      },
      "education": {
        "title": "What TrustAI will do next",
        "subtitle": "Import → Discover → Map → Evaluate → Govern",
        "discover": {
          "title": "Discover",
          "description": "Discover agents, tools and data sources."
        },
        "map": {
          "title": "Map",
          "description": "Understand how identity reaches data: Identity → Agent → Tool / Service → Data."
        },
        "evaluate": {
          "title": "Evaluate",
          "description": "Evaluate access against governance controls to find policy gaps, risky access and violations."
        },
        "govern": {
          "title": "Govern",
          "description": "Recommend policies and remediation actions."
        }
      },
      "onboarding": {
        "startError": "Could not start the import. Try again."
      },
      "setupProgress": {
        "title": "Setup progress",
        "subtitle": "Where TrustAI has got to with your estate.",
        "statusDone": "Complete",
        "statusActive": "In progress",
        "statusPending": "Not started",
        "connect": {
          "title": "Connect",
          "done_one": "{{count}} platform connected",
          "done_other": "{{count}} platforms connected",
          "pending": "No platforms connected yet"
        },
        "discover": {
          "title": "Discover",
          "active": "Discovering agents and data resources",
          "done": "{{agents}} agents and {{dataSources}} data sources discovered",
          "pending": "Discovery has not started"
        },
        "govern": {
          "title": "Govern",
          "active": "Evaluating agent access",
          "done": "Governance findings available",
          "pending": "Evaluation has not started"
        },
        "readyCount": "{{done}} of {{total}} ready",
        "statusAttention": "Needs attention",
        "enforcement": {
          "title": "Enforcement setup",
          "ready": "{{ready}} of {{total}} agents have enforcement setup configured",
          "environmentRequired": "Enable TrustLogix enforcement for this tenant",
          "environmentAttention": "TrustLogix enforcement requires attention",
          "environmentUnknown": "TrustLogix enforcement status unknown",
          "notReady_one": "{{count}} agent requires routing or enforcement configuration.",
          "notReady_other": "{{count}} agents require routing or enforcement configuration."
        }
      },
      "discovery": {
        "title": "Importing agents",
        "subtitle": "TrustLogix is connecting agent, identity, and governance context.",
        "barLabel": "Import progress",
        "viewActivity": "View import activity",
        "continueNote": "You can continue using TrustLogix while the import runs."
      },
      "governanceReadiness": {
        "title": "Governance Landscape",
        "calloutTitle": "Governance insights aren't available yet",
        "calloutDescription": "TrustAI has discovered your estate. Evaluate agent access to identify policy gaps and governance issues.",
        "startCta": "Start evaluation",
        "exploreCta": "Explore discovered estate",
        "started": "Evaluation started. Findings will appear as they land.",
        "startError": "Could not start the evaluation. Try again."
      },
      "evaluation": {
        "title": "Governance evaluation in progress",
        "subtitle": "TrustAI is evaluating agent access paths and policy coverage.",
        "evaluatingLabel": "Evaluating",
        "chain": "Identity → Agent → Tool → Data",
        "barLabel": "Evaluation progress",
        "percent": "{{value}}% complete",
        "agentsEvaluated_one": "{{count}} agent evaluated",
        "agentsEvaluated_other": "{{count}} agents evaluated",
        "dataSourcesAnalyzed_one": "{{count}} data source analyzed",
        "dataSourcesAnalyzed_other": "{{count}} data sources analyzed",
        "viewActivity": "View evaluation activity"
      },
      "flowIllustration": {
        "title": "Agent Access Path",
        "subtitle": "TrustAI maps how agents reach enterprise data and whether TrustLogix can enforce policies on that path.",
        "illustrativeBadge": "Illustrative",
        "illustrativeNote": "Access paths and enforcement readiness become available after agents are discovered. This is an illustrative path.",
        "nodes": {
          "identity": "Identity",
          "agent": "AI Agent",
          "enforcement": "TrustLogix Enforcement",
          "gateway": "MCP / Gateway",
          "data": "Data Source"
        }
      },
      "integrations": {
        "azureAiFoundry": "The platform where your Azure-hosted agents run.",
        "sharepoint": "Documents and sites your agents may read.",
        "snowflake": "Warehouse data your agents may query.",
        "databricks": "Lakehouse tables and models your agents may reach.",
        "mcpServers": "The servers that expose tools to your agents."
      },
      "capabilities": {
        "agents": "agents, their prompts and capabilities",
        "documents": "sites, libraries and sensitive documents",
        "datasets": "databases, schemas and sensitive datasets",
        "tools": "MCP servers, their tools and the agents using them"
      }
    },
    "enforcementReadiness": {
      "eyebrow": "AI + Data governance setup",
      "connected": "Platform connected",
      "discoveredOn_one": "{{platform}} · {{count}} agent discovered",
      "discoveredOn_other": "{{platform}} · {{count}} agents discovered",
      "discovered_one": "{{count}} agent discovered",
      "discovered_other": "{{count}} agents discovered",
      "environmentRequired": {
        "title": "TrustLogix enforcement is disabled",
        "description": "Policies can be created and assigned, but TrustLogix runtime enforcement is unavailable until workspace enforcement is enabled and the required agent setup is complete.",
        "configured_one": "{{ready}} of {{count}} agent already has an enforcement path configured.",
        "configured_other": "{{ready}} of {{count}} agents already have an enforcement path configured."
      },
      "attentionRequired": {
        "title": "Workspace enforcement needs attention",
        "description": "The workspace's enforcement path is reporting a problem. Configured agent setup does not mean runtime enforcement is available."
      },
      "incomplete": {
        "title_one": "{{count}} agent needs enforcement setup",
        "title_other": "{{count}} agents need enforcement setup",
        "summary_one": "Enforcement is enabled for this workspace. An enforcement path is configured for {{ready}} of {{total}} agents; {{count}} still needs setup.",
        "summary_other": "Enforcement is enabled for this workspace. An enforcement path is configured for {{ready}} of {{total}} agents; {{count}} still need setup.",
        "unverified_one": "Enforcement setup is not verified for {{count}} agent.",
        "unverified_other": "Enforcement setup is not verified for {{count}} agents."
      },
      "complete": {
        "title": "Enforcement setup is configured",
        "ready_one": "An enforcement path is configured for {{count}} agent.",
        "ready_other": "An enforcement path is configured for all {{count}} agents.",
        "description": "Configuration alone does not confirm runtime policy enforcement. Policy coverage is reported separately."
      },
      "unknown": {
        "title": "Workspace enforcement status is not verified",
        "description": "TrustLogix could not establish whether enforcement is enabled. Review the workspace settings before relying on runtime enforcement."
      },
      "unverifiedOnly": {
        "title_one": "Enforcement setup is not verified for {{count}} agent",
        "title_other": "Enforcement setup is not verified for {{count}} agents",
        "summary": "Enforcement is enabled for this workspace. An enforcement path is configured for {{ready}} of {{total}} agents; the rest cannot be verified from the information available."
      },
      "setupUnavailable": {
        "title": "Enforcement setup is not verified",
        "description": "Agents' enforcement setup could not be read, so no agent is counted as configured or as needing setup."
      }
    },
    "nextSteps": {
      "opensInNewTab": "{{label}} (opens in a new tab)",
      "agentRegistry": {
        "cta": "Import Agents",
        "learnMore": "How agent protection works"
      },
      "dataPlatforms": {
        "title": "Connect your data platforms",
        "description": "Bring your enterprise data into TrustLogix to understand sensitive-data exposure and govern what AI agents can access.",
        "cta": "Connect Data Sources",
        "supported": "Supported platforms",
        "more_one": "+ {{count}} more",
        "more_other": "+ {{count}} more"
      }
    },
    "learnMore": {
      "eyebrow": "Learn more",
      "title": "New to TrustLogix?",
      "description": "Explore how TrustLogix helps organizations secure AI agents, govern data access, and reduce risk.",
      "links": {
        "documentation": "Documentation",
        "releaseNotes": "Release notes"
      }
    },
    "governance": {
      "pageTitle": "AI & Data Security Governance Overview",
      "pageSubtitle": "Monitor agent authorization, policy enforcement, and data access protection across your enterprise.",
      "tabsAria": "Resource type",
      "notAvailableYet": "Not available yet",
      "tab": {
        "data": "Data Sources",
        "ai": "AI Agents",
        "comingSoon": "Coming soon",
        "status": {
          "data": {
            "attention": "Needs attention",
            "healthy": "Healthy",
            "notConnected": "Not connected",
            "unknown": "Status not available"
          },
          "ai": {
            "attention": "Needs attention",
            "allProtected": "All agents protected",
            "notImported": "Not imported",
            "unknown": "Status not available"
          }
        },
        "tip": {
          "data": {
            "alerts_one": "{{count}} source has open alerts.",
            "alerts_other": "{{count}} sources have open alerts.",
            "failed_one": "{{count}} access control failed to deploy.",
            "failed_other": "{{count}} access controls failed to deploy.",
            "saved_one": "{{count}} access control is saved but not deployed.",
            "saved_other": "{{count}} access controls are saved but not deployed.",
            "notDeployed_one": "{{count}} access control is not deployed.",
            "notDeployed_other": "{{count}} access controls are not deployed.",
            "incomplete_one": "{{count}} source has incomplete setup.",
            "incomplete_other": "{{count}} sources have incomplete setup.",
            "disabled_one": "{{count}} monitoring policy is disabled.",
            "disabled_other": "{{count}} monitoring policies are disabled.",
            "healthy": "Monitoring and access controls are active, setup is complete, and no open alerts remain.",
            "notConnected": "No data sources connected. Connect a source to start monitoring.",
            "unknown": "Governance status cannot be confirmed until every measure has been read."
          },
          "ai": {
            "attention_one": "{{value}} agent has missing, ineffective, or unenforced authorization controls.",
            "attention_other": "{{value}} agents have missing, ineffective, or unenforced authorization controls.",
            "allProtected": "All {{value}} agents meet the required authorization controls.",
            "notImported": "No AI agents imported. Import agents to review authorization protection.",
            "unknown": "Authorization protection has not been evaluated yet."
          }
        }
      },
      "state": {
        "loading": "Loading…",
        "error": "Could not load this section.",
        "retry": "Retry",
        "restricted": "You do not have permission to view this information."
      },
      "data": {
        "statusTitle": "Data Governance Status",
        "currentState": "Current state",
        "currentStateTip": "Current monitoring, control deployment, alert, and setup state for connected data sources.",
        "currentStateAria": "About the current state",
        "metric": {
          "monitoring": {
            "label": "Monitoring policies enabled",
            "tip": "Enabled monitoring policies out of all configured monitoring policies.",
            "disabled": "{{count}} disabled",
            "allEnabled": "All monitoring policies enabled"
          },
          "access": {
            "label": "Access controls deployed",
            "tip": "Deployed access controls out of all saved and deployed controls. A saved control is not yet deployed.",
            "saved": "{{count}} saved",
            "failed": "{{count}} failed",
            "failedAria_one": "{{count}} access control failed to deploy. View deployment details",
            "failedAria_other": "{{count}} access controls failed to deploy. View deployment details",
            "allDeployed": "All access controls deployed"
          },
          "alerts": {
            "label": "Open alerts",
            "tip": "Open alerts across connected data sources. No open alerts does not by itself confirm protection coverage.",
            "affected_one": "Across {{count}} affected source",
            "affected_other": "Across {{count}} affected sources",
            "none_one": "No open alerts across {{count}} source",
            "none_other": "No open alerts across {{count}} sources"
          },
          "incomplete": {
            "label": "Sources with incomplete setup",
            "tip": "Sources that still require configuration to complete their setup.",
            "action": "Complete configuration",
            "allConfigured_one": "All {{count}} source configured",
            "allConfigured_other": "All {{count}} sources configured"
          },
          "infoAria": "About {{label}}"
        },
        "riskTitle": "Data Source Risk Summary",
        "riskSubtitle": "Review affected sources and investigate open alerts across your data platforms.",
        "viewAllAlerts": "View all alerts",
        "viewSources": "View sources",
        "sortBy": "Sort by",
        "sort": {
          "affected": "Most sources with open alerts",
          "alerts": "Most open alerts",
          "name": "Name A–Z"
        },
        "view": "View",
        "viewSourcesOption": "Sources",
        "viewPlatformsOption": "Platforms",
        "legend": {
          "total": "Total sources",
          "withAlerts": "With open alerts",
          "noAlerts": "No open alerts",
          "noAlertsTip": "No open alerts at the last evaluation. This does not confirm protection coverage or complete setup.",
          "noAlertsTipAria": "About sources with no open alerts",
          "platforms_one": "Across {{count}} platform",
          "platforms_other": "Across all {{count}} platforms"
        },
        "column": {
          "platform": "Data platform",
          "sources": "Sources",
          "alertStatus": "Source alert status",
          "openAlerts": "Open alerts",
          "categories": "Open alerts by category",
          "source": "Data source"
        },
        "sourcesLinkAria": "View {{count}} {{platform}} sources",
        "noOpenAlerts": "No open alerts",
        "notAssessed": "Not assessed",
        "setupIncomplete": "Setup is incomplete, so this data source's details can't be opened yet.",
        "segment": {
          "bad": "sources with open alerts",
          "good": "sources with no open alerts",
          "neutral": "sources not assessed for alerts",
          "tip": "{{count}} {{label}} · {{platform}}. View matching sources.",
          "barAria": "{{bad}} with open alerts, {{good}} without open alerts",
          "barAriaNotAssessed": "{{bad}} with open alerts, {{good}} without open alerts, {{neutral}} not assessed"
        },
        "footnote": "Alert status is separate from source configuration and control deployment. No open alerts does not confirm protection coverage.",
        "empty": {
          "title": "No data sources connected yet",
          "description": "Connect your first data source to view monitoring status, access control deployment, and alerts. Governance metrics will appear after connection and evaluation.",
          "action": "Connect Data Sources"
        },
        "noResults": "No matching {{items}}.",
        "items": {
          "sources": "sources",
          "platforms": "platforms"
        },
        "searchPlaceholder": "Search sources and platforms",
        "searchLabel": "Search data sources",
        "clearSearch": "Clear search"
      },
      "ai": {
        "activityTitle": "AI Agent Activity",
        "activityWindow": "· Last {{count}} Hours",
        "metric": {
          "decisions": {
            "label": "Authorization Decisions",
            "tip": "Authorization decisions recorded during the last 24 hours."
          },
          "policies": {
            "label": "Policies Applied",
            "tip": "Unique authorization policies that contributed to access decisions during the last 24 hours."
          },
          "drift": {
            "label": "Agents with Intent Drift",
            "tip": "Unique agents whose runtime behavior deviated from their defined purpose during the last 24 hours."
          },
          "imported": {
            "label": "New Agents Imported",
            "tip": "Agents imported into TrustLogix during the last 24 hours."
          },
          "noAgents": "No agents imported"
        },
        "quiet": "No agent activity recorded in the last 24 hours. Fleet protection is shown separately below.",
        "fleetTitle": "Agent Fleet Protection Summary",
        "fleetSubtitle": "Authorization protection across connected agent platforms.",
        "groupBy": "Group by",
        "dimension": {
          "BUSINESS_UNIT": "Business Unit",
          "DEPARTMENT": "Department",
          "GEOGRAPHY": "Geography"
        },
        "groupHeader": {
          "BUSINESS_UNIT": "Business unit",
          "DEPARTMENT": "Department",
          "GEOGRAPHY": "Geography"
        },
        "groupNoun": {
          "BUSINESS_UNIT": "business unit",
          "DEPARTMENT": "department",
          "GEOGRAPHY": "geography"
        },
        "group": {
          "QUANT_ANALYTICS": "Quantitative Analytics",
          "TRADING_AND_SALES": "Trading & Sales",
          "CLIENT_AND_PEOPLE": "Client & People Services",
          "AMERICAS": "Americas",
          "EMEA": "EMEA",
          "APAC": "Asia Pacific"
        },
        "sortBy": "Sort by",
        "sort": {
          "unprotected": "Most unprotected agents",
          "protected": "Most protected agents",
          "name": "Name A–Z"
        },
        "legend": {
          "total": "Total Agents:",
          "unprotected": "Unprotected:",
          "protected": "Protected:",
          "unprotectedTip": "Unprotected: One or more required authorization controls are missing, ineffective, or not enforced.",
          "protectedTip": "Protected: Required authorization policies are effective and the applicable enforcement paths are active.",
          "unprotectedTipAria": "About unprotected agents",
          "protectedTipAria": "About protected agents"
        },
        "sortHeaderAria": "Sort by most {{measure}} agents on {{platform}}",
        "measure": {
          "unprotected": "unprotected",
          "protected": "protected"
        },
        "notConnected": "Not connected",
        "connectedNoAgents": "Connected · No agents",
        "segment": {
          "unprotected": "unprotected agents",
          "protected": "protected agents",
          "tip": "{{count}} {{label}} · {{platform}} · {{group}}. View matching agents.",
          "barAria": "{{bad}} unprotected, {{good}} protected"
        },
        "matrixNote": "Not connected: {{noun}} not connected to platform. Connected · No agents: platform connected, with no agents in this {{noun}}.",
        "protectionUnavailable": "Protection has not been evaluated for these agents yet. Results appear here after evaluation.",
        "empty": {
          "title": "No AI agents imported yet",
          "description": "Import your agents to review authorization protection across platforms. Activity metrics will appear when runtime events are received.",
          "action": "Import Agents"
        }
      }
    }
  },
  "whitelist": {
    "title": "Allowlist",
    "type": "Type",
    "dataSource": "Data Source",
    "description": "An allow list is a security configuration that permits only specified IP addresses, users, or applications to access a data source or system.",
    "infoTooltip": "Allow lists are a way to limit access to the data source by only allowing a specific set of IP addresses, application tools, or users to interact with it. This can help administrators enforce compliant cloud security policies.",
    "noDataName": "whitelist",
    "saved": "The Service Accounts Allowlist has been saved",
    "saveFailed": "Failed to save the Service Accounts Allowlist.",
    "systemUserCannotBeEdited": "This user is system-generated and cannot be edited.",
    "systemUserCannotBeDeleted": "This user is system-generated and cannot be deleted.",
    "systemUserInfo": "This user is system-generated.",
    "panel": {
      "addTitle": "Add Allowlist Entry",
      "editTitle": "Edit Allowlist Entry",
      "save": "Save",
      "freemiumSaveDisabled": "This is a premium feature. Please contact TrustLogix at sales@trustlogix.io.",
      "fields": {
        "type": "Type",
        "value": "Value",
        "groups": "Groups"
      },
      "placeholders": {
        "type": "Choose a type",
        "name": "Choose a name",
        "value": "Type allowlist name or value",
        "groups": "Type allowlist groups",
        "description": "Type allowlist description"
      }
    },
    "validation": {
      "typeRequired": "Please choose a whitelist type",
      "valueRequired": "Please type a value",
      "invalidIp": "Invalid IP Address supported format \"10.10.10.10\" and \"10.0.0.8-10.0.0.10\""
    },
    "delete": {
      "title": "Delete Entry",
      "description": "Are you sure you want to delete this row <strong>{{name}}</strong>?",
      "warning": "Deleting row will delete the entry."
    }
  },
  "login": {
    "title": "Login",
    "username": "Username",
    "password": "Password",
    "submitButton": "Log in",
    "continueButton": "Continue",
    "backButton": "Back to login",
    "checking": "Checking…",
    "signingIn": "Signing in…",
    "verifying": "Verifying…",
    "verifyButton": "Verify",
    "errors": {
      "unavailable": "We couldn’t sign you in. Please try again. If the problem continues, contact your administrator.",
      "noSignInOptions": "No sign-in options are available for this account. Please try again or contact your administrator.",
      "federated": "Your account uses Single Sign-On. Sign in through your organization’s identity provider."
    },
    "selectTenant": "Select a Tenant",
    "sessionExpired": "Session Expired",
    "brand": {
      "headline": "The preemptive security control plane for Agentic AI, tools and data",
      "subline": "The unified data security layer that enables least-privilege data access for enterprise AI agents across heterogeneous data stores"
    },
    "mfa": {
      "title": "Verify your identity",
      "description": "Enter the 6-digit code from your authenticator app."
    }
  },
  "mfa": {
    "inputLabel": "Authentication code",
    "digitLabel": "Digit {{digit}} of {{total}}"
  },
  "signUp": {
    "automation": "Discover Hidden Data Risk",
    "aws_marketplace": "Also available directly through the AWS Marketplace",
    "dataAccess": "Start identifying data access issues within minutes without seeing the data itself",
    "deploy": "See and deploy recommended policies native to your data sources with no coding or scripting required",
    "emailVerification": {
      "body1": "You will shortly receive an email containing your TrustLogix login details.",
      "body2": "If you have not received the email within the next 24 hours.  Please contact us at <0> support@trustlogix.io </0> using Customer ID: <strong>{{id}}</strong>",
      "body3": "<strong>While we work on setting you up, please check how TrustLogix can improve your <0>Data Security Posture Management</0></strong>",
      "title": "Thank you! Your email has been verified"
    },
    "resetPassword": "Reset Password",
    "errors": {
      "DUPLICATE_TENANT": "This account already exists in our system. Please check your email for login details.",
      "INVALID_TOKEN": " Your token has expired. Please re-subscribe by logging in again to your AWS Marketplace account.",
      "PENDING_PROVISIONING": "Your tenant is in provisioning. Please try again later",
      "PENDING_VERIFICATION": "A verification link has been sent to your email. Click on the link to verify your email and complete registration.",
      "SERVER_ERROR": "Something went wrong please try again."
    },
    "improve": "Govern Multi-Cloud Data Sprawl",
    "main": "Get started in a few minutes",
    "mainSub": "Manage Data Security Posture and Access Controls Across All Your Cloud Environments",
    "monitor": "Enforce Least Privilege Policies",
    "soc": "SOC 2 Compliant",
    "success": "Your request has been received. A verification link has been sent to email <strong>{{email}}</strong>. Click on the link to verify your email and complete registration.",
    "term": "By signing up you are accepting these <0>Terms & Conditions</0>",
    "title": "Register for a free trial",
    "titleSub": "Safeguard Your Data Access Quickly & Easily.",
    "visibility": "Central visibility and control across all your data sources"
  },
  "snowflake": {
    "Column Masking Policy": "Mask Column",
    "DATABASE": "Database",
    "INTEGRATION": "Integration",
    "RESOURCE MONITOR": "Resource Monitor",
    "RLS Policy": "Row Access",
    "Role Template": "Privilege Template",
    "Row Filter": "Row Access",
    "SHARED_DATABASE": "Shared Database",
    "Schema (All-Tables)": "Database - Multi Schema",
    "Schema (Multi-Table)": "Schema - Multi Objects",
    "Shares": "Share Objects",
    "Single-Table": "Row Access Policy",
    "Tag": "Tag",
    "WAREHOUSE": "Warehouse"
  },
  "oracle": {
    "Schema (All-Tables)": "Database - Multi Schema",
    "Schema (Multi-Table)": "Schema - Multi Objects"
  },
  "sqlserver": {
    "Schema (All-Tables)": "Schema (All-Objects)",
    "Schema (Multi-Table)": "Schema (Multi-Objects)",
    "Single-Table": "Row Access and Mask Column",
    "Role Template": "Privilege Template",
    "Column Masking Policy": "Mask Column",
    "RLS Policy": "Row Access",
    "Row Filter": "Row Access"
  },
  "standardSnowflake": {
    "Single-Table": "Mask Column"
  },
  "successMessage": "Your data has been saved.",
  "successTestConnectionMessage": "Account validated successfully.",
  "table": {
    "loading": "Loading table data…",
    "noDataTagManagement": "No tags exist. To add a new tag, click the Add Tag button.",
    "noDataTagManagementWithFilters": "No tags exist with the applied filters",
    "noDataTagAssociation": "No tag associations exist. To add a new tag association, click the Add Tag Association button.",
    "noDataTagAssociationWithFilters": "No tag associations exist with the applied filters",
    "noDataAuditReport": "No audit reports exist. To view audit reports, click the View Audit Report button.",
    "noDataAuditReportWithFilters": "No audit reports exist with the applied filters",
    "noDataCustom": "There are no {{name}} created. Click on the button above to create new {{name}}.",
    "noSearchResult": "No data found for this search <strong>{{name}}</strong>",
    "noAccessPolicies": "No access policies found.",
    "noDataSources": "No data sources found.",
    "noPrivilegeTemplatesFound": "No privilege templates found.",
    "emptyResult": "No data found for applied filters ",
    "noRecordsForSearch": "No records found for this search <strong>{{name}}</strong>",
    "adjustFiltersMessage": "Try adjusting your <1>filters</1> to find what you are looking for.",
    "actions": {
      "viewDetails": "View Details"
    },
    "policyMarkers": {
      "redeployRequired": "You need to re-deploy this policy because changes were made to the policy configuration",
      "draftNotDeployed": "Draft: Changes saved but not deployed"
    },
    "columns": {
      "createdOn": "Created On",
      "name": "Name",
      "description": "Description",
      "status": "Status",
      "lastUpdated": "Last Updated",
      "createdBy": "Created By",
      "type": "Type"
    }
  },
  "tagAssociation": {
    "dialog": {
      "addTitle": "Add Tag Association",
      "save": "Save",
      "tagDatabaseLabel": "Tag Database",
      "tagSchemaLabel": "Tag Schema",
      "tagNameLabel": "Tag Name",
      "tagValueLabel": "Tag Value",
      "tagNamePlaceholder": "Select key or type to create one",
      "tagValuePlaceholder": "Select value or type to create one",
      "quotesNotAllowedTagName": "Quotes are not allowed in the tag name",
      "quotesNotAllowedTagValue": "Quotes are not allowed in the tag value",
      "createSuccess": "New Tag Association is created."
    },
    "object": {
      "objectTypeLabel": "Object Type",
      "databaseNameLabel": "Database Name",
      "schemaNameLabel": "Schema Name",
      "tableNameLabel": "Table Name",
      "columnNameLabel": "Column Name",
      "enterValuesLabel": "Enter values",
      "enableSectionMessage": "Select appropriate fields above to enable this section",
      "hintNote": "<b>Note:</b> type and press <b>enter</b> to add value",
      "exampleColumn": "<b>e.g.</b> DATABASE<b>.</b>SCHEMA<b>.</b>TABLE<b>.</b>COLUMN",
      "exampleTableWithSchema": "<b>e.g.</b> DATABASE<b>.</b>SCHEMA<b>.</b>TABLE",
      "exampleTableNoSchema": "<b>e.g.</b> DATABASE<b>.</b>TABLE",
      "exampleSchema": "<b>e.g.</b> DATABASE<b>.</b>SCHEMA",
      "exampleDatabase": "<b>e.g.</b> DATABASE"
    },
    "page": {
      "title": "Objects",
      "deleteTitle": "Delete Tag Association",
      "deleteConfirmMessage": "Do you want to remove the tag association from <strong>{{path}}</strong>?",
      "deleteConfirmSnowflakeNote": "<b>Note:</b> The list shown here might not reflect the deletion immediately due to a latency of 2 hours within the data source.",
      "columns": {
        "workspace": "Workspace",
        "objectDatabase": "Database",
        "objectSchema": "Schema",
        "objectName": "Object Name",
        "columnName": "Column"
      }
    }
  },
  "tagManagement": {
    "systemTagCantNotBeDeleted": "This tag is system-generated and cannot be deleted.",
    "systemTagInfo": "This tag is system-generated.",
    "tagValueRequiredInfo": "No values added. Add at least one tag value using the input above.",
    "createWarning": "Tag creation may take up to two hours to appear in the list.",
    "updateWarning": "Tag updates may take up to two hours to reflect in the list.",
    "tagAssociationWarning": "Tag association changes may take up to two hours to reflect in the list.",
    "dialog": {
      "addTitle": "Add Tag",
      "editTitle": "Edit Tag",
      "save": "Save",
      "update": "Update",
      "editDbSchemaCheckbox": "Edit Tag Database & Schema",
      "tagValueInputError": "Please add at least one tag value",
      "tagDatabaseLabel": "Tag Database",
      "tagSchemaLabel": "Tag Schema",
      "tagNameLabel": "Tag Name",
      "tagValueInputLabel": "Enter Tag Values",
      "tagValueInputHint": "Note: type and press enter to add value",
      "tagValuesHeader": "Tag Values",
      "addMoreTags": "Add More Tags",
      "duplicateTagName": "Duplicate tag value found for the same tag key",
      "quotesNotAllowed": "Quotes are not allowed in the tag values",
      "createSuccess": "New Tag is created.",
      "updateSuccess": "The tag is updated.",
      "removeTagConfirmTitle": "Update Tag",
      "removeTagConfirmMessage": "Do you want to remove <strong>{{tags}}</strong> from the allowed values which can have an impact on the access and monitoring policies?"
    }
  },
  "tenantActivation": {
    "error": "Error in activating the account",
    "labels": {
      "activateAccount": "Activate Account",
      "helperText": "Tenant Id for Activating Account",
      "tenantId": "Tenant Id"
    },
    "success": "Account Activated successfully"
  },
  "title": "TrustLogix",
  "unifiedPolicy": {
    "policyType": "Choose a Policy Type",
    "policyTags": {
      "label": "Choose tags",
      "floatLabel": "Tags",
      "errorTitle": "Tags Error"
    },
    "identityAttributesErrorTitle": "Attributes Error",
    "rhsAttributeValueLabels": {
      "default": "Value",
      "USER_ATTRIBUTE": "Attribute Name",
      "DATA_ATTRIBUTE": "Column Name",
      "VALUE": "Value",
      "CONSTANT": "Value",
      "SESSION_ATTRIBUTE": "Session Attribute",
      "COLUMN_TAGGED_AS": "Column Tagged as",
      "CUSTOM_EXPRESSION": "Value",
      "AGENT_ATTRIBUTE": "Agent Attribute",
      "RESOURCE_ATTRIBUTE": "Resource Attribute"
    },
    "selectField": "Select {{label}}",
    "helpMeChoose": "Help Me Choose Policy Type",
    "compactViewAdvanced": "Compact View (Advanced)",
    "bestForLabel": "Best For",
    "chooseShareObjects": "Choose Shares",
    "chooseNames": "Choose names",
    "withMaskingPattern": "with masking pattern",
    "conditionCardTooltip": "<b>Named As:</b><br />All objects that belong to a certain database, schema and table/view.<br /><br /><b>Classified As:</b><br />All objects that belong to one or more of the defined Tags.",
    "conditionCard": {
      "namedAs": {
        "title": "Named As (Static Path Selector)",
        "description": "Directly target specific tables or individual column paths manually. Ideal for custom overrides and singular table restrictions.",
        "scopeTag": "Static Scope"
      },
      "classifiedAs": {
        "title": "Classified As (Dynamic Governance Tags)",
        "description": "Target data dynamically across multiple systems via metadata tags (PII, SSN, Credit Card labels). Automatically updates for future catalog items.",
        "scopeTag": "Dynamic Discovery"
      }
    },
    "simulator": {
      "title": "Masking Simulator",
      "subtitle": "Preview the masking pattern applied to a few sample records.",
      "cosmeticNote": "Cosmetic preview — does not affect the saved policy.",
      "dataFieldColumn": "Data Field",
      "originalColumn": "Original Value",
      "maskedColumn": "Masked Output",
      "noPattern": "Select a masking type to preview."
    },
    "chooseTableModalTitle": {
      "10": "Select Tables/Views you want to protect",
      "12": "Select Columns you want to protect",
      "powerbi": {
        "10": "Select Object you want to protect",
        "12": "Select the column to mask"
      }
    },
    "columnFloatLabel": {
      "10": "Objects",
      "12": "Columns"
    },
    "columnLabel": {
      "10": "Objects",
      "12": "Columns"
    },
    "conditionBuilderUserLabel": {
      "8": "Users who match the below conditions",
      "9": "Users who do NOT match the below conditions"
    },
    "conditions": {
      "9": "Choose Principals",
      "10": "Users can access rows",
      "12": "Users you want to unmask"
    },
    "dataRule": {
      "9": "Objects you want to apply policy",
      "10": "Objects you want to apply row access",
      "12": "Columns you want to mask"
    },
    "dataRuleInfo": {
      "10": "Access to the data will be restricted to the users who fulfill the conditions outlined in **step 3**",
      "12": "The data will be masked for everyone except for the users who meet the conditions in **Step 3**"
    },
    "dataRuleInfoTitle": {
      "9": "<b>Columns by Name :</b><br />\"This list displays the names of columns that you are authorized to manage. It is sourced from your Snowflake data catalog.\"<br /><br /><b>Columns by Classification:</b><br />\"This list shows tags assigned to columns within Snowflake Databases. The policy defined below will apply to all columns with the specific tag. Please refer to https://docs.snowflake.com/en/user-guide/object-tagging for more details\"",
      "10": "<b>Objects by Name:</b><br />\"This list displays the names of databases that you are authorized to manage. It is sourced from your Snowflake data catalog.\"<br /><br /><b>Objects by Classification:</b><br />\"This list shows tags assigned to tables and views within Snowflake Databases. The policy defined below will apply to all tables and views that have the specific tag assigned. Please refer to https://docs.snowflake.com/en/user-guide/object-tagging for more details\"",
      "12": "<b>Columns by Name :</b><br />\"This list displays the names of columns that you are authorized to manage. It is sourced from your Snowflake data catalog.\"<br /><br /><b>Columns by Classification:</b><br />\"This list shows tags assigned to columns within Snowflake Databases. The policy defined below will apply to all columns with the specific tag. Please refer to https://docs.snowflake.com/en/user-guide/object-tagging for more details\"",
      "maskingPattern": "<b>Masking Pattern:</b><br />\"The entries are based on the selected column’s data type. For classified columns, masking patterns are applicable only to supported data types.\""
    },
    "policySubtype": {
      "9": "Columns Identified By",
      "10": "Objects Identified By",
      "12": "Columns Identified By"
    },
    "wizardOnlyPolicyTypeMessage": "Resource Access policies are created and edited in the new policy wizard. Use \"Try the new wizard\" above to continue.",
    "wizardOnlyPolicyTypeUnavailableMessage": "Resource Access policies are created and edited in the new policy wizard, which is not enabled for this tenant. Contact your administrator to enable it.",
    "policyTypes": {
      "9": {
        "description": "Provision access to various securable Objects like Database, Schema, Warehouse, Stream, Data Share, & Tags to Access Roles.",
        "name": "Object Access",
        "bestFor": "Preventing engineers from deleting production schemas."
      },
      "10": {
        "description": "Grant access to data based on one or more conditions.",
        "name": "Row Access",
        "bestFor": "Letting EU managers view only records tagged \"EU\"."
      },
      "12": {
        "description": "Mask column data, and selectively unmask it based on one or more conditions.",
        "name": "Data Masking",
        "bestFor": "Hiding SSN, Credit Card, or emails from analytics teams."
      },
      "14": {
        "description": "Create a policy that governs access to data products (e.g., tables, views, materialized views) across multiple data sources, such as databases or data catalogs, within a single data domain.<br /><br />A data domain is a logical grouping of related data sources, typically identified by tags or metadata.<br /><br />By creating a policy at the data domain level, you can ensure consistent access controls and permissions for the specified data products, regardless of the physical location or database object they reside in.",
        "name": "Data Product Access",
        "bestFor": "Governing access to published data products and subscriptions."
      },
      "16": {
        "description": "Govern access to content by its Microsoft Purview sensitivity labels, rather than by individual files or locations. Newly labelled content is covered automatically.",
        "name": "Resource Access",
        "bestFor": "Restricting Confidential SharePoint documents to a named group."
      }
    },
    "review": {
      "step_2": {
        "10": "Objects {{type}} {{values}}",
        "12": "Mask columns {{type}} {{values}} with masking pattern {{pattern}}"
      }
    },
    "ruleSubTitle": {
      "10": "Objects",
      "12": "Mask columns"
    },
    "ruleTitle": {
      "10": "Set conditions to determine which users can view the data",
      "12": "Set conditions to determine which users can view the unmasked data"
    },
    "tableLabel": {
      "10": "Objects",
      "12": "Tables/Views"
    },
    "tableLabelFloat": {
      "10": "Objects",
      "12": "Tables/Views"
    },
    "form": {
      "policyDataTypeId": "Policy Type",
      "objectNameList": "Object Name List",
      "roleTemplate": "Privilege Template",
      "subRoleTemplate": "Sub Role Template",
      "schemaName": "Schema Name",
      "schemaNames": "Schema Names",
      "tableName": "Table Name",
      "objectType": "Object Type",
      "databaseNames": "Database Names",
      "databaseName": "Database Name",
      "catalogName": "Catalog Name",
      "dataSourceNames": "Data Source Names",
      "dataSourceName": "Data Source Name",
      "viewName": "View Names",
      "functionName": "Function Names",
      "tableNames": "Table Names",
      "objectName": "Object Name",
      "objectNames": "Object Names",
      "objectPrivilegeList": "Object Privilege List",
      "objectPrivilegeMapping": "Object Privilege Mapping",
      "tagNames": "Tags",
      "glueDataSourceName": "Glue Database Name",
      "objectPrivileges": "Object Privileges",
      "workspace": "Workspace",
      "roleTemplateId": "Privilege Template",
      "withFollowingConditions": "with the following conditions",
      "importConditions": "Import Conditions",
      "importConditionsTooltip": "Import conditions from an existing deployed policy",
      "useDaxEditor": "Use DAX Editor",
      "useSqlEditor": "Use SQL Editor",
      "useConditionBuilder": "Use Condition Builder",
      "sqlServerMaskingNoConditions": "Conditional masking is not supported for SQL Server. SQL Server's native Dynamic Data Masking applies masks to an entire column and cannot filter rows with a WHERE condition. To restrict data by row, consider using Row-Level Security alongside this masking policy."
    }
  },
  "users": {
    "searchPlaceholder": "Search by name or role or email address",
    "allDataSources": "All Data Sources ({{count}})",
    "createUser": "Create New User",
    "error": "$t(users.title) Error",
    "form": {
      "accessOn": "Access On",
      "accessOnApplicationsTitle": "Access on Application and AI Agents",
      "basicDetailsTitle": "Basic User Details",
      "databaseOrSchema": "Database or Schema",
      "dataSources": "Data Sources",
      "dataSourceOption": "Data Source",
      "domainOption": "Domain",
      "domain": "Domain",
      "basicDetailsSubtitle": "Enter the basic details to create the user and set their access.",
      "emailAddress": "Email Address",
      "emailHint": "An email with the password will be sent to this address",
      "fullName": "Full Name",
      "loginType": "Login Type:",
      "accessType": "Access Type",
      "addMore": "Add More",
      "aiAgents": "AI Agents",
      "allApplicationsAndAiAgents": "All Applications and AI Agents ({{count}})",
      "accessOnDataSourceTitle": "Access on Data Source",
      "application": "Application",
      "createUserAction": "Create User",
      "manageAllApplicationsAndAiAgents": "Super User can manage all applications and AI agents across all {{count}} targets",
      "selectDataSource": "Select Data Source",
      "selectTarget": "Select Target",
      "saveChanges": "Save Changes",
      "rolesSubtitle": "Users can belong to multiple roles. Higher-level roles grant downstream permissions automatically.",
      "roleError": "Please choose at least one role from the available options.",
      "rolesTitle": "Roles",
      "singleSignOn": "Single sign on",
      "superUserManageAllDataSources": "{{role}} can manage all databases across all {{count}} data sources",
      "tags": "Tags",
      "trustlogixUser": "TrustLogix User",
      "userDescription": "Description",
      "workspaces": "Workspaces"
    },
    "infoTitle": {
      "chooseDataSources": "Allow users to manage access control policies by  selecting the desired objects from the drop-down list",
      "domainsIdentifiedBy": "Select Domains that users can manage policies by specifying either the individual database names or by selecting Tags.<br /><br />A data domain is a logical collection of databases or schemas within the data source. This grouping is achieved by tagging related databases or schemas with a common identifier or label."
    },
    "rootUser": "Root User",
    "details": {
      "title": "User Details",
      "previousUser": "Previous user",
      "nextUser": "Next user",
      "editUser": "Edit user",
      "overviewTab": "Overview",
      "accessSection": "Access",
      "roles": "Roles",
      "loginType": "Login Type",
      "standardUser": "Standard User",
      "mfa": "Multi-Factor Authentication",
      "noAccessAssigned": "No access assigned",
      "noAccessDescription": "This user has no data source, domain, or application assignments.",
      "access": {
        "categories": {
          "data-sources": "Data Sources",
          "domains": "Domains",
          "applications": "Applications",
          "ai-agents": "AI Agents"
        },
        "grantedViaAll": "Access to all {{category}} — anything added later is included automatically.",
        "search": "Search {{category}}",
        "noMatches": "No matches for “{{search}}”",
        "noneAvailable": "No {{category}} available yet.",
        "showAll": "Show all {{count}}",
        "showLess": "Show less",
        "allScope": "All databases and schemas",
        "scopeCount_one": "{{count}} database or schema",
        "scopeCount_other": "{{count}} databases or schemas",
        "loading": "Loading"
      }
    },
    "actions": {
      "viewDetailsFor": "View details for {{name}}"
    },
    "noUsers": "No records available",
    "title": "User Account",
    "updateUser": "Edit User Details"
  },
  "validation": {
    "alertFrequency": "Valid number between 2 and 1000",
    "columnsTypesNotMatching": "Columns selected have different data types so please select them with the same type.",
    "conditionType": "Contains cannot be selected for this principal type",
    "conditionTypeForUserAgent": "User Agent condition type has to be “Contains”",
    "confirmPassword": "Passwords must match",
    "passwordRequirements": "Password must be at least 8 characters and include uppercase, lowercase, a number and a special character.",
    "invalidEmail": "Invalid Email",
    "invalidEmailLoginId": "Please enter valid email/loginId",
    "invalidUrl": "Invalid URL",
    "invalidIPAddress": "Invalid IP Address",
    "listType": "Value cannot be selected for this principal type",
    "listTypeForUserAgent": "User Agent list type has to be “Value”",
    "password": "Password must be at least 8 characters",
    "policyNameExists": "This Policy Name already exists",
    "required": "Please fill out this required field",
    "uniqueAccessOn": "Access On must be unique",
    "reasonMinLength": "Reason must be at least {{min}} characters",
    "reasonMaxLength": "Reason must not exceed {{max}} characters"
  },
  "configurations": {
    "tenantSettings": {
      "disableConfirmationMessage": "Are you sure you want to disable this feature?",
      "enableConfirmationMessage": "Are you sure you want to enable this feature?"
    },
    "onPremMetadata": {
      "pageTitle": "OnPrem Metadata",
      "description": "Authorized service user and host info for database access.",
      "noDataMessage": "No on-prem metadata available",
      "columns": {
        "appHostname": "App Hostname",
        "dbServerType": "DB Server Type",
        "dbServerHostname": "DB Server Hostname",
        "svcUsername": "Service Username",
        "svcType": "Service Type",
        "ingestionTimestamp": "Ingestion Timestamp",
        "createdAt": "Created At",
        "createdBy": "Created By",
        "accountName": "Account Name",
        "applicationName": "Application Name",
        "instanceType": "Instance Type",
        "dbVersion": "DB Version",
        "serverType": "Server Type",
        "oudAccount": "OUD Account"
      }
    }
  },
  "reports": {
    "downloadUnexpectedResponse": "The report could not be downloaded — the server returned an unexpected response.",
    "classificationTagsMapping": {
      "TLX_UNCLASSIFIED_FULL_TAG_KEY.UNCLASSIFIED": "No Classification Tag"
    },
    "title": "Reports",
    "searchPlaceholder": "Search reports, categories, or keywords...",
    "recent": "Recent Reports",
    "scheduledReportsTab": "Scheduled Reports",
    "reportsTab": "Reports",
    "lastUsed": "Last used",
    "noRecentReports": "No Recent Reports",
    "carousel": {
      "previousReports": "Previous reports",
      "nextReports": "Next reports"
    },
    "noRecentReportsSubtitle": "Reports you have scheduled recently will appear here for quick access and tracking.",
    "noResults": "No reports match your search",
    "filterByReport": "Report Name",
    "filterByDataSource": "Data Source",
    "filterByGeneratedBy": "Generated By",
    "allReports": "All Reports",
    "allDataSources": "All Data Sources",
    "allUsers": "All Users",
    "noScheduledReports": "No scheduled reports found",
    "errorLoadingScheduled": "Failed to load scheduled reports",
    "columnReportName": "Report Name",
    "columnDataSource": "Data Source",
    "columnStatus": "Status",
    "columnScheduledAt": "Scheduled At",
    "columnScheduledBy": "Scheduled By",
    "columnCompletedAt": "Completed At",
    "columnFilters": "Filters",
    "reportFilters": "Report Filters",
    "filter": {
      "dataSource": "Data Source",
      "startDate": "Start Date",
      "endDate": "End Date",
      "daysAgo": "Days Ago",
      "sessionTime": "Session Time Threshold",
      "lastUsed": "Last Used",
      "users": "User Name(s)",
      "userName": "User Name",
      "userNames": "User Name(s)",
      "roles": "Role Name(s)",
      "groups": "Group(s)",
      "databases": "Database(s)",
      "databaseName": "Database Name",
      "schemas": "Schema(s)",
      "objects": "Object(s)",
      "tables": "Table(s)",
      "privileges": "Object Privilege(s)",
      "objectType": "Object Type",
      "objectName": "Object Name(s)",
      "workspace": "Workspace",
      "policyDataTypes": "Policy Data Type",
      "policySubType": "Policy Subtype",
      "accessPolicyNames": "Policy Names",
      "classification": "Classification Tags",
      "actions": "Actions",
      "fileExtension": "File Extension",
      "securityFramework": "Security Framework",
      "securityFrameworkLoadError": "Could not load security frameworks. Please try again.",
      "securityFrameworkEmpty": "No security frameworks are available."
    },
    "objectsNotAccessedIn": "Objects Not Accessed In",
    "usersNotLoggedIn": "Users Not Logged In",
    "generateReport": "Schedule Report",
    "reportsGeneratedFor": "Reports Generated for {{name}}",
    "reportsGeneratedWindow": "Reports generated in last 30 days",
    "reportLabel": "Reports",
    "runReport": "Run Report",
    "selectReportFirst": "Choose a report from the list above to configure your delivery schedule and automation settings.",
    "noReportSelectedTitle": "No Report Selected",
    "reportLimitMessage": "There are five reports scheduled for this data source. Wait for them to finish before scheduling more.",
    "reportGeneratingMessage": "The report is being prepared. Please check back in some time to download it.",
    "generateReportErrorFallback": "Unable to generate report.",
    "reportCatalogTab": "Report Catalog",
    "searchCatalogPlaceholder": "Search for a report...",
    "reportHistoryTab": "Report History",
    "systemAuditTab": "System Audit Report",
    "auditColumns": {
      "loginIp": "Login IP",
      "loginId": "Login ID",
      "resource": "Resource",
      "action": "Action",
      "result": "Result"
    },
    "auditDetails": {
      "dataAccessPolicy": "Data Access Policy Details",
      "account": "Account Details",
      "user": "User Details",
      "default": "Data Preview"
    },
    "auditNoDetails": "No Data",
    "recentReportsSubtitle": "Reports generated in the last 3 days",
    "availableReportsTab": "Report History",
    "availableReportsSubtitle": "Browse and schedule reports from your connected data sources",
    "noRecentReportsDesc": "No reports were generated in the last 3 days.",
    "browseAvailableReports": "Browse Report History",
    "noAvailableReports": "No reports found",
    "noAvailableReportsDesc": "Try adjusting your filters or schedule a new report.",
    "filterByReportName": "Report Name",
    "filterByStatus": "Status",
    "resetFilters": "Reset filters",
    "dataSourceRequired": "Data source is required.",
    "startDateRequired": "Start date is required.",
    "endDateRequired": "End date is required.",
    "wizardSelectTitle": "Select a Report",
    "wizardSelectSubtitle": "Choose a report type to schedule",
    "wizardConfigTitle": "Configure Report",
    "wizardConfigSubtitle": "Set the parameters for your report",
    "startGeneration": "Schedule Report",
    "continueButton": "Continue",
    "allCategories": "All",
    "reportGenerationStarted": "Report scheduled successfully.",
    "reportGenerationError": "Failed to start report generation.",
    "reportTriggerError": "Report schedule trigger failed. Please try again.",
    "columnDescription": "Description",
    "columnDownload": "Download",
    "statusAll": "All",
    "statusCompleted": "Completed",
    "statusScheduled": "Scheduled",
    "statusGenerationSuccessful": "Generation successful",
    "statusGenerationScheduled": "Generation scheduled",
    "statusGenerationFailed": "Generation failed",
    "downloadReport": "Download report",
    "downloadNotAvailable": "Not available",
    "downloadNoData": "This report returned no data",
    "statusNoData": "No Data",
    "duplicateScheduleWarning": "This report is already scheduled or completed for the selected data source today. Download it from Report History instead.",
    "validatorSelectReport": "Select a report",
    "categories": {
      "usageReports": "Usage Reports",
      "entitlementReports": "Entitlement Reports",
      "riskReports": "Risk Reports",
      "trustlogixReports": "TrustLogix Reports"
    },
    "reportData": {
      "audit_report": {
        "name": "System Audit Report",
        "description": "This report contains events related to TrustLogix actions like logins, access policy creation etc."
      },
      "user_activity_report": {
        "name": "User Activity Report",
        "description": "This report contains the complete log of user activities performed within the datasource for a specified period.",
        "disabledButtonTooltip": "Select the Data source, User name(s), Actions, Start date and End date to generate the report."
      },
      "compliance_report": {
        "name": "Compliance Report",
        "description": "Gain a clear view of your organization's compliance status across industry standards and regulatory frameworks. This report summarizes key findings, identifies areas of non-compliance, prioritizes risks, and provides recommendations to support audit readiness."
      }
    }
  },
  "domainManagement": {
    "pageTitle": "Data Domains",
    "NoDataAssetsFound": "No data assets found across places.",
    "tabs": {
      "details": "Domain Details",
      "objects": "Data Assets",
      "dataProducts": "Data Products",
      "productDetails": "Product Details"
    },
    "dataAssets": {
      "powerBi": {
        "database": "Workspace",
        "schema": "Semantic Model",
        "table": "Objects"
      },
      "powerBiObjectTypes": {
        "DATABASE": "Workspace",
        "SCHEMA": "Semantic Model",
        "TABLE": "Object"
      }
    }
  },
  "resourcePolicies": {
    "entity": {
      "application": "the Application",
      "aiAgent": "the AI Agent"
    },
    "resourceForms": {
      "detailsSection": "Details",
      "attributesSection": "Attributes",
      "actionsSection": "Actions",
      "addAttribute": "Add Attribute",
      "attributeLabel": "Attribute",
      "selectAttributes": "Select attributes",
      "valuesLabel": "Values",
      "valuesPlaceholder": "Enter values",
      "enterAttributeValue": "Enter {{attribute}}",
      "multiValueHint": "Type and press enter to add each value",
      "dateHint": "Type or enter a valid date",
      "noAttributeResults": "No search results found for “{{value}}”",
      "addCustomAttributePrompt": "Would you like to add this as a new attribute?",
      "attributeOptionTooltip": "Attribute: {{attribute}}\nData type: {{dataType}}",
      "createAction": "Create",
      "updateAction": "Update",
      "dataTypes": {
        "STRING": "String",
        "DATE": "Date",
        "BOOLEAN": "Boolean",
        "NUMBER": "Number",
        "ENUM": "Enum"
      },
      "validation": {
        "attributeRequired": "Attribute is required",
        "attributeValueRequired": "At least one value is required"
      }
    },
    "resourceTypeForm": {
      "addTitle": "Add Resource Type",
      "editTitle": "Edit Resource Type",
      "nameLabel": "Resource Type Name",
      "namePlaceholder": "Enter resource type name",
      "descriptionPlaceholder": "Enter description",
      "attributeNameLabel": "Attribute Name",
      "attributeNamePlaceholder": "Enter attribute name",
      "dataTypeLabel": "Data Type",
      "dataTypePlaceholder": "Select data type",
      "enumValuesPlaceholder": "Enter values separated by comma",
      "actionsPlaceholder": "Select actions",
      "createSuccess": "Resource type created successfully",
      "updateSuccess": "Resource type updated successfully",
      "deleteSuccess": "Resource type deleted successfully",
      "createAction": "Create",
      "updateAction": "Update",
      "validation": {
        "nameRequired": "Resource type name is required",
        "attributeNameRequired": "Attribute name is required",
        "attributeNameUnique": "Attribute name must be unique",
        "attributeNameFormat": "Attribute name must start with a letter and contain only letters, numbers, and underscores",
        "dataTypeRequired": "Data type is required",
        "enumValueRequired": "At least one value is required for ENUM data type"
      }
    },
    "resourceForm": {
      "addTitle": "Add Resources",
      "editTitle": "Edit Resources",
      "resourceTypeLabel": "Resource Type",
      "resourceTypePlaceholder": "Select resource type",
      "nameLabel": "Resource Name",
      "namePlaceholder": "Enter resource name",
      "descriptionPlaceholder": "Enter description",
      "actionsPlaceholder": "Select actions",
      "createSuccess": "Resources created successfully",
      "updateSuccess": "Resources updated successfully",
      "deleteSuccess": "Resources deleted successfully",
      "createAction": "Create",
      "updateAction": "Update",
      "validation": {
        "nameRequired": "Resource name is required",
        "typeRequired": "Resource type is required"
      }
    },
    "dataProductAttributesForm": {
      "title": "Edit Data Product Attributes",
      "namedTitle": "Edit Attributes: {{name}}",
      "discoveredSection": "Discovered Resource Details",
      "domains": "Domains",
      "objectNames": "Object Names",
      "discoveredHint": "Domains and Object Names are discovered from data systems and are not editable.",
      "updateSuccess": "Data Product attributes updated successfully"
    },
    "wizard": {
      "optionalBadge": "Optional",
      "retrySave": "Retry Save",
      "purposeNeedsIdentity": "A Client ID is required to store the agent's purpose. Add the service principal details, or clear Purpose on the previous step.",
      "steps": {
        "details": {
          "label": "{{entity}} Details",
          "description": "Name, description and status"
        },
        "configuration": {
          "label": "Configuration",
          "description": "Service principal credentials"
        },
        "agentAttributes": {
          "label": "Agent Attributes",
          "description": "Metadata used for policy evaluation"
        },
        "review": {
          "label": "Review",
          "description": "Confirm before saving"
        }
      },
      "review": {
        "sectionDescription": "Confirm the {{entity}}'s details before saving. Nothing is written until you finish.",
        "secretSet": "Provided",
        "noConfiguration": "No service principal credentials were entered. You can add them later from the Configuration tab."
      }
    },
    "agentDetails": {
      "title": "{{entity}} Details",
      "description": "Basic information that defines the {{entity}}, including its name, description, and active status.",
      "nameLabel": "{{entity}} Name",
      "descriptionLabel": "Description",
      "statusLabel": "{{entity}} Status",
      "statusInfo": "Only active {{entity}}s can be targeted by new Access Policies.",
      "purposeLabel": "Purpose",
      "purposeHint": "The approved reason this agent accesses data. Required for IBAC policy evaluation.",
      "purposeNoIdentity": "Configure the Agent Identity in the Configuration section to set a purpose."
    },
    "settings": {
      "saveSuccess": "Settings saved successfully.",
      "missingApplicationIdError": "The application was saved, but the server did not return its id, so the remaining settings could not be applied. Open the application and finish configuring it from its Settings tab.",
      "apiKeyLabel": "API Key",
      "regenerateApiKey": "Regenerate API Key",
      "sections": {
        "ApplicationConfiguration": "Configuration",
        "agentAttributes": "Agent Attributes",
        "AgentConfiguration": "Agent Identity",
        "mcpServerBinding": "MCP Server Access"
      },
      "agentAttributes": {
        "sourceDescription": "Sourced from external providers {{name}}",
        "description": "Metadata used for policy evaluation.",
        "noAttributesTitle": "No attribute definitions found",
        "noAttributesDescription": "Agent attributes are not defined yet. Attributes are required for fine-grained policy evaluation.",
        "goToAttributeManagement": "Go to Attribute Management",
        "requiresAdminPermissions": "Requires administrative permissions",
        "missingIdentityTitle": "Agent Identity not configured",
        "missingIdentityDescription": "A Client ID is required to manage attribute values. Configure the Agent Identity in the Configuration section above.",
        "missingIdentityError": "Agent Identity is not configured. Configure the Agent Identity in the Configuration section, then save again.",
        "staleRecordError": "Attribute values could not be reloaded after the last save. Refresh the page before saving again.",
        "goToConfiguration": "Go to Configuration",
        "multiValueHint": "Type and press enter to add each value",
        "dateHint": "Type or enter valid date"
      }
    },
    "oAuth": {
      "title": {
        "Application": "Service Principal Configuration",
        "Agent": "Service Principal used by this Agent"
      },
      "description": {
        "Application": "These credentials identify the application to target systems.",
        "Agent": "These credentials identify the agent to the MCP Access Gateway and target systems."
      },
      "docsHint": "Follow the <a>documentation</a> to configure the service principal details required by the {{entity}}.",
      "fields": {
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "clientSecretPlaceholder": "Client Secret Value",
        "scope": "Scope",
        "scopePlaceholder": "Application scope",
        "tokenEndpoint": "Token Endpoint"
      }
    },
    "agentIdentity": {
      "sectionTitle": "Authentication Method",
      "sectionDescription": "Choose how this agent authenticates to the systems it connects to.",
      "comingSoon": "Coming soon",
      "types": {
        "OAUTH": "OAuth",
        "DCR": "Dynamic Client Registration",
        "PAT": "Personal Access Token"
      },
      "typeDescriptions": {
        "OAUTH": "Use an existing service principal's client credentials and token endpoint.",
        "DCR": "Register with the vendor and let them issue this agent's credentials.",
        "PAT": "Authenticate with a long-lived personal access token."
      },
      "dcr": {
        "cardTitle": "Dynamic Client Registration",
        "cardDescription": "Register this agent with the vendor to have a Client ID issued for it.",
        "vendorLabel": "Vendor",
        "vendors": {
          "ATLASSIAN": "Atlassian"
        },
        "registerButton": "Register Dynamic Client",
        "reRegisterButton": "Re-register",
        "downloadTokenButton": "Download Token",
        "downloading": "Downloading…",
        "downloadFailed": "Could not download the token. Please try again.",
        "registered": "Registered",
        "registrationRequired": "Register the dynamic client before continuing.",
        "registering": "Waiting for approval…",
        "registeringHint": "Approve the request in the tab that just opened. This page updates on its own once you are done.",
        "failures": {
          "initiateFailed": "Could not start the registration. Please try again.",
          "timedOut": "Registration timed out before it was approved. Please try again.",
          "tokenUnreadable": "Registration completed but the response could not be read. Please try again."
        }
      }
    },
    "mcpBinding": {
      "title": "MCP Server Access",
      "description": "Shows the MCP servers this agent can access after evaluating server access policies against the agent’s attributes",
      "effectiveAccessTitle": "MCP Server Access",
      "lastEvaluatedAt": "Last evaluated {{timeAgo}}",
      "actions": {
        "viewPolicyDetails": "View Policy Details",
        "viewServerDetails": "View MCP Server Details",
        "viewEvaluationHistory": "View Evaluation History",
        "createPolicy": "Create Policy"
      },
      "toolsCount_one": "{{count}} tool",
      "toolsCount_other": "{{count}} tools",
      "granularToolPolicies": "Granular Tool Policies",
      "toolStatusAllowed": "Allowed",
      "toolStatusRestricted": "Restricted",
      "configureAdditionalToolPolicies": "Configure Additional Tool Policies",
      "subtitle": "Bind this agent to one or more MCP servers. Bound servers determine which tools are accessible to this agent.",
      "serverSelectionTitle": "Server Selection",
      "serverSelectionDescription": "Select one or more MCP servers to bind to this agent.",
      "auth": {
        "oauth": "OAuth",
        "apiKey": "API Key",
        "keyPair": "Key Pair"
      },
      "status": {
        "connected": "Connected",
        "notVerified": "Not Verified"
      },
      "authTypeLabel": "Auth Type",
      "statusLabel": "Status",
      "toolCount_one": "{{count}} Tool",
      "toolCount_other": "{{count}} Tools",
      "collapsedSummaryNone": "No servers bound - 0 tools available.",
      "collapsedSummary_one": "{{count}} server bound - {{toolCount}} tools available.",
      "collapsedSummary_other": "{{count}} servers bound - {{toolCount}} tools available.",
      "currentlyBound": "Currently Bound",
      "noServersBoundPlaceholder": "No servers bound.",
      "removeBoundServer": "Remove {{serverName}}",
      "searchPlaceholder": "Search for available servers...",
      "searchAria": "Search MCP servers",
      "selectionLabel": "Select",
      "serverNameHeader": "Server Name",
      "toolsHeader": "Tools",
      "statusHeader": "Status",
      "noSearchResults": "No results found.",
      "toggleServerSelectionAria": "Toggle server selection for {{serverName}}",
      "noServersBound": "No MCP servers bound to this agent yet.",
      "singleServerSummary": "This agent will have access to {{toolCount}} tools.",
      "multiServerSummary": "This agent will have access to {{toolCount}} tools across {{serverCount}} servers.",
      "viewTools": "View Tools",
      "viewToolsSubtitle_one": "{{count}} server bound",
      "viewToolsSubtitle_other": "{{count}} servers bound",
      "saveBinding": "Save Binding",
      "cancel": "Cancel",
      "bindingRequiredError": "At least one MCP server must be selected.",
      "noServersAvailable": "No MCP servers available.",
      "registerMcpServer": "Register MCP Server",
      "toolsModalTitle": "Tools available to this agent",
      "toolsModalSearchPlaceholder": "Search tools",
      "toolsModalSearchAria": "Search tools",
      "toolType": {
        "data": "Data",
        "action": "Action",
        "metadata": "Metadata"
      },
      "sensitivity": {
        "pii": "PII",
        "financial": "Financial",
        "none": "None"
      },
      "noToolsMatchSearch": "No tools match your search.",
      "close": "Close"
    },
    "policyAudit": {
      "auditType": {
        "DECISION": "Decision",
        "ENFORCEMENT": "Enforcement"
      },
      "resourceType": {
        "APPLICATION": "Application",
        "RESOURCE": "Resource",
        "SENSITIVITY_LABELS": "Sensitivity Label",
        "DATA_OBJECT": "Data Object"
      },
      "table": {
        "title": "Policy Evaluation History",
        "columns": {
          "resourceName": "Resource Name",
          "resourceType": "Resource Type",
          "userName": "User Name",
          "permissionGranted": "Permission Granted",
          "auditType": "Audit Type",
          "createdOn": "Created On",
          "mcpServer": "MCP Server"
        }
      },
      "panel": {
        "title": "Policy Evaluation Audit",
        "previousAudit": "Previous evaluation",
        "nextAudit": "Next evaluation"
      },
      "tabs": {
        "keyInputValues": "Key Input Values",
        "rawJsonRequest": "Raw JSON Request",
        "rawJsonResult": "Raw JSON Result",
        "policyDefinition": "Policy Definition (Rego)"
      },
      "codeTitles": {
        "result": "Policy Evaluation Result:",
        "requestPayload": "Original Request Payload:",
        "regoRules": "Rego Policy Rules executed during evaluation:"
      },
      "emptyStates": {
        "noData": "No Data"
      },
      "inputValues": {
        "emptyState": "No data available",
        "sections": {
          "entitlements": "User Entitlements",
          "agent": "Agent Attributes",
          "request": "Request Attributes",
          "resource": "Resource Attributes"
        }
      }
    },
    "errors": {
      "updateConfigurationFailed": "Failed to update configuration. Please try again."
    },
    "agentAttributes": {
      "title": "Agent Attributes",
      "subtitle": "View attribute values for this agent. To change values, select Edit Values.",
      "editValues": "Edit Values",
      "editTitle": "Edit Agent Attributes",
      "editSubtitle": "Update attribute values for {{name}}. You can change several values and save them at once.",
      "editSubtitleNoName": "Update attribute values for this agent. You can change several values and save them at once.",
      "info": "Attribute values help determine policy evaluation and access control for this agent. Attribute definitions are managed in Attribute Management.",
      "infoWithLink": "Attribute values help determine policy evaluation and access control for this agent. Manage attribute definitions in <managementLink>Attribute Management</managementLink>.",
      "editNotice": "Changed values can affect how policies evaluate access for this agent. Saving updates the values only; it does not change or deploy any policy.",
      "purposeSection": "Purpose",
      "purposeSectionDescription": "The approved reason this agent accesses data. Intent-based (IBAC) policies evaluate it, so every agent needs one.",
      "purposeLabel": "Purpose",
      "purposeMissing": "Set this agent's purpose before saving.",
      "customSection": "Custom Attributes ({{count}})",
      "customSectionDescription": "These attributes can be set for this agent.",
      "systemSection": "System-Managed Attributes ({{count}})",
      "systemSectionDescription": "These attributes are managed by the system and cannot be edited here.",
      "noEditable": "This agent has no attributes that can be edited here.",
      "notSet": "Not set",
      "aboutAttribute": "About {{name}}",
      "readOnly": "Read-only",
      "readOnlyTooltip": "This attribute is read-only and cannot be edited.",
      "unsavedChanges_one": "{{count}} unsaved change",
      "unsavedChanges_other": "{{count}} unsaved changes",
      "noChanges": "No changes",
      "requiredMissing": "Fill in every required attribute before saving.",
      "saveChanges": "Save Changes",
      "saveSuccess": "Agent attribute values updated.",
      "failed": "Agent attributes could not be loaded.",
      "missingIdentityDescription": "A Client ID is required to manage attribute values. Configure the Agent Identity on the Details tab."
    }
  },
  "releases": {
    "versionTitle": {
      "API": "API - {{version}}",
      "UI": "UI - {{version}}",
      "DAG": "DAG - {{version}}",
      "DSPM": "DSPM - {{version}}",
      "POWER_BI_API": "POWER BI API - {{version}}"
    },
    "subVersionLabel": {
      "recommendation": "Recommendation",
      "analytics": "Analytics",
      "observability": "Observability",
      "accessPolicy": "Access Policy",
      "attributeSync": "Attribute Sync",
      "powerBiAccessPolicy": "Power BI Access Policy"
    }
  },
  "userAttributes": {
    "tabs": {
      "attributes": "Attributes",
      "values": "Attribute Values",
      "sourceConfigurations": "Source Configurations"
    },
    "sourceConfigurations": {
      "search": "Search source configurations"
    },
    "identityType": {
      "USER": "User",
      "AGENT": "Agent",
      "ASSET": "Asset"
    },
    "columns": {
      "name": "Name",
      "code": "Code",
      "description": "Description",
      "type": "Type",
      "sourceName": "Source Name",
      "group": "Group",
      "category": "Category",
      "target": "Target",
      "attributeLevelUdf": "Attribute Level UDF",
      "dataProducts": "Data Products",
      "userIdentifier": "User Identifier",
      "multiValue": "Multi Value",
      "virtual": "Virtual",
      "required": "Required",
      "lastModifiedDate": "Last Modified Date",
      "status": "Status"
    },
    "copyAttributeValues": "Copy Attribute Values",
    "attributeForm": {
      "displayName": "Display Name",
      "description": "Description",
      "type": "Type",
      "selectGroup": "Select Group",
      "selectGroupPlaceholder": "Select value or type to create one",
      "useAsUserIdentifier": "Use this as user identifier",
      "multipleValues": "Multiple Values",
      "virtual": "Virtual",
      "required": "Required",
      "requiredTooltip": "When enabled, users must provide a value for this attribute before they can save or update the attribute values",
      "requiredFieldError": "This field is required and cannot be empty.",
      "userMapping": {
        "title": "User Mapping",
        "optional": "(Optional)",
        "description": "Identify the column used to match users with their virtual attribute values.",
        "sourceTable": "Source Table",
        "identityColumn": "User Identity Column",
        "identityColumnPlaceholder": "Select column…",
        "identityColumnHint": "Select the column containing the user's email, UPN, or other identity.",
        "noSourceColumn": "Select a source column to configure user mapping.",
        "infoMessage": "This information is used for policy deployment and does not affect the entitlement table."
      }
    },
    "addAttribute": {
      "identityType": {
        "sectionTitle": "Attributes Category",
        "user": "User Attributes",
        "userDescription": "A human identity within the organization (employees, contractors, partners).",
        "agent": "AI Agent Attributes",
        "agentDescription": "Non-human automated service, LLM agents, service principals, or API processes.",
        "asset": "Asset Attributes",
        "assetDescription": "Resource attributes (e.g. S3 buckets, Snowflake databases, tables, data products)."
      },
      "conflictAction": "Click here",
      "conflictMessage": "to edit the existing attribute.",
      "noAttributesFound": "No attributes found for the selected Target and Data Product. Please add attributes and provision them to add values.",
      "validation": {
        "requiredField": "This field is required.",
        "requiredSummary_one": "{{count}} required field needs your attention",
        "requiredSummary_other": "{{count}} required fields need your attention",
        "requiredDescription": "Please review and provide values for the missing attributes below.",
        "goToFirstError": "Go to first error",
        "errorsRemaining_one": "{{count}} error remaining",
        "errorsRemaining_other": "{{count}} errors remaining",
        "previousError": "Previous error",
        "nextError": "Next error",
        "groupErrors_one": "{{count}} error",
        "groupErrors_other": "{{count}} errors"
      },
      "valueManagement": {
        "agentMessage": "Agent attributes are stored in TrustLogix. Agent attribute values are managed per agent in the Agent Management screen.",
        "localMessage": "Attribute values are stored and managed locally in TrustLogix.",
        "externalMessage": "Attribute values are sourced externally from the connected target."
      }
    },
    "importUsers": {
      "title": "Import Users",
      "import": "Import",
      "sourceSectionTitle": "Source",
      "attributeSource": "Attribute Source",
      "dataSource": "Data Source",
      "selectUsers": "Select Users",
      "success": "Successfully imported users",
      "noAttributesConfigured": "No attributes are configured with the source <strong>{{name}}</strong>. Please create attributes with this source before importing users.",
      "noAttributesDisabledTitle": "Create attributes with this source before importing users.",
      "applyFilters": "Apply filters to view the user list.",
      "noUsersFound": "No Users Found",
      "noUsersFoundHint": "Try adjusting your filters to find what you are looking for.",
      "selectedUsersRequired": "Select at least one user to import."
    },
    "sourceConfiguration": {
      "title": "Add Source Configuration",
      "saved": "The source configuration is saved.",
      "configurationName": "Configuration Name",
      "dataSource": "Data Source",
      "steps": {
        "chooseDataSource": "Choose Data Source",
        "mapAttributes": "Map Attributes",
        "importUsers": "Import Users"
      }
    },
    "confirmUserCopy": {
      "title": "Confirm Copy Attribute Values",
      "newAssignment": "New Assignment",
      "replaceExisting": "Existing Assignment",
      "multipleAssigned": "Multiple Assignment",
      "noEntitlementRecords": "No Entitlement Records",
      "singleEntitlementRecord": "Single Entitlement Record",
      "multipleEntitlementRecords": "Multiple Entitlement Records",
      "newAssignmentMessage_zero": "**Summary:** No new assignments found.\n\n**Note:** Replacement and skipped users are also processed upon confirmation.",
      "newAssignmentMessage_one": "**Summary:** This {{count}} user has 0 existing entitlements and is ready for copy.\n\n**Note:** Replacement and skipped users are also processed upon confirmation.",
      "newAssignmentMessage_other": "**Summary:** These {{count}} users have 0 existing entitlements and are ready for copy.\n\n**Note:** Replacement and skipped users are also processed upon confirmation.",
      "replaceExistingMessage_one": "**Action Required:** This user has 1 entitlement. Proceeding will **overwrite** their assignment.",
      "replaceExistingMessage_other": "**Action Required:** These users have 1 entitlement. Proceeding will **overwrite** their assignment.",
      "multipleAssignedMessage_one": "**Ignored:** This {{count}} user has 2 or more entitlements. They are skipped and will not be modified.",
      "multipleAssignedMessage_other": "**Ignored:** These {{count}} users have 2 or more entitlements. They are skipped and will not be modified.",
      "noEntitlementRecordsInfo": "A new entry will be created for identifiers that do not have any entitlement records",
      "singleEntitlementRecordInfo": "Identifiers whose value will be overwritten due to copy",
      "multipleEntitlementRecordsInfo": "Identifiers having more than one entitlement record will be skipped",
      "userName": "User Name",
      "action": "Action",
      "status": "Status",
      "assignNew": "Assign New",
      "overwrite": "Overwrite",
      "ignored": "Ignored",
      "confirmCopy": "Confirm Copy",
      "confirmCopyWithCount_one": "Confirm Copy (1 User)",
      "confirmCopyWithCount_other": "Confirm Copy ({{count}} Users)",
      "noUsersToCreate": "No Users to Create",
      "noUsersToCreateSubtext": "No new entries will be created.",
      "noUsersToOverwrite": "No Users to Overwrite",
      "noUsersToOverwriteSubtext": "No user attributes will be changed.",
      "noUsersSkipped": "No Users Skipped",
      "noUsersSkippedSubtext": "No users found with multiple entitlement records.",
      "noUsersToCopy": "No users selected for copy. Remove exclusions or cancel."
    }
  },
  "lazyLoadError": {
    "loadingError": "Loading Error",
    "title": "We couldn't load this page",
    "titleForm": "We couldn't load this form",
    "messageLine1": "This looks like a temporary issue. Your data is safe.",
    "messageLine2": "It may be caused by a brief network interruption or an update in progress.",
    "retry": "Retry Loading",
    "goHome": "Go to Home",
    "utc": "UTC",
    "brandAlt": "TrustLogix",
    "defaultAvatar": "U"
  },
  "lazyComponentError": {
    "genericTitle": "Something went wrong",
    "genericMessage": "This form couldn't be loaded. Please try again.",
    "retry": "Retry"
  },
  "mcpRegistry": {
    "back": "Back",
    "templates": {
      "groups": {
        "serverConfiguration": "Server Configuration",
        "workspace": "Workspace",
        "endpoint": "Endpoint",
        "resourceTenant": "Resource Tenant"
      },
      "SNOWFLAKE": {
        "label": "Snowflake",
        "description": "Connect to a managed MCP server in your Snowflake account."
      },
      "DATABRICKS": {
        "label": "Databricks",
        "description": "Connect to a managed MCP server in your Databricks workspace."
      },
      "GLEAN": {
        "label": "Glean",
        "description": "Connect to a Glean MCP server."
      },
      "CUSTOM": {
        "label": "Custom",
        "description": "Connect to a custom MCP server."
      },
      "MICROSOFT": {
        "label": "Microsoft Work IQ",
        "description": "Connect to a managed MCP server in your Microsoft account."
      },
      "ATLASSIAN": {
        "label": "Atlassian",
        "description": "Connect to an Atlassian MCP server."
      },
      "GITHUB": {
        "label": "GitHub",
        "description": "Connect to a GitHub MCP server."
      },
      "SALESFORCE": {
        "label": "Salesforce",
        "description": "Connect to a Salesforce MCP server."
      },
      "SERVICENOW": {
        "label": "ServiceNow",
        "description": "Connect to a ServiceNow MCP server."
      },
      "WORKDAY": {
        "label": "Workday",
        "description": "Connect to a Workday MCP server."
      },
      "SLACK": {
        "label": "Slack",
        "description": "Connect to a Slack MCP server."
      },
      "fields": {
        "unmanagedUrl": {
          "label": "MCP Server URL",
          "placeholder": "e.g. https://my-mcp-server.com",
          "hint": "The URL of the MCP server"
        },
        "snowflakeDataSource": {
          "label": "Data Source",
          "placeholder": "Choose a data source"
        },
        "snowflakeUrl": {
          "label": "MCP Server",
          "placeholder": "Choose a MCP server"
        },
        "gleanUrl": {
          "label": "MCP Server URL",
          "placeholder": "e.g. https://[tenant_id]-be.glean.com/mcp/[your-mcp-server-name]",
          "hint": "The URL of the Glean API. Replace [tenant_id] with your tenant ID and [your-mcp-server-name] with the name of your MCP server."
        },
        "microsoftUrl": {
          "label": "MCP Server URL",
          "placeholder": "e.g. https://my-mcp-server.com",
          "hint": "The URL of the MCP server"
        },
        "databricksWorkspaceHostname": {
          "label": "Workspace Hostname",
          "placeholder": "e.g. adb-1234567890.12.azuredatabricks.net",
          "hint": "From your workspace URL — e.g. adb-1234567890.12.azuredatabricks.net — no protocol or trailing slash"
        },
        "databricksServerType": {
          "label": "Server Type",
          "placeholder": "Select type"
        },
        "databricksResourceName": {
          "label": "Resource Name",
          "placeholder": "e.g. index name, warehouse name",
          "hint": "The index, function name, Genie space, or SQL warehouse name"
        },
        "microsoftResourceAccountId": {
          "label": "Microsoft Data Source",
          "description": "Choose the Microsoft Account that owns the SharePoint and Microsoft resources accessed by this MCP Server. The selected account's tenant must match the MCP Server tenant."
        }
      },
      "authFields": {
        "account": {
          "label": "Account Identifier",
          "placeholder": "Enter Account Identifier"
        },
        "username": {
          "label": "User Name",
          "placeholder": "Enter User Name"
        },
        "passphrase": {
          "label": "Passphrase",
          "placeholder": "Passphrase"
        },
        "privateKey": {
          "label": "Private Key",
          "placeholder": "Enter Private Key"
        },
        "scope": {
          "label": "Scope",
          "placeholder": "Enter Scope"
        },
        "tokenEndpoint": {
          "label": "Token/Authorization Endpoint",
          "placeholder": "Enter Token/Authorization Endpoint"
        }
      }
    },
    "addServer": "Register MCP Service",
    "tabRegistry": "MCP Services",
    "tabConfiguration": "Enforcement Options",
    "missingEnforcement": "Enforcement strategy is not configured. Please configure an enforcement strategy to enable security enforcement.",
    "tabConfigurationDescription": "Manage global security enforcement and identity sourcing for your MCP infrastructure.",
    "title": "MCP Services Administration",
    "titleDescription": "Register and manage Model Context Protocol services across your infrastructure.",
    "noServersFound": "No MCP servers found. Add a new MCP server to get started.",
    "name": "Name",
    "description": "Description",
    "url": "URL",
    "status": "Status",
    "toolCount": "Tools",
    "details": {
      "tabs": {
        "overview": "Overview",
        "policies": "Access Policies",
        "tools": "Tools"
      },
      "providerService": "{{provider}} MCP service",
      "loading": "Loading…",
      "notConfigured": "Not configured",
      "defaultDeny": "Deny",
      "actions": {
        "menu": "Service actions",
        "editConnection": "Edit connection",
        "editPolicy": "Edit policy"
      },
      "assignment": {
        "specific": "Tool-specific policy",
        "inherited": "Server policy",
        "none": "No policy",
        "unknown": "Unknown"
      },
      "overview": {
        "connection": "Connection",
        "provider": "Provider: {{provider}}",
        "serverAccess": "Server access",
        "conditions_one": "{{count}} condition",
        "conditions_other": "{{count}} conditions",
        "registeredTools": "Registered tools",
        "toolCount_one": "{{count}} tool",
        "toolCount_other": "{{count}} tools",
        "viewCatalog": "View catalog",
        "accessTitle": "Access & protection",
        "viewAccessPolicies": "View access policies",
        "serverPolicy": "Server access policy",
        "toolPolicies": "Tool-specific policies",
        "defaultBehaviorLabel": "Default behavior",
        "serviceTitle": "Service details",
        "mcpUrl": "MCP URL",
        "copyMcpUrl": "Copy MCP URL",
        "providerLabel": "Provider",
        "auth": "Authentication",
        "transport": "Transport",
        "serviceId": "Service ID",
        "copyServiceId": "Copy service ID",
        "scope": "Protection scope",
        "registration": "Registration",
        "imported": "Imported",
        "manual": "Registered manually",
        "created": "Created",
        "updated": "Last updated",
        "toolsPreviewTitle": "Registered tools",
        "viewAllTools_one": "View {{count}} tool",
        "viewAllTools_other": "View all {{count}} tools",
        "noTools": "This server has not registered any tools.",
        "configured": "Configured",
        "configuredConditions_one": "Configured · {{count}} condition",
        "configuredConditions_other": "Configured · {{count}} conditions",
        "viewPolicies": "View policies",
        "dedicatedToolPolicies_one": "{{count}} of {{total}} tools has a dedicated policy",
        "dedicatedToolPolicies_other": "{{count}} of {{total}} tools have dedicated policies",
        "dedicatedToolPoliciesAbout": "About dedicated tool policies",
        "dedicatedToolPoliciesHelp": "Server access rules apply at the service level. Dedicated tool policies add controls for individual tools, according to the configured policy evaluation rules.",
        "technicalDetails": "Technical details"
      },
      "policies": {
        "serverTitle": "Server access policy",
        "serverSubtitle": "Determines whether an agent or client can access this MCP service.",
        "editServerPolicy": "Edit policy",
        "defaultFallback": "Default fallback",
        "activeConditions": "Access conditions",
        "conditionsMatchAny_one": "{{count}} condition",
        "conditionsMatchAny_other": "{{count}} conditions · any may match",
        "conditionsMatchAll_one": "{{count}} condition",
        "conditionsMatchAll_other": "{{count}} conditions · all must match",
        "conditionRules": "Conditions",
        "rule": "Rule {{index}}",
        "showExpression": "Show the full expression for rule {{index}}",
        "expression": "Rule expression",
        "noServerRules": "No server access policy is configured.",
        "toolsTitle": "Tool access policies",
        "toolsSubtitle": "Access rules configured specifically for individual tools.",
        "noServerConditions": "The server access policy has no conditions.",
        "registeredTools": "Registered tools",
        "withDedicatedPolicies": "Dedicated policies",
        "dedicatedOfTotal_one": "{{count}} of {{total}} tools",
        "dedicatedOfTotal_other": "{{count}} of {{total}} tools",
        "noToolPolicies": "No dedicated tool policies are configured for this MCP service.",
        "noToolPoliciesDetail": "Its server access policy is configured at the service level and applies at the MCP service boundary.",
        "noToolPoliciesNoServer": "No server access policy is configured either.",
        "toolPoliciesUnknown": "Tool policy assignments are not available because the access policies could not be fully loaded.",
        "viewAllTools": "View all tools",
        "configureToolPolicies": "Configure tool policies",
        "showingDedicated_one": "Showing {{count}} tool with a dedicated policy",
        "showingDedicated_other": "Showing {{count}} tools with dedicated policies",
        "resourcePoliciesUnavailable": "Resource policies could not be loaded.",
        "combinator": {
          "AND": "AND",
          "OR": "OR"
        }
      },
      "tools": {
        "empty": "No tools found for this server.",
        "noMatches": "No tools match your search or filter.",
        "unavailable": "Tools are unavailable right now. Try again in a moment.",
        "searchPlaceholder": "Search tools",
        "filterLabel": "Policy assignment",
        "openTool": "Open details for {{tool}}",
        "filters": {
          "all": "All tools",
          "inherited": "Server policy only",
          "specific": "Has tool-specific policy"
        },
        "columns": {
          "name": "Tool name",
          "description": "Description",
          "assignment": "Policy assignment",
          "toolConditions": "Tool conditions",
          "dedicatedPolicies": "Dedicated policies"
        },
        "assignmentHelpLabel": "About policy assignment",
        "assignmentHelp": "Server policy: the tool has no dedicated tool policy, and server-level access rules apply at the MCP service boundary. Tool-specific policy: at least one policy is configured for the tool itself. An assignment is not an access decision; that depends on the caller at request time.",
        "searchPoliciesPlaceholder": "Search tools or policies",
        "clearFilters": "Clear search and filter",
        "dedicatedPolicyCount_one": "{{count}} tool-specific policy",
        "dedicatedPolicyCount_other": "{{count}} tool-specific policies",
        "actions": {
          "viewAccessRules": "View access rules",
          "editToolPolicy": "Edit tool policy"
        }
      },
      "toolDrawer": {
        "title": "Tool Details",
        "previous": "Previous tool",
        "next": "Next tool",
        "typeLabel": "Tool",
        "tabs": {
          "toolDetails": "Details",
          "inputSchema": "Input Schema",
          "accessRules": "Access Rules"
        },
        "name": "Tool name",
        "service": "Service",
        "description": "Description",
        "noDescription": "No description provided.",
        "resourceType": "Resource type",
        "source": "Source",
        "schema": {
          "parameters": "Parameters",
          "required": "Required",
          "allowedValues": "Allowed values: {{values}}",
          "toggleNested": "Show the fields of {{name}}",
          "rawJson": "Raw JSON",
          "copy": "Copy schema",
          "copyAria": "Copy schema to clipboard",
          "none": "This tool does not publish an input schema.",
          "noParameters": "This tool takes no parameters."
        },
        "access": {
          "contextNote": "Whether a call is allowed depends on the caller's identity and attributes at request time.",
          "editToolPolicy": "Edit tool policy",
          "assignment": "Policy assignment",
          "policyN": "Tool-specific policy {{index}}",
          "noPolicyConditions": "This policy has no conditions.",
          "explain": {
            "specific": "Policies configured for this tool itself are shown below.",
            "inherited": "This tool has no dedicated tool policy. The server access policy applies at the MCP service boundary.",
            "none": "No server access policy or tool-specific policy is configured.",
            "unknown": "The policy assignment could not be determined because the access policies could not be fully loaded."
          }
        },
        "missing": {
          "title": "Tool not found",
          "description": "This MCP server does not register a tool with this name. It may have been renamed or removed."
        },
        "unavailable": {
          "title": "Tool details unavailable",
          "description": "This server's tools could not be loaded. Try again in a moment."
        }
      },
      "notFound": {
        "title": "MCP server not found",
        "description": "This server may have been removed, or you may not have access to it.",
        "back": "Back to MCP Services"
      },
      "notAvailable": "Not available",
      "loadFailed": {
        "title": "Couldn't load this MCP server",
        "description": "The server details could not be retrieved. This is usually temporary.",
        "retry": "Try again"
      }
    },
    "viewDetails": {
      "rowAction": "View details",
      "noResourceConditionsNarrative": "No conditions defined for this resource policy."
    },
    "viewTools": "View Tools",
    "dataAccessPolicyCount": "Data Policies",
    "transport": "Transport",
    "registerDialogTitle": "Register MCP Server",
    "sectionServerConfiguration": "Server configuration",
    "protectionScope": {
      "sectionTitle": "Protection Scope",
      "sectionDescription": "Choose what to protect during onboarding.",
      "server_onlyLabel": "Server Access Only",
      "server_onlyDescription": "Control who can access this MCP server.",
      "server_onlyHint": "Skip tool discovery and skip tool/data policy setup during onboarding.",
      "server_toolsLabel": "Tools",
      "server_toolsDescription": "Run tool discovery and keep tool-focused access control setup.",
      "server_toolsHint": "Includes only tool discovery and tool-focused access control setup.",
      "server_tools_dataLabel": "Tools + Data",
      "server_tools_dataDescription": "Run tool discovery and keep tool-focused access control setup.",
      "server_tools_dataHint": "Includes only tool discovery and tool-focused access control setup."
    },
    "sectionTemplateDetails": "Server details",
    "serverNameLabel": "Server Name",
    "serverNamePlaceholder": "e.g. my-snowflake-mcp",
    "serverNameRequired": "Server name is required",
    "serverNameInvalid": "Use only lowercase letters, numbers, and hyphens",
    "serverNameMaxLength": "Maximum 60 characters",
    "templateLabel": "Server type",
    "templatePlaceholder": "Select server type",
    "docLink": "Documentation",
    "urlPreviewPlaceholder": "Select server type and fill fields to see the URL",
    "urlComplete": "URL is complete",
    "unresolvedField": "Unresolved field",
    "authSectionTitle": "Identity used to authenticate to the downstream MCP servers",
    "validateConnection": "Validate Connection",
    "validating": "Validating…",
    "connectionValidated": "Connection Validated",
    "cancelValidation": "Cancel",
    "oauthValidationRequired": "Please validate the OAuth connection before proceeding",
    "oauthValidationTimeout": "Validation timed out. Please try again.",
    "oauthRedirectFailed": "Could not start OAuth validation. Please check your settings and try again.",
    "gatewayClientIdMissing": "Configure the MCP Access Gateway client ID in the Enforcement Options tab before validating.",
    "validateConnectionHint": "Opens a third-party portal to complete authentication",
    "authSectionDescription": "Select which identity the MCP Access Gateway will use when connecting to this MCP service. This determines how downstream systems identify and authorize requests.",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Enter description",
    "fixedFieldsLabel": "Fixed settings",
    "submit": "Register",
    "cancel": "Cancel",
    "registerSuccess": "MCP server registered successfully",
    "editDialogTitle": "Edit MCP Server",
    "editPolicyDialogTitle": "Edit Access Policies",
    "editPolicy": "Edit policies",
    "update": "Update",
    "updateSuccess": "MCP server updated successfully",
    "hyphenNormalizedNotice": "Underscores were converted to hyphens",
    "validationRequired": "This field is required",
    "authType": "Type",
    "authTypes": {
      "none": "None",
      "oauth_obo": "Human identity",
      "oauth_client_credentials": "Agent identity",
      "key_pair": "Service account (JWT)",
      "oauth": "Service account (OAuth 2.0 On-Behalf-Of flow)",
      "passthrough": "Pass-through"
    },
    "authTypeDescription": {
      "none": "No identity is used to authenticate to the MCP server. This is the default option.",
      "oauth_obo": "The gateway will use the human identity to authenticate to the MCP server.",
      "oauth_client_credentials": "Use the connecting Agent’s client id and secret to impersonate the agent connecting using a token exchange",
      "key_pair": "The gateway uses a dedicated service account (private key JWT) to authenticate.",
      "oauth": "The gateway uses a service account (OAuth) to authenticate.",
      "passthrough": "Incoming client tokens are forwarded directly to the MCP server. A separate identity is used only for metadata discovery."
    },
    "identityStrategy": {
      "sectionTitle": "Authentication Setup",
      "sectionDescription": "Choose how TrustLogix accesses this MCP Service.",
      "authTypes": {
        "key_pair": "JWT",
        "oauth": "OAuth",
        "none": "None",
        "passthrough": "Pass-through"
      },
      "authTypeDescriptions": {
        "key_pair": "Use the existing provider-specific service-account and key configuration.",
        "oauth": "Use a configured OAuth client to obtain access to the MCP Service.",
        "none": "This MCP Service does not require downstream authentication.",
        "passthrough": "Use the configured caller-token handling mode at runtime, with separate access for metadata discovery."
      },
      "serviceIdentityTitle": "Service Identity",
      "serviceIdentitySubtitle": "Select the identity the MCP gateway will use when connecting to the MCP server.",
      "serviceIdentity": {
        "AGENT": "Agent",
        "GATEWAY": "Gateway",
        "CUSTOM": "Custom"
      },
      "serviceIdentityDescriptions": {
        "AGENT": "Use an existing agent identity for downstream authentication.",
        "GATEWAY": "Reuse gateway credentials already configured in the platform.",
        "CUSTOM": "Provide your own OAuth client credentials."
      },
      "grantTypeTitle": "Grant Type",
      "grantTypeDescription": "Select how the gateway obtains its access token.",
      "grantType": {
        "CLIENT_CREDENTIALS": "Client Credentials",
        "TOKEN_EXCHANGE": "Token Exchange"
      },
      "grantTypeDescriptions": {
        "CLIENT_CREDENTIALS": "The service authenticates with its own credentials. Use this when the gateway acts independently, not on behalf of any specific user.",
        "TOKEN_EXCHANGE": "Exchanges a user's token so the gateway can act on their behalf. Use this when downstream access should reflect what that user is allowed to do."
      },
      "exchangeTypeTitle": "Type of Exchange",
      "exchangeType": {
        "DELEGATION": "Delegation (OBO)",
        "IMPERSONATION": "Impersonation"
      },
      "exchangeTypeDescriptions": {
        "DELEGATION": "Act on behalf of the user. Uses the selected service identity to connect on behalf of the user.",
        "IMPERSONATION": "Act as the user identity. Coming soon."
      },
      "impersonationComingSoon": "Coming soon",
      "oauthConfigTitle": "OAuth Configuration",
      "scopeLabel": "Scope",
      "scopePlaceholder": "Enter scope",
      "tokenEndpointLabel": "Token Endpoint",
      "authorizationEndpointLabel": "Authorization Endpoint",
      "endpointPlaceholder": "Enter endpoint URL",
      "endpointHint": "Used by TrustLogix to obtain access for metadata discovery.",
      "clientCredentialsNoValidation": "No connection validation needed. Client Credentials doesn't use a browser sign-in, so TrustLogix requests a token with this client ID and secret when it discovers tools in the next step.",
      "agentApplicationLabel": "Select Agent",
      "agentApplicationPlaceholder": "Select an AI Agent application",
      "clientIdLabel": "Client ID",
      "clientIdPlaceholder": "Enter Client ID",
      "clientSecretLabel": "Client Secret",
      "clientSecretPlaceholder": "Enter Client Secret",
      "gatewayInfoBanner": "Gateway credentials will be resolved from the configured gateway setup. No additional configuration is needed.",
      "passthrough": {
        "flowSummaryTitle": "Authentication & Runtime Flow",
        "phase1Label": "Phase 1",
        "phase2Label": "Phase 2",
        "metadataDiscoveryTitle": "Metadata Discovery",
        "metadataDiscoveryDescription": "TrustLogix uses its <strong>Service Identity</strong> to securely discover MCP server metadata, including available tools, schemas, and capabilities.",
        "metadataDiscoveryFlow": [
          "TrustLogix",
          "Service Identity",
          "Discover MCP Metadata"
        ],
        "runtimeAccessTitle": "Runtime Authorization",
        "runtimeAccessDescription": "The original agent or user token is validated and authorized by the TrustLogix Gateway before the request is forwarded to the MCP server.",
        "runtimeAccessFlow": [
          "Agent / User Token",
          "TrustLogix Gateway",
          "MCP Server"
        ],
        "runtimeAccessGatewayActions": [
          "Validate token",
          "Validate claims",
          "Apply TrustLogix policies"
        ],
        "identityPreserved": "Runtime requests carry the original agent or user token",
        "tokenValidated": "The TrustLogix Gateway validates the token before forwarding",
        "policiesEnforced": "TrustLogix policies are evaluated before the request is forwarded",
        "serviceIdentityTitle": "Metadata Discovery Authentication",
        "serviceIdentitySubtitle": "Choose the identity TrustLogix will use to retrieve MCP metadata during registration and tool discovery.",
        "serviceIdentity": {
          "GATEWAY": "Gateway Identity",
          "CUSTOM": "Custom Identity"
        },
        "serviceIdentityDescriptions": {
          "GATEWAY": "Use the OAuth credentials already configured for the TrustLogix gateway.",
          "CUSTOM": "Provide a separate OAuth client for metadata discovery."
        },
        "serviceIdentityUsageBadge": "Used for metadata discovery",
        "gatewayBannerTitle": "How this identity is used",
        "gatewayBannerBody": "TrustLogix will use the configured gateway credentials to retrieve MCP tools, schemas, and capabilities. Runtime requests will still use the incoming agent or user token.",
        "customBannerBody": "These OAuth credentials are used for metadata discovery. Runtime requests will use the incoming agent or user token.",
        "oauthConfigTitle": "Discovery OAuth Configuration",
        "oauthConfigDescription": "These settings are used to obtain access for metadata discovery and to tell connecting clients which scope to request.",
        "scopeLabel": "Required Scope",
        "scopeHint": "Used during metadata discovery and advertised to clients so they know which scope to request.",
        "inheritedFromGateway": "Inherited from Gateway configuration"
      },
      "noneNote": "No downstream credentials are sent to this MCP Service. Incoming TrustLogix authentication and policy evaluation still apply, and a connection test can still fail for reachability or service errors."
    },
    "key_pairWarning": "Downstream systems will not see individual agent identities. All enforcement beyond the gateway will use the shared service account.",
    "transportTypes": {
      "streamable-http": "Streamable HTTP",
      "see": "Secure Event Exchange"
    },
    "statusTypes": {
      "OFFLINE": "Offline",
      "ACTIVE": "Online",
      "DRAFT": "Draft",
      "UNKNOWN": "Unknown"
    },
    "deleteServer": "Delete Server",
    "deleteServerDescription": "Are you sure you want to delete <strong>{{name}}</strong> ?",
    "serverDeleted": "MCP server deleted successfully",
    "stepServiceConfig": "Service Configuration",
    "stepServiceConfigDesc": "Configure the MCP server details.",
    "stepIdentityStrategy": "Authentication Setup",
    "stepIdentityStrategyDesc": "Choose how TrustLogix accesses this MCP Service.",
    "stepServerAccessPolicy": "Server Access Policy",
    "stepToolDiscovery": "Tool Discovery",
    "stepToolDiscoveryDesc": "Discover and configure tools.",
    "stepToolPolicies": "Tool Policies",
    "stepToolPoliciesDesc": "Define per-tool access rules.",
    "stepResourcePolicies": "Resource Policies",
    "stepResourcePoliciesDesc": "Protect documents and files agents can access.",
    "stepAccessRules": "Access Control Policies",
    "stepAccessRulesDesc": "Define access control policies for the tools.",
    "stepServerAccessPolicyDesc": "Control who can access this MCP server.",
    "stepReviewActivate": "Review & Activate",
    "stepReviewActivateDesc": "Review the MCP protection setup before activation.",
    "stepReviewAndSave": "Review and Save",
    "stepReviewAndSaveDesc": "Validate and save all access policies.",
    "savePolicies": "Save Policies",
    "deployPolicies": "Deploy to Gateway",
    "deploySuccess": "Policies deployed successfully.",
    "close": "Close",
    "activateProtection": "Save and Exit",
    "continue": "Continue",
    "continueToToolDiscovery": "Continue to Tool Discovery",
    "skipToReview": "Skip to Review",
    "skipToReviewDisabledHint": "Complete all server-level access conditions (attribute, operator, and value) to skip ahead to review.",
    "serverAccessPolicy": {
      "title": "Server Access Policy",
      "helper": "Control who can access this MCP server using user, group, and agent attribute conditions",
      "denyDefault": "Deny by default unless explicitly allowed.",
      "bannerDiscoveringTitle": "Discovering tools…",
      "bannerDiscoveringBody": "We are fetching tool metadata from this MCP server. The count below will update when discovery finishes.",
      "bannerErrorTitle": "Tool discovery failed",
      "bannerErrorBody": "We could not load tools for this server. Fix your configuration on the previous step, then try again.",
      "bannerNoToolsTitle": "No tools on this server",
      "bannerNoToolsBody": "Discovery completed and no tools were returned. You can still continue to finish setup.",
      "bannerProtectedTitle_one": "{{count}} Tool Protected by Server-Level Policy",
      "bannerProtectedTitle_other": "{{count}} Tools Protected by Server-Level Policy",
      "bannerProtectedTitlePending": "Tools Protected by Server-Level Policy",
      "bannerUnprotectedTitle_one": "{{count}} Tool Detected (Unprotected)",
      "bannerUnprotectedTitle_other": "{{count}} Tools Detected (Unprotected)",
      "bannerUnprotectedTitlePending": "Tools Detected (Unprotected)",
      "bannerProtectedBody_one": "The <strong>MCP server-level policy</strong> defined above automatically protects the {{count}} detected tool. No further configuration is required to secure it.",
      "bannerProtectedBody_other": "The <strong>MCP server-level policy</strong> defined above automatically protects the {{count}} detected tools. No further configuration is required to secure them.",
      "bannerProtectedBodyPending": "The <strong>MCP server-level policy</strong> defined above automatically protects detected tools. No further configuration is required to secure them.",
      "bannerProtectedPathAdvancedLabel": "Advanced setup",
      "bannerProtectedPathAdvancedBody": "Review the tool and set granular access rules in <strong>Tool Discovery</strong>.",
      "bannerProtectedPathQuickLabel": "Quick finish",
      "bannerProtectedPathQuickBody": "Select <strong>Skip to Review</strong> to finalize your setup with this server-wide protection.",
      "bannerUnprotectedBody_one": "You haven't added any server-level access conditions. To ensure your server is secure, <strong>Tool Discovery and Tool Policies are now required</strong> so you can configure access rules for this tool.",
      "bannerUnprotectedBody_other": "You haven't added any server-level access conditions. To ensure your server is secure, <strong>Tool Discovery and Tool Policies are now required</strong> so you can configure access rules for individual tools.",
      "bannerUnprotectedBodyPending": "You haven't added any server-level access conditions. To ensure your server is secure, <strong>Tool Discovery and Tool Policies are now required</strong> so you can configure access rules for individual tools.",
      "bannerUnprotectedBodyIncomplete": "Some server-level access conditions are incomplete. <strong>Tool Discovery and Tool Policies are now required</strong> until every row has attribute, operator, and value filled in.",
      "bannerUnprotectedCta": "Click <strong>Continue to Tool Discovery</strong> below to begin mandatory setup.",
      "allowedIdentities": "Allowed identities and attributes",
      "resourceSummaryTitle": "Resource Summary",
      "resourceTypeLabel": "Resource Type",
      "resourceTypeValue": "MCP Server",
      "resourceNameLabel": "Resource Name",
      "scopeLabel": "Scope"
    },
    "reviewActivate": {
      "title": "Review & Activate",
      "subtitle": "Confirm configuration before enabling protection on this MCP server.",
      "serverName": "Server Name",
      "serverType": "Server Type",
      "protectionScope": "Protection Scope",
      "authMode": "Authentication Mode",
      "serviceIdentity": "Service Identity",
      "grantType": "Grant Type",
      "exchangeType": "Exchange Type",
      "accessRules": "Access Rules Summary",
      "accessRulesCount_one": "{{count}} condition",
      "accessRulesCount_other": "{{count}} conditions",
      "defaultBehavior": "Default Behavior",
      "defaultDeny": "Deny by default"
    },
    "reviewAndSave": {
      "title": "Review and Save Policies",
      "subtitle": "Review your configuration and save all access policies in a single operation.",
      "policyList": "Policies to Save",
      "phaseCreating": "Creating policies…",
      "phaseUpdating": "Updating policies…",
      "phaseReviewing": "Reviewing policies…",
      "successCount_one": "{{count}} policy saved successfully",
      "successCount_other": "{{count}} policies saved successfully",
      "partialFailureTitle": "Some policies failed to save",
      "errorTitle": "Policy save failed",
      "retryAction": "Retry",
      "retryFailed_one": "Retry Failed ({{count}})",
      "retryFailed_other": "Retry Failed ({{count}})",
      "policyName": "Policy",
      "statusColumn": "Status",
      "messageColumn": "Message",
      "scopeServerOnly": "Server Access",
      "scopeServerAndTools": "Server and Tools",
      "serverRulesSummary_one": "Server: {{count}} condition",
      "serverRulesSummary_other": "Server: {{count}} conditions",
      "toolRulesSummary": "Tools: {{tools}}",
      "toolPoliciesLabel": "Tool Policies",
      "resourcePoliciesLabel": "Resource Policies",
      "resourceConditionCount_one": "{{count}} condition",
      "resourceConditionCount_other": "{{count}} conditions",
      "resourceScopeMetadata": "Metadata-based",
      "resourceScopeSpecific": "Specific: {{path}}",
      "createApplication": "Create MCP Server",
      "createApplicationError": "Failed to create the MCP server. Please try again.",
      "deployNote": "Policies must be deployed to take effect. After saving, click \"Deploy to Gateway\" to activate protection.",
      "successReadyToDeploy_one": "{{count}} policy reviewed and ready to deploy.",
      "successReadyToDeploy_other": "{{count}} policies reviewed and ready to deploy.",
      "nothingToDoMessage": "All policies are already deployed and up-to-date. No action is required.",
      "metadataDiscoveryIdentity": "Metadata Discovery Identity",
      "runtimeAccess": "Runtime Access",
      "runtimeAccessForwarded": "Incoming token forwarded"
    },
    "accessRulesToolsListTitle": "Tools",
    "accessRulesSearchPlaceholder": "Search tools by name",
    "accessRulesNoToolMatches": "No tools match your search.",
    "accessRulesToolSpecificLabel": "Control who can access this Tool using user, group, and agent attribute conditions",
    "accessRulesSelectTool": "Select a tool from the list to configure its access rules.",
    "optionalBadge": "Optional",
    "toolPoliciesEmptyState": {
      "title": "No tools available",
      "body": "Discover tools first to define tool-level policies.",
      "action": "Go to Tool Discovery"
    },
    "conditionBuilder": {
      "userAttributes": "User Attributes",
      "agentAttributes": "Agent Attributes",
      "resourceAttributes": "Resource Attributes",
      "matchWithLabel": "Match With",
      "matchWith": {
        "constantValue": "Constant Value",
        "customValue": "Custom Value",
        "customExpression": "Custom Expression",
        "value": "Value",
        "userAttribute": "User Attribute",
        "agentAttribute": "Agent Attribute",
        "assetAttribute": "Asset Attribute",
        "externalFunction": "External Function"
      }
    },
    "resourcePolicies": {
      "title": "Resource Policies",
      "helper": "Control which documents and files AI agents can access, based on classifications, locations, ownership, and metadata.",
      "emptyTitle": "Protect Documents and Files",
      "emptyText": "Control which resources AI agents can access based on classifications, locations, ownership, and metadata.",
      "createPolicy": "Create Resource Policy",
      "listTitle": "Resources",
      "newPolicy": "New Policy",
      "deletePolicy": "Delete policy",
      "noResourceTypes": "No resource types",
      "policyNameLabel": "Policy Name",
      "policyNamePlaceholder": "e.g. Analyst Research Access",
      "scopeTitle": "Policy Scope",
      "scopeMetadataLabel": "Metadata Based",
      "scopeMetadataHint": "Match resources by classification, sensitivity, and other attributes.",
      "scopeAdvanced": "Advanced",
      "advancedBadge": "Advanced",
      "scopeSpecificLabel": "Specific Resource",
      "scopeSpecificHint": "Pin this policy to a single file or folder path.",
      "resourcePathPlaceholder": "/Board/board_minutes_q1.pdf",
      "specificWarning": "Targeting individual files does not scale. Prefer metadata-based conditions wherever possible.",
      "conditionsTitle": "Resource Conditions",
      "conditionsHint": "Control which resources this policy covers using user, agent, and resource attribute conditions."
    },
    "toolPolicy": {
      "inheritTitle": "Inherit Server Policy",
      "inheritSubtext": "Use the server access policy configured in the previous step.",
      "customTitle": "Custom Tool Policy",
      "customSubtext": "Define access rules specifically for this tool. These rules override the server access policy.",
      "inheritLabel": "INHERITING",
      "customLabel": "CUSTOM POLICY",
      "effectivePolicyTitle": "Effective Global Policy",
      "effectivePolicySummary_one": "{{count}} condition defined",
      "effectivePolicySummary_other": "{{count}} conditions defined",
      "effectivePolicyEmpty": "No server-level conditions defined yet.",
      "viewServerPolicy": "View Server Policy (Step 2)",
      "activeServerRulesLabel": "Active Server Rules",
      "viewInStep2": "View in Step 3",
      "noServerRulesPreview": "No server-level rules defined yet.",
      "narrativePrefix": "Access is granted if",
      "operatorLabel": {
        "equals": "is equal to",
        "not_equals": "is not equal to",
        "in": "is in",
        "not_in": "is not in",
        "contains": "contains",
        "unknown": "—"
      },
      "attributeCategory": {
        "USER": "User Attribute",
        "AGENT": "Agent Attribute",
        "RESOURCE": "Resource Attribute"
      },
      "validationBannerText_one": "{{count}} tool requires at least one validation condition before you can proceed.",
      "validationBannerText_other": "{{count}} tools require at least one validation condition before you can proceed.",
      "choosePrompt": "Select a policy type above to configure access for this tool.",
      "requirementBadge": "Requirement: 1+ condition",
      "conditionsEmptyTitle": "No conditions defined yet",
      "conditionsEmptyDesc": "You must add at least one condition to specify who can execute this tool.",
      "conditionsEmptyAction": "Add Your First Condition"
    },
    "preview": {
      "title": "Live Preview",
      "serverConfigTitle": "Server Configuration",
      "accessPolicyTitle": "Server Access Policy",
      "toolsTitle": "Tools & Policies",
      "resourcePoliciesTitle": "Resource Policies",
      "noResourcePolicies": "No resource policies defined yet.",
      "compiledDsl": "Compiled policy (DSL)",
      "denyByDefault": "Deny by default",
      "allowByDefault": "Allow by default",
      "noToolsSelected": "No tools selected yet.",
      "reviewNote": "Review everything above before saving.",
      "fieldName": "Name",
      "fieldScope": "Protection scope",
      "fieldServerType": "Server type",
      "fieldDataSource": "Data source",
      "fieldResourceAccount": "Microsoft account",
      "fieldAuthType": "Auth type",
      "fieldServiceIdentity": "Service identity",
      "fieldGrantType": "Grant type",
      "toolStatusInherit": "Inheriting",
      "toolStatusCustom": "Custom",
      "toolStatusMissing": "Not set",
      "toolStatusIncomplete": "Incomplete"
    },
    "toolDiscovery": {
      "resultsTitle": "Tool Discovery Results",
      "subheader": "Select which tools to secure",
      "toolsFound_one": "{{count}} Tool Found",
      "toolsFound_other": "{{count}} Tools Found",
      "defaultTitle": "Tool discovery is ready",
      "defaultBody": "Run discovery to load tools for this MCP server.",
      "loadingTitle": "Discovering tools",
      "loadingBody": "Please wait while tool metadata is being fetched.",
      "emptyTitle": "No tools available yet",
      "emptyBody": "No tools were discovered for this server.",
      "discoverAction": "Discover Tools",
      "toggleToolSelection": "Toggle {{toolName}}"
    },
    "toolTypeLabel": "Tool Type",
    "associatedSemanticModelsLabel": "Associated Semantic Models",
    "tabRegisteredServices": "Registered MCP Services",
    "authentication": {
      "registration": {
        "title": "Client Registration",
        "subtitle": {
          "runtime": "How the authorization server recognizes this OAuth client.",
          "discovery": "How the authorization server recognizes the metadata discovery client."
        },
        "method": {
          "EXISTING_OAUTH_CLIENT": "Registered Application (Client ID)",
          "CIMD": "Client Metadata (CIMD)",
          "DCR_EXISTING": "Dynamic Client Registration (existing)"
        },
        "methodDescriptions": {
          "EXISTING_OAUTH_CLIENT": "Use the client ID of an application already registered with your authorization provider.",
          "CIMD": "Use a published client metadata URL to identify the application."
        },
        "cimdIntro": "Identify the OAuth client using its managed metadata document. The metadata URL is also the OAuth client ID.",
        "cimdUnavailable": "CIMD setup is not available in this environment.",
        "cimdUnsupported": "This authorization server does not support this registration method. Use an existing OAuth client.",
        "cimdSupportUnknown": "CIMD support has not been established for this authorization server. Check compatibility before relying on it.",
        "metadataNotConfigured": "Client metadata is not configured.",
        "noSecretNote": "No client secret: a public metadata document cannot contain one. Any key used for client authentication stays in managed credentials.",
        "dcrNote": "This client was registered dynamically. It is kept as is; this form does not re-register it.",
        "sourceTitle": "Metadata source",
        "source": {
          "MANAGED_PROFILE": "Use configured client metadata",
          "MANAGED_EXTERNAL_URL": "Reference an existing managed metadata URL"
        },
        "sourceDescriptions": {
          "MANAGED_PROFILE": "Pick a client metadata document the tenant already manages.",
          "MANAGED_EXTERNAL_URL": "Enter the URL of a metadata document that is already published."
        },
        "metadataUrlPlaceholder": "https://clients.example.com/oauth/client-metadata.json",
        "metadataUrlHint": "Used exactly as entered - it is the OAuth client ID.",
        "fields": {
          "clientProfile": "Client profile",
          "issuer": "Issuer",
          "environment": "Environment",
          "method": "Client registration",
          "clientId": "OAuth client ID",
          "metadataUrl": "Client metadata URL",
          "metadataUrlAsClientId": "OAuth client ID / Client metadata URL"
        },
        "gateway": {
          "loading": "Loading the gateway client profile…",
          "unavailableTitle": "Gateway Identity unavailable",
          "unavailableBody": "No applicable gateway client is configured for this connection.",
          "useCustomForDiscovery": "A Custom Identity can be used for metadata discovery instead.",
          "executionContextRequired": "Execution context required - you can resolve this later.",
          "viewEnforcement": "View Settings → Enforcement",
          "manage": "Manage client profile",
          "managedNote": "This registration belongs to the gateway client profile and is changed there, not per service."
        },
        "validation": {
          "invalidUrl": "Enter a valid URL.",
          "https": "The metadata URL must use https.",
          "fragment": "The metadata URL cannot contain a fragment (#).",
          "path": "The metadata URL must include a path to the document."
        },
        "saveAsProfile": "Save as client profile",
        "directUrlLocal": "This URL is saved on this connection only. Saving it as a client profile makes it reusable.",
        "profilePicker": {
          "newTab": "(opens in a new tab)",
          "recentDraft": "Draft “{{name}}” saved. Finish its setup before using it in a connection.",
          "recentSaved": "Profile “{{name}}” saved. Select it to use it for this connection.",
          "recentSavedNotEligible": "Profile “{{name}}” saved, but it cannot be used for this connection. See the reasons below.",
          "useThisProfile": "Use this profile",
          "viewProfile": "View profile",
          "add": "Add client profile",
          "manage": "Manage client profiles",
          "refresh": "Refresh profiles",
          "directUrlAlternative": "You can reference an existing metadata URL instead.",
          "forbidden": "You do not have permission to view or use client profiles for this connection.",
          "loading": "Loading client profiles…",
          "failed": "Client profiles could not be loaded.",
          "retry": "Retry",
          "unavailable": "Client profile management is not available in this environment.",
          "none": "No client profiles have been added for this tenant.",
          "draftsOnly": "Profiles exist, but setup is incomplete. Complete their profile checks before selecting them.",
          "noMatch": "No profiles match this service's current context.",
          "askAdministrator": "An administrator with access to OAuth Client Profiles can add one.",
          "ineligibleSummary_one": "{{count}} profile is not available for this connection",
          "ineligibleSummary_other": "{{count}} profiles are not available for this connection",
          "archived": "This profile is archived. Existing references are retained, but it cannot be selected for a new connection.",
          "currentIneligible": "This profile cannot be used for this connection: {{reasons}}.",
          "pending": {
            "VALIDATION_STALE": "Metadata has not been checked recently - check the profile again before relying on it.",
            "ISSUER_UNKNOWN": "This service's authorization server is not known yet, so compatibility is checked when the connection is tested.",
            "CONTEXT_UNKNOWN": "Whether this service's authorization server accepts client metadata documents is not known yet."
          },
          "changed": "This profile changed since you opened the form. Review the latest details before saving.",
          "inaccessible": "The selected profile is no longer available to you. The existing reference is kept until you choose another.",
          "managedWhere": "Profiles are managed under Settings → AI Policy Enforcement → OAuth Client Profiles.",
          "notAuthorization": "Selecting a profile does not complete this service's authorization.",
          "inherited": "Inherited from the selected gateway identity.",
          "inheritedUnknown": "Gateway client profile"
        }
      }
    }
  },
  "semanticModels": {
    "tabTitle": "Semantic Models",
    "title": "Semantic Models",
    "titleDescription": "View and manage semantic data models used for policy and AI context.",
    "noModelsFound": "No semantic models found.",
    "name": "Name",
    "objects": "Objects",
    "description": "Description",
    "policyCount": "Policies",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "importModels": "Import models",
    "searchPlaceholder": "Search models...",
    "importPanelTitle": "Import semantic models",
    "importPanelSubtitle": "Choose a data source and select models to import.",
    "dataSourceLabel": "Data source",
    "dataSourcePlaceholder": "Select data source",
    "selectModelsLabel": "Select models",
    "selectModelsSearchPlaceholder": "Search models...",
    "noModelsToSelect": "No models available. Select a data source first.",
    "importSuccess": "Semantic models imported successfully.",
    "policy": "Policy",
    "createPolicy": "Create policy",
    "editPolicy": "Edit policy",
    "policySaveSuccess": "Policy saved successfully.",
    "createPolicyPanelTitle": "Create policy",
    "editPolicyPanelTitle": "Edit policy",
    "policyDetailsSectionTitle": "Policy details",
    "policyName": "Policy name",
    "policyDescription": "Description",
    "objectAccessSectionTitle": "Object Access Policy Condition",
    "objectAccessObjectsLabel": "Objects",
    "rowFilterSectionTitle": "Row Filter Policy Condition",
    "columnFilterSectionTitle": "Column Filter Policy Condition",
    "columnFilterObjectsLabel": "Objects",
    "columnFilterColumnsLabel": "Columns",
    "selectedSemanticModel": "Model Name ",
    "selectedSemanticModelDescription": "Policy for this semantic model",
    "policyNotFound": "Policy not found."
  },
  "mcpEnforcement": {
    "title": "Enforcement Strategy Configuration",
    "subtitle": "Select how your AI agents will connect to registered MCP services. For most cloud deployments, the MCP Access Gateway is recommended to ensure centralized policy enforcement and auditing.",
    "patternProxy": "MCP Access Gateway",
    "patternProxyDescription": "Routes MCP traffic through TrustLogix so runtime access policies can be evaluated and enforced. Recommended for multi-tenant SaaS environments.",
    "patternMiddleware": "Middleware",
    "patternMiddlewareDescription": "Inject logic directly into your application framework using our SDK. Best for custom app logic.",
    "patternInterceptor": "Interceptor",
    "patternInterceptorDescription": "Deploy TrustLogix policy enforcement directly within your existing API gateway infrastructure.",
    "proxyConfigTitle": "MCP Access Gateway Configuration",
    "proxyGatewayUrl": "MCP Access Gateway URL",
    "proxyGatewayUrlPlaceholder": "https://proxy.internal.network/v1",
    "proxyGatewayUrlHint": "This endpoint is managed by TrustLogix and is environment-specific.",
    "reset": "Reset",
    "resetConfirmTitle": "Reset MCP Access Gateway configuration",
    "resetConfirmDescription": "This will delete the saved MCP Access Gateway enforcement strategy and clear the current configuration.",
    "resetSuccess": "MCP Access Gateway configuration reset successfully",
    "activateStrategy": "Save",
    "copyUrl": "Copy URL",
    "viewSetupInstructions": "View Setup Instructions",
    "securityCredentialsOauth": "Security Credentials (OAuth)",
    "securityCredentialsHelp": "Credentials used by the MCP Access Gateway to authenticate with downstream MCPs configured in TLX",
    "clientId": "Client ID",
    "clientSecret": "Client Secret",
    "scope": "Scope",
    "tokenEndpoint": "Token Endpoint",
    "middlewareConfigTitle": "Middleware Configuration",
    "interceptorConfigTitle": "Interceptor Configuration — API Gateway Plugin",
    "interceptorGatewayProviderLabel": "Gateway Provider",
    "interceptorGatewayProviderName": "Kong Gateway",
    "interceptorGatewayProviderSupportedBadge": "Currently supported plugin provider",
    "interceptorSecurityCredentialsHelp": "Used by the Kong Interceptor plugin to authenticate with TrustLogix policy decision endpoints.",
    "interceptorPluginResourceRequiredBadge": "Required",
    "interceptorPluginResourceDescription": "Defines the Kong plugin configuration schema required for the TrustLogix interceptor.",
    "interceptorPluginResourceType": "Lua Schema",
    "interceptorPluginResourceMeta": "Type: {{type}} • Size: {{size}}",
    "interceptorPluginSizeLoading": "…",
    "interceptorPluginSizeUnavailable": "Unavailable",
    "interceptorSchemaLoading": "Loading plugin schema…",
    "interceptorSchemaLoadError": "Unable to load the plugin schema. Check your connection and try again.",
    "interceptorSchemaRetry": "Retry",
    "interceptorDownloadIdle": "Download schema.lua",
    "interceptorDownloadDone": "Downloaded schema.lua",
    "interceptorDownloadSuccess": "schema.lua downloaded successfully to your device.",
    "interceptorStep1Title": "Download schema.lua",
    "interceptorStep1Desc": "Save the schema file for use during Kong plugin installation.",
    "interceptorStep1Action": "Get File",
    "interceptorStep2Title": "Install the Lua plugin",
    "interceptorStep2Desc": "Add the TrustLogix plugin implementation to your Kong deployment.",
    "interceptorStep3Title": "Register the schema",
    "interceptorStep3Desc": "Use schema.lua when configuring the plugin in Kong.",
    "interceptorStep3Action": "View Credentials",
    "interceptorStep4Title": "Restart or reload Kong",
    "interceptorStep4Desc": "Follow your organization's standard Kong deployment process.",
    "interceptorStepLabel": "STEP {{number}}",
    "interceptorViewSetupInstructions": "View setup instructions",
    "interceptorSetupHelpText": "Need detailed architecture diagrams or troubleshooting steps?",
    "interceptorTabSecurityCredentials": "Security Credentials",
    "interceptorTabPluginSchema": "Plugin Schema & Assets",
    "interceptorTabSetupGuide": "Setup Guide & Checklist",
    "interceptorSecurityCredentialsTabTitle": "OAuth Security Credentials",
    "interceptorPluginSchemaTabTitle": "Required Plugin Resource File",
    "interceptorPluginSchemaTabSubtitle": "Download the schema file or pull it directly into your build pipeline.",
    "interceptorDeploymentResponsibilityTitle": "Deployment & Lifecycle Responsibility",
    "interceptorDeploymentResponsibilityBody": "Your platform team is responsible for installing, configuring, upgrading, and maintaining the Lua plugin in your Kong environment. TrustLogix does not access or manage your gateway infrastructure directly.",
    "interceptorSetupGuideTabTitle": "Kong Plugin Installation Workflow",
    "interceptorSetupGuideTabSubtitle": "Follow these sequential steps to activate policy enforcement in Kong.",
    "interceptorSaveConfiguration": "Save Configuration",
    "interceptorSetupModalTitle": "Kong Gateway Plugin Setup Instructions",
    "interceptorSetupStep1Title": "1. Download schema.lua",
    "interceptorSetupStep1Desc": "Save the official Lua plugin schema from the Enforcement Options configuration panel to your repository or workspace.",
    "interceptorSetupStep2Title": "2. Install the Plugin in Kong",
    "interceptorSetupStep2Desc": "Place the TrustLogix plugin code into your Kong custom plugins directory (e.g., <code>/usr/local/share/lua/5.1/kong/plugins/trustlogix-interceptor</code>).",
    "interceptorSetupStep3Title": "3. Code Schema Preview",
    "interceptorSetupStep4Title": "4. Register the Plugin & Restart",
    "interceptorSetupStep4Desc": "Include <code>trustlogix-interceptor</code> in your Kong configuration file (<code>plugins = bundled, trustlogix-interceptor</code>) and reload Kong.",
    "interceptorSetupDeploymentNote": "<strong>Note:</strong> Installation steps may vary depending on your specific Kong deployment model (e.g., Kong Ingress Controller, DB-less mode, Docker, or Kong Konnect). If you do not manage Kong directly, pass these instructions and <code>schema.lua</code> to your API platform administrator.",
    "interceptorSetupModalClose": "Close Guidance",
    "interceptorActivateSuccess": "Kong Gateway Plugin (Interceptor) is now the active enforcement strategy for this environment.",
    "interceptorResetConfirmTitle": "Reset Interceptor configuration",
    "interceptorResetConfirmDescription": "This will delete the saved Kong Gateway Plugin (Interceptor) enforcement strategy and clear the current configuration.",
    "interceptorResetSuccess": "Interceptor configuration reset successfully",
    "implementationLibrary": "Implementation Library",
    "implementationFastMcp": "fast-mcp",
    "implementationFastMcpDesc": "Optimized for async I/O",
    "implementationLangchain": "langchain",
    "implementationLangchainDesc": "Native agent integration",
    "apiAccessKey": "API Access Key",
    "apiAccessKeyPlaceholder": "sk-mcp-............",
    "systemInstructions": "System Instructions",
    "viewApiGuide": "View API Guide",
    "systemInstructionsPlaceholder": "Define enforcement rules here (YAML or JSON)...",
    "noSelectionTitle": "Configure Enforcement",
    "noSelectionSubtitle": "To begin, please select one of the architectural patterns above. Each strategy offers different levels of control and performance.",
    "noSelectionRecommendation": "Recommended",
    "noSelectionRecommendationText": "Choose <1>MCP Access Gateway</1> for quick setup with minimal code changes.",
    "noSelectionPerformance": "Performance",
    "noSelectionPerformanceText": "Choose <1>Middleware</1> for low-latency, integrated logic.",
    "libraryNoSelectionTitle": "Select Middleware Library",
    "libraryNoSelectionSubtitle": "Choose an implementation above to configure API keys and custom instructions.",
    "resetStrategy": "Reset Strategy",
    "activeBadge": "Active",
    "replaceConfirmTitle": "Replace active enforcement strategy?",
    "replaceConfirmDescription": "{{current}} is currently the active enforcement strategy for this environment. Saving this configuration will replace it with {{next}}.",
    "replaceConfirmDescriptionGeneric": "An enforcement strategy is already active for this environment. Saving this configuration will replace it with {{next}}.",
    "replaceConfirmAction": "Replace & Save",
    "administration": {
      "back": "Back"
    }
  },
  "mcpRuntimeRequirements": {
    "title": "Customer Runtime Requirements",
    "description": "Hybrid runtime services require matching secrets in your customer-managed vault. TrustLogix cannot read or validate values stored in your private vault.",
    "keyCount_one": "{{count}} key",
    "keyCount_other": "{{count}} keys",
    "summary_one": "{{count}} customer-managed vault key required.",
    "summary_other": "{{count}} customer-managed vault keys required.",
    "review": "Review Requirements",
    "sourceAiAgent": "AI Agent",
    "sourceMcpServer": "MCP Server",
    "sourceTenantServicePrincipal": "Tenant Service Principal",
    "columnSource": "Source",
    "columnType": "Type",
    "columnPurpose": "Purpose",
    "columnAws": "AWS Secrets Manager",
    "columnAzure": "Azure Key Vault",
    "columnAction": "Action",
    "notProvided": "Not provided",
    "copyAws": "Copy AWS",
    "copyAzure": "Copy Azure",
    "copyAllAws": "Copy All AWS Keys",
    "copyAllAzure": "Copy All Azure Keys",
    "copyAwsSuccess": "AWS key copied to clipboard.",
    "copyAzureSuccess": "Azure Key Vault name copied to clipboard.",
    "copyAllAwsSuccess_one": "{{count}} AWS key copied to clipboard.",
    "copyAllAwsSuccess_other": "{{count}} AWS keys copied to clipboard.",
    "copyAllAzureSuccess_one": "{{count}} Azure Key Vault name copied to clipboard.",
    "copyAllAzureSuccess_other": "{{count}} Azure Key Vault names copied to clipboard.",
    "copyError": "Unable to copy to clipboard.",
    "empty": "No customer-managed vault keys.",
    "error": "Unable to load customer runtime requirements.",
    "retry": "Retry"
  },
  "mcpEntitlement": {
    "title": "Entitlement Source",
    "subtitle": "Define where TrustLogix retrieves identity attributes used during policy evaluation.",
    "sourceIdentity": "Source Identity",
    "sourceIdentityPlaceholder": "Select source identity",
    "sourceIdentityDescription": "Select the identity source for your MCP infrastructure.",
    "sourceIdentityTypes": {
      "mcp": "MCP",
      "mcp-server": "MCP Server"
    },
    "sourceConnectedTitle": "Connected Data Sources",
    "sourceConnectedDescription": "Attributes retrieved from configured enterprise data systems like Snowflake or Databricks.",
    "sourceCentralizedTitle": "Centralized Attributes",
    "sourceCentralizedDescription": "Manage agent and user attributes directly within TrustLogix centralized repository.",
    "comingSoon": "Coming Soon",
    "sourceConnectionLabel": "Source Connection",
    "sourceConnectionDescription": "Select the specific enterprise data system to pull attributes from.",
    "sourceConnectionPlaceholder": "Select data source",
    "sourceConnectionHint": "Mapping attributes from source to policy conditions allows for dynamic access based on data tags and classifications."
  },
  "enterprisePolicies": {
    "title": "Enterprise Policies",
    "subtitle": "Define reusable authorization rules centrally and apply them consistently across applications, data platforms, and AI systems.",
    "searchPlaceholder": "Search policies",
    "noResults": "No policies match your search.",
    "actions": {
      "createPolicy": "Create Enterprise Policy",
      "viewDetails": "View Details"
    },
    "dialogs": {
      "delete": {
        "title": "Delete Policy",
        "description": "Are you sure you want to delete \"{{name}}\"?"
      },
      "deploy": {
        "title": "Deploy Policy",
        "description": "Are you sure you want to deploy policy \"{{name}}\"?"
      }
    },
    "createWizard": {
      "title": "Policy Creation",
      "subtitle_one": "{{count}} guided step",
      "subtitle_other": "{{count}} guided steps",
      "actions": {
        "createPolicy": "Create Policy",
        "continue": "Continue",
        "publish": "Publish Enterprise Policy"
      },
      "errors": {
        "missingPolicyId": "The policy could not be published because it was not created successfully. Go back and create the policy again."
      },
      "steps": {
        "basicInformation": {
          "label": "Basic Information",
          "description": "Name and describe the enterprise policy."
        },
        "policyConditions": {
          "label": "Policy Conditions",
          "description": "Combine enterprise attributes into an applicability rule."
        },
        "platformCoverage": {
          "label": "Platform Coverage",
          "description": "Review adoption across connected platforms."
        },
        "reviewAndPublish": {
          "label": "Review & Publish",
          "description": "Review the enterprise policy and publish it."
        }
      },
      "basic": {
        "sectionTitle": "Basic information",
        "sectionDescription": "Describe the enterprise outcome without selecting a policy type or platform implementation.",
        "policyName": "Policy name",
        "policyNamePlaceholder": "e.g. Protect sensitive customer records",
        "businessDescription": "Business description",
        "businessDescriptionPlaceholder": "Explain the business outcome this policy should produce.",
        "severity": "Severity",
        "severityOptions": {
          "low": "Low",
          "medium": "Medium",
          "high": "High",
          "critical": "Critical"
        }
      },
      "conditions": {
        "title": "Policy Conditions",
        "subtitle": "Define when this policy should apply by combining enterprise attributes. Author policies using business objects instead of physical tables.",
        "summaryTitle": "Summary",
        "summaryPrefix": "Allow access if",
        "summaryFallback": "Allow access when the selected policy conditions are met.",
        "userAttributes": "User Attributes",
        "agentAttributes": "Agent Attributes",
        "assetAttributes": "Asset Attributes",
        "attributeLabel": "Attribute",
        "operatorLabel": "Operator",
        "matchWithLabel": "Match With"
      },
      "platformCoverage": {
        "title": "Platform Coverage",
        "subtitle": "Enterprise policies are authored centrally. Individual platforms adopt and enforce them according to their capabilities.",
        "tableTitle": "Platform adoption",
        "tableDescription": "Review current adoption and continue configuration from the platform workspace.",
        "columns": {
          "platform": "Platform",
          "type": "Type",
          "adoptionStatus": "Adoption Status",
          "owner": "Owner"
        },
        "adoptionStatuses": {
          "applied": "Applied",
          "pendingAdoption": "Pending Adoption",
          "configurationRequired": "Configuration Required",
          "unsupported": "Unsupported"
        },
        "empty": "No platform coverage details are available yet.",
        "loadFailed": "We couldn't load platform coverage for this policy. You can continue and review adoption later from the policy details page.",
        "noteTitle": "Enterprise policies define organizational intent.",
        "noteDescription": "Deployment and enforcement occur from each participating platform after publication."
      },
      "review": {
        "title": "Review & Publish",
        "subtitle": "Review the policy details and publish to make it available for platform adoption.",
        "policySummary": "Policy summary",
        "name": "Name",
        "description": "Description",
        "priority": "Priority",
        "status": "Status",
        "policyCode": "Policy Code",
        "validation": "Validation",
        "conditionsValid": "Policy conditions are valid and synchronized.",
        "conditionsCount_one": "{{count}} condition",
        "conditionsCount_other": "{{count}} conditions",
        "expressionSynchronized": "Expression synchronized",
        "humanReadableRule": "Human-readable rule",
        "readyToPublishTitle": "Ready to publish",
        "readyToPublishDescription": "Publishing makes this enterprise policy available for platform owners to adopt. It does not deploy or configure enforcement."
      },
      "stepPlaceholders": {
        "policyConditions": {
          "title": "Policy Conditions",
          "description": "This step will be integrated next in the common flow."
        },
        "reviewAndPublish": {
          "title": "Review & Publish",
          "description": "This step will be integrated next in the common flow."
        }
      }
    },
    "detail": {
      "tabs": {
        "overview": "Overview",
        "decisionLogic": "Decision Logic",
        "enforcement": "Enforcement",
        "decisionActivity": "Decision Activity"
      },
      "overview": {
        "title": "Business summary",
        "lead": "This enterprise policy is governed independently from the platforms that participate in enforcement.",
        "name": "Policy name",
        "status": "Status",
        "description": "Description",
        "createdBy": "Created by",
        "policyId": "Policy ID",
        "priority": "Priority",
        "created": "Created",
        "lastModifiedBy": "Last modified by",
        "lastUpdated": "Last updated"
      },
      "enforcementCoverage": {
        "title": "Enforcement coverage",
        "native": "Native enforcement",
        "decisionApi": "Decision API",
        "missing": "Missing",
        "captionNative": "Native",
        "captionApi": "API",
        "captionMissing": "Missing",
        "openCoverageMatrix": "Open coverage matrix"
      },
      "decisionLogic": {
        "title": "Decision logic",
        "narrativePrefix": "Allow access if",
        "structuredView": "Conditions",
        "defaultDecision": "Default decision",
        "defaultDeny": "Deny",
        "empty": "This policy has no conditions configured."
      },
      "enforcement": {
        "title": "Enforcement",
        "columns": {
          "dataSource": "Data source",
          "status": "Status"
        },
        "status": {
          "active": "Active",
          "pending": "Pending"
        },
        "empty": "No enforcement details are available yet."
      },
      "decisionActivity": {
        "title": "Decision activity",
        "columns": {
          "timestamp": "Timestamp",
          "user": "User",
          "decision": "Decision",
          "resource": "Resource",
          "platform": "Platform"
        },
        "filters": {
          "decision": "Decision",
          "all": "All decisions",
          "allow": "Allow",
          "deny": "Deny",
          "timeRange": "Time range",
          "allTime": "All time",
          "last24Hours": "Last 24 hours",
          "last7Days": "Last 7 days",
          "last30Days": "Last 30 days"
        },
        "loadedCount": "Showing {{shown}} of {{loaded}} loaded records. The time range filter applies to the records loaded on this page.",
        "empty": "No policy decisions have been recorded yet."
      }
    },
    "portfolio": {
      "title": "Policy portfolio"
    },
    "columns": {
      "policy": "Policy",
      "priority": "Priority",
      "status": "Status",
      "enforcementCoverage": "Enforcement Coverage",
      "platforms": "Platforms",
      "gaps": "Gaps",
      "updated": "Updated"
    },
    "toast": {
      "deployed": "Policy published successfully.",
      "deleted": "Policy deleted successfully."
    }
  },
  "agentEstate": {
    "pageTitle": "AI Agents",
    "pageDescription": "Import your agents from the platforms where they run, or register them manually. TrustLogix organizes them and helps you govern their access.",
    "connectEnvironment": "Import Agents",
    "importAgents": {
      "title": "Add AI Agents",
      "subtitle": "Choose how to bring your agents into TrustLogix so you can see and govern them.",
      "readOnlyNote": "TrustLogix only reads agent metadata. It doesn't move, change, or redeploy your agents.",
      "paths": {
        "platform": {
          "title": "Import from a platform",
          "description": "Connect TrustLogix to a supported AI platform and discover its agents automatically.",
          "footerLabel": "Supported platforms"
        },
        "manual": {
          "title": "Register manually",
          "description": "Add an agent that TrustLogix can't discover, such as one that runs locally, in a custom app, or on an unsupported platform.",
          "footerLabel": "Best for",
          "footer": "Local agents, custom applications and unsupported platforms"
        }
      },
      "registerManuallyPrompt": "Don't see your platform?",
      "registerManuallyLink": "Register agents manually",
      "registryNotice": "Are these agents in an agent registry such as Microsoft Foundry?",
      "registryNoticeAction": "Import from an agent registry",
      "connected": "Connected",
      "imported": "Imported"
    },
    "tabs": {
      "categories": "Agent Categories",
      "allAgents": "All Agents"
    },
    "wizard": {
      "title": "Import Agents",
      "subtitle": "Import agent metadata into TrustLogix. Your agents stay on their platform.",
      "platformIntro": "Choose the platform where the agents you want to import are built or run.",
      "platformRequired": "Select an agent platform to continue.",
      "connectionFieldsRequired": "Complete every required field, then test access again.",
      "testBeforeContinue": "Test platform access before continuing.",
      "started": "Agent import started. Follow its progress from the dashboard.",
      "startFailed": "Could not start the agent import.",
      "steps": {
        "platform": {
          "label": "Platform",
          "description": "Choose your agent platform"
        },
        "platformAccess": {
          "label": "Platform access",
          "description": "Validate access and select projects"
        },
        "identityAccess": {
          "label": "Identity access",
          "description": "Connect an identity provider"
        },
        "review": {
          "label": "Review & import",
          "description": "Review details and import"
        }
      },
      "fields": {
        "connectionName": "Connection name",
        "account": "Account / tenant",
        "clientId": "Client ID",
        "authorizationToken": "Authorization token",
        "identityProvider": "Identity provider",
        "environmentType": "Environment"
      },
      "choosePlatform": "Agent platforms",
      "identityProviderSection": "Identity provider",
      "connectionTestError": "TrustLogix could not reach this platform. Check the access details and try again.",
      "identityDetected": "Identity context detected from {{platform}}",
      "identityDetectedHint": "Additional enterprise identity configuration can be added later.",
      "identityRecommended": "Additional identity context recommended",
      "identityRecommendedHint": "TrustLogix can build the inventory without it, and identity resolution stays pending until a provider is connected.",
      "authSetup": {
        "methodTitle": "Access method",
        "methods": {
          "OAUTH_CLIENT_CREDENTIALS": {
            "title": "OAuth 2.0 client credentials",
            "description": "Authenticate with a client ID and client credential issued for TrustLogix."
          },
          "AUTHORIZATION_TOKEN": {
            "title": "Authorization token",
            "description": "Authenticate with a pre-issued read-only token."
          }
        }
      },
      "retryHint": "Correct the details above, then try again.",
      "identity": {
        "intro": "Connect an identity provider so TrustLogix can resolve the identity each agent runs as, along with its owners, organizational context, and entitlements.",
        "purpose": "Identity context helps TrustLogix understand who owns an agent, where it belongs, and what access it should have.",
        "entraDescription": "Resolve agent identities, owners and group membership from Microsoft Entra ID.",
        "oktaDescription": "Resolve agent identities and entitlements from an Okta organization.",
        "configureTitle": "Connect {{provider}}",
        "credentialMode": {
          "label": "Credentials",
          "reuse": "Use existing connection",
          "separate": "Use different credentials"
        },
        "reusedFrom": "Reusing the credentials from {{connection}}",
        "reusedHint": "The same Microsoft application TrustLogix just connected with. Nothing further to enter.",
        "fields": {
          "tenantId": "Directory (tenant) ID",
          "clientId": "Application (client) ID",
          "clientSecret": "Client secret"
        },
        "untested": "Identity provider not connected yet.",
        "testing": "Connecting to the identity provider…",
        "testConnection": "Connect identity provider",
        "retestConnection": "Reconnect identity provider",
        "connectionTestError": "Unable to connect to the identity provider. Check the details and try again.",
        "connectBeforeContinue": "Connect the identity provider before continuing.",
        "pingIdentityDescription": "Resolve agent identities and access policies from PingOne or PingFederate.",
        "saviyntDescription": "Resolve agent identities, owners and entitlements from Saviynt Identity Cloud.",
        "sailpointDescription": "Resolve agent identities, owners and entitlements from SailPoint Identity Security Cloud."
      },
      "review": {
        "intro": "Review the connection, import scope and identity access before starting the import.",
        "identity": "Identity access",
        "projects": "Projects",
        "allAgentsIncluded": "All agents in these projects will be included.",
        "evidence": {
          "validated": "Validated",
          "connected": "Connected",
          "notVerified": "Not verified"
        },
        "platform": "Platform & connection",
        "access": "Platform access",
        "accessValidated": "Access validated",
        "projectNames_one": "{{count}} project: {{names}}",
        "projectNames_other": "{{count}} projects: {{names}}",
        "existingConnection": "Existing connection",
        "separateCredentials": "Separate credentials"
      },
      "startOnboarding": "Start Import",
      "startingOnboarding": "Starting import…",
      "prerequisites": {
        "gateway": {
          "title": "MCP Access Gateway",
          "checking": "Checking gateway configuration…",
          "endpointUnavailable": "The gateway endpoint is not available from the tenant configuration. Use the setup instructions to find it.",
          "copyEndpoint": "Copy gateway endpoint",
          "endpointCopied": "Gateway endpoint copied.",
          "endpointCopyFailed": "Could not copy the gateway endpoint.",
          "recheck": "Recheck",
          "configure": "Configure Gateway",
          "setupInstructions": "Setup instructions",
          "adminRequired": "Setting up the MCP Access Gateway requires administrator access. Ask your TrustLogix administrator to configure it, then recheck.",
          "missing": {
            "notEnabled": {
              "title": "An MCP Access Gateway has not been configured.",
              "description": "Importing agents needs the TrustLogix MCP Gateway configured for this tenant. Set it up, then recheck."
            },
            "configurationRequired": {
              "title": "MCP Access Gateway setup is incomplete.",
              "description": "Credentials are saved, but no enforcement strategy is selected. Choose the MCP Access Gateway strategy, then recheck."
            },
            "otherMethod": {
              "title": "This tenant does not use the MCP Access Gateway.",
              "description": "Enforcement is configured with a different strategy. Importing agents in this release requires the TrustLogix MCP Gateway."
            }
          },
          "failed": {
            "description": "TrustLogix could not read the gateway configuration. This does not mean the gateway is missing - try again."
          },
          "forbidden": {
            "description": "Ask your TrustLogix administrator for access, or to confirm the MCP Access Gateway is configured."
          },
          "readyDescription": "A gateway is configured for this tenant. Its reachability and routing are not checked here.",
          "needsAttentionDescription": "TrustLogix could not confirm that the gateway is ready."
        },
        "mcpServices": {
          "label": "I confirm that the MCP services required by the agents I plan to import are registered in TrustLogix.",
          "helper": "Confirm this with the administrator responsible for MCP service registration. TrustLogix does not verify service coverage in this step."
        },
        "agentsUseGateway": {
          "label": "I confirm that the agents I plan to import are configured to use the TrustLogix MCP Gateway.",
          "instruction": "Update each agent's MCP URL or connection configuration to use the TrustLogix MCP Gateway endpoint, rather than connecting directly to the downstream MCP service. This allows the gateway to evaluate access policies for requests routed through it.",
          "noRewrite": "Make this change in your agent platform. Starting the import does not update any agent's MCP URL."
        },
        "details": {
          "summary": "How to find the gateway endpoint",
          "endpointSource": "Use the gateway endpoint shown above, or the endpoint given in the setup instructions for your integration.",
          "notOtherUrls": "The agent's MCP endpoint is not the agent registry URL, an authorization-server URL, or a client-metadata URL.",
          "perService": "Where each MCP service has its own gateway route, the setup instructions explain how to obtain the URL for that service."
        },
        "blocked": {
          "checking": "Wait for the gateway configuration check to finish.",
          "gateway": "The MCP Access Gateway configuration check must pass before continuing."
        },
        "required": {
          "badge": "Required setup",
          "learnMore": "Learn more",
          "items": {
            "mcpServices": {
              "title": "Required MCP services are registered in TrustLogix",
              "description": "Ensure the MCP services your agents need are registered in TrustLogix so they can be discovered, managed, and protected by policy."
            },
            "agentRouting": {
              "title": "Agents use the TrustLogix MCP Access Gateway",
              "description": "Configure your agents to route MCP traffic through the TrustLogix MCP Access Gateway instead of connecting directly to downstream MCP services."
            },
            "microsoftPermissions": {
              "title": "Grant required Microsoft permissions",
              "description": "TrustLogix requires these permissions to discover and import agents from Microsoft Foundry."
            }
          }
        },
        "permissions": {
          "count_one": "{{count}} permission required",
          "count_other": "{{count}} permissions required",
          "view": "View permissions",
          "hide": "Hide permissions",
          "notice": "These permissions can’t currently be verified automatically by TrustLogix. Make sure they are granted to the TrustLogix application before starting the import.",
          "groups": {
            "application_one": "Application permission",
            "application_other": "Application permissions",
            "delegated_one": "Delegated permission",
            "delegated_other": "Delegated permissions"
          },
          "consent": {
            "required": "Admin consent required",
            "notRequired": "Admin consent not required"
          },
          "descriptions": {
            "agentIdentityReadAll": "Read all agent identities",
            "applicationReadAll": "Read all applications",
            "customSecAttributeAssignmentReadAll": "Read custom security attribute assignments",
            "customSecAttributeDefinitionReadAll": "Read custom security attribute definitions",
            "directoryReadAll": "Read directory data",
            "userRead": "Sign in and read user profile"
          },
          "viewRequired": "View required permissions",
          "hideRequired": "Hide required permissions"
        }
      },
      "projects": {
        "intro": "All projects are selected by default. Choose the projects to import from. Agent lists are read-only.",
        "loading": "Loading projects…",
        "retry": "Retry",
        "failed": {
          "title": "Could not load projects",
          "description": "TrustLogix could not read the project list for this connection. This is not an empty list - try again."
        },
        "forbidden": {
          "title": "This connection cannot read projects",
          "description": "The connection authenticated, but it is not allowed to list projects. Grant it access in the platform, then try again."
        },
        "empty": {
          "title": "No accessible projects",
          "description": "This connection can read the platform, but no projects are visible to it. Check its access in the platform."
        },
        "searchPlaceholder": "Search projects",
        "selected": "{{selected}}/{{total}} selected",
        "noneSelected": "Select at least one project to import from.",
        "noMatch": "No projects match this search.",
        "scopeNote": "All agents in the selected projects will be included. Agent lists are read-only previews; the import job retrieves the current inventory when the import starts.",
        "countUnavailable": "Not available",
        "previewCount_one": "{{count}} agent (preview)",
        "previewCount_other": "{{count}} agents (preview)",
        "viewAgents": "View agents",
        "viewAgentsIn": "View agents in {{project}}",
        "columns": {
          "project": "Project",
          "agents": "Agents",
          "preview": "Preview"
        },
        "blocked": {
          "loading": "Wait for the project list to load.",
          "none": "No accessible projects to import from.",
          "select": "Select at least one project before continuing.",
          "confirm": "Choose Use selected projects to confirm the import scope."
        },
        "preview": {
          "title": "Agents in {{project}}",
          "subtitle": "Read-only preview",
          "readOnlyNote": "A read-only preview. Every agent in this project is included when it is selected; the import job may find a different current inventory.",
          "partial": "The platform returned only part of this project's agents. The import job imports the full current inventory.",
          "empty": "No agents in this project yet.",
          "failedTitle": "Could not load this project's agents",
          "failedDescription": "The project stays selected. Try again, or continue without the preview.",
          "retry": "Retry",
          "searchPlaceholder": "Search agents",
          "noMatch": "No agents match this search.",
          "count_one": "{{count}} agent in preview",
          "count_other": "{{count}} agents in preview",
          "columns": {
            "name": "Name",
            "identifier": "Identifier"
          }
        },
        "title": "Select projects"
      },
      "registry": {
        "onboard": "Save Connection & Import",
        "edit": {
          "title": "Edit Agent Registry",
          "subtitle": "Update this connection's details. Saving imports its agents again.",
          "save": "Save Changes & Import",
          "saving": "Saving changes & importing agents…"
        },
        "onboarding": "Saving connection & importing agents…",
        "fields": {
          "tenantId": "Microsoft Entra tenant ID",
          "clientSecret": "Client secret"
        },
        "validation": {
          "nameRequired": "Enter a connection name.",
          "nameTooLong": "Use at most 255 characters for the connection name.",
          "tenantIdRequired": "Enter the Microsoft Entra tenant ID.",
          "clientIdRequired": "Enter the application (client) ID.",
          "uuid": "Enter a valid ID, in the form 00000000-0000-0000-0000-000000000000.",
          "secretRequired": "Enter the client secret."
        },
        "connection": {
          "passed": "TrustLogix can authenticate to Microsoft Azure and find Foundry projects.",
          "failed": "The connection did not pass every check. Fix what is listed below, then test again."
        },
        "identity": {
          "bindingHint": "Agent identities are read with the same app registration as the agent registry. No other credentials are needed.",
          "credentialSource": "Agent registry",
          "passed": "TrustLogix can read agent identities from Microsoft Entra ID.",
          "failed": "TrustLogix cannot read agent identities yet. Fix what is listed below, then test again."
        },
        "checks": {
          "status": {
            "PASSED": "Passed",
            "FAILED": "Failed",
            "NOT_CHECKED": "Not checked"
          },
          "PROVIDER_AUTHENTICATION": {
            "label": "Authenticate to Microsoft",
            "advice": "Check the tenant ID, client ID and client secret, and that the secret has not expired."
          },
          "PROJECT_DISCOVERY_ACCESS": {
            "label": "Find Foundry projects",
            "advice": "Assign the app registration the Reader role on the subscription or management group that holds your Foundry projects."
          },
          "AGENT_IDENTITY_READ": {
            "label": "Read agent identities",
            "advice": "Grant the Microsoft Graph application permission AgentIdentity.Read.All, with admin consent."
          },
          "AGENT_ATTRIBUTE_READ": {
            "label": "Read agent attributes",
            "advice": "Grant the Microsoft Graph application permissions CustomSecAttributeAssignment.Read.All and CustomSecAttributeDefinition.Read.All, with admin consent."
          },
          "unknown": "{{code}}",
          "missingPermissions": "Missing permissions: {{permissions}}"
        },
        "projects": {
          "intro": "These are the Foundry projects this connection can import agents from. All are selected; clear any you do not want to import from.",
          "loading": "Listing the Foundry projects this connection can read…",
          "scopeNote": "All agents in the selected projects are imported. Projects are listed only when the app registration holds the Foundry Agent Consumer role on them; assign the role on another project, then list again, to include it.",
          "empty": {
            "title": "No readable Foundry projects found",
            "description": "This connection cannot import agents from any Foundry project. Assign the app registration the Foundry Agent Consumer role on each project to import from, then go back and test access again."
          },
          "incomplete": {
            "title": "The project list is incomplete",
            "description": "Microsoft did not return the complete list of projects. Try again - a partial list is never used."
          },
          "forbidden": {
            "title": "You cannot list these projects",
            "description": "Ask an administrator for permission to manage integrations, then try again."
          },
          "failed": {
            "title": "Projects could not be loaded",
            "description": "TrustLogix could not list the Foundry projects. Try again."
          },
          "blocked": {
            "loading": "Wait for the complete project list.",
            "none": "There are no accessible projects to import from.",
            "select": "Select at least one project.",
            "confirm": "Choose Use selected projects to confirm the import scope."
          },
          "selected": "{{selected}}/{{total}} selected",
          "noneSelected": "Select at least one project to import from.",
          "title": "Select Foundry projects",
          "searchPlaceholder": "Search project names",
          "duplicates": {
            "title": "Some projects share a name",
            "description": "More than one listed project is named {{names}}. Keep only one of each selected, or rename them in Microsoft Foundry and list again.",
            "blocked": "The selection holds projects that share a name. Keep only one of each selected, or rename them in Microsoft Foundry and list again."
          },
          "columns": {
            "project": "Project"
          }
        },
        "review": {
          "projectsChanged": "The listed projects changed",
          "projectsChangedHint": "The projects this connection can reach are no longer the ones you reviewed. List them again and review them before importing.",
          "reviewProjects": "Review projects again"
        },
        "errors": {
          "secretRequired": "Enter the client secret - the stored one is no longer available.",
          "secretRequiredForIdentityChange": "The tenant or client ID changed. Enter the client secret for the new app registration.",
          "previewIncomplete": "Microsoft did not return the complete list of projects. Try again.",
          "projectSelectionChanged": "The listed projects changed since you reviewed them. Review the refreshed list, then import again.",
          "emptyProjectSelection": "There are no projects to import agents from.",
          "mcpConfirmationRequired": "Confirm that the required MCP services are registered.",
          "notFound": "The agent registry could not be found. It may have been deleted.",
          "registryChanged": "The agent registry was changed while agents were imported. Try again.",
          "agentListIncomplete": "The agents of a project could not be loaded completely. Try again later.",
          "invalid": "Some details are not valid. Check them and try again.",
          "forbidden": "The request was not allowed. Check the app registration's permissions, or ask an administrator for access.",
          "conflict": "An agent registry with this name or Microsoft tenant already exists.",
          "upstream": "Microsoft could not be reached. Try again later.",
          "generic": "Something went wrong. Try again.",
          "gatewayRequired": "Onboarding needs the tenant's MCP Gateway. Set up the gateway in Settings, then try again.",
          "invalidCredentials": "Microsoft rejected the tenant ID, client ID or client secret. Check them and test the connection again."
        },
        "result": {
          "title": "Agent import",
          "importFailed": "Connection saved, import failed",
          "importFailedHint": "The connection is saved. Retry the import - it will not create another connection.",
          "retryImport": "Retry import",
          "retryingImport": "Importing agents…",
          "importedToast": "Agents synced.",
          "attributesSyncedToast": "Attributes synced. Created: {{created}}, agents updated: {{agents}}.",
          "viewRegistries": "View agent registries",
          "done": "Done",
          "completeTitle": "Import complete",
          "completed": "Import completed",
          "empty": "Import completed; no agents found in the selected scope",
          "emptyHint": "The selected projects have no agents TrustLogix can read. Add agents in the platform, then retry the import from Agent Registries.",
          "imported_one": "{{count}} agent imported",
          "imported_other": "{{count}} agents imported",
          "breakdown": "{{created}} new, {{updated}} updated",
          "skipped_one": "{{count}} agent was not imported:",
          "skipped_other": "{{count}} agents were not imported:",
          "unnamedAgent": "Unnamed agent",
          "connectionSaved": "Connection saved",
          "connectionUpdated": "Connection updated",
          "viewAgents": "View imported agents",
          "fromProjects_one": "from {{count}} selected project",
          "fromProjects_other": "from {{count}} selected projects"
        },
        "authSetup": {
          "readOnly": "Read-only access",
          "test": "Test access",
          "retest": "Test access again",
          "completeFields": "Complete the fields above to test access.",
          "placeholders": {
            "connectionName": "e.g., Azure production",
            "tenantId": "Enter tenant ID",
            "clientId": "Enter client ID",
            "clientSecret": "Enter client secret"
          },
          "hints": {
            "tenantId": "Your directory ID. You can find it under Entra ID → Overview.",
            "clientId": "The Application (client) ID from your app registration's Overview page.",
            "clientSecret": "Create one under Certificates & Secrets and copy the value, not the secret ID."
          }
        }
      },
      "platformStep": {
        "intro": "Name the connection and review the setup guidance for your selected platform.",
        "agentPlatform": "Agent platform",
        "change": "Change platform",
        "cancelChange": "Cancel",
        "changeWarning": "Choosing a different platform clears its credentials, access results and project selection. The connection name is kept.",
        "connectionTitle": "Connection details",
        "connectionHint": "Use a name your team will recognize.",
        "requiredSetup": {
          "title": "Required setup",
          "importPermissions": "Import permissions",
          "importPermissionsDescription": "Grant the platform permissions required to discover projects and read agent metadata.",
          "notVerified": "Not verified",
          "guidance": "These instructions are guidance. Platform access is verified in the next step."
        }
      },
      "results": {
        "passed": "{{passed}} of {{total}} checks passed",
        "passedNoChecks": "Validation passed",
        "failed_one": "{{count}} of {{total}} checks failed",
        "failed_other": "{{count}} of {{total}} checks failed",
        "incomplete": "Validation incomplete: a required check was not run",
        "error": "Could not complete validation",
        "stale": "Validation out of date. The details changed since the last test, so test again.",
        "view": "View results",
        "hide": "Hide results"
      },
      "platformAccessStep": {
        "intro": "Enter the credentials TrustLogix uses to read platform metadata, then test access.",
        "introValidated": "Platform access is validated. Choose which projects to import from.",
        "credentialsTitle": "{{platform}} access",
        "credentialsSubtitle": "These credentials let TrustLogix read platform metadata. Your agents keep their own credentials.",
        "testing": "Testing access…",
        "notTested": "Not tested",
        "projectsPending": "Projects will appear after access is verified."
      },
      "projectScope": {
        "selected_one": "{{count}} project selected",
        "selected_other": "{{count}} projects selected",
        "change": "Change projects",
        "showAll_one": "Show {{count}} more",
        "showAll_other": "Show {{count}} more",
        "showFewer_one": "Show fewer",
        "showFewer_other": "Show fewer",
        "useSelected": "Use selected projects"
      },
      "protectionFollowUp": {
        "notice": {
          "title": "Protection setup comes after import",
          "description": "Gateway routing, MCP service registration and policy enforcement are separate from importing metadata."
        },
        "warning": {
          "title": "Import does not enable protection",
          "description": "This saves the connection and imports agent metadata. Importing does not apply policies, change traffic routing or verify enforcement."
        },
        "view": "View protection follow-up",
        "hide": "Hide protection follow-up",
        "steps": {
          "review": "Review imported agents and the resources they reach.",
          "policies": "Configure policies and route agent traffic through the TrustLogix MCP Access Gateway.",
          "verify": "Verify enforcement with runtime evidence."
        },
        "result": {
          "title": "Protection has not been verified",
          "description": "Importing metadata does not apply policies, route traffic or prove that access is enforced."
        }
      },
      "identityStep": {
        "defaultForFoundry": "Default for Foundry",
        "notVerified": "Not verified",
        "validated": "Validated",
        "reuseTitle": "Reuse the existing Microsoft Entra connection",
        "test": "Test identity access",
        "retest": "Test identity access again",
        "testing": "Testing identity access…",
        "choiceNote": {
          "title": "Provider choice stays available",
          "description": "Choose another identity provider to see its connection flow."
        }
      }
    },
    "progress": {
      "complete": "Agent import complete",
      "discoveredAgents_one": "{{count}} agent discovered",
      "discoveredAgents_other": "{{count}} agents discovered",
      "technologies_one": "{{count}} technology detected",
      "technologies_other": "{{count}} technologies detected",
      "recommendationsReady_one": "{{count}} agent has a recommended policy ready",
      "recommendationsReady_other": "{{count}} agents have recommended policies ready",
      "noRecommendationsReady": "No policy recommendations are currently available.",
      "stageDetail": "{{value}} of {{total}}",
      "barLabel": "Agent import progress",
      "backgroundNote": "TrustLogix continues this work in the background.",
      "dismiss": "Dismiss",
      "reviewRecommendations": "Review Recommended Policies",
      "viewAllAgents": "View all agents",
      "stage": {
        "importing": "Importing agents from selected projects",
        "linkingMcp": "Linking MCP Services",
        "resolvingIdentity": "Resolving identity and ownership",
        "metadata": "Syncing detailed agent metadata",
        "analyzing": "Analyzing prompts and capabilities",
        "classifying": "Classifying agent purpose",
        "policyGaps": "Identifying policy gaps",
        "recommendations": "Preparing policy recommendations"
      },
      "enforcementAgents_one": "{{count}} agent",
      "enforcementAgents_other": "{{count}} agents",
      "enforcementReady": "Enforcement setup configured",
      "enforcementSetupRequired": "Enforcement setup required",
      "running_one": "Importing {{count}} agent",
      "running_other": "Importing {{count}} agents",
      "importedAgents_one": "{{count}} agent imported",
      "importedAgents_other": "{{count}} agents imported"
    },
    "list": {
      "title": "{{scope}} ({{count}})",
      "allAgents": "All Agents",
      "scopedTitle": "{{scope}} Agents",
      "searchPlaceholder": "Search agents by name, purpose, platform or owner",
      "editAgent": {
        "loadFailed": "This agent could not be loaded for editing."
      },
      "deleteAgent": {
        "title": "Delete agent",
        "description": "Delete {{name}}? This removes the agent from TrustLogix and cannot be undone.",
        "success": "{{name}} was deleted."
      },
      "empty": "No agents match these filters.",
      "noPolicy": "No policy applied",
      "noRecommendations": "None available",
      "recommendationCount_one": "{{count}} policy",
      "recommendationCount_other": "{{count}} policies",
      "neverEvaluated": "Not yet evaluated",
      "selectAgentAria": "Select {{name}}",
      "selectAllAria": "Select every agent on this page",
      "bulkActionsAria": "Actions for the selected agents",
      "selectedCount_one": "{{count}} agent selected",
      "selectedCount_other": "{{count}} agents selected",
      "clearSelection": "Clear",
      "moreActions": "More actions",
      "reviewRecommendations": "Review Recommended Policies",
      "applyPolicy": "Apply policy",
      "browsePolicies": "Browse Policies",
      "columns": {
        "agent": "Agent",
        "purpose": "Purpose",
        "platform": "Platform / Technology",
        "businessUnit": "Business Unit",
        "project": "Project",
        "environmentType": "Environment",
        "connectedResource": "Connected Resource",
        "securityStatus": "Security Status",
        "recommendedPolicies": "Recommended Policies",
        "appliedPolicy": "Applied Policy",
        "lastEvaluated": "Last Evaluated",
        "lastObserved": "Last Observed",
        "agentRegistry": "Agent Registry"
      },
      "reviewPolicies": "Review Policies",
      "filteredPolicyReviewAria_one": "Review policies for the matching agent",
      "filteredPolicyReviewAria_other": "Review policies for all {{count}} matching agents",
      "notAvailable": "N/A",
      "failed": "Agents couldn't be loaded. Try again in a moment."
    },
    "applyPolicy": {
      "action": "Apply Policy",
      "panelTitle": "Review Policies",
      "panelSubtitle": "Review recommended controls or choose another policy for the {{scope}}.",
      "scopeCount_one": "{{count}} agent selected",
      "scopeCount_other": "{{count}} agents selected",
      "scopeCountCategory_one": "{{count}} agent in this category",
      "scopeCountCategory_other": "{{count}} agents in this category",
      "scopeCountFilter_one": "{{count}} agent in this filtered list",
      "scopeCountFilter_other": "{{count}} agents in this filtered list",
      "scopeCountEstate_one": "{{count}} agent in the estate",
      "scopeCountEstate_other": "{{count}} agents in the estate",
      "groupScope": "{{group}} Agents",
      "selectedScope": "Selected Agents",
      "singleAgentScope": "Selected Agent",
      "groupDescriptor": "{{group}} agents",
      "selectedDescriptor": "selected agents",
      "viewSelected": "View agents",
      "hideSelected": "Hide agents",
      "selectedMore_one": "and {{count}} more",
      "selectedMore_other": "and {{count}} more",
      "tabs": {
        "recommended": "Recommended",
        "allPolicies": "All Policies",
        "custom": "Create New",
        "recommendedCount": "Recommended ({{count}})",
        "allPoliciesCount": "All Policies ({{count}})"
      },
      "coverage": {
        "heading": "Current Coverage",
        "lead": "Policies already applied to {{scope}}",
        "summaryPartial_one": "{{count}} of {{total}} {{scope}} has existing policy coverage.",
        "summaryPartial_other": "{{count}} of {{total}} {{scope}} have existing policy coverage.",
        "summaryFull_one": "The {{scope}} has policy coverage.",
        "summaryFull_other": "All {{count}} {{scope}} have policy coverage.",
        "none_one": "No policies are currently applied to the {{scope}}. Review the recommendations below to establish policy coverage.",
        "none_other": "No policies are currently applied to the {{count}} {{scope}}. Review the recommendations below to establish policy coverage.",
        "noneShort_one": "No policies are currently applied to the {{scope}}.",
        "noneShort_other": "No policies are currently applied to the {{count}} {{scope}}.",
        "error": "Current policy coverage could not be loaded.",
        "appliedTo": "Applied to {{count}} of {{total}} {{scope}}",
        "appliedToAll_one": "Applied to the {{scope}}",
        "appliedToAll_other": "Applied to all {{count}} {{scope}}",
        "appliesAcross": "Applies across",
        "acrossTargets": "{{servers}} · {{tools}} · {{sources}}"
      },
      "recommendations": {
        "heading": "Recommended Actions",
        "lead": "Policies recommended based on agent purpose, connected resources, available capabilities, and current access.",
        "error": "Policy recommendations could not be loaded. Browse available enterprise policies to apply one manually.",
        "noneAdditionalTitle": "No additional policy recommendations",
        "noneAdditional": "No additional policy changes are currently recommended for the {{scope}} based on their evaluated access requirements.",
        "noneAvailableTitle": "No policy recommendations are currently available.",
        "noneAvailable": "TrustLogix may need additional agent purpose, resource, or access context before it can recommend policies.",
        "viewAllPolicies": "View all policies"
      },
      "selectedPolicies_one": "{{count}} policy selected",
      "selectedPolicies_other": "{{count}} policies selected",
      "apply": "Apply Selected Policies",
      "applyRecommended_one": "Apply Recommended Policy",
      "applyRecommended_other": "Apply {{count}} Recommended Policies",
      "applying": "Applying…",
      "applied_one": "Policy applied to {{count}} agent",
      "applied_other": "Policy applied to {{count}} agents",
      "appliedDetail_one": "{{count}} policy control was applied successfully.",
      "appliedDetail_other": "{{count}} policy controls were applied successfully.",
      "failed": "Could not apply the selected policies.",
      "appliedEnforcementPending_one": "{{count}} policy applied. Enforcement setup is still required for some agents.",
      "appliedEnforcementPending_other": "{{count}} policies applied. Enforcement setup is still required for some agents.",
      "appliedDeploying_one": "The policy definition was applied. Its native policies are deploying.",
      "appliedDeploying_other": "{{count}} policy definitions were applied. Their native policies are deploying.",
      "createTitle": "Create Agent Policy",
      "createSubtitle": "Define access controls for the {{scope}}. You can add multiple rules across MCP services and tools.",
      "reviewRecommendedTitle_one": "Review Recommended Policy",
      "reviewRecommendedTitle_other": "Review Recommended Policies",
      "entryTool": "Started from {{tool}} on {{service}}. Catalog policies apply to the agent, across every tool it reaches.",
      "method": {
        "label": "Authoring method",
        "intent": "Generate from Intent",
        "conditions": "Build with Conditions"
      },
      "buildLaunch": {
        "title": "Build a policy with conditions",
        "body": "Define rules for this agent's MCP services and tools - each with its own access decision and conditions - in the policy wizard.",
        "start": "Start building"
      }
    },
    "details": {
      "missingValue": "-",
      "identity": "Identity",
      "identityName": "Identity name",
      "identityProvider": "Identity provider",
      "owner": "Owner",
      "purpose": "Purpose",
      "model": "Model",
      "resources": "Resources and MCP relationships",
      "noResources": "No connected resources were discovered for this agent.",
      "activity": "Recent activity",
      "noActivity": "No activity has been recorded for this agent yet.",
      "backToEstate": "Back to AI Agents",
      "notFoundTitle": "Agent not found",
      "notFoundDescription": "This agent is not part of the connected environment. It may have been removed, or the environment disconnected.",
      "tabs": {
        "overview": "Overview",
        "accessProtection": "Access & Protection",
        "activity": "Activity",
        "accessFlow": "Access Flow"
      },
      "region": "Region",
      "connectedResources": "Connected resources",
      "resourceCount": "{{services}} services · {{tools}} tools",
      "columns": {
        "service": "Service",
        "tool": "Tool",
        "classification": "Classification",
        "dataAccess": "Data access",
        "capabilities": "Capabilities",
        "time": "Time",
        "action": "Action",
        "decision": "Decision",
        "policy": "Policy"
      },
      "resourcesTab": {
        "title": "Connected Resources",
        "description": "MCP services, tools, and data sources accessible to this agent.",
        "searchPlaceholder": "Search services, tools or data sources...",
        "searchLabel": "Search services, tools or data sources",
        "treeLabel": "Connected services and tools",
        "expandService": "Expand {{service}}",
        "collapseService": "Collapse {{service}}",
        "openTool": "View access details for {{tool}}",
        "noTools": "No directly callable tools are exposed by this context service.",
        "riskLabel": "{{risk}} risk",
        "summary": {
          "aria": "Connected resource summary",
          "mcpServices": "MCP services",
          "tools": "Tools",
          "dataSourcesCount_one": "Data source",
          "dataSourcesCount_other": "Data sources",
          "dataSourcesUnavailable": "Data sources not available",
          "needPolicy_one": "Tool needs policy",
          "needPolicy_other": "Tools need policy",
          "highRisk_one": "High risk tool",
          "highRisk_other": "High risk tools"
        },
        "filters": {
          "all": "All",
          "capability": "Capability",
          "risk": "Risk",
          "coverage": "Coverage",
          "reset": "Reset"
        },
        "risk": {
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "classification": {
          "read": "Read",
          "write": "Write",
          "destructive": "Destructive",
          "privileged": "Privileged"
        },
        "status": {
          "protected": "Protected",
          "review": "Review",
          "needsPolicy": "Needs policy",
          "restricted": "Restricted",
          "denied": "Denied"
        },
        "empty": {
          "title": "No MCP services connected",
          "description": "Some agent registries do not provide MCP connection information. Connect registered MCP services to complete this agent's resource inventory."
        },
        "addMcpServices": "Add MCP Services",
        "registerMcpService": "Register New MCP Service",
        "addedManually": "Added manually",
        "serviceMenu": {
          "viewDetails": "View MCP Details",
          "viewInRegistry": "View in MCP Registry",
          "viewPolicies": "View Applied Policies",
          "createPolicyRule": "Create Policy Rule",
          "managePolicyRules": "Manage Policy Rules",
          "remove": "Remove from Agent",
          "removeDiscovered": "Reported by the agent registry. Remove it there - it would be added back on the next sync."
        },
        "filteredEmpty": {
          "title": "No access matches these filters",
          "description": "Adjust the current access filters to see connected services and tools."
        },
        "panel": {
          "subtitle": "Tool access detail",
          "accessTitle": "Access",
          "protectionTitle": "Protection assessment",
          "service": "Service",
          "capability": "Capability",
          "risk": "Risk",
          "dataAccess": "Data access",
          "agentAccess": "Agent access",
          "agentPurpose": "Agent purpose",
          "operation": "Operation",
          "enforcement": "Enforcement",
          "currentControls": "Current enterprise controls",
          "noPolicy": "No enforcing policy",
          "policyDescription": "This {{classification}} operation is evaluated against the agent's confirmed {{purpose}} purpose.",
          "policyDescriptionUnclassified": "This operation is evaluated against the agent's confirmed {{purpose}} purpose.",
          "controlsDescription": "Current enterprise controls protect this capability for the agent's {{purpose}} purpose.",
          "noPolicyDescription": "This capability is accessible, but no enforcing policy currently covers it.",
          "suspendedDescription": "The Kill Switch currently denies this agent access to every connected capability.",
          "access": {
            "allowed": "Allowed",
            "restricted": "Restricted",
            "denied": "Denied"
          },
          "viewPolicy": "View Policy"
        },
        "columns": {
          "tool": "Tool",
          "description": "Description",
          "dataSource": "Data source",
          "capability": "Capability",
          "risk": "Risk",
          "coverage": "Policy coverage",
          "actions": "Actions"
        },
        "serviceTools_one": "{{count}} tool",
        "serviceTools_other": "{{count}} tools",
        "serviceSources_one": "{{count}} data source",
        "serviceSources_other": "{{count}} data sources",
        "highRisk": "High risk",
        "needPolicy_one": "{{count}} needs policy",
        "needPolicy_other": "{{count}} need policy",
        "serviceActions": "Actions for {{service}}",
        "scope": "Showing: {{name}}",
        "clearScope": "Show all resources, not just {{name}}"
      },
      "reviewRecommendations": "Review Recommended Policy",
      "evidence": {
        "title": "Why TrustLogix classified this agent this way",
        "lead": "The signals behind this agent's {{purpose}} classification.",
        "showSystemPrompt": "Show system prompt excerpt",
        "hideSystemPrompt": "Hide system prompt excerpt",
        "registeredTools": "Registered tools",
        "dataSource": "Data source",
        "applicationTags": "Application tags"
      },
      "identityContext": "Identity & Context",
      "accessSuspendedNotice": "Resource access is suspended for this agent. Restore it from the posture actions above.",
      "posture": {
        "eyebrow": "Policy coverage",
        "secure": {
          "title": "Policy coverage is active",
          "description": "This agent is covered by {{policies}}.",
          "descriptionNoPolicies": "Every access policy control TrustLogix evaluates is in place for this agent."
        },
        "notSecure": {
          "title": "This agent needs policy coverage",
          "titlePartial": "Additional policy coverage is recommended",
          "description_one": "TrustLogix found {{count}} recommended policy for this agent's {{purpose}} purpose and its {{resource}} access.",
          "description_other": "TrustLogix found {{count}} recommended policies for this agent's {{purpose}} purpose and its {{resource}} access.",
          "descriptionNoRecommendations": "One or more required policy controls are missing, and no recommendation matches this agent. Browse enterprise policies to add coverage."
        },
        "notEvaluated": {
          "title": "Policy coverage has not been evaluated",
          "description": "Discovery found this agent, but it has not been evaluated against access policies yet. It was last observed {{lastObserved}}."
        },
        "metrics": {
          "appliedPolicies": "Applied policies",
          "recommended": "Recommended",
          "missingControls": "Missing controls",
          "connectedTools": "Connected tools",
          "lastObserved": "Last observed"
        }
      },
      "attention": {
        "eyebrow": "Priority findings",
        "title": "Attention Needed",
        "count_one": "{{count}} finding",
        "count_other": "{{count}} findings",
        "emptyTitle": "No immediate findings",
        "emptyDescription": "The current identity, access and policy coverage context does not require review.",
        "severityHigh": "High",
        "severityMedium": "Medium",
        "reviewGap": "Review gap",
        "additional_one": "+{{count}} additional finding",
        "additional_other": "+{{count}} additional findings",
        "reviewAll": "Review All Recommendations"
      },
      "recentActivity": {
        "eyebrow": "Authorization evidence",
        "title": "Recent Activity",
        "viewActivity": "View Activity",
        "emptyTitle": "No recent activity",
        "emptyDescription": "No authorization decisions have been observed for this agent."
      },
      "policyCoverage": {
        "appliedOn": "Applied {{date}}",
        "policyActive": "Active",
        "recommendedAction": {
          "title": "Recommended Action",
          "thisWill": "This will",
          "keep": "Keep access to {{label}}",
          "restrict": "Add restriction for {{label}}",
          "appliesAcross": "Applies across",
          "appliesAcrossHelp": "Resources where this policy will be enforced.",
          "appliesAcrossHelpLabel": "About where this policy applies",
          "viewDetails": "View details",
          "reviewAndApply": "Review and apply",
          "fromAccessPath": "Showing the recommendation for the access path you opened.",
          "showAll": "Show all recommendations",
          "alreadyApplied": "Already applied"
        },
        "appliedPolicy": {
          "title_one": "Applied Policy",
          "title_other": "Applied Policies",
          "governs": "Governs this agent's access across",
          "viewEnforcement": "View enforcement"
        },
        "authored": {
          "draft": "Draft",
          "applied": "Applied"
        }
      },
      "mission": {
        "title": "Mission",
        "eyebrow": "Governed intent",
        "notDefined": "Mission not defined",
        "unclear": "Mission unclear",
        "noDescription": "No mission description is currently available.",
        "purposeCategory": "Purpose category",
        "purposeCategoryNotSet": "Not set",
        "purposeCategoryNotDetermined": "Not determined",
        "sourceLabel": "Source",
        "confidenceLabel": "Mission confidence",
        "confidenceValue": "{{level}} · {{score}}%",
        "notConfirmed": "Not confirmed",
        "notReviewed": "Not reviewed",
        "confirmedBy": "Confirmed by",
        "confirmedOn": "Confirmed",
        "lastReviewed": "Last reviewed",
        "unknownActor": "An administrator",
        "inferenceUnavailableTitle": "Mission intelligence temporarily unavailable",
        "inferenceUnavailableBody": "The existing mission remains available and this page is not blocked.",
        "changeSummary": "Capabilities changed since this mission was confirmed.",
        "changeSignals_one": "{{count}} new context signal",
        "changeSignals_other": "{{count}} new context signals",
        "updateFailed": "The mission could not be updated. Try again.",
        "status": {
          "administratorDefined": "Administrator Defined",
          "inferredNeedsReview": "Inferred · Needs Review",
          "confirmed": "Confirmed",
          "overridden": "Overridden",
          "needsMoreContext": "Needs More Context",
          "reviewRecommended": "Review Recommended"
        },
        "statusTooltip": {
          "administratorDefined": "An administrator defined this mission directly.",
          "inferredNeedsReview": "TrustLogix inferred this mission from discovered signals. An administrator has not confirmed it yet.",
          "confirmed": "An administrator reviewed the inferred mission and confirmed it.",
          "overridden": "An administrator replaced the inferred mission with their own.",
          "needsMoreContext": "TrustLogix does not have enough evidence to state a mission confidently.",
          "reviewRecommended": "Capabilities changed after this mission was confirmed. Review the change."
        },
        "source": {
          "administrator": "Administrator defined",
          "administratorOverride": "Administrator override",
          "imported": "Imported purpose metadata",
          "inferred": "TrustLogix inferred",
          "inferredConfirmed": "TrustLogix inferred · Administrator confirmed"
        },
        "confidence": {
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "evidenceType": {
          "identity": "Identity metadata",
          "runtime": "Runtime metadata",
          "mcp": "MCP metadata",
          "tool": "Tool metadata",
          "data": "Data metadata",
          "semantic": "Semantic metadata"
        },
        "actions": {
          "review": "Review Mission",
          "define": "Define Mission",
          "reviewEvidence": "Review Evidence",
          "reviewChanges": "Review Changes",
          "keepCurrent": "Keep Current Mission",
          "viewDetails": "View Mission Details",
          "editMission": "Edit Mission",
          "confirm": "Confirm Mission",
          "notEnoughInformation": "Not Enough Information",
          "reassessLater": "Reassess Later",
          "update": "Update Mission",
          "reviewRecommendations": "Review Policy Recommendations"
        },
        "review": {
          "title": "Review Agent Mission",
          "eyebrow": "Explainable mission intelligence",
          "agent": "Agent",
          "assessment": "TrustLogix assessment",
          "missionLabel": "Mission",
          "statusLabel": "Status",
          "possibleMissions": "Possible missions",
          "whyTitle": "Why TrustLogix thinks this",
          "synthesisTitle": "Evidence synthesis",
          "sourcesTitle": "Evidence sources and provenance",
          "decision": "Does this mission accurately describe the agent?",
          "decisionUnclear": "TrustLogix needs more context before making a reliable recommendation.",
          "noEvidence": "No automated evidence was used for this administrator-defined mission.",
          "signalCount_one": "{{count}} relevant signal",
          "signalCount_other": "{{count}} relevant signals",
          "freshnessUnavailable": "Freshness unavailable",
          "sourceUnavailable": "Source unavailable",
          "staleEvidence": "Stale evidence",
          "unavailable": "Unavailable",
          "columnMission": "Possible mission",
          "columnConfidence": "Confidence"
        },
        "edit": {
          "title": "Edit Agent Mission",
          "eyebrow": "Administrator decision",
          "purposeCategory": "Purpose category",
          "purposeCategoryHint": "Drives which enterprise policies TrustLogix recommends for this agent.",
          "name": "Mission name",
          "namePlaceholder": "Describe the agent's primary mission",
          "description": "Mission description",
          "descriptionPlaceholder": "Explain what this agent is intended to do",
          "reason": "Reason for the change",
          "reasonHint": "Recorded in mission history so a later reviewer can see why the assessment was overridden.",
          "nameRequired": "Enter a mission name.",
          "descriptionRequired": "Enter a mission description.",
          "preservedTitle": "Inferred mission will be preserved",
          "preservedBody": "The prior TrustLogix assessment stays available in mission history after this override."
        },
        "changes": {
          "title": "Review Mission Changes",
          "eyebrow": "Context drift review",
          "confirmedMission": "Confirmed mission",
          "whatChanged": "What changed",
          "assessment": "TrustLogix assessment",
          "suggested": "Suggested mission"
        },
        "details": {
          "title": "Mission Details",
          "eyebrow": "Governed mission record",
          "evidenceSources": "Evidence sources",
          "history": "Mission history"
        },
        "toast": {
          "confirmed": "Mission confirmed",
          "overridden": "Mission saved and confirmed",
          "deferred": "TrustLogix will reassess when more agent context becomes available",
          "kept": "Mission reviewed and kept unchanged",
          "updated": "Mission updated and confirmed"
        }
      },
      "accessFlow": {
        "direct": "Direct access",
        "openNode": "{{name}}. {{kind}}. {{status}} Open details.",
        "emptyTitle": "No access paths found",
        "emptyDescription": "This agent does not currently have discovered access relationships.",
        "unavailable": "Access relationship data is currently unavailable. Reopen this agent to try again.",
        "loadError": "Unable to load agent details. Try again.",
        "retry": "Retry",
        "allActivity": "Show all activity"
      },
      "accessExplorer": {
        "title": "Access Explorer",
        "titleWithAgent": "Access Explorer - {{name}}",
        "loading": "Loading access flow",
        "description": "Explore how this agent reaches enterprise resources and where policy controls apply.",
        "minimap": "Access graph overview",
        "summary": {
          "label": "Access summary",
          "accessPaths_one": "{{count}} access path",
          "accessPaths_other": "{{count}} access paths",
          "needsAttention_one": "{{count}} path needs attention",
          "needsAttention_other": "{{count}} paths need attention",
          "notEvaluated_one": "{{count}} path not evaluated",
          "notEvaluated_other": "{{count}} paths not evaluated",
          "policyGaps_one": "{{count}} policy gap",
          "policyGaps_other": "{{count}} policy gaps",
          "violations_one": "{{count}} violation",
          "violations_other": "{{count}} violations",
          "showIssues": "Show paths needing attention"
        },
        "toolbar": {
          "label": "Access Explorer controls",
          "filters": "Filter",
          "filtersActive_one": "Filter, {{count}} active",
          "filtersActive_other": "Filter, {{count}} active",
          "issuesOnly": "Issues only",
          "issuesOnlyHint": "Show only paths with policy gaps or violations",
          "fit": "Fit to view",
          "zoomIn": "Zoom in",
          "zoomOut": "Zoom out",
          "openFullscreen": "Open full screen",
          "exitFullscreen": "Exit full screen"
        },
        "search": {
          "placeholder": "Search this access flow...",
          "label": "Search this agent's access flow: identity, MCP servers, tools and data",
          "results": "Search results",
          "noResults": "No results for \"{{query}}\". Try a different tool, MCP, data resource, or agent name.",
          "more_one": "{{count}} more match - refine your search",
          "more_other": "{{count}} more matches - refine your search",
          "groups": {
            "identity": "Identities",
            "agent": "Agents",
            "mcp": "MCP servers",
            "tool": "Tools",
            "dataPlatform": "Data platforms",
            "dataResource": "Data resources",
            "enforcement": "TrustLogix enforcement"
          }
        },
        "filters": {
          "title": "Filter access paths",
          "status": "Governance status",
          "resourceType": "Resource type",
          "mcp": "MCP server",
          "dataPlatform": "Data platform",
          "clear": "Clear filters",
          "done": "Done",
          "statuses": {
            "POLICY_GAP": "Policy gaps",
            "VIOLATION": "Violations",
            "POLICY_ASSIGNED": "Policy assigned",
            "NOT_EVALUATED": "Not yet evaluated"
          },
          "layers": {
            "mcp": "MCP Servers",
            "tools": "Tools",
            "dataPlatform": "Data Platforms",
            "dataResource": "Data Resources"
          },
          "chips": {
            "label": "Active filters",
            "layerShown": "{{layer}} shown",
            "layerHidden": "{{layer}} hidden",
            "remove": "Remove filter: {{filter}}"
          }
        },
        "kinds": {
          "identity": "Identity",
          "SERVICE_ACCOUNT": "Service account",
          "MANAGED_IDENTITY": "Managed identity",
          "agent": "AI Agent",
          "mcp": "MCP Server",
          "toolGroup": "Tools",
          "tool": "Tool",
          "dataPlatform": "Data Platform",
          "dataResource": "Data Resource",
          "enforcement": "TrustLogix Enforcement"
        },
        "node": {
          "open": "{{name}}. {{kind}}. {{status}} Open details.",
          "tools_one": "{{formatted}} tool",
          "tools_other": "{{formatted}} tools",
          "exploreTools": "Explore tools",
          "resources_one": "{{count}} resource",
          "resources_other": "{{count}} resources",
          "issueCount": {
            "POLICY_GAP_one": "{{count}} policy gap",
            "POLICY_GAP_other": "{{count}} policy gaps",
            "VIOLATION_one": "{{count}} violation",
            "VIOLATION_other": "{{count}} violations"
          },
          "counts": {
            "POLICY_ASSIGNED_one": "{{formatted}} assigned",
            "POLICY_ASSIGNED_other": "{{formatted}} assigned",
            "POLICY_GAP_one": "{{formatted}} gap",
            "POLICY_GAP_other": "{{formatted}} gaps",
            "VIOLATION_one": "{{formatted}} violation",
            "VIOLATION_other": "{{formatted}} violations",
            "NOT_EVALUATED_one": "{{formatted}} not evaluated",
            "NOT_EVALUATED_other": "{{formatted}} not evaluated"
          }
        },
        "focus": {
          "title": "Focused path:",
          "clear": "Clear focus"
        },
        "empty": {
          "noPaths": "No access paths found. This agent does not currently have discovered access relationships.",
          "noIssues": "No policy gaps or violations found in the current access paths.",
          "noMatches": "No access paths match the current filters.",
          "showAll": "Show all paths",
          "clearFilters": "Clear filters",
          "noScope": "This policy doesn't act on any path in this agent's observed access flow."
        },
        "panel": {
          "close": "Close panel",
          "inspector": "Access details"
        },
        "inspector": {
          "accessSummary": "Access summary",
          "connectedResources": "Connected resources",
          "reachedBy": "Reached through",
          "resources": "Data resources",
          "enforcement": "Controls in force",
          "evidence": "Policy gaps",
          "relationship": "Access relationship",
          "expectedControl": "Expected control",
          "to": "to",
          "tools": "Tools",
          "paths": "Access paths",
          "mcps": "MCP servers",
          "classification": "Classification",
          "risk": "Risk",
          "resource": "Target resource",
          "policy": "Policy",
          "platform": "Data platform",
          "platformType": "Platform",
          "server": "MCP server",
          "identityType": "Identity type",
          "businessUnit": "Business unit",
          "toolsWithGaps_one": "{{formatted}} tool can be invoked without an assigned policy.",
          "toolsWithGaps_other": "{{formatted}} tools can be invoked without an assigned policy.",
          "toolsWithViolations_one": "{{formatted}} tool has a recorded governance violation.",
          "toolsWithViolations_other": "{{formatted}} tools have recorded governance violations.",
          "actions": {
            "reviewGaps": "Review policy gaps",
            "reviewGap": "Review gap",
            "exploreTools": "Explore tools",
            "focus": "Focus on this path",
            "viewResources": "View in Resources",
            "viewIdentity": "View identity context",
            "backToTools": "Back to tool list",
            "viewRelationship": "View access relationship",
            "viewTarget": "View {{name}}"
          },
          "guardian": {
            "mcp": "Ask Guardian about this MCP",
            "tool": "Ask Guardian about this tool",
            "access": "Ask Guardian about this access",
            "relationship": "Ask Guardian about this relationship"
          }
        },
        "toolExplorer": {
          "title": "Tool Explorer",
          "total_one": "{{formatted}} tool",
          "total_other": "{{formatted}} tools",
          "search": "Search tools in {{name}}",
          "statusFilter": "Filter tools by status",
          "all": "All",
          "sortBy": "Sort by",
          "sort": {
            "name": "Name",
            "status": "Status",
            "risk": "Risk"
          },
          "showing": "Showing {{shown}} of {{total}}",
          "view": "View",
          "viewTool": "View {{name}} in the graph",
          "empty": "No tools match your search or filter.",
          "listLabel": "Tools on {{name}}"
        },
        "guardianContext": "{{subject}} · {{agent}}",
        "edge": {
          "directConnection": "Direct connection"
        }
      }
    },
    "accessProtection": {
      "title": "Access & Protection",
      "description": "What this agent can access, the protection that applies to it, and whether that protection is enforced.",
      "retry": "Retry",
      "emptyValue": "-",
      "metaSeparator": " · ",
      "errors": {
        "generic": "Something went wrong. Try again."
      },
      "loadError": {
        "title": "Access & Protection could not be loaded",
        "description": "The agent's resources and policies could not be read. Nothing is shown as protected until they load."
      },
      "views": {
        "label": "Resources",
        "mcp": "MCP Services & Tools ({{count}})",
        "data": "Data Sources ({{count}})"
      },
      "dimensions": {
        "policyGaps": "Policy gaps",
        "policyGapsTip": "Expected restrictions from the agent's definition that the current policies do not satisfy, as of the last assessment. A policy can exist and a gap can still remain.",
        "policyGapsAbout": "About policy gaps",
        "viewProtectionGaps_one": "{{count}} policy gap. View protection details",
        "viewProtectionGaps_other": "{{count}} policy gaps. View protection details",
        "viewProtectionState": "Policy gaps: {{state}}. View protection details",
        "notEvaluated": "Not evaluated",
        "unknown": "Unknown",
        "loading": "Loading",
        "setup": "Enforcement setup",
        "setupAria": "View enforcement setup for {{name}}",
        "verification": "Enforcement verification",
        "verificationTip": "Whether agent traffic has been verified to pass through the TrustLogix gateway. Configured does not mean verified, and not verified is not a confirmed gap.",
        "verificationAbout": "About enforcement verification",
        "verificationState": {
          "PENDING": "Pending",
          "NOT_VERIFIED": "Not verified",
          "VERIFIED": "Verified",
          "CONFIRMED_BYPASS": "Confirmed bypass",
          "NONE": "Not applicable"
        }
      },
      "mcp": {
        "scope": "Showing: {{name}}",
        "clearScope": "Show all services, not just {{name}}",
        "treeLabel": "MCP services and tools",
        "empty": {
          "title": "No MCP services are associated with this agent",
          "description": "Associate registered MCP services the agent uses, including ones the import did not detect."
        },
        "filteredEmpty": {
          "title": "No tools match",
          "description": "Change the search or filters to see more tools."
        },
        "expand": "Show tools for {{service}}",
        "collapse": "Hide tools for {{service}}",
        "tools_one": "{{count}} tool",
        "tools_other": "{{count}} tools",
        "highRisk_one": "{{count}} high-risk tool",
        "highRisk_other": "{{count}} high-risk tools",
        "sources_one": "{{count}} data source",
        "sources_other": "{{count}} data sources",
        "sourcesUnknown": "Data sources not reported",
        "noTools": "This service has no registered tools.",
        "showAll": "Show all {{count}} tools",
        "showFewer": "Show fewer",
        "recommended": "Suggested",
        "recommendedHint": "A suggested improvement restricts {{tool}}. Review it.",
        "columns": {
          "tool": "Tool",
          "description": "Description",
          "dataSource": "Data source",
          "capability": "Capability",
          "risk": "Risk",
          "protection": "Applicable protection",
          "actions": "Actions",
          "name": "Name",
          "type": "Type",
          "tools": "Tools",
          "associated": "Associated",
          "associatedHint": "Whether this MCP service is linked to this agent. Manual: an administrator added it here, so it can be removed here. Discovered: the platform import detected it, so it stays while the platform reports it."
        },
        "serviceMenu": {
          "label": "Actions for {{service}}",
          "viewInRegistry": "View in MCP Registry",
          "viewPolicies": "View Applied Policies",
          "createPolicyRule": "Create Policy Rule",
          "managePolicyRules": "Manage Policy Rules",
          "remove": "Remove from Agent"
        },
        "openTool": "View details for {{tool}}",
        "typeLabel": "MCP Service"
      },
      "aboutColumn": "About {{name}}",
      "ruleScope": {
        "AGENT": "Agent",
        "SERVER": "MCP server",
        "TOOL": "Tool"
      },
      "data": {
        "treeLabel": "Data sources and their native policies",
        "empty": {
          "title": "No data sources are associated with this agent",
          "description": "Associate registered data sources this agent reaches. Associating a source never grants access or creates policies."
        },
        "expand": "Show policies on {{name}}",
        "collapse": "Hide policies on {{name}}",
        "linkedThrough": "Linked through {{names}}",
        "pathUnknown": "Access path not specified",
        "policies_one": "{{count}} policy",
        "policies_other": "{{count}} policies",
        "deployed_one": "{{count}} deployed",
        "deployed_other": "{{count}} deployed",
        "drafts_one": "{{count}} draft",
        "drafts_other": "{{count}} drafts",
        "failed_one": "{{count}} failed",
        "failed_other": "{{count}} failed",
        "createPolicy": "Create Data Policy",
        "unsupported": "TrustLogix cannot author native policies on {{platform}}. Protect this source through the MCP tool rules on the services that reach it, and configure any native restrictions directly in {{platform}}.",
        "unsupportedHint": "Native policy authoring is not supported on {{platform}}.",
        "noPolicies": "No native policies on {{name}} yet.",
        "openPolicy": "View details for {{name}}",
        "policyActions": "Actions for {{name}}",
        "deployedReadOnly": "Deployed policies are changed in policy management, never from an agent.",
        "columns": {
          "name": "Policy name",
          "type": "Policy type",
          "targets": "Target objects",
          "principal": "Native principal / role",
          "status": "Deployment state",
          "updated": "Updated",
          "actions": "Actions",
          "source": "Data source",
          "policies": "Policies",
          "deployment": "Deployment"
        },
        "menu": {
          "label": "Actions for {{name}}",
          "details": "View Source Details",
          "editAssociation": "Edit Association",
          "remove": "Remove from Agent",
          "completeAccess": "Complete Access Context"
        },
        "editPolicy": "Edit Policy",
        "viewDeployment": "View Deployment",
        "manageCentrally": "Manage in Data Source Policy Management",
        "createHint": {
          "ROW_ACCESS": "Limit which rows a native role can read",
          "DATA_MASKING": "Mask sensitive columns for a native role",
          "OBJECT_ACCESS": "Grant or restrict access to objects"
        },
        "viewPolicy": "View Policy",
        "filteredEmpty": {
          "title": "No matching data sources",
          "description": "No data source matches the search or filters. Reset them to see every data source."
        }
      },
      "policyTypes": {
        "ROW_ACCESS": "Row Access",
        "DATA_MASKING": "Data Masking",
        "OBJECT_ACCESS": "Object Access"
      },
      "policyStatus": {
        "DRAFT": "Draft",
        "APPLYING": "Applying",
        "DEPLOYED": "Deployed",
        "FAILED": "Failed"
      },
      "mapping": {
        "source": {
          "ADMINISTRATOR": "Administrator-provided"
        },
        "verification": {
          "NOT_VERIFIED": "Not verified",
          "VERIFIED": "Verified",
          "FAILED": "Verification failed"
        }
      },
      "association": {
        "origin": {
          "DISCOVERED": "Discovered",
          "MANUAL": "Manually added"
        },
        "originHint": {
          "DISCOVERED": "Reported by the agent registry.",
          "MANUAL": "Associated by an administrator."
        },
        "verification": {
          "NOT_VERIFIED": "Not verified",
          "VERIFIED": "Verified",
          "FAILED": "Verification failed"
        },
        "verificationHint": "Evidence that the agent really reaches this resource. Separate from how the association was recorded.",
        "sourceMeta": "{{platform}} · {{environment}}",
        "editTitle": "Edit Association",
        "editSubtitle": "How {{agent}} reaches this data source",
        "detailsSubtitle": "Data source associated with this agent",
        "accessPath": "Access path",
        "accessPathLead": "Describe how this agent accesses the data source. This is administrator-provided and does not verify live connectivity.",
        "paths": {
          "NOT_SPECIFIED": {
            "label": "Not specified",
            "hint": "The access path is unknown or not yet documented."
          },
          "THROUGH_MCP": {
            "label": "Through MCP services",
            "hint": "The agent reaches the source through one or more MCP services already associated with it."
          },
          "DIRECT": {
            "label": "Direct access",
            "hint": "The agent reaches the source directly, not through an MCP service."
          }
        },
        "linkedMcp": "MCP services",
        "linkedMcpHint": "Only MCP services already associated with this agent. Selecting one does not add it to the agent.",
        "mcpRequired": "Select at least one MCP service.",
        "note": "Notes",
        "notePlaceholder": "Add notes about this association (e.g., purpose, known access path, owner)…",
        "noteCount": "{{count}} / {{limit}}",
        "noteTooLong": "Notes can be at most {{count}} characters.",
        "notVerification": "Administrator-provided association information is not verification of real connectivity. Saving changes no policy and does not verify the association.",
        "save": "Save Association",
        "saved": "Association updated for {{name}}.",
        "platform": "Platform",
        "nativeSupport": "Native policy authoring",
        "nativeSupported": "Supported",
        "nativeUnsupported": "Not supported - MCP tool rules only",
        "reachedThrough": "Reached through",
        "noKnownPath": "No known MCP path",
        "policies": "Native policies",
        "policyCounts": "{{total}} total · {{deployed}} deployed · {{draft}} draft · {{failed}} failed",
        "addedAt": "Added"
      },
      "addResources": {
        "button": "Add Resources",
        "mcp": "Add MCP Services",
        "mcpHint": "Associate existing MCP services",
        "data": "Add Data Sources",
        "dataHint": "Associate existing data sources",
        "titleMcp": "Add MCP Services",
        "titleData": "Add Data Sources",
        "subtitleMcp": "Select registered MCP services to associate with this agent.",
        "subtitleData": "Select registered data sources to associate with this agent.",
        "agent": "Agent: {{agent}}",
        "leadMcp": "Select registered MCP services this agent can use, including services that were not detected during import.",
        "leadData": "Select registered data sources this agent can access, including sources that were not detected during import.",
        "safetyMcp": "Adding an MCP service records its association with this agent. It does not create or modify policies, and does not automatically grant access to all tools.",
        "safetyData": "Adding a data source records its association with this agent. It does not grant access, verify connectivity, or create policies.",
        "searchMcp": "Search MCP services…",
        "searchData": "Search data sources…",
        "platform": "Platform",
        "allPlatforms": "All",
        "clear": "Clear",
        "selectAria": "Select {{name}}",
        "alreadyAddedAria": "{{name}} is already added",
        "notMapped": "Not mapped",
        "notReported": "Not reported",
        "alreadyAdded": "Already added",
        "added": "Added",
        "notAdded": "Not added",
        "failed": "Failed",
        "nativeSupported": "Supported",
        "nativeUnsupported": "MCP only",
        "noMatch": "No resources match the search or filter.",
        "noneMcp": "No MCP services are registered in TrustLogix. Register one in the MCP Registry first.",
        "noneData": "No data sources are registered in TrustLogix. Connect one in Data Sources first.",
        "loadError": "Registered resources could not be loaded.",
        "registerTitle": "Can't find your MCP service?",
        "registerNew": "Register New MCP Service",
        "selected_one": "{{count}} selected",
        "selected_other": "{{count}} selected",
        "submitMcp_one": "Add {{count}} MCP Service",
        "submitMcp_other": "Add {{count}} MCP Services",
        "submitData_one": "Add {{count}} Data Source",
        "submitData_other": "Add {{count}} Data Sources",
        "adding": "Adding…",
        "retryFailed_one": "Retry {{count}} Failed",
        "retryFailed_other": "Retry {{count}} Failed",
        "doneMcp_one": "{{count}} MCP service associated - manually added, not verified.",
        "doneMcp_other": "{{count}} MCP services associated - manually added, not verified.",
        "doneData_one": "{{count}} data source associated - manually added, not verified.",
        "doneData_other": "{{count}} data sources associated - manually added, not verified.",
        "partial": "{{added}} of {{total}} associated. Retry the failed ones.",
        "columns": {
          "mcp": "MCP service",
          "source": "Data source",
          "description": "Description",
          "platform": "Platform",
          "tools": "Registered tools",
          "nativePolicies": "Native policies",
          "knownSources": "Registered data sources",
          "knownMcp": "Known MCP mapping",
          "association": "Agent association"
        }
      },
      "remove": {
        "title": "Remove {{name}} from this agent?",
        "description": "This removes only the association between {{name}} and {{agent}}.",
        "staysRegistered": "{{name}} stays registered in TrustLogix.",
        "policiesKept_one": "Its {{count}} native policy is kept and unchanged.",
        "policiesKept_other": "Its {{count}} native policies are kept and unchanged.",
        "rulesKept_one": "The {{count}} rule naming it in the agent's MCP policy is kept.",
        "rulesKept_other": "The {{count}} rules naming it in the agent's MCP policy are kept.",
        "accessNotRevoked": "Runtime access is not necessarily revoked - removing the association changes no grant.",
        "confirm": "Remove from Agent",
        "done": "{{name}} removed from {{agent}}.",
        "discoveredHint": "Discovered by the agent registry. Removing it here would be undone by the next sync."
      },
      "policyDetails": {
        "subtitle": "Native policy on {{source}}",
        "type": "Policy type",
        "status": "Deployment state",
        "source": "Data source",
        "targets": "Target objects",
        "columns": "Masked columns",
        "privileges": "Privileges",
        "principal": "Native principal",
        "noPrincipal": "Not mapped",
        "mapping": "Mapping",
        "mappingValue": "{{source}} · {{verification}}",
        "updated": "Updated",
        "conditions": "Conditions",
        "conditionPrefix": "Rows are returned when",
        "sharedNote": "A native policy applies to everyone holding its role on the platform - it is not exclusive to the agent it was written from.",
        "continue": "Continue Editing",
        "fix": "Fix Role Mapping"
      },
      "gap": {
        "agent": "Agent",
        "source": "Data source",
        "path": "Access path",
        "expected": "Expected protection",
        "severities": {
          "HIGH": "High",
          "MEDIUM": "Medium",
          "LOW": "Low"
        },
        "open": "Gap open",
        "resolved": "Satisfied",
        "assessed": "Last assessed",
        "stale": "stale",
        "mcpRulesLead": "These let the agent call {{tool}}. None of them limits which rows the source returns.",
        "noMcpRules": "No MCP rule applies on this path.",
        "inspected_one": "{{count}} native policy inspected",
        "inspected_other": "{{count}} native policies inspected",
        "missing": "Once deployed and reassessed, the agent only sees {{object}} rows where {{attribute}} is {{value}}.",
        "viewPolicies": "View Existing Policies",
        "why": "Why this is a gap",
        "whyDetail": "The agent is authorized to access {{scope}} customer records, but the current applicable {{type}} restrictions do not enforce that requirement.",
        "issue": "Issue",
        "current": "Current protection",
        "proposed": "Proposed change",
        "impact": "Impact",
        "impactPrincipal": "The draft is written for the native role {{role}} on {{object}}. Everything that uses this role is affected, including other users or workloads that share it - review before deploying.",
        "impactUnknown": "The identity this restriction would apply to is not known yet. Review the native role mapping in the policy before deploying; its impact on other users or workloads cannot be determined here.",
        "impactShared": "A new agent-specific policy is created. Existing shared policies are not modified.",
        "reviewDraft": "Review Draft",
        "createType": "Create {{type}} Policy",
        "reassess": "Reassess",
        "severityTag": "{{severity}} severity",
        "proposedTitle": "Add a {{type}} policy",
        "proposedObject": "Object",
        "proposedCondition": "Rows where",
        "mcpRulesTitle": "MCP rules on this path"
      },
      "enforcement": {
        "lead": "Setup and verification are separate: a configured gateway is not verified until traffic is observed passing through it, and an unverified path is not a confirmed gap.",
        "none": "This agent has no MCP paths.",
        "route": "{{agent}} → TrustLogix gateway → MCP service",
        "setup": "Setup",
        "verification": "Verification",
        "checked": "Last checked",
        "neverChecked": "Never",
        "setupState": {
          "CONFIGURED": "Configured",
          "NOT_CONFIGURED": "Not configured",
          "UNKNOWN": "Unknown"
        },
        "tag": {
          "PENDING": "Enforcement: Not verified",
          "VERIFIED": "Enforcement: Verified",
          "CONFIRMED_BYPASS": "Enforcement: Bypass",
          "NOT_CONFIGURED": "Enforcement: Not configured",
          "UNKNOWN": "Enforcement: Unknown"
        },
        "hint": {
          "PENDING": "The gateway is configured, but traffic has not been verified to pass through it.",
          "VERIFIED": "Agent traffic was verified passing through the gateway.",
          "CONFIRMED_BYPASS": "Agent traffic was confirmed to bypass the gateway.",
          "NOT_CONFIGURED": "No gateway is configured for this path.",
          "UNKNOWN": "The enforcement setup for this path could not be read. Unknown is not a gap."
        },
        "bypassDetail": "Agent traffic to {{service}} was observed going around the gateway. Correct the route (point the agent's MCP client at the gateway endpoint), then verify again.",
        "configureHint": "Configure the gateway for this path in the agent's enforcement setup.",
        "result": {
          "VERIFIED": "{{service}} gateway path verified.",
          "PENDING": "{{service}} could not be verified yet.",
          "CONFIRMED_BYPASS": "{{service}} traffic bypasses the gateway."
        },
        "runVerify": "Run Verification Check",
        "reverify": "Re-verify After Correction",
        "openService": "Open {{service}}"
      },
      "results": {
        "title": "Deployment results",
        "subtitle": "The last deployment's outcome, operation by operation",
        "applying": "Applying the native policy…",
        "complete": "Deployment complete",
        "issues": "Deployment completed with issues",
        "retrying": "Retrying failed operations…",
        "count_one": "{{succeeded}} of {{count}} requested change succeeded",
        "count_other": "{{succeeded}} of {{count}} requested changes succeeded",
        "countNote": "Counts include only the changes this deployment attempted. Existing policies are listed as unchanged, and gateway verification is a separate status.",
        "retryFailed_one": "Retry {{count}} Failed",
        "retryFailed_other": "Retry {{count}} Failed",
        "viewError": "View Error",
        "fixRole": "Fix Role Mapping",
        "viewPolicy": "View Policy",
        "viewGateway": "View Gateway Setup",
        "gatewayLabel": "{{service}} gateway path",
        "kinds": {
          "MCP_RULE": "New or changed · MCP tool rule",
          "NATIVE_POLICY": "New or changed · Native policy",
          "EXISTING_UNCHANGED": "Existing · unchanged",
          "GATEWAY_VERIFICATION": "Independent status · Enforcement verification"
        },
        "status": {
          "SUCCEEDED": "Deployed",
          "FAILED": "Failed",
          "UNCHANGED": "Unchanged",
          "PENDING": "Not verified",
          "VERIFIED": "Verified",
          "CONFIRMED_BYPASS": "Bypass",
          "APPLYING": "Applying"
        },
        "columns": {
          "change": "Change",
          "status": "Status",
          "attempts": "Attempts",
          "actions": "Actions"
        }
      },
      "wizard": {
        "title": "Create Data Policy",
        "titleEdit": "Continue Data Policy",
        "subtitle": "Native policy on {{source}}, authored from {{agent}}",
        "summaryTitle": "Policy Summary",
        "steps": {
          "basics": "Basics",
          "basicsDescription": "Policy name and type",
          "dataRules": "Data Rules",
          "dataRulesDescription": "Select objects and columns",
          "policyBuilder": "Policy Builder",
          "policyBuilderDescription": "Conditions and principals",
          "review": "Review",
          "reviewDescription": "Confirm settings",
          "deploy": "Deploy",
          "deployDescription": "Validate and publish policy"
        },
        "agentContext": "Agent context (read-only)",
        "agentContextNote": "You are creating a data policy from this agent's context. The policy targets a native identity and may affect other users or agents.",
        "sourceContext": "Selected data source (read-only)",
        "chooseType": "Choose a policy type",
        "bestFor": "Best for",
        "types": {
          "DATA_MASKING": {
            "description": "Mask column data, and selectively unmask it based on one or more conditions.",
            "bestFor": "Hiding SSN, credit card, or emails."
          },
          "ROW_ACCESS": {
            "description": "Grant access to data based on one or more conditions.",
            "bestFor": "Restricting rows, e.g. Texas customers only."
          },
          "OBJECT_ACCESS": {
            "description": "Provision access to database objects like tables, schemas, and views.",
            "bestFor": "Controlling access to specific objects."
          }
        },
        "name": "Policy name",
        "description": "Short description",
        "targets": "Target objects",
        "targetsLead": {
          "ROW_ACCESS": "Select the table whose rows this policy restricts.",
          "DATA_MASKING": "Select the objects whose columns this policy masks.",
          "OBJECT_ACCESS": "Select the objects this policy grants access to."
        },
        "selectObject": "Select {{name}}",
        "columns": {
          "schema": "Schema",
          "object": "Object",
          "kind": "Kind",
          "columns": "Discovered columns"
        },
        "loadingCatalog": "Loading the source's objects…",
        "noObjects": "No objects were discovered on this source.",
        "maskedColumns": "Columns to mask",
        "maskedColumnsHint": "From the selected objects' discovered columns.",
        "privileges": "Privileges",
        "discovered": "Discovered columns (read-only)",
        "identityTitle": "1. Native identity",
        "identityLead": "Select the data platform identity through which this agent accesses {{source}}.",
        "identityType": "Identity type",
        "identityRole": "Role",
        "nativeRole": "Native role",
        "mappingSource": "Mapping source",
        "mappingVerification": "Mapping verification",
        "verifyMapping": "Verify Mapping",
        "mappingNote": "Selecting a native role records the administrator's mapping. It does not verify that the agent actually uses this role, and the agent's identity is never assumed to be a native role.",
        "verifyResult": {
          "VERIFIED": "Role {{role}} exists and can be used.",
          "FAILED": "Role {{role}} was not found on the platform."
        },
        "conditionsTitle": {
          "ROW_ACCESS": "2. Access conditions",
          "DATA_MASKING": "2. Masking",
          "OBJECT_ACCESS": "2. Object access"
        },
        "conditionsLead": "Define the row access conditions for the selected objects.",
        "conditionsMode": "Condition view",
        "visualBuilder": "Visual Builder",
        "sqlPreview": "SQL Preview",
        "conditionColumn": "Column",
        "conditionOperator": "Operator",
        "conditionValue": "Value",
        "operators": {
          "equals": "equals",
          "not_equals": "does not equal",
          "in": "is one of"
        },
        "noConditions": {
          "DATA_MASKING": "The selected columns are masked for the native role.",
          "OBJECT_ACCESS": "The native role is granted the selected privileges on the selected objects."
        },
        "applyTo_one": "Apply to {{count}} selected object:",
        "applyTo_other": "Apply to {{count}} selected objects:",
        "change": "Change",
        "summary": {
          "name": "Policy name",
          "type": "Type",
          "agent": "Agent",
          "source": "Data source",
          "identity": "Native identity",
          "role": "Role: {{role}}",
          "targets": "Target objects",
          "conditions": "Condition",
          "rowsWhere": "Rows where"
        },
        "readiness": "Deploy readiness",
        "checks": {
          "name": "Policy name",
          "targets": "Target objects selected",
          "role": "Native role selected",
          "conditions": "Row conditions defined",
          "mapping": {
            "NOT_VERIFIED": "Role mapping not verified - deployment validates it",
            "VERIFIED": "Role mapping verified",
            "FAILED": "Role mapping verification failed - deployment is expected to fail"
          }
        },
        "sharedImpact": "The native role {{role}} may also be used by other users or agents. This policy is not necessarily agent-exclusive.",
        "retryNote": "This policy's last deployment failed. Continuing retries only that failed operation; nothing else is redeployed.",
        "unchanged_one": "{{count}} existing policy on this source - unchanged",
        "unchanged_other": "{{count}} existing policies on this source - unchanged",
        "deploy": "Deploy",
        "retryFailed": "Retry Failed Operation",
        "done": "Done",
        "deployNote": "Deploys the policy to the data platform. Gateway verification is reported separately and does not depend on this result.",
        "deployRefused": "The deployment could not start",
        "backToReview": "Back to Review",
        "draftSaved": "{{name}} saved as a draft. Drafts do not close policy gaps.",
        "errors": {
          "type": "Choose a policy type.",
          "name": "A policy name is required.",
          "duplicate": "A policy with this name already exists on this source.",
          "targets": "Select at least one object.",
          "columns": "Select at least one column to mask.",
          "privileges": "Select at least one privilege.",
          "role": "Select the native role this policy applies to. You can save a draft without one.",
          "conditions": "Add at least one condition.",
          "conditionIncomplete": "Complete or remove each condition."
        }
      },
      "demo": {
        "button": "Scenario tools",
        "hint": "Development only. Changes local scenario data.",
        "associationFailure": {
          "off": "Simulate a failed association (next add)",
          "on": "Stop simulating a failed association"
        },
        "associationFailureOn": "Simulation on: the next association fails once.",
        "associationFailureOff": "Simulation off.",
        "bypass": "Simulate confirmed bypass",
        "bypassDone": "Simulated: confirmed bypass on the first MCP path.",
        "verified": "Simulate verified gateway",
        "verifiedDone": "Simulated: first MCP path verified.",
        "openGap": "Open Policy Gap details",
        "openRecommendation": "Open recommendation review",
        "openResults": "Open deployment results",
        "reset": "Reset scenario",
        "resetHint": "Restores this agent's original fixture",
        "resetDone": "Scenario reset."
      },
      "suggestions": {
        "title": "Suggested improvements",
        "subtitle_one": "{{count}} optional control for this agent",
        "subtitle_other": "{{count}} optional controls for this agent",
        "note": "Suggestions are optional hardening. They are not missing protection, and applying one does not close a policy gap.",
        "loading": "Loading suggested improvements…",
        "none": "No suggested improvements for this agent.",
        "applied": "Already applied ({{count}})",
        "noneApplied": "No suggested improvements have been applied yet.",
        "browseCatalog": "Browse Policy Catalog"
      },
      "viewDetails": "View details",
      "viewDetailsFor": "View details for {{name}}",
      "actionRequired": {
        "title_one": "Action required ({{count}})",
        "title_other": "Action required ({{count}})",
        "listLabel": "Protection actions",
        "sourceName": "{{name}} ({{platform}})",
        "highPriority": "High priority",
        "lastAssessed": "Last assessed {{time}}",
        "stale": "Assessment out of date",
        "reassess": "Reassess",
        "reassessHint": "Reassess expected versus deployed controls for this agent.",
        "reassessed": "Reassessment complete.",
        "suggestions_one": "{{count}} suggestion",
        "suggestions_other": "{{count}} suggestions",
        "suggestionsLoading": "Loading suggestions…",
        "suggestionsHint": "Optional hardening for this agent. Suggestions are not missing protection.",
        "empty": "No outstanding protection actions were identified in the latest assessment.",
        "emptyNotEvaluated": "This agent has not been assessed yet, so no protection actions can be identified.",
        "announce_one": "{{count}} protection action required.",
        "announce_other": "{{count}} protection actions required.",
        "groups": {
          "gap": {
            "title_one": "{{count}} policy gap",
            "title_other": "{{count}} policy gaps",
            "detailOne": "{{title}}.",
            "detail_one": "A required restriction is missing on {{count}} data source.",
            "detail_other": "Required restrictions are missing on {{count}} data sources.",
            "action": "Review policy gap"
          },
          "failed": {
            "title_one": "{{count}} failed deployment",
            "title_other": "{{count}} failed deployments",
            "detailOne": "{{name}} could not be deployed.",
            "detail_one": "A native policy could not be deployed on {{count}} data source.",
            "detail_other": "Native policies could not be deployed on {{count}} data sources.",
            "action": "Review deployment"
          },
          "bypass": {
            "title_one": "{{count}} MCP path bypassing enforcement",
            "title_other": "{{count}} MCP paths bypassing enforcement",
            "detail": "Agent traffic was confirmed to bypass the gateway. Deployed policies are not enforced on these paths.",
            "action": "Review enforcement"
          },
          "setup": {
            "title_one": "{{count}} MCP path without enforcement setup",
            "title_other": "{{count}} MCP paths without enforcement setup",
            "detail": "The TrustLogix gateway is not configured for these MCP paths.",
            "action": "Review setup"
          },
          "verification": {
            "title_one": "{{count}} MCP path awaiting verification",
            "title_other": "{{count}} MCP paths awaiting verification",
            "detail": "Gateway enforcement has not been verified.",
            "action": "Review verification"
          }
        }
      },
      "toolbar": {
        "searchPlaceholder": "Search services, tools, or data sources…",
        "searchLabel": {
          "mcp": "Search MCP services and tools",
          "data": "Search data sources"
        }
      },
      "filters": {
        "button": "Filters",
        "active_one": "Filters, {{count}} active",
        "active_other": "Filters, {{count}} active",
        "title": "Filter resources",
        "reset": "Reset",
        "done": "Done",
        "coverage": "Policy coverage",
        "enforcement": "Enforcement",
        "risk": "Tool risk",
        "capability": "Tool capability",
        "toolPolicy": "Tool protection",
        "deployment": "Deployment",
        "platform": "Platform"
      },
      "columns": {
        "coverage": "Policy coverage",
        "enforcement": "Enforcement",
        "lastAssessed": "Last assessed"
      },
      "states": {
        "coverage": {
          "POLICY_GAP": "Policy gap",
          "SATISFIED": "Requirements satisfied",
          "NOT_EVALUATED": "Not evaluated"
        },
        "coverageHint": {
          "POLICY_GAP": "The latest assessment found a required restriction that the current policies do not satisfy.",
          "SATISFIED": "Every requirement the latest assessment checked is satisfied. This is not verified runtime enforcement.",
          "NOT_EVALUATED": "No requirement on this resource was checked by the latest assessment. Not evaluated is not a gap."
        },
        "enforcement": {
          "VERIFIED": "Verified",
          "PENDING": "Not verified",
          "CONFIRMED_BYPASS": "Bypass detected",
          "NOT_CONFIGURED": "Not configured",
          "UNKNOWN": "Unknown"
        },
        "deployment": {
          "NONE": "No policies"
        }
      },
      "details": {
        "nextSteps": "Next steps",
        "why": "Why it needs attention",
        "currentProtection": "Current protection",
        "ruleCount_one": "{{count}} MCP policy rule applies",
        "ruleCount_other": "{{count}} MCP policy rules apply",
        "nativeOnSources_one": "{{count}} native policy on linked data sources · {{deployed}} deployed · {{draft}} draft",
        "nativeOnSources_other": "{{count}} native policies on linked data sources · {{deployed}} deployed · {{draft}} draft",
        "policyBreakdown": "{{deployed}} deployed · {{draft}} draft · {{failed}} failed",
        "viewPolicies": "View policies",
        "viewTools": "View tools",
        "viewResults": "View results",
        "viewEnforcementSetup": "View Enforcement Setup",
        "enforcementStatus": "Enforcement status",
        "deploymentStatus": "Native deployment",
        "nativeManaged": "TrustLogix deploys native policies on {{platform}}. Deployed means applied on the platform, not verified at runtime.",
        "nativeCustomerManaged": "Native policies on {{platform}} are customer-managed. MCP tool rules still apply to the agent's MCP access.",
        "checkedAt": "Last checked {{time}}",
        "updatedAt": "Updated {{time}}",
        "associated": "Associated with agent",
        "tools": "Tools",
        "mcpRules": "MCP policy rules",
        "shared": "Shared - managed centrally",
        "sharedHint": "This policy reaches other agents too. Change it where it is managed, not here.",
        "noRules": "No MCP policy rules apply to this service for this agent.",
        "nativeOnLinked": "Native policies on linked data sources",
        "nativeSeparate": "These protect the data itself and are deployed separately. Publishing an MCP rule does not apply them.",
        "reviewDraft": "Review Draft",
        "noDeployments": "No native policies to deploy on this data source.",
        "gapPicker": "Policy gaps on this data source",
        "reasons": {
          "gap": "{{title}}.",
          "failed": "{{name}} could not be deployed.",
          "enforcement": {
            "PENDING": "Gateway enforcement has not been verified for this MCP service. Without verified enforcement, it cannot be confirmed that the agent's access is controlled through the TrustLogix gateway.",
            "NOT_CONFIGURED": "No TrustLogix gateway is configured for this MCP path, so its policies are not enforced at runtime.",
            "CONFIRMED_BYPASS": "Agent traffic was confirmed to bypass the gateway. Deployed policies are not enforced on this path.",
            "UNKNOWN": "The enforcement setup for this path could not be read. Unknown is not a gap."
          }
        },
        "steps": {
          "gap": {
            "title": "Review the policy gap",
            "description": "{{title}}.",
            "action": "Review"
          },
          "failed": {
            "title": "Fix the failed deployment",
            "description": "{{name}} could not be deployed.",
            "action": "View deployment"
          },
          "setup": {
            "title": "Review enforcement setup",
            "description": "Confirm the agent is using the TrustLogix MCP gateway.",
            "action": "View setup"
          },
          "verify": {
            "title": "Validate runtime traffic",
            "description": "Run a verification check to confirm traffic passes through the gateway.",
            "action": "Run check"
          },
          "access": {
            "title": "Complete the access context",
            "description": "How the agent reaches this data source is not specified. Unspecified is not a gap.",
            "action": "Complete Access Context"
          }
        },
        "associationPill": {
          "NOT_VERIFIED": "Association: Not verified",
          "VERIFIED": "Association: Verified",
          "FAILED": "Association: Failed"
        },
        "tabs": {
          "overview": "Overview",
          "tools_one": "Tools ({{count}})",
          "tools_other": "Tools ({{count}})",
          "policies_one": "Policies ({{count}})",
          "policies_other": "Policies ({{count}})",
          "enforcement": "Enforcement",
          "deployment": "Deployment",
          "gap_one": "Policy gap",
          "gap_other": "Policy gaps ({{count}})"
        },
        "paths": {
          "verification": {
            "title": "Enforcement verification",
            "subtitle_one": "{{count}} MCP path awaiting verification",
            "subtitle_other": "{{count}} MCP paths awaiting verification"
          },
          "setup": {
            "title": "Enforcement setup",
            "subtitle_one": "{{count}} MCP path without enforcement setup",
            "subtitle_other": "{{count}} MCP paths without enforcement setup"
          },
          "bypass": {
            "title": "Enforcement gaps",
            "subtitle_one": "{{count}} MCP path bypassing enforcement",
            "subtitle_other": "{{count}} MCP paths bypassing enforcement"
          }
        },
        "fixRoleMapping": "Fix Role Mapping"
      }
    },
    "agentPlatforms": {
      "pageTitle": "Agent Registries",
      "empty": "No agent registries yet. Import agents from a platform to create one.",
      "registries": {
        "title": "Agent registries",
        "columns": {
          "name": "Name",
          "provider": "Platform",
          "tenant": "Account / tenant",
          "projects": "Projects",
          "status": "Status",
          "agents": "Agents"
        },
        "importAgents": "Sync agents",
        "syncAttributes": "Sync attributes",
        "delete": {
          "title": "Delete Agent Registry",
          "description": "Are you sure you want to delete <strong>{{name}}</strong>?",
          "success": "{{name}} deleted"
        },
        "failed": "Agent registries could not be loaded.",
        "projectsTitle": "Projects in {{name}}",
        "projectsAction_one": "View {{count}} project in {{name}}",
        "projectsAction_other": "View {{count}} projects in {{name}}",
        "projectsEmpty": "No projects are selected for this connection.",
        "projectColumns": {
          "project": "Project",
          "resource": "Resource"
        },
        "details": {
          "title": "Agent Registry Details",
          "openAction": "View details of {{name}}",
          "connection": "Connection",
          "identity": "Identity",
          "prerequisites": "Required setup",
          "projects": "Projects",
          "configured": "Configured",
          "fields": {
            "name": "Name",
            "platform": "Platform",
            "status": "Status",
            "agents": "Agents",
            "confirmedBy": "Confirmed by",
            "confirmedAt": "Confirmed on"
          }
        }
      }
    },
    "platform": {
      "microsoftFoundry": "Microsoft Azure AI Foundry",
      "openAi": "OpenAI",
      "databricks": "Databricks",
      "snowflake": "Snowflake",
      "awsAgentCore": "AWS AgentCore",
      "microsoft365": "Microsoft 365 / Work IQ",
      "glean": "Glean"
    },
    "identityProvider": {
      "microsoftEntraId": "Microsoft Entra ID",
      "okta": "Okta",
      "other": "Other",
      "pingIdentity": "Ping Identity",
      "saviynt": "Saviynt",
      "sailpoint": "SailPoint"
    },
    "environmentType": {
      "production": "Production",
      "test": "Test",
      "development": "Development"
    },
    "categories": {
      "title": "Agent Categories",
      "groupBy": "Group by",
      "secureCount_one": "{{count}} Policy Covered",
      "secureCount_other": "{{count}} Policy Covered",
      "notSecureCount_one": "{{count}} Policy Gap",
      "notSecureCount_other": "{{count}} Policy Gaps",
      "notEvaluatedCount_one": "{{count}} Not Yet Evaluated",
      "notEvaluatedCount_other": "{{count}} Not Yet Evaluated",
      "platformAria": "Platform: {{platform}}",
      "reviewRecommendationsAria_one": "Review {{count}} recommended policy for {{name}}",
      "reviewRecommendationsAria_other": "Review {{count}} recommended policies for {{name}}",
      "empty": "No agents match the current filters.",
      "dimension": {
        "none": "None",
        "platform": "Technology / Platform",
        "businessUnit": "Business Unit",
        "project": "Project",
        "environment": "Environment",
        "connectedResource": "Connected Resource",
        "purpose": "Agent Purpose",
        "securityStatus": "Security Status"
      },
      "card": {
        "agentsLink_one": "{{count}} agent",
        "agentsLink_other": "{{count}} agents",
        "agentsLinkAria_one": "View the {{count}} agent in {{name}}",
        "agentsLinkAria_other": "View all {{count}} agents in {{name}}",
        "unprotected": "Unprotected",
        "protected": "Protected",
        "unprotectedAtLeast_one": "At least {{count}} agent is unprotected. An exact count needs per-agent detail that isn't available for this category yet.",
        "unprotectedAtLeast_other": "At least {{count}} agents are unprotected. An exact count needs per-agent detail that isn't available for this category yet.",
        "unprotectedAtLeastLabel": "About this count",
        "gaps": {
          "title": "Protection gaps",
          "info": "An unprotected agent may have both policy and enforcement gaps, so these counts can add up to more than the unprotected total.",
          "infoLabel": "About protection gaps",
          "policy": "Policy gaps",
          "enforcement": "Enforcement gaps",
          "policyAria_one": "View the {{count}} agent in {{name}} with a policy gap",
          "policyAria_other": "View the {{count}} agents in {{name}} with a policy gap",
          "enforcementAria_one": "View the {{count}} agent in {{name}} with an enforcement gap",
          "enforcementAria_other": "View the {{count}} agents in {{name}} with an enforcement gap"
        },
        "allProtected": {
          "title": "All agents are protected",
          "detail_one": "{{count}} of {{total}} agent has TrustLogix controls",
          "detail_other": "{{count}} of {{total}} agents have TrustLogix controls"
        },
        "empty": "No agents in this category yet."
      }
    },
    "businessUnit": {
      "hr": "Human Capital",
      "customerSupport": "Private Banking & Client Services",
      "finance": "Markets & Trading",
      "engineering": "Technology & Trading Systems",
      "analytics": "Risk & Quant Research"
    },
    "securityStatus": {
      "secure": "Policy Covered",
      "notSecure": "Policy Gaps",
      "notEvaluated": "Not Yet Evaluated",
      "needsAttention": "Needs Policy Attention",
      "secureTooltip": "Required access policies are currently applied based on TrustAI's evaluated policy coverage.",
      "notSecureTooltip": "One or more recommended access controls are missing, incomplete, or require review.",
      "notEvaluatedTooltip": "TrustAI does not yet have enough information to evaluate whether the required access controls are in place."
    },
    "purpose": {
      "engineering": "Engineering",
      "analytics": "Analytics",
      "research": "Research",
      "hr": "HR",
      "finance": "Finance",
      "customerSupport": "Customer Support",
      "contentCreation": "Content Creation"
    },
    "policyCategory": {
      "privacyProtection": "Privacy Protection",
      "regulatoryCompliance": "Regulatory Compliance",
      "businessRules": "Business Rules",
      "toolActionControls": "Tool & Action Controls",
      "dataAccessControls": "Data Access Controls",
      "label": "Category"
    },
    "summary": {
      "title": "Agent estate",
      "agents": "Agents",
      "secure": "Policy Covered",
      "notSecure": "Policy Gaps",
      "notEvaluated": "Not Yet Evaluated",
      "withRecommendations": "Have Recommendations",
      "withRecommendationsTooltip": "Agents with policy gaps that TrustAI can already recommend a policy for.",
      "agentsTooltip": "Every agent discovered in this environment.",
      "filterAria": "Filter the estate by {{metric}}",
      "activeAria": "{{metric}} filter is active. Select again to clear it.",
      "coverage": "{{percent}}% policy coverage",
      "coverageTooltip": "The share of discovered agents with every required access policy applied."
    },
    "allPolicies": {
      "heading": "Available policies",
      "lead": "Choose from reusable enterprise policies available in your environment.",
      "searchPlaceholder": "Search policies",
      "technologyFilter": "Technology",
      "allCategories": "All categories",
      "allTechnologies": "All technologies",
      "empty": "No policy matches these filters.",
      "scope": "Applies to",
      "categoryChipsLabel": "Filter by category",
      "allChip": "All",
      "groups": {
        "RECOMMENDED": "Recommended for this selection",
        "APPLICABLE": "Applicable",
        "NOT_APPLICABLE": "Not applicable"
      }
    },
    "customPolicy": {
      "heading": "Create a custom policy",
      "lead": "Describe what this agent should be allowed or prevented from doing. TrustLogix can use this intent to create a draft policy.",
      "intentLabel": "Policy intent",
      "intentPlaceholder": "Example: Allow engineering agents to read and update GitHub repositories, but prevent repository deletion and administrative actions.",
      "generate": "Generate draft policy",
      "generating": "Generating draft…",
      "draftBadge": "Draft",
      "draftHeading": "Draft policy",
      "intentSummary": "Intent",
      "proposedControls": "Proposed controls",
      "derivedFrom": "from “{{phrase}}”",
      "unmatched": "TrustLogix could not map part of this intent to a known control. Review the draft before using it.",
      "useDraft": "Use this draft",
      "startOver": "Start over",
      "selected": "This draft will be applied with the selected policies.",
      "failed": "Could not generate a draft policy."
    },
    "recommendation": {
      "stronglyRecommended": "Strongly recommended",
      "recommended": "Recommended",
      "whyRecommended": "Why recommended",
      "whyToggle": "Why recommended?",
      "hideWhy": "Hide details",
      "thisWill": "This will",
      "recommendedFor": "Recommended for {{count}} of {{total}} {{scope}}",
      "recommendedForAll_one": "Recommended for the {{scope}}",
      "recommendedForAll_other": "Recommended for all {{count}} {{scope}}",
      "appliesTo": "Applies to",
      "allow": "Allow",
      "block": "Block",
      "selectAria": "Select the policy {{name}}"
    },
    "killSwitch": {
      "action": "Kill Switch",
      "tooltip": "Immediately cuts off protected-resource access for the selected agents. The agents are not deleted and access can be restored later.",
      "restore": "Restore Access",
      "confirmTitle": "Activate Kill Switch?",
      "confirmDescription": "This will immediately revoke protected-resource access for the selected agents. The agents will remain registered and can be restored later.",
      "affected_one": "{{count}} agent will be affected",
      "affected_other": "{{count}} agents will be affected",
      "confirmAction": "Activate Kill Switch",
      "activated_one": "Access suspended for {{count}} agent.",
      "activated_other": "Access suspended for {{count}} agents.",
      "restored_one": "Access restored for {{count}} agent.",
      "restored_other": "Access restored for {{count}} agents.",
      "failed": "Could not update agent access.",
      "suspended": "Access suspended",
      "suspendedTooltip": "Access was suspended using Kill Switch. This agent has not been deleted and access can be restored."
    },
    "cleanup": {
      "comingSoon": "Coming Soon",
      "policyReviewTitle": "Review policy application",
      "policyResultTitle": "Policy application result",
      "done": "Done",
      "reviewSelection": "Review Selected Policies",
      "reviewFailed": "The policy request failed. Your selections are preserved; review them to try again.",
      "policyScope": "{{count}} affected · {{excluded}} not applicable · {{applied}} already assigned",
      "affectedAgents": "View affected agents and gaps",
      "applicationNotRuntime": "Policy assignments are recorded in this demo. Agent readiness and policy coverage are shown separately.",
      "result_one": "Policies applied to {{count}} agent; {{secure}} now Policy Covered. Agents with remaining gaps still show Policy Gaps.",
      "result_other": "Policies applied to {{count}} agents; {{secure}} now Policy Covered. Agents with remaining gaps still show Policy Gaps.",
      "outcome": {
        "policies_one": "{{count}} recommended policy",
        "policies_other": "{{count}} recommended policies",
        "agents_one": "{{count}} agent",
        "agents_other": "{{count}} agents",
        "summary": "{{policies}} applied to {{agents}}",
        "created_one": "{{count}} TrustLogix policy record created: {{detail}}",
        "created_other": "{{count}} TrustLogix policy records created: {{detail}}",
        "createdAnd": " and ",
        "controlsCreated_one": "{{count}} native data-platform control created",
        "controlsCreated_other": "{{count}} native data-platform controls created",
        "updated_one": "{{count}} existing policy record updated",
        "updated_other": "{{count}} existing policy records updated",
        "unchanged_one": "{{count}} policy already in place",
        "unchanged_other": "{{count}} policies already in place",
        "skipped_one": "{{count}} policy left alone (individually modified)",
        "skipped_other": "{{count}} policies left alone (individually modified)",
        "pending_one": "{{count}} policy record still publishing",
        "pending_other": "{{count}} policy records still publishing",
        "failed_one": "{{count}} policy record not published or deployed",
        "failed_other": "{{count}} policy records not published or deployed",
        "covered_one": "{{count}} targeted agent is now Policy Covered",
        "covered_other": "{{count}} targeted agents are now Policy Covered",
        "remaining_one": "{{count}} targeted agent still has policy gaps",
        "remaining_other": "{{count}} targeted agents still have policy gaps",
        "setup_one": "{{count}} targeted agent still needs enforcement setup",
        "setup_other": "{{count}} targeted agents still need enforcement setup",
        "setupUnknown_one": "{{count}} targeted agent's enforcement setup could not be read",
        "setupUnknown_other": "{{count}} targeted agents' enforcement setup could not be read",
        "agent": {
          "SUCCESS_one": "{{count}} agent completed",
          "SUCCESS_other": "{{count}} agents completed",
          "PARTIAL_one": "{{count}} agent partly completed",
          "PARTIAL_other": "{{count}} agents partly completed",
          "FAILED_one": "{{count}} agent not completed",
          "FAILED_other": "{{count}} agents not completed",
          "UNCHANGED_one": "{{count}} agent already in place",
          "UNCHANGED_other": "{{count}} agents already in place",
          "PENDING_one": "{{count}} agent still deploying",
          "PENDING_other": "{{count}} agents still deploying",
          "SKIPPED_one": "{{count}} agent with nothing to deploy",
          "SKIPPED_other": "{{count}} agents with nothing to deploy"
        },
        "stale": "The agents or coverage changed after this review. It now applies to {{count}} agents (it was {{before}}). Review the updated plan before applying.",
        "reviewUpdated": "Review updated plan"
      },
      "reviewAgents_one": "Review {{count}} agent",
      "reviewAgents_other": "Review {{count}} agents",
      "policyGaps_one": "{{count}} policy gap",
      "policyGaps_other": "{{count}} policy gaps",
      "scope": "{{scope}} · {{status}}",
      "browse": "Browse Policies",
      "review": "Review Recommended Policies",
      "identityAndPurpose": "Identity and purpose",
      "viewMission": "View mission details",
      "viewEvidence": "View classification evidence",
      "recorded": "Recorded",
      "filteredResult_one": "{{count}} agent became Secure and may no longer appear in this filtered list.",
      "filteredResult_other": "{{count}} agents became Secure and may no longer appear in this filtered list.",
      "killSubset": "Kill Switch ({{count}})",
      "restoreSubset": "Restore Access ({{count}})",
      "reviewAll": "Review Recommended Policies",
      "resources": "View Resources",
      "activity": "View Activity",
      "flow": "View Access Flow",
      "policy": "View Policy Coverage",
      "aiEstate": "AI Agent Estate",
      "dataEstate": "Data Estate",
      "simulated": "Mock simulation",
      "exclusion": {
        "NOT_APPLICABLE": "Purpose or resources do not match this policy",
        "ALREADY_ASSIGNED": "Policy already assigned"
      },
      "reviewStale": "The agents or coverage changed after this review. Your selections are preserved; review the current scope again.",
      "confirmApply_one": "Apply Policy",
      "confirmApply_other": "Apply Policies",
      "policyDeployingTitle": "Applying policy"
    },
    "enforcement": {
      "intentPolicy": "Intent Policy",
      "status": {
        "enforced": "Enforced",
        "partiallyEnforced": "Partially enforced",
        "notEnforced": "Not enforced",
        "notMapped": "Not mapped",
        "conflictDetected": "Conflict detected",
        "enforcedTooltip": "Every mapped control for this intent is in force.",
        "partiallyEnforcedTooltip": "Some controls for this intent are in force and others are not yet mapped or enforced.",
        "notEnforcedTooltip": "This intent is not yet in effect at these enforcement points.",
        "notMappedTooltip": "No existing policy or control is mapped to this intent here.",
        "conflictDetectedTooltip": "An existing policy here contradicts this intent.",
        "notYetEffective": "Not yet effective",
        "notYetEffectiveTooltip": "Recommended for this agent. Enforcement starts once the policy is applied."
      },
      "layer": {
        "agent": "Agent Policy",
        "server": "Server Policy",
        "tool": "Tool Policy",
        "data": "Data Policy"
      },
      "count": {
        "mcpServer_one": "{{count}} MCP server",
        "mcpServer_other": "{{count}} MCP servers",
        "tool_one": "{{count}} tool",
        "tool_other": "{{count}} tools",
        "dataSource_one": "{{count}} data source",
        "dataSource_other": "{{count}} data sources",
        "control_one": "{{count}} control",
        "control_other": "{{count}} controls",
        "agent_one": "{{count}} agent",
        "agent_other": "{{count}} agents",
        "usedBy_one": "Used by {{count}} agent",
        "usedBy_other": "Used by {{count}} agents"
      },
      "intent": {
        "allow": "Allow",
        "restrict": "Restrict"
      },
      "targets": {
        "title": "Enforcement targets",
        "mcpServers": "MCP Servers",
        "dataSources": "Data Sources",
        "pair": "{{count}} · {{detail}}"
      },
      "mcp": {
        "serverPolicy": "Server Access Policy: {{name}}",
        "toolSummary": "Tool Policies: {{tools}} · {{inherited}} inherited · {{custom}} custom",
        "viewPolicy": "View MCP policy",
        "showTools": "Show tool policies",
        "hideTools": "Hide tool policies",
        "inherited": "Inherited",
        "custom": "Custom"
      },
      "data": {
        "viewPolicies": "View data policies"
      },
      "drawer": {
        "title": "Policy Enforcement",
        "subtitle": "Intent Policy · Policy Enforcement",
        "context": "Context: {{label}}",
        "allAgents": "All agents in policy scope",
        "coverage": "Enforcement Coverage",
        "coverageLine": "{{servers}} / {{tools}} · {{sources}} / {{controls}}",
        "identityContext": "Identity context: Agent identity + requesting user context",
        "identityTooltip": "How the agent's identity and the requesting user's context combine at each enforcement point is still being defined.",
        "viewPolicyScope": "View complete policy scope",
        "backToContext": "Back to {{label}}",
        "unavailable": "Enforcement details are not available for this context.",
        "intentHeading": "Security intent",
        "notYetEffective": "Recommended for this agent and not yet effective. The targets below show where this intent will be enforced once the policy is applied.",
        "appliesTo_one": "Applies to {{count}} agent",
        "appliesTo_other": "Applies to {{count}} agents",
        "appliesToGroup_one": "Applies to {{count}} agent in this category",
        "appliesToGroup_other": "Applies to {{count}} agents in this category",
        "groupLabel": "{{name}} · {{dimension}}",
        "recommended": "Recommended",
        "pathHeading": "Controls along this path",
        "findingsHeading": "Incomplete enforcement",
        "finding": "{{control}} is {{status}} on {{resource}} for {{agents}}.",
        "findingResource": "{{resource}} is {{status}} for {{agents}}.",
        "mcpServers": "MCP Servers ({{count}})",
        "dataSources": "Data Sources ({{count}})"
      },
      "review": {
        "context": "Context: {{label}}"
      },
      "result": {
        "configured": "Applies to {{servers}} / {{tools}} and {{sources}} / {{controls}}.",
        "viewEnforcement": "View enforcement"
      },
      "hop": {
        "chip": "{{layer}}: {{status}}",
        "viewEnforcement": "View enforcement",
        "control": "Control",
        "status": "Status"
      }
    },
    "enforcementEnvironment": {
      "status": {
        "enabled": "Enabled",
        "setupRequired": "Environment setup required"
      },
      "tooltip": {
        "setupRequired": "TrustLogix enforcement is disabled for this workspace, so this agent has no enforcement path to use yet."
      }
    },
    "enforcementReadiness": {
      "status": {
        "ready": "Configured",
        "setupRequired": "Setup required",
        "attentionRequired": "Setup required",
        "unknown": "Not verified",
        "notApplicable": "Not applicable"
      },
      "tooltip": {
        "coverage": "Whether configured policies cover the agent's evaluated access requirements. Policy coverage does not confirm runtime enforcement.",
        "dimension": "Whether the required enforcement path is configured for the agents in this scope. Configuration alone does not confirm runtime policy enforcement.",
        "ready": "The required enforcement path is configured for this agent. Configuration alone does not confirm runtime policy enforcement.",
        "setupRequired": "At least one required enforcement prerequisite is missing or invalid for this agent.",
        "attentionRequired": "An enforcement path exists, but its configuration or health is failing.",
        "unknown": "Available information cannot establish whether this agent's required enforcement setup is complete."
      },
      "filter": {
        "notReady": "Setup not fully configured",
        "columnTitle": "Enforcement setup",
        "setupGap": "Needs enforcement setup"
      },
      "reason": {
        "noEnvironment": "TrustLogix enforcement is disabled for this workspace, so this agent has no enforcement path to use yet.",
        "directMcp": "This agent connects directly to its MCP server instead of through the required enforcement path.",
        "notRouted": "This agent is not configured to use the required enforcement path.",
        "gatewayUnhealthy": "The gateway reported a problem with this agent's enforcement path.",
        "unverifiable": "Enforcement setup has not been verified for this agent.",
        "mcpConnectionMissing": "The gateway connection to {{service}} needs configuration.",
        "mcpConnectionFailed": "The gateway could not connect to {{service}}."
      },
      "method": {
        "mcpGateway": "MCP Access Gateway",
        "plugin": "Plugin",
        "other": "Other integration",
        "none": "None"
      },
      "health": {
        "healthy": "Healthy",
        "unhealthy": "Unhealthy",
        "unknown": "Status unknown"
      },
      "actions": {
        "setUp": "Set up enforcement",
        "setUpAgent": "Review agent setup",
        "configure": "Configure enforcement",
        "view": "View enforcement",
        "completeSetup": "Complete enforcement setup",
        "viewSetupInstructions": "View setup instructions",
        "reviewAgents_one": "Review {{count}} agent",
        "reviewAgents_other": "Review {{count}} agents",
        "reviewAgentsRequiringSetup": "Review agents requiring setup",
        "adminRequired": "You don't have permission to change enforcement settings. Ask a workspace administrator to enable or configure enforcement.",
        "enable": "Enable enforcement",
        "retryStatus": "Retry",
        "reviewSettings": "Review enforcement settings",
        "viewAgentInstructions": "View agent setup instructions",
        "configureConnection": "Configure MCP connection",
        "reviewConnection": "Review connection issue",
        "reviewSetup": "Review setup",
        "reviewUnverifiedAgents_one": "Review {{count}} agent not verified",
        "reviewUnverifiedAgents_other": "Review {{count}} agents not verified"
      },
      "metric": {
        "label": "Enforcement setup",
        "aboutLabel": "About enforcement setup"
      },
      "notice": {
        "scope_one": "{{count}} of {{total}} agents needs enforcement setup.",
        "scope_other": "{{count}} of {{total}} agents need enforcement setup.",
        "environmentRequired": {
          "title": "TrustLogix enforcement is disabled",
          "description": "Policies can be created and assigned, but TrustLogix runtime enforcement is unavailable until workspace enforcement is enabled and the required agent setup is complete."
        },
        "environmentAttention": {
          "title": "Workspace enforcement needs attention",
          "description": "The workspace's enforcement path is reporting a problem. Configured setup does not mean runtime enforcement is available."
        },
        "agentSetupRequired": {
          "title": "Agent enforcement setup required",
          "description": "This agent is not configured to use the required enforcement path. Policies can be created, but cannot control its runtime access through TrustLogix until setup is complete."
        },
        "policyCoverage": {
          "title": "Enforcement setup required",
          "description": "These policies are configured in TrustLogix, but cannot control this agent's runtime access through TrustLogix until its enforcement setup is complete."
        },
        "reviewPolicies": {
          "title": "Enforcement setup required",
          "description": "These policies can be created and assigned now, but they cannot control runtime access through TrustLogix until enforcement setup is complete."
        },
        "applyResult": {
          "title": "Enforcement setup still required",
          "description": "The policies cannot control runtime access through TrustLogix until enforcement setup is complete."
        },
        "accessFlowBypass": {
          "title": "TrustLogix enforcement is not in this runtime path",
          "description": "Policies configured in TrustLogix cannot be enforced on this traffic."
        },
        "accessFlowSetup": {
          "title": "Enforcement setup required",
          "description": "This agent is not configured to use the required enforcement path."
        },
        "accessFlowAttention": {
          "title": "Enforcement path needs attention",
          "description": "This agent's enforcement path is configured, but its configuration or health is failing."
        },
        "accessFlowUnknown": {
          "title": "Enforcement setup not verified",
          "description": "Enforcement setup has not been verified for this agent, so no enforcement path is drawn."
        },
        "statusUnknown": {
          "title": "Enforcement setup not verified",
          "description": "TrustLogix could not verify this agent's enforcement setup, so these policies may not control its runtime access."
        },
        "workspaceUnknown": {
          "title": "Workspace enforcement status is not verified",
          "description": "TrustLogix could not establish whether enforcement is enabled. Review the workspace settings before relying on runtime enforcement."
        },
        "accessFlowConnectionMissing": {
          "title": "MCP connection needs configuration",
          "description": "The gateway connection to {{service}} needs configuration."
        },
        "accessFlowConnectionFailed": {
          "title": "MCP connection check failed",
          "description": "The gateway could not connect to {{service}}."
        }
      },
      "panel": {
        "title": "TrustLogix Enforcement",
        "headline": {
          "ready": "Enforcement path configured",
          "environmentRequired": "Workspace enforcement is disabled",
          "setupRequired": "Enforcement setup required",
          "attentionRequired": "Enforcement setup required",
          "unknown": "Enforcement setup not verified"
        },
        "consequence": "Policies may exist in TrustLogix, but they cannot control this agent's runtime access through TrustLogix until setup is complete.",
        "method": "Method",
        "environment": "Environment",
        "notReported": "Not reported",
        "viewAccessFlow": "View access flow",
        "viewConfiguration": "View enforcement configuration",
        "configuredNote": "Configuration alone does not confirm runtime policy enforcement.",
        "workspaceBlocked": "Enforcement setup is configured, but workspace enforcement is disabled.",
        "gatewayConnectivity": "Gateway connectivity",
        "pathsLabel": "Required enforcement paths",
        "routingPath": "Agent routing"
      },
      "heading": "Enforcement setup",
      "verification": {
        "heading": "Runtime verification",
        "NOT_VERIFIED": "Not verified",
        "IN_PROGRESS": "Verification in progress",
        "VERIFIED_PATH": "Verified for the tested path",
        "PARTIAL": "Partially verified",
        "FAILED": "Verification failed",
        "REVERIFY_REQUIRED": "Reverification required",
        "UNAVAILABLE": "Verification unavailable",
        "helper": {
          "NOT_VERIFIED": "No runtime check has been recorded for these paths. Publication and setup do not confirm that requests are being evaluated.",
          "IN_PROGRESS": "A runtime check is running.",
          "VERIFIED_PATH": "{{verified}} of {{required}} tested paths evaluated as expected. This does not cover other access paths or agents.",
          "PARTIAL": "{{verified}} of {{required}} required paths have qualifying evidence. The rest are not verified.",
          "FAILED": "A runtime check reported a failure.",
          "REVERIFY_REQUIRED": "Earlier evidence no longer establishes the current configuration or policy version.",
          "UNAVAILABLE": "Runtime verification is not available for this workspace."
        },
        "currencyUnknown": "Whether earlier evidence still matches the current configuration cannot be established.",
        "simulated": "Simulated runtime check — demo data",
        "historical": "Historical evidence",
        "detailsToggle": "Evidence details",
        "checkedAt": "Checked {{time}}",
        "path": "Path: {{path}}",
        "agent": "Agent: {{agent}}",
        "revision": "Policy revision {{policy}} · configuration revision {{config}}"
      },
      "publication": {
        "heading": "Policy publication",
        "CONFIRMED": "Confirmed",
        "NOTHING_TO_PUBLISH": "Nothing to publish",
        "PENDING": "Saved; publication pending",
        "IN_PROGRESS": "Publication in progress",
        "PARTIAL": "Partially published",
        "FAILED": "Publication failed",
        "engine": {
          "title": "TrustLogix policies",
          "CONFIRMED": "Published to the TrustLogix policy engine",
          "PENDING": "Saved; publication to the TrustLogix policy engine pending",
          "IN_PROGRESS": "Publishing to the TrustLogix policy engine",
          "PARTIAL": "Some policies were not published to the TrustLogix policy engine",
          "FAILED": "Publication to the TrustLogix policy engine failed"
        },
        "platform": {
          "title": "Native data-platform controls",
          "CONFIRMED": "Deployed to {{platform}}",
          "PENDING": "Saved; deployment to {{platform}} pending",
          "IN_PROGRESS": "Deploying to {{platform}}",
          "PARTIAL": "Some controls were not deployed to {{platform}}",
          "FAILED": "Deployment to {{platform}} failed"
        },
        "counts": "{{confirmed}} of {{total}} confirmed",
        "detailsToggle": "Publication details"
      },
      "thisService": "this MCP service"
    },
    "policyCard": {
      "thisWill": "This will",
      "appliesTo": "Applies to",
      "enforcement": "TrustLogix enforcement",
      "readyOfTotal": "{{ready}} of {{total}} agents have enforcement setup configured",
      "reviewPolicy": "Review policy",
      "reviewPolicyAria": "Review policy {{name}}",
      "whyToggle": "Why recommended?",
      "hideWhy": "Hide rationale",
      "notApplicable": "Not applicable",
      "notApplicableSelectAria": "{{name}} can't be selected: {{reason}}",
      "applicable": "Applicable",
      "restrictSummary": "Restrict {{items}}"
    },
    "policyApplicability": {
      "RECOMMENDED": "Recommended",
      "APPLICABLE": "Applicable",
      "NOT_APPLICABLE": "Not applicable",
      "tooltip": {
        "coverage": "Shows whether recommended TrustLogix policies are configured for this scope.",
        "enforcement": "Whether the required enforcement path is configured for the agents under review. Configuration alone does not confirm runtime enforcement.",
        "APPLICABLE": "This policy can be applied to the selected context but is not currently recommended.",
        "NOT_APPLICABLE": "Required context or resources for this policy were not found."
      },
      "aboutLabel": "About {{status}}"
    },
    "policyReview": {
      "back": "Back",
      "backToPolicies": "Back to policies",
      "selectPolicy": "Select policy",
      "deselectPolicy": "Deselect policy",
      "close": "Close",
      "reviewAndApply": "Review and apply",
      "loading": "Loading policy review",
      "error": "This policy review could not be loaded.",
      "retry": "Try again",
      "header": {
        "RECOMMENDED": "Recommended policy",
        "APPLICABLE": "Catalog policy",
        "NOT_APPLICABLE": "Catalog policy",
        "draft": "Draft policy",
        "forAgent": "For {{name}}",
        "forAgents_one": "Applies to {{count}} {{scope}}",
        "forAgents_other": "Applies to {{count}} {{scope}}",
        "intentPolicyType": "Intent-based access policy",
        "controlPolicyType": "Access control policy",
        "frameworks": "Supports {{frameworks}}"
      },
      "what": {
        "heading": "What this policy does"
      },
      "why": {
        "heading": "Why this is recommended"
      },
      "applicability": {
        "heading": "Applicability",
        "canApply": "This policy can be applied to this selection.",
        "matching": "Matching resources",
        "notRecommended": "This policy was not identified as a current recommendation.",
        "cannotApply": "This policy cannot currently be applied",
        "required": "Required resource",
        "detected": "Detected"
      },
      "where": {
        "heading": "Where this policy applies",
        "combinedHeading": "Combined enforcement scope",
        "servers": "MCP servers",
        "tools": "Tools",
        "sources": "Data sources",
        "controls": "Data controls",
        "noAgent": "No agent in this selection is reached by this policy, so there is no access path to show.",
        "forAgent": "Inspecting {{name}}. The totals and access flow below are for this agent only; they do not change which agents the policies apply to."
      },
      "agents": {
        "heading": "Selected agents",
        "caption": "Agents this review covers",
        "agent": "Agent",
        "enforcement": "Enforcement setup",
        "targets": "Policy targets",
        "targetsValue": "{{servers}} · {{tools}}",
        "none": "—",
        "viewing": "Viewing",
        "viewingAria": "Choose which agent's access flow to view",
        "applicability": "Applicability",
        "showAll": "Show all agents",
        "notApplicable": "Not applicable",
        "application": "Application",
        "show": "Show",
        "showAria": "Choose which agents the table lists",
        "view": {
          "targeted": "Targeted agents ({{count}})",
          "excluded": "Not targeted ({{count}})",
          "all": "All agents ({{count}})"
        },
        "membership": {
          "TARGETED": "Will receive these policies",
          "ALREADY_ASSIGNED": "Already has these policies",
          "NOT_APPLICABLE": "Outside these recommendations' scope",
          "UNRESOLVED": "Applicability unknown"
        },
        "showSetupGap": "Showing agents that need enforcement setup.",
        "showUnverified": "Showing agents whose enforcement setup is not verified."
      },
      "selected": {
        "heading": "Selected policies"
      },
      "impact": {
        "heading": "Policy impact"
      },
      "enforcement": {
        "heading": "Enforcement setup",
        "policyState": "Policy state",
        "runtimeStatus": "Runtime verification",
        "method": "Method",
        "state": {
          "NOT_APPLIED": "Not yet applied",
          "APPLIED": "Applied",
          "PARTIALLY_APPLIED": "Applied to some agents"
        },
        "population": {
          "TARGETED_one": "Across the {{count}} targeted agent.",
          "TARGETED_other": "Across the {{count}} targeted agents.",
          "ASSIGNED_one": "Across the {{count}} agent that already has these policies.",
          "ASSIGNED_other": "Across the {{count}} agents that already have these policies."
        },
        "agentMessage": {
          "READY": "The required enforcement path is configured for this agent.",
          "SETUP_REQUIRED": "Required enforcement setup is missing for this agent.",
          "ATTENTION_REQUIRED": "This agent's enforcement path is configured, but its configuration or health is failing.",
          "UNKNOWN": "Enforcement setup has not been verified for this agent."
        },
        "scopeMessage": "{{ready}} of {{total}} agents have the required enforcement path configured.",
        "needSetup_one": "{{count}} needs setup.",
        "needSetup_other": "{{count}} need setup.",
        "notVerified_one": "{{count}} is not verified.",
        "notVerified_other": "{{count}} are not verified.",
        "workspace": {
          "DISABLED": "Workspace enforcement is disabled, so configured agents are not enforcing policies through TrustLogix.",
          "UNKNOWN": "Workspace enforcement status is not verified.",
          "ATTENTION": "The workspace's enforcement path is reporting a problem."
        },
        "applyDoesNot": "Applying policies does not route agents, enable enforcement, repair connections or run a runtime check."
      },
      "cohort": {
        "source": {
          "category_one": "{{name}} · {{count}} agent in this category",
          "category_other": "{{name}} · {{count}} agents in this category",
          "filter_one": "{{count}} agent in this filtered list",
          "filter_other": "{{count}} agents in this filtered list",
          "selection_one": "{{count}} agent selected",
          "selection_other": "{{count}} agents selected",
          "estate_one": "{{count}} agent in the estate",
          "estate_other": "{{count}} agents in the estate",
          "agent": "Reviewing for {{name}}"
        },
        "recommendations_one": "{{count}} recommended policy selected",
        "recommendations_other": "{{count}} recommended policies selected",
        "willApply_one": "Will apply to {{count}} agent.",
        "willApply_other": "Will apply to {{count}} agents.",
        "outsideScope_one": "{{count}} agent is outside these recommendations' scope.",
        "outsideScope_other": "{{count}} agents are outside these recommendations' scope.",
        "alreadyHave_one": "{{count}} agent already has them.",
        "alreadyHave_other": "{{count}} agents already have them.",
        "unresolved_one": "{{count}} agent could not be assessed.",
        "unresolved_other": "{{count}} agents could not be assessed.",
        "expected_one": "{{count}} targeted agent is expected to have its remaining policy gaps resolved.",
        "expected_other": "{{count}} targeted agents are expected to have their remaining policy gaps resolved.",
        "expectedNone": "No targeted agent is expected to have all of its policy gaps resolved by these policies.",
        "noneTargeted": "No agents would receive these recommendations, so there is nothing to apply."
      },
      "combined": {
        "title": "Review selected policies",
        "count_one": "{{count}} policy selected",
        "count_other": "{{count}} policies selected",
        "apply_one": "Apply {{count}} policy",
        "apply_other": "Apply {{count}} policies",
        "statusChange": "Status change",
        "excluded": "Excluded",
        "alreadyAssigned": "Already applied",
        "notApplicable": "Not applicable",
        "applyRecommended_one": "Apply recommended policy",
        "applyRecommended_other": "Apply {{count}} recommended policies"
      },
      "scope": {
        "policyScope": "Policy scope",
        "allAccess": "All access",
        "toggleLabel": "What the access flow shows",
        "affectedBy_one": "Affected by {{count}} selected policy",
        "affectedBy_other": "Affected by {{count}} selected policies",
        "policyCount_one": "{{count}} policy",
        "policyCount_other": "{{count}} policies",
        "policyCountAria_one": "Affected by {{count}} policy",
        "policyCountAria_other": "Affected by {{count}} policies",
        "unmatched_one": "{{count}} policy target isn't in this agent's observed access path, so it isn't drawn.",
        "unmatched_other": "{{count}} policy targets aren't in this agent's observed access path, so they aren't drawn.",
        "inScope": "Policy applies here",
        "outOfScope": "Outside this policy's scope"
      },
      "announce": {
        "opened": "Reviewing {{name}}",
        "closed": "Back to policy list"
      },
      "setupWarning": {
        "title": {
          "TARGETED_one": "{{count}} targeted agent still needs enforcement setup",
          "TARGETED_other": "{{count}} targeted agents still need enforcement setup",
          "ASSIGNED_one": "{{count}} agent that has this policy still needs enforcement setup",
          "ASSIGNED_other": "{{count}} agents that have this policy still need enforcement setup"
        },
        "description": {
          "single": "This policy can be created and assigned now, but it cannot control runtime access through TrustLogix for those agents until setup is complete.",
          "combined": "These policies can be created and assigned now, but they cannot control runtime access through TrustLogix for those agents until setup is complete."
        },
        "unverified": {
          "TARGETED_one": "Enforcement setup is not verified for {{count}} targeted agent.",
          "TARGETED_other": "Enforcement setup is not verified for {{count}} targeted agents.",
          "ASSIGNED_one": "Enforcement setup is not verified for {{count}} agent that has this policy.",
          "ASSIGNED_other": "Enforcement setup is not verified for {{count}} agents that have this policy."
        },
        "unverifiedTitle": {
          "TARGETED_one": "Enforcement setup is not verified for {{count}} targeted agent",
          "TARGETED_other": "Enforcement setup is not verified for {{count}} targeted agents",
          "ASSIGNED_one": "Enforcement setup is not verified for {{count}} agent that has this policy",
          "ASSIGNED_other": "Enforcement setup is not verified for {{count}} agents that have this policy"
        },
        "unverifiedDescription": "The policies can be created and assigned, but TrustLogix cannot tell whether they will control runtime access for those agents.",
        "agentTitle": "Enforcement setup required for this agent",
        "agentUnverifiedTitle": "Enforcement setup is not verified for this agent"
      }
    },
    "implementation": {
      "state": {
        "implementation": {
          "NOT_CREATED": "Not created",
          "CREATING": "Creating",
          "DEPLOYING": "Deploying",
          "DEPLOYED": "Deployed",
          "PARTIALLY_DEPLOYED": "Partially deployed",
          "FAILED": "Deployment failed"
        },
        "native": {
          "QUEUED": "Queued",
          "CREATING": "Creating",
          "DEPLOYING": "Deploying",
          "DEPLOYED": "Deployed",
          "FAILED": "Failed"
        },
        "alignment": {
          "MATCHES_DEFINITION": "Matches definition",
          "MODIFIED": "Modified after deployment",
          "UNKNOWN": "Not yet deployed"
        },
        "definition": {
          "RECOMMENDED": "Recommended",
          "APPLYING": "Applying",
          "APPLIED": "Applied",
          "FAILED": "Apply failed"
        }
      },
      "target": {
        "MCP_SERVER": "MCP Server",
        "MCP_TOOL": "Tool",
        "DATA_PLATFORM": "Data Policy"
      },
      "engine": {
        "TLX_POLICY_ENGINE": "TrustLogix Policy Engine",
        "DATA_PLATFORM": "Data platform"
      },
      "source": {
        "GENERATED": "Generated",
        "MANUALLY_MODIFIED": "Individual override"
      },
      "effect": {
        "ALLOW": "Allow",
        "BLOCK": "Block",
        "MASK": "Mask",
        "REQUIRE_APPROVAL": "Require approval"
      },
      "count": {
        "serverPolicy_one": "{{count}} MCP server policy",
        "serverPolicy_other": "{{count}} MCP server policies",
        "server_one": "{{count}} MCP server",
        "server_other": "{{count}} MCP servers",
        "toolPolicy_one": "{{count}} tool policy",
        "toolPolicy_other": "{{count}} tool policies",
        "tlxPolicy_one": "{{count}} TrustLogix policy",
        "tlxPolicy_other": "{{count}} TrustLogix policies",
        "control_one": "{{count}} control",
        "control_other": "{{count}} controls"
      },
      "plan": {
        "heading": "Enforcement plan",
        "combinedHeading": "Will create / update",
        "intro": "Applying this recommendation will create the policies required to enforce its intent across the selected access path.",
        "combinedIntro_one": "{{count}} policy definition selected. Applying creates or updates these native policies.",
        "combinedIntro_other": "{{count}} policy definitions selected. Applying creates or updates these native policies.",
        "serverPolicies": "MCP server policies",
        "toolPolicies": "Tool policies",
        "enforcedThrough": "Evaluated through",
        "gateway": "The configured enforcement path, such as the MCP Access Gateway",
        "dataHeading": "Native data-platform controls",
        "dataNote": "Native controls are deployed only where data-layer enforcement is required, and only to the data platforms listed here.",
        "noData": "No native data-platform controls are required: this definition is evaluated at the MCP server and tool through the TrustLogix policy engine.",
        "units": {
          "definitions": "Recommended policies",
          "agents": "Targeted agents",
          "trustlogix": "TrustLogix policies",
          "controls": "Data-platform controls",
          "changes": "Generated policy changes"
        },
        "operations": {
          "create_one": "{{count}} will be created",
          "create_other": "{{count}} will be created",
          "update_one": "{{count}} will be updated",
          "update_other": "{{count}} will be updated",
          "unchanged_one": "{{count}} already in place",
          "unchanged_other": "{{count}} already in place",
          "skipped_one": "{{count}} left alone (individually modified)",
          "skipped_other": "{{count}} left alone (individually modified)",
          "pending_one": "{{count}} not yet classified as create or update",
          "pending_other": "{{count}} not yet classified as create or update"
        },
        "sharedImpact_one": "{{records}} of these policies also apply to {{count}} agent outside this review. Updating them affects that agent too.",
        "sharedImpact_other": "{{records}} of these policies also apply to {{count}} agents outside this review. Updating them affects those agents too.",
        "updates_one": "{{count}} of these native policies already exists and will be updated for the newly selected agents.",
        "updates_other": "{{count}} of these native policies already exist and will be updated for the newly selected agents.",
        "empty": "Nothing to create: the selected agents are outside this definition's access path.",
        "destination": "Destination",
        "engineDestination": "Published to the TrustLogix policy engine",
        "dataDestination": "Deployed to {{platforms}}",
        "tlxHeading": "TrustLogix policies"
      },
      "progress": {
        "heading": {
          "APPLY": "Applying policy",
          "REAPPLY": "Reapplying policy definition",
          "RETRY": "Retrying failed publication"
        },
        "settled": "Policy publication",
        "intro": "Saving and publishing the policies required to implement this definition.",
        "hint": "This usually takes a few moments. You can close this panel - publication continues.",
        "platformDetail_one": "{{resources}} · {{count}} control",
        "platformDetail_other": "{{resources}} · {{count}} controls",
        "step": {
          "CREATE_TLX": {
            "PENDING": "Create or update policy records",
            "ACTIVE": "Creating/updating policy records…",
            "DONE": "Policy records saved",
            "FAILED": "Policy records could not be saved"
          },
          "DEPLOY_TLX": {
            "PENDING": "Publish TrustLogix policies",
            "ACTIVE": "Publishing TrustLogix policies…",
            "DONE": "Published to the TrustLogix policy engine",
            "FAILED": "Some policies were not published to the TrustLogix policy engine"
          },
          "DEPLOY_PLATFORM": {
            "PENDING": "Deploy required data-platform controls to {{resources}}",
            "ACTIVE": "Deploying required data-platform controls to {{resources}}…",
            "DONE": "Deployed to {{resources}}",
            "FAILED": "Some controls were not deployed to {{resources}}"
          },
          "VERIFY": {
            "PENDING": "Publication confirmation pending",
            "ACTIVE": "Confirming publication…",
            "DONE": "Publication confirmed",
            "FAILED": "Some policies were not published or deployed"
          }
        },
        "summary": {
          "serverPolicies_one": "{{count}} MCP server policy published to the TrustLogix policy engine",
          "serverPolicies_other": "{{count}} MCP server policies published to the TrustLogix policy engine",
          "serverPoliciesPartial": "{{count}} of {{total}} MCP server policies published",
          "toolPolicies_one": "{{count}} tool policy published to the TrustLogix policy engine",
          "toolPolicies_other": "{{count}} tool policies published to the TrustLogix policy engine",
          "toolPoliciesPartial": "{{count}} of {{total}} tool policies published",
          "controls_one": "{{count}} control deployed to {{resource}}",
          "controls_other": "{{count}} controls deployed to {{resource}}",
          "controlsPartial": "{{count}} of {{total}} controls deployed to {{resource}}",
          "verified": "Publication confirmed",
          "failed_one": "{{count}} policy was not published or deployed",
          "failed_other": "{{count}} policies were not published or deployed"
        }
      },
      "section": {
        "heading": "Policy implementation",
        "deployment": "Deployment",
        "alignment": "Alignment",
        "dataPlatform": "Native data-platform controls",
        "serverPolicy": "Server access policy",
        "viewPolicies": "View policies",
        "viewPoliciesFor": "View native policies for {{name}}",
        "matching": "{{count}} of {{total}} native policies match the applied definition.",
        "modifiedCount_one": "{{count}} policy has been modified individually.",
        "modifiedCount_other": "{{count}} policies have been modified individually.",
        "reviewChanges": "Review changes",
        "reapply": "Reapply definition",
        "partialTitle": "Partially published or deployed",
        "failedTitle": "Publication failed - the definition is not implemented",
        "tlxDeployed": "{{count}} of {{total}} TrustLogix policies published",
        "platformDeployed": "{{count}} of {{total}} controls deployed to {{resource}}",
        "failedCount_one": "{{count}} policy failed",
        "failedCount_other": "{{count}} policies failed",
        "reviewIssue": "Review issue",
        "retry": "Retry failed deployment",
        "runtime": "Enforcement setup",
        "runtimeDeployedNotEnforced_one": "The policies are published, but {{count}} agent does not have the required enforcement path configured, so they cannot control its runtime access through TrustLogix.",
        "runtimeDeployedNotEnforced_other": "The policies are published, but {{count}} agents do not have the required enforcement path configured, so they cannot control their runtime access through TrustLogix.",
        "runtimeNotEnforced_one": "{{count}} agent does not have the required enforcement path configured, so these policies cannot control its runtime access through TrustLogix.",
        "runtimeNotEnforced_other": "{{count}} agents do not have the required enforcement path configured, so these policies cannot control their runtime access through TrustLogix.",
        "setUpEnforcement": "Set up agent enforcement"
      },
      "summary": {
        "implementation": "Implementation",
        "tlxPolicies_one": "{{count}} TLX policy",
        "tlxPolicies_other": "{{count}} TLX policies",
        "platformControls_one": "{{count}} {{resource}} control",
        "platformControls_other": "{{count}} {{resource}} controls",
        "modified_one": "{{count}} native policy modified",
        "modified_other": "{{count}} native policies modified",
        "failed_one": "{{count}} native policy failed",
        "failed_other": "{{count}} native policies failed"
      },
      "inventory": {
        "subtitle_one": "{{count}} native policy · {{engine}}",
        "subtitle_other": "{{count}} native policies · {{engine}}",
        "search": "Search policies…",
        "columns": {
          "name": "Policy / Target",
          "type": "Type",
          "source": "Source",
          "status": "Status"
        },
        "empty": "No native policies match your search.",
        "viewPolicy": "View policy",
        "editPolicy": "Edit policy"
      },
      "details": {
        "parent": "Policy definition",
        "target": "Target",
        "engine": "Engine",
        "platform": "Platform",
        "source": "Source",
        "status": "Deployment status",
        "currentLogic": "Current native policy",
        "expectedLogic": "Expected from applied definition",
        "effect": "Effect",
        "subject": "Applies to",
        "rule": "Rule",
        "created": "Created",
        "deployed": "Deployed",
        "modified": "Modified",
        "never": "-",
        "context": "Enforcement context",
        "contextGateway": "Enforced by the TrustLogix Policy Engine through the MCP Access Gateway.",
        "contextPlatform": "Enforced natively by {{platform}}.",
        "failure": "Deployment failure",
        "edit": "Edit policy",
        "editDisabledDeploying": "This policy can be edited once its deployment completes.",
        "openRegistry": "Open in MCP Registry",
        "openDataSource": "Open data-source policies",
        "viewPolicyFor": "View native policy {{name}}"
      },
      "override": {
        "title": "Edit generated policy",
        "generatedFrom": "This policy was generated from:",
        "warning": "Changing it will create an individual override. The parent policy definition will remain unchanged.",
        "save": "Save override",
        "subjectRequired": "Say what this policy applies to.",
        "ruleRequired": "Describe the rule this policy enforces.",
        "saved": "{{name}} saved as an individual override. {{definition}} is unchanged.",
        "failed": "The override could not be saved."
      },
      "changes": {
        "title": "Implementation changes",
        "subtitle_one": "{{count}} native policy differs from the applied definition",
        "subtitle_other": "{{count}} native policies differ from the applied definition",
        "expected": "Expected from applied definition",
        "current": "Current native policy",
        "modified": "Modified",
        "viewNative": "View native policy",
        "none": "Every native policy matches the applied definition."
      },
      "reapply": {
        "title": "Reapply policy definition",
        "body": "This will regenerate and deploy the implementation for the current definition.",
        "overridesBody_one": "This implementation contains {{count}} individual modification.",
        "overridesBody_other": "This implementation contains {{count}} individual modifications.",
        "willUpdate": "Reapplying will update:",
        "overwrite_one": "{{count}} manually modified policy will be overwritten.",
        "overwrite_other": "{{count}} manually modified policies will be overwritten.",
        "currentValue": "Current",
        "requiredValue": "Definition requires",
        "confirm": "Reapply definition",
        "confirmSimple": "Reapply",
        "reviewChanges": "Review changes",
        "started": "Reapplying {{name}}. Its native policies are being redeployed.",
        "failed": "The definition could not be reapplied.",
        "overridesPresent": "Review the individual overrides before reapplying."
      },
      "retry": {
        "started_one": "Retrying {{count}} failed native policy.",
        "started_other": "Retrying {{count}} failed native policies.",
        "failed": "The failed deployment could not be retried."
      },
      "permission": {
        "readOnly": "You have read-only access to native policies."
      },
      "flow": {
        "policyDeployed": "Policy deployed",
        "controlsDeployed_one": "{{count}} control deployed",
        "controlsDeployed_other": "{{count}} controls deployed",
        "heading": "Native policies",
        "deployed_one": "{{count}} policy deployed",
        "deployed_other": "{{count}} policies deployed"
      }
    },
    "scopeNoun": {
      "category_one": "agent in this category",
      "category_other": "agents in this category",
      "filter_one": "agent in this filtered list",
      "filter_other": "agents in this filtered list",
      "selection_one": "selected agent",
      "selection_other": "selected agents",
      "estate_one": "agent in the estate",
      "estate_other": "agents in the estate"
    },
    "applyResult": {
      "headline": {
        "applied": "Policies applied",
        "appliedSetupRequired": "Policies applied — enforcement setup still required",
        "appliedWorkspace": "Policies applied — workspace enforcement is not enabled",
        "appliedSetupNotVerified": "Policies applied — enforcement setup not verified",
        "inProgress": "Applying policies — publication in progress",
        "partial": "Policies partially published",
        "recordsSaved": "Policy records saved — publication incomplete",
        "failed": "Policy application failed"
      },
      "changes": {
        "heading": "Policy changes",
        "summaryIncomplete": "{{policies}} for {{agents}}: publication is not complete.",
        "configuredFor": "{{policy}} is configured for {{context}}.",
        "viewChanges": "View policy changes"
      },
      "setup": {
        "configured_one": "{{count}} agent configured",
        "configured_other": "{{count}} agents configured",
        "needSetup_one": "{{count}} agent still needs setup",
        "needSetup_other": "{{count}} agents still need setup",
        "notVerified_one": "{{count}} agent not verified",
        "notVerified_other": "{{count}} agents not verified",
        "unavailable": "Enforcement setup could not be read for these agents.",
        "consequence_one": "The policies cannot control runtime access through TrustLogix for this agent until its enforcement setup is complete.",
        "consequence_other": "The policies cannot control runtime access through TrustLogix for those {{count}} agents until their enforcement setup is complete."
      },
      "summary": {
        "label": "Publication, setup and verification"
      },
      "note": "Publication is confirmed separately from agent setup and runtime verification. Policy coverage is reported separately.",
      "retryFailed_one": "Retry failed publication",
      "retryFailed_other": "Retry failed publication",
      "footer": {
        "CONFIRMED": "{{policies}} applied · {{agents}}",
        "NOTHING_TO_PUBLISH": "{{policies}} applied · {{agents}}",
        "PENDING": "{{policies}} saved · publication pending",
        "IN_PROGRESS": "{{policies}} saved · publishing",
        "PARTIAL": "{{policies}} · publication incomplete",
        "FAILED": "{{policies}} saved · publication failed"
      }
    },
    "gatewaySetup": {
      "title": "MCP Gateway setup instructions",
      "subtitle": "What to prepare before importing agents",
      "steps": {
        "configure": {
          "title": "Configure the TrustLogix MCP Gateway",
          "description": "A workspace administrator sets up the gateway for this tenant in Settings."
        },
        "registerServices": {
          "title": "Register the MCP services your agents use",
          "description": "Add each MCP service that the agents you plan to import rely on in the MCP Registry."
        },
        "updateAgents": {
          "title": "Point each agent's MCP connection at the gateway",
          "description": "In your agent platform, change each agent's MCP server URL or connection setting to the TrustLogix MCP Gateway endpoint instead of the downstream MCP service's own endpoint. TrustLogix does not change this for you."
        },
        "confirm": {
          "title": "Return to agent import and confirm",
          "description": "In step 2 of the import wizard, TrustLogix checks the gateway configuration and you confirm the two items above."
        }
      },
      "endpointTitle": "Gateway endpoint",
      "endpointPending": "The endpoint is shown here once the gateway configuration check succeeds. You can also find it in Settings, under the gateway configuration.",
      "notProviderUrl": "This changes the agent's MCP connection only. It is not the agent registry URL, your identity provider's URL, or any other credential.",
      "docs": "Read the full setup guide"
    },
    "syncJob": {
      "view": "View import job",
      "title": "Import job",
      "details": "Details",
      "progress": "Onboarding progress",
      "fields": {
        "provider": "Platform",
        "reference": "Job reference",
        "startedAt": "Started",
        "projects": "Project scope",
        "completedAt": "Completed"
      },
      "projectsNotRecorded": "Not recorded for this import",
      "unavailable": {
        "title": "Job status unavailable",
        "description": "TrustLogix could not read this job's status. The job itself may still be running."
      },
      "retry": "Retry",
      "notFound": "No status has been reported for this job.",
      "completeNotice_one": "Agent import finished: {{count}} agent imported.",
      "completeNotice_other": "Agent import finished: {{count}} agents imported.",
      "close": "Close"
    },
    "onboarding": {
      "trackerLabel": "Onboarding progress",
      "steps": {
        "importing": "Importing agents",
        "processing": "Processing",
        "completed": "Completed"
      },
      "state": {
        "complete": "Completed",
        "running": "In progress",
        "pending": "Pending",
        "failed": "Failed",
        "notStarted": "Not started"
      },
      "badge": {
        "importing": "Importing",
        "processing": "Processing",
        "completed": "Completed",
        "failed": "Failed"
      },
      "stepDetail": {
        "importingRunning": "Importing agents from the selected projects.",
        "importingComplete_one": "{{count}} agent imported",
        "importingComplete_other": "{{count}} agents imported",
        "processingRunning": "Analyzing agent context and preparing policy recommendations.",
        "processingComplete": "Agents analyzed and policy recommendations generated",
        "completedComplete": "All tasks finished"
      },
      "card": {
        "title": {
          "running": "Agent onboarding in progress",
          "completed": "Agent onboarding completed",
          "failed": "Agent onboarding needs attention"
        },
        "summary": {
          "importing": "Importing agents from the selected projects.",
          "processing_one": "{{count}} agent imported successfully.",
          "processing_other": "{{count}} agents imported successfully.",
          "completed_one": "{{count}} agent is ready to review.",
          "completed_other": "{{count}} agents are ready to review.",
          "failed": "Onboarding could not be completed."
        },
        "detail": {
          "processing": "TrustLogix is analyzing agent context and preparing policy recommendations.",
          "completed": "Agent onboarding completed successfully.",
          "failed": "View the activity details for more information."
        },
        "continueNote": "You can continue using TrustLogix while onboarding runs.",
        "viewActivity": "View onboarding activity",
        "reviewAgents": "Review agents",
        "dismiss": {
          "label": "Dismiss onboarding summary",
          "hint": "Hides this summary. You can still open the onboarding activity from Agent Platforms."
        }
      },
      "callout": {
        "running": "Processing is running in the background. You can continue using TrustLogix.",
        "completedTitle": "Agent onboarding completed successfully.",
        "completedDescription": "You can now review your agents and recommended policies.",
        "failedTitle": "Onboarding could not be completed.",
        "failedFallback": "TrustLogix did not receive a reason for the failure. Try importing again, or contact support if it keeps failing.",
        "noAgents": "Completed - no agents were found in the selected projects."
      },
      "detailed": {
        "title": "Processing details ({{count}})",
        "show": "View detailed activity",
        "hide": "Hide detailed activity",
        "listLabel": "Detailed activity",
        "stageCount": "{{value}} / {{total}}"
      }
    },
    "createAgent": "Create AI Agent",
    "toolCoverage": {
      "agentPolicy": "Agent policy",
      "serverRule": "Server rule",
      "toolRule": "Tool rule",
      "multipleRules": "Multiple rules",
      "needsPolicy": "Needs policy",
      "notEvaluated": "Not evaluated",
      "hint": {
        "agentPolicy": "Agent-level policy {{policy}} applies to this tool. It applies; that alone does not mean it is sufficient.",
        "serverRule": "A rule in {{policy}} targets every tool on this MCP server, including this one.",
        "toolRule": "A rule in {{policy}} targets this tool directly.",
        "multipleRules_one": "{{count}} rule applies, from {{policy}}.",
        "multipleRules_other": "{{count}} rules apply, from {{policy}}.",
        "alsoAgentPolicy": "Agent-level policy {{policy}} also applies.",
        "needsPolicy": "The agent's evaluation found a required control missing for this tool.",
        "agentNotEvaluated": "This agent has not been evaluated, so coverage for this tool is unknown.",
        "accessSuspended": "The Kill Switch suspends this agent's access. That is an enforcement state; policy coverage is not evaluated while it is active.",
        "noEvidence": "Nothing in the agent's evaluation maps this tool to a policy or to a gap."
      }
    },
    "policyEditor": {
      "title": {
        "createAgentPolicy": "Create Agent Policy",
        "createPolicy": "Create Policy",
        "customizeTool": "Customize Tool Access",
        "editToolRules": "Edit Tool Rules",
        "editAgentPolicy": "Edit Agent Policy"
      },
      "subtitleAgent": "Define access controls for {{agent}}. You can add multiple rules across MCP services and tools.",
      "subtitleTool": "Define access controls for {{tool}} on {{agent}}.",
      "defaultToolPolicyName": "{{tool}} access policy",
      "browseExisting": "Browse existing policies",
      "steps": {
        "details": "Policy details",
        "detailsDescription": "Agent, name and description",
        "rules": "Policy rules",
        "rulesDescription": "MCP servers, tools and conditions",
        "review": "Review",
        "reviewDescription": "Check the policy, then apply"
      },
      "agentTitle": "Agent",
      "inheritedTitle": "Inherited agent controls",
      "inheritedDescription": "Read-only. These rules refine this policy for the tool; the inherited policy itself is not changed, and its restrictions still apply.",
      "noInherited": "No agent-level policy is known to cover this tool.",
      "detailsTitle": "Policy details",
      "nameLabel": "Policy name",
      "descriptionLabel": "Description",
      "rulesTitle": "Policy rules",
      "rulesHelp": "Add one or more rules to control this agent's access to MCP services and tools.",
      "addRule": "Add rule",
      "effect": {
        "allow": "Allow when conditions match",
        "deny": "Deny when conditions match",
        "allowOnlyWhen": "Allow only when conditions match",
        "allowShort": "Allow",
        "denyShort": "Deny",
        "allowOnlyWhenShort": "Allow only when"
      },
      "rule": {
        "number": "Rule {{number}}",
        "untitled": "Untitled rule",
        "nameLabel": "Rule name",
        "duplicate": "Duplicate",
        "delete": "Delete rule",
        "menu": "More actions for rule {{number}}",
        "expand": "Expand rule {{number}}",
        "collapse": "Collapse rule {{number}}",
        "appliesTo": "Applies to",
        "server": "MCP server",
        "tools": "Tools",
        "noServer": "No MCP server selected",
        "noTools": "No tools selected",
        "toolsSelected_one": "{{count}} tool selected",
        "toolsSelected_other": "{{count}} tools selected",
        "toolCount_one": "{{count}} tool",
        "toolCount_other": "{{count}} tools",
        "allTools": "All tools",
        "allToolsDetail": "All tools on {{server}}, including tools added later",
        "selectTools": "Select tools",
        "changeScope": "Change scope",
        "decision": "Access decision",
        "noEffect": "No decision",
        "conditions": "Conditions",
        "optional": "(optional)",
        "noConditions": "No conditions",
        "noConditionsHint": "No additional conditions. This rule applies to the selected tools whenever they are called.",
        "conditionCount_one": "{{count}} condition",
        "conditionCount_other": "{{count}} conditions",
        "addCondition": "Add condition",
        "conditionsUnavailable": "Condition attributes could not be loaded, so conditions can't be added right now.",
        "issue": {
          "scope": "Select an MCP server and tools for this rule.",
          "tools": "Select at least one tool.",
          "effect": "Choose an access decision.",
          "conditions": "Complete or remove the unfinished condition."
        }
      },
      "selector": {
        "title": "Select MCP servers and tools",
        "subtitle": "Choose the tools {{rule}} applies to.",
        "searchPlaceholder": "Search MCP servers or tools",
        "searchLabel": "Search MCP servers and tools",
        "capabilityLabel": "Filter by capability",
        "allCapabilities": "All capabilities",
        "listLabel": "MCP servers and tools",
        "oneServerNote": "One MCP server per rule. To cover tools on another server, add another rule. Selected tools are fixed - choose All tools to include tools the server adds later.",
        "serverScope": "All tools, including tools added later",
        "serverScopeLabel": "Apply to every tool on {{server}}, including tools added later",
        "selectedServerScope": "All tools on {{server}}",
        "expandServer": "Expand {{server}}",
        "collapseServer": "Collapse {{server}}",
        "selectServer": "Select the shown tools on {{server}}",
        "selectedOf": "{{count}} of {{total}} tools selected",
        "selectedTotal_one": "{{count}} tool selected",
        "selectedTotal_other": "{{count}} tools selected",
        "more": "+{{count}} more",
        "apply": "Apply selection",
        "noMatches": "No MCP servers or tools match your search.",
        "noServers": "This agent has no connected MCP servers."
      },
      "review": {
        "summaryTitle": "Policy summary",
        "agents_one": "agent",
        "agents_other": "agents",
        "servers_one": "MCP server",
        "servers_other": "MCP servers",
        "tools_one": "tool",
        "tools_other": "tools",
        "rules_one": "rule",
        "rules_other": "rules",
        "acrossRules": "Across all rules",
        "rulesTitle": "Policy rules ({{count}})",
        "expandAll": "Expand all",
        "collapseAll": "Collapse all",
        "unconditional": "No conditions: applies whenever these tools are called.",
        "impactTitle": "Policy impact",
        "impactAgent": "Applies to 1 agent ({{agent}}) only.",
        "impactCoverage": "Covers {{serversCount}} {{servers}} and {{toolsCount}} {{tools}}.",
        "impactInherited": "Refines the inherited policy {{names}} without changing it.",
        "impactRestrictions": "Existing enterprise and agent-level restrictions remain applicable.",
        "overlap_one": "{{count}} tool is targeted by more than one rule. Conflict evaluation is unavailable, so how those rules combine is not shown.",
        "overlap_other": "{{count}} tools are targeted by more than one rule. Conflict evaluation is unavailable, so how those rules combine is not shown.",
        "declaredOnly": "This is the rules as written, not an evaluated access decision."
      },
      "saveDraft": "Save as draft",
      "applyPolicy": "Apply policy",
      "saveChanges": "Save changes",
      "enforcementLabel": "Enforcement setup",
      "applied": "Policy “{{name}}” applied",
      "savedDraft": "Draft “{{name}}” saved",
      "saveFailed": "Could not save the policy.",
      "saveFailedInline": "The policy was not saved. Your changes are kept; try again.",
      "serverHasNoTools": "This MCP server has no tools yet, so a rule for all of its tools would protect nothing. Choose tools, or try again once the server reports its tools.",
      "conflict": "This policy changed since you opened it. Your changes are kept here; close and reopen to see the current version before saving again.",
      "confirmDelete": {
        "title": "Delete rule?",
        "body": "Rule {{number}} and its selections and conditions will be removed from this policy. Nothing is saved until you apply or save the policy.",
        "ok": "Delete rule"
      },
      "confirmUnlock": {
        "title": "Change scope?",
        "body": "This rule is scoped to the tool you started from. Changing it lets the rule target other tools on this agent. The change is shown in the review before anything is saved.",
        "ok": "Change scope"
      }
    },
    "applicablePolicies": {
      "title": "Applicable Policies",
      "inheritedTitle": "Inherited from agent",
      "inheritedDescription": "An agent-level policy applied to this agent that covers this tool.",
      "viewAgentPolicy": "View in Policy Coverage",
      "noInherited": "No agent-level policy is known to cover this tool.",
      "toolRulesTitle": "Tool-targeted rules",
      "noToolRules": "No applied agent policy has a rule targeting this tool.",
      "updated": "Last updated",
      "updatedValue": "{{date}} by {{actor}}",
      "version": "Version",
      "evaluationUnavailable": "Applicable rules are listed. An evaluated access decision combining them is not available yet.",
      "enforcementTitle": "Enforcement setup",
      "enforcementDescription": "Tracked separately from policy coverage: a policy that applies is enforced only when the agent's traffic passes through TrustLogix.",
      "fromPolicy": "From agent policy “{{name}}”.",
      "unconditional": "{{effect}}: applies whenever this tool is called (no conditions).",
      "gapReported": "The agent's evaluation still reports a missing control for this tool. These rules do not close it on their own."
    },
    "policyRules": {
      "title": "Policy Rules — {{name}}",
      "manageSubtitle": "Manage the rules that target this resource",
      "inherited": "Inherited",
      "inheritedServerDescription": "An agent-level policy applied to this agent that covers tools on this MCP service. Change it in Policy Coverage.",
      "noInheritedServer": "No agent-level policy is known to cover tools on this MCP service.",
      "serverRulesTitle": "Server-targeted rules",
      "unconditionalServer": "{{effect}}: applies whenever any tool on this MCP server is called (no conditions).",
      "noServerRules": "No agent policy has a rule targeting this whole MCP server.",
      "noToolRulesServer": "No agent policy has a rule targeting specific tools on this MCP server.",
      "view": "View policy",
      "create": "Create Policy Rule",
      "removeToolRule": "Remove Tool Rule",
      "removeServerRule": "Remove Server Rule",
      "onlyRule": "This is the policy's only rule. Edit the policy to change it, or delete the whole policy.",
      "deletePolicy": "Delete Policy",
      "delete": {
        "title": "Delete policy",
        "confirm": "Delete Policy",
        "description_other": "Delete {{policy}}? All {{count}} of its rules are removed from {{agent}}. This cannot be undone.",
        "description_one": "Delete {{policy}}? Its rule is removed from {{agent}}. This cannot be undone.",
        "applied": "This policy is applied: access it allowed or denied stops being enforced once it is deleted.",
        "done": "{{policy}} was deleted.",
        "failed": "The policy could not be deleted."
      },
      "remove": {
        "titleTool": "Remove tool-specific rule?",
        "titleServer": "Remove server-wide rule?",
        "confirm": "Remove Rule",
        "rule": "Rule",
        "unnamed": "Unnamed rule ({{id}})",
        "policy": "Owning policy",
        "agent": "Agent",
        "target": "Target",
        "scope": "Only this rule is removed from {{policy}}. The policy, its other rules and every other applicable policy stay unchanged. Effective coverage may change.",
        "impactTitle": "Coverage after removal",
        "impactRow": "{{tool}}: {{coverage}}",
        "draft": "This rule belongs to a draft policy, so removing it does not change what applies to the agent.",
        "done": "Removed the rule from {{policy}}.",
        "failed": "The rule could not be removed. Coverage is unchanged - try again.",
        "conflict": "This policy changed since it was loaded, so nothing was removed. The latest version is now shown."
      }
    },
    "toolActions": {
      "menu": "Policy actions for {{tool}}",
      "viewApplicable": "View Applicable Policies",
      "createPolicyRule": "Create Policy Rule",
      "editToolRule": "Edit Tool Rule",
      "removeToolRule": "Remove Tool Rule",
      "viewDetails": "View Tool Details",
      "reviewRecommendation": "Review Suggestion"
    },
    "toolContext": {
      "title": "Context",
      "agent": "Agent",
      "service": "MCP service",
      "tool": "Tool",
      "capability": "Capability",
      "risk": "Risk",
      "dataSource": "Data source"
    }
  },
  "breadcrumbSwitcher": {
    "openLabel": "Switch {{entity}}",
    "loading": "Loading...",
    "error": "Could not load the list.",
    "empty": "No matches for \"{{query}}\".",
    "emptyCollection": "No {{entity}} yet.",
    "truncated": "Showing {{shown}} of {{total}}. Refine your search.",
    "lastUpdated": "Updated {{value}}",
    "rowActionsLabel": "Shortcuts for {{entity}}",
    "viewAll": "View all {{entity}}",
    "counts": {
      "policies_one": "{{count}} policy",
      "policies_other": "{{count}} policies",
      "resources_one": "{{count}} resource",
      "resources_other": "{{count}} resources"
    },
    "actions": {
      "analyzer": "Analyzer",
      "risks": "Risks",
      "monitoring": "Monitoring",
      "policies": "Policies",
      "auditLogs": "Audit Logs",
      "settings": "Settings"
    },
    "dataSources": {
      "title": "Data Sources",
      "searchPlaceholder": "Search data sources..."
    },
    "applications": {
      "title": "Applications",
      "searchPlaceholder": "Search applications..."
    },
    "aiAgents": {
      "title": "AI Agents",
      "searchPlaceholder": "Search AI agents..."
    },
    "dataDomains": {
      "title": "Data Domains",
      "searchPlaceholder": "Search data domains..."
    }
  },
  "carousel": {
    "previous": "Previous {{label}}",
    "next": "Next {{label}}",
    "pageIndicator": "{{current}} / {{total}}"
  },
  "investmentBankingDemo": {
    "beta": "Beta",
    "awsIam": "AWS IAM",
    "awsIamDescription": "Future identity context integration. Coming soon.",
    "oktaHint": "Enter your tenant/domain, client ID and client secret to validate their format.",
    "runtimePending": "Runtime evaluation pending.",
    "policyAssignmentNote": "Policy assignment recorded. Agent readiness and policy coverage are shown separately.",
    "accessPathLabel": "Access path",
    "accessPathPending": "Access paths become available after discovery and evaluation.",
    "unavailable": "Not available",
    "snapshotHint": "Data sources are read-only. Connection status and policy coverage are evaluated separately.",
    "dataSources": "Data Sources",
    "formatValidated": "Credential format validated"
  },
  "sidebar": {
    "groups": {
      "MonitorInsights": "Activity Monitoring & Insights",
      "DataDiscovery": "Data Platform Security",
      "AccessPolicies": "Application Security",
      "AISecurity": "AI Security",
      "Administration": "Administration"
    }
  },
  "oauthClientProfiles": {
    "description": "Manage the OAuth client identities TrustLogix uses when connecting to MCP services. Save a profile once and reuse it in Authentication Setup.",
    "identityNote": "A client profile identifies TrustLogix - not an agent or an MCP server. Saving a profile does not grant access to an MCP service or enable enforcement.",
    "add": "Add client profile",
    "createPermission": "Adding a profile requires permission to create administration settings.",
    "tableTitle": "Client profiles",
    "searchPlaceholder": "Search profiles",
    "noMatch": "No profiles match these filters.",
    "needsAttention": "Needs attention",
    "how": {
      "title": "How profiles are used",
      "step1": "Add a client profile here.",
      "step2": "Select it in an MCP service's Authentication Setup.",
      "step3": "Complete that service's authorization and connection checks."
    },
    "empty": {
      "title": "No client profiles yet",
      "body": "Add a reusable OAuth client identity for MCP service connections.",
      "cimd": "For Client Metadata (CIMD), you need an already-published metadata URL.",
      "existing": "For an existing OAuth client, you need its registered client details.",
      "noGateway": "You can create a profile before configuring a gateway. Service access is configured and tested separately."
    },
    "states": {
      "forbidden": "You do not have permission to view client profiles.",
      "loadFailed": "Client profiles could not be loaded.",
      "retry": "Retry",
      "unavailable": "Client profile management is not available in this environment. Existing service configurations keep working."
    },
    "columns": {
      "profile": "Profile",
      "registration": "Registration",
      "status": "Status",
      "lastCheck": "Last check",
      "usedBy": "Used by",
      "updated": "Last updated"
    },
    "actions": {
      "archive": "Archive profile",
      "restore": "Restore profile",
      "viewUsage": "View usage"
    },
    "confirm": {
      "archive": {
        "title": "Archive “{{name}}”?",
        "confirm": "Archive profile",
        "body": "It will no longer be offered for new connections. Existing references will remain. This does not revoke provider tokens or delete the published metadata document."
      },
      "restore": {
        "title": "Restore “{{name}}”?",
        "confirm": "Restore profile",
        "body": "It returns as a draft. Its checks must run again before it can be selected for a new connection."
      }
    },
    "lifecycle": {
      "DRAFT": "Draft",
      "AVAILABLE": "Available for selection",
      "ARCHIVED": "Archived"
    },
    "lifecycleHelp": {
      "DRAFT": "Saved for completion; not selectable for a new connection.",
      "AVAILABLE": "Profile setup is complete. Each service still checks its own compatibility.",
      "ARCHIVED": "Not offered for new connections; existing references remain."
    },
    "checkState": {
      "NOT_CHECKED": "Not checked",
      "CHECKING": "Checking",
      "PASSED": "Passed",
      "FAILED": "Failed",
      "STALE": "Stale",
      "UNAVAILABLE": "Unavailable",
      "NOT_APPLICABLE": "Not applicable",
      "NOT_REQUIRED": "Not required",
      "NEEDS_CONFIGURATION": "Needs configuration"
    },
    "registration": {
      "CIMD": "Client Metadata (CIMD)",
      "EXISTING_OAUTH_CLIENT": "Registered Application (Client ID)",
      "LEGACY_READ_ONLY": "Dynamically registered (read-only)"
    },
    "purpose": {
      "METADATA_DISCOVERY": "Metadata discovery",
      "RUNTIME_ACCESS": "Runtime access"
    },
    "eligibility": {
      "reasons": {
        "DRAFT": "setup is incomplete (draft)",
        "ARCHIVED": "archived",
        "VALIDATION_FAILED": "its last profile check failed",
        "VALIDATION_STALE": "metadata not checked recently",
        "PURPOSE_RESTRICTED": "not intended for this use",
        "ENVIRONMENT_RESTRICTED": "restricted to another environment",
        "CREDENTIAL_UNAVAILABLE": "managed authentication is missing or restricted",
        "METHOD_MISMATCH": "uses a different registration method",
        "ISSUER_MISMATCH": "registered with a different authorization server",
        "ISSUER_UNSUPPORTED": "this service's authorization server does not support client metadata documents",
        "ISSUER_UNKNOWN": "authorization server not known yet",
        "CONTEXT_UNKNOWN": "compatibility not known yet"
      }
    },
    "staleReason": {
      "DOCUMENT_CHANGED": "The published document changed after this check.",
      "CHECK_AGED": "This check is more than 30 days old.",
      "INPUT_CHANGED": "The configuration changed after it was checked."
    },
    "checks": {
      "METADATA_RETRIEVAL": "Metadata retrieval",
      "DOCUMENT_VALIDATION": "Document validation",
      "CLIENT_ID_MATCH": "Client identifier match",
      "MANAGED_AUTHENTICATION": "Managed authentication reference",
      "DETAILS_COMPLETE": "Details complete",
      "ISSUER_BINDING": "Authorization server URL (issuer)",
      "running": "Checking…",
      "notApplicable": "This profile is managed where it was created; TrustLogix does not check it here.",
      "none": "Not checked yet.",
      "checkedAt": "Checked",
      "specification": "validated against {{profile}}",
      "scopeNote": "This checks the saved profile. Compatibility and authorization for an MCP service are checked when the profile is used there."
    },
    "reasons": {
      "INVALID_URL": "Enter the client's published metadata URL in the supported format.",
      "UNSAFE_DESTINATION": "This metadata location is not permitted by your tenant's security policy. Use an approved location or contact your administrator.",
      "REDIRECT_REJECTED": "This URL redirects to another location. Use the client's actual published metadata URL.",
      "UNREACHABLE": "TrustLogix could not retrieve the metadata document. Retry, or save a draft and check later.",
      "NOT_METADATA_DOCUMENT": "The URL did not return a supported client metadata document. Check with the client owner.",
      "CLIENT_ID_MISMATCH": "The document's client ID does not match the URL entered. Correct the source or the URL - TrustLogix does not repair it.",
      "FORBIDDEN_CREDENTIAL_DATA": "The metadata document contains unsupported credential material. Ask its publisher to correct it.",
      "AUTH_REFERENCE_MISSING": "Select an approved managed authentication reference for this client.",
      "AUTH_REFERENCE_RESTRICTED": "This managed authentication reference is restricted and cannot be used for this client.",
      "KEY_BINDING_NOT_ESTABLISHED": "The managed authentication reference could not be matched to this client configuration. Review the client and key setup.",
      "ISSUER_UNKNOWN": "Select where the application is registered.",
      "DETAILS_INCOMPLETE": "Select the authorization provider and enter the registered application's client ID.",
      "DOCUMENT_CHANGED": "The published document changed after the last check. Check it again.",
      "CHECK_AGED": "This check is more than 30 days old. Check it again.",
      "INPUT_CHANGED": "The configuration changed after it was checked. Check again.",
      "VALIDATION_UNAVAILABLE": "Profile validation is unavailable in this environment. Save a draft or use an existing supported setup.",
      "NOT_REQUIRED": "Not required by this client configuration.",
      "ISSUER_NOT_CONFIGURED": "This provider does not have an authorization server URL configured. Complete its provider configuration before using this application.",
      "ISSUER_MISMATCH": "The discovered issuer does not match this provider configuration. Review the provider settings."
    },
    "preview": {
      "none": "None",
      "clientName": "Published client name",
      "clientId": "Client ID",
      "authMethod": "Declared client authentication",
      "grantTypes": "Declared grant types",
      "redirectUris": "Registered redirect URIs",
      "publicKey": "Public key reference",
      "observed": "Observed",
      "technicalDetails": "Technical details (sanitized document)"
    },
    "usage": {
      "unavailable": "Usage details unavailable",
      "connections_one": "{{count}} connection",
      "connections_other": "{{count}} connections",
      "partial": "{{text}} (partial usage information)",
      "gatewayReferences_one": "{{count}} gateway reference",
      "gatewayReferences_other": "{{count}} gateway references",
      "agents_one": "{{count}} affected agent",
      "agents_other": "{{count}} affected agents",
      "partialNote": "Usage information is partial. Changes to managed authentication or usage restrictions are blocked until usage can be assessed."
    },
    "toast": {
      "saveFailed": "The client profile could not be saved.",
      "checkFailed": "The profile check could not be started.",
      "impactFailed": "The impact of this change could not be assessed.",
      "archived": "Profile archived. Existing references remain.",
      "archiveFailed": "The profile could not be updated.",
      "lifecycleConflict": "This profile was changed elsewhere. The list has been refreshed; review it and try again.",
      "restored": "Profile restored as a draft. Run its checks before using it.",
      "savedAvailable": "Profile saved. You can now select it in Authentication Setup. Authorization and access checks are completed for each MCP service separately.",
      "savedDraft": "Draft saved. Complete the required checks before using this profile in a new connection."
    },
    "details": {
      "title": "Client profile details",
      "subtitle": "Client profile",
      "close": "Close",
      "loadFailed": "This profile could not be loaded.",
      "legacy": "This client was registered dynamically for {{source}}. It is preserved as is and managed on that service.",
      "legacyManage": "Open the service",
      "archivedNote": "This profile is archived: it is not offered for new connections, and existing references remain. Archiving did not revoke tokens or delete the published document.",
      "overview": "Overview",
      "registration": "Registration method",
      "description": "Description",
      "intendedUse": "Intended use",
      "managedAuthentication": "Managed authentication",
      "noCredential": "No reference",
      "lastCheck": "Last profile check",
      "updated": "Last updated",
      "checks": "Profile checks",
      "usage": "Usage",
      "activity": "Activity",
      "activityType": {
        "CREATED": "Profile created",
        "UPDATED": "Profile updated",
        "VALIDATED": "Profile checked",
        "MADE_AVAILABLE": "Made available",
        "ARCHIVED": "Archived",
        "RESTORED": "Restored",
        "DOCUMENT_CHANGED": "Published document changed"
      },
      "metadataSource": "Metadata source",
      "clientIdUrl": "Client metadata URL / client ID",
      "notSet": "Not set",
      "clientId": "Registered client ID",
      "referenceType": {
        "MCP_CONNECTION": "MCP connection",
        "GATEWAY_DEFAULT": "Gateway default",
        "INHERITED_GATEWAY": "Via gateway identity"
      },
      "columns": {
        "resource": "Resource",
        "type": "Reference type",
        "purpose": "Purpose",
        "environment": "Environment"
      },
      "noUsage": "No saved configuration references this profile.",
      "usageNote": "A reference identifies configuration use only. It does not route agents or guarantee service access.",
      "provider": "Authorization provider"
    },
    "form": {
      "addTitle": "Add client profile",
      "editTitle": "Edit client profile",
      "validation": {
        "nameRequired": "Enter a profile name.",
        "nameTooLong": "Use {{max}} characters or fewer."
      },
      "sections": {
        "details": "Profile details",
        "configuration": "Configuration",
        "checks": "Checks and next steps"
      },
      "name": "Profile name",
      "nameHint": "An internal label for people in your tenant. It does not rename the published OAuth client.",
      "description": "Description",
      "environment": "Environment",
      "environmentHint": "The tenant environments this profile is meant for. Leave empty for none in particular.",
      "intendedUse": "Intended use",
      "intendedUseHint": "Limits where this profile can be selected in TrustLogix. It does not grant permission to the MCP service.",
      "registration": {
        "title": "Client registration",
        "descriptions": {
          "CIMD": "Use a published client metadata URL to identify the application.",
          "EXISTING_OAUTH_CLIENT": "Use the client ID of an application already registered with your authorization provider."
        },
        "description": "Choose how TrustLogix identifies its gateway or discovery application to the authorization provider."
      },
      "identityLocked": "This profile has been available, so its OAuth client identity cannot be replaced in place. Create a new profile for a different client and reassign deliberately.",
      "cimd": {
        "intro": "Client Metadata (CIMD) identifies an OAuth client using a published metadata document. Add its URL here; TrustLogix will reference the existing document rather than publish a new one.",
        "sourceTitle": "Metadata source",
        "sourceValue": "Existing published document",
        "sourceNote": "TrustLogix stores a reference to this document. Changes to its contents must be made by the team that hosts it.",
        "url": "Client metadata URL / OAuth client ID",
        "urlHint": "Enter the URL of this OAuth client's metadata document - not an MCP server endpoint or an identity provider's discovery URL.",
        "urlPlaceholder": "https://clients.example.com/oauth/client-metadata.json",
        "whereTitle": "Where do I find this URL?",
        "whereBody": "Ask the team that manages your OAuth client for its published client metadata URL. An authorization server discovery URL describes the server, not your client."
      },
      "existing": {
        "title": "Registered application details",
        "intro": "Enter the details of the gateway or discovery application already registered with your authorization provider. TrustLogix will save a reference to this application; it will not register a new application with the provider.",
        "provider": "Authorization provider",
        "providerPlaceholder": "Select where the application is registered",
        "providerHint": "Choose the specific authorization server and tenant associated with this application.",
        "providerChanged": "The authorization provider changed. Review the client ID for the new provider - checks for the previous provider no longer apply.",
        "clientId": "Application / Client ID",
        "clientIdPlaceholder": "Enter the registered application's client ID",
        "clientIdHint": "This identifies the gateway or discovery application, not an imported agent or the tenant itself.",
        "saveExplanation": "Saving creates a reference in TrustLogix. It does not create an application, grant service access, or change enforcement in your provider."
      },
      "credentials": {
        "availability": {
          "USABLE": "Usable",
          "MISSING": "Missing",
          "RESTRICTED": "Restricted",
          "NOT_CHECKED": "Not checked",
          "NOT_REQUIRED": "Not required"
        }
      },
      "checkMetadata": "Check metadata",
      "checkDetails": "Check details",
      "cancelCheck": "Cancel check",
      "checkCancelled": "Check cancelled. Nothing was recorded.",
      "nextSteps": {
        "create": "Next: select this profile in an MCP service's Authentication Setup, then complete that service's own authorization and connection checks.",
        "edit": "Changes apply to this profile only. Services that reference it keep their own authorization and checks."
      },
      "impact": {
        "title": "Update a shared client profile?",
        "confirm": "Save changes",
        "cancel": "Cancel",
        "body": "This profile is referenced by {{connections}} MCP service connections and {{references}} gateway settings. These changes may affect those references:",
        "fields": {
          "managedCredentialRef": "Managed client authentication",
          "purposes": "Intended use",
          "environmentIds": "Environment"
        }
      },
      "blocked": {
        "method": "Choose a registration method.",
        "incomplete": "Complete the required fields to check this profile.",
        "checking": "Waiting for the check to finish.",
        "stale": "The configuration changed after it was checked. Check again.",
        "checks": "Run the profile checks, and resolve any failures, before saving it as available."
      },
      "errors": {
        "VERSION_CONFLICT": "This profile was updated by someone else. Reload the latest version; your unsaved changes stay in the form until you do.",
        "DUPLICATE_PROFILE": "A profile for this OAuth client already exists.",
        "IDENTITY_LOCKED": "The OAuth client identity of an available profile cannot be replaced in place.",
        "VALIDATION_REQUIRED": "Complete the profile checks for these exact inputs before saving.",
        "IMPACT_REVIEW_REQUIRED": "Review the impact of this change before saving it.",
        "USAGE_UNKNOWN": "Usage for this profile is not fully known, so this change cannot be assessed. Name and description changes can still be saved.",
        "PROFILE_NOT_FOUND": "This profile no longer exists.",
        "PROFILE_NOT_ASSIGNABLE": "This profile cannot be used for this connection.",
        "PROFILE_REGISTRY_UNAVAILABLE": "Client profile management is not available in this environment.",
        "PROFILE_FORBIDDEN": "You do not have permission to change client profiles.",
        "PROFILE_INVALID": "This change is not available for this profile."
      },
      "viewExisting": "View existing profile",
      "reloadLatest": "Reload latest",
      "cancel": "Cancel",
      "saveDraft": "Save draft",
      "saveChanges": "Save changes",
      "saveProfile": "Save profile",
      "makeAvailable": "Make available"
    },
    "provider": {
      "issuerLabel": "Authorization server URL (issuer)",
      "issuerHelp": "The token issuer associated with the selected provider integration. TrustLogix uses the configured URL; it does not generate one here.",
      "notConfiguredValue": "Authorization server URL not configured",
      "sourceLabel": "Source",
      "source": {
        "SAVED_CONFIGURATION": "Saved provider configuration (Settings → Integrations)",
        "PROVIDER_METADATA": "Provider metadata",
        "SAVED_PROFILE": "Saved on this profile"
      },
      "formatLabel": "Documented format for this provider type (not a configured value):",
      "retry": "Retry",
      "endpoints": {
        "title": "Provider endpoint details",
        "metadataUrl": "Metadata/discovery URL",
        "authorizationEndpoint": "Authorization endpoint",
        "tokenEndpoint": "Token endpoint",
        "notConfigured": "Not configured"
      },
      "states": {
        "loading": "Loading authorization providers…",
        "loadingDetails": "Loading provider configuration…",
        "loadFailed": "Unable to load authorization providers.",
        "none": "No authorization provider is configured for this context.",
        "noIssuer": "This provider does not have an authorization server URL configured. Complete its provider configuration before using this application.",
        "notChecked": "Provider metadata has not been checked.",
        "verificationUnavailable": "Provider verification is unavailable.",
        "mismatch": "The discovered issuer does not match this provider configuration. Review the provider settings.",
        "demo": "Demo configuration — no provider connection has been verified.",
        "detailsUnavailable": "This provider's configuration is not available to you."
      }
    }
  },
  "cardGridPager": {
    "label": "{{noun}} pages",
    "showing": "Showing {{from}}–{{to}} of {{total}} {{noun}}",
    "noun": {
      "categories_one": "category",
      "categories_other": "categories",
      "dataSources_one": "data source",
      "dataSources_other": "data sources",
      "platforms_one": "platform",
      "platforms_other": "platforms"
    }
  }
}
